(function () {
//# allFunctionsCalledOnLoad
/**
 * Swiper 11.2.10
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 28, 2025
 */ /**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */ /* eslint-disable no-param-reassign */ function $0054b2036b0e0661$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $0054b2036b0e0661$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($0054b2036b0e0661$var$isObject(src[key]) && $0054b2036b0e0661$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $0054b2036b0e0661$var$extend(target[key], src[key]);
    });
}
const $0054b2036b0e0661$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $0054b2036b0e0661$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $0054b2036b0e0661$var$extend(doc, $0054b2036b0e0661$var$ssrDocument);
    return doc;
}
const $0054b2036b0e0661$var$ssrWindow = {
    document: $0054b2036b0e0661$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $0054b2036b0e0661$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $0054b2036b0e0661$var$extend(win, $0054b2036b0e0661$var$ssrWindow);
    return win;
}



function $b61410ca6dc8b1dd$export$35e795649ee09318(classes) {
    if (classes === void 0) classes = '';
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $b61410ca6dc8b1dd$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $b61410ca6dc8b1dd$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $b61410ca6dc8b1dd$export$2d1720544b23b823() {
    return Date.now();
}
function $b61410ca6dc8b1dd$var$getComputedStyle(el) {
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $b61410ca6dc8b1dd$export$342063e11d6c3cad(el, axis) {
    if (axis === void 0) axis = 'x';
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $b61410ca6dc8b1dd$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $b61410ca6dc8b1dd$export$ae1af26003f05816(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $b61410ca6dc8b1dd$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $b61410ca6dc8b1dd$export$d141bba7fdc215a3() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$b61410ca6dc8b1dd$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($b61410ca6dc8b1dd$export$ae1af26003f05816(to[nextKey]) && $b61410ca6dc8b1dd$export$ae1af26003f05816(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $b61410ca6dc8b1dd$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$b61410ca6dc8b1dd$export$ae1af26003f05816(to[nextKey]) && $b61410ca6dc8b1dd$export$ae1af26003f05816(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $b61410ca6dc8b1dd$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $b61410ca6dc8b1dd$export$407448d2b89b1813(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $b61410ca6dc8b1dd$export$3b14a55fb2447963(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $b61410ca6dc8b1dd$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $b61410ca6dc8b1dd$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = '';
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $b61410ca6dc8b1dd$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $b61410ca6dc8b1dd$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $b61410ca6dc8b1dd$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $b61410ca6dc8b1dd$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $b61410ca6dc8b1dd$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $b61410ca6dc8b1dd$export$35e795649ee09318(classes));
    return el;
}
function $b61410ca6dc8b1dd$export$4368d992c4eafac0(el) {
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    const document1 = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $b61410ca6dc8b1dd$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $b61410ca6dc8b1dd$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $b61410ca6dc8b1dd$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $b61410ca6dc8b1dd$export$23f2a1d2818174ef(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $b61410ca6dc8b1dd$export$8b22cf2602fb60ce(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $b61410ca6dc8b1dd$export$882b5998b3b9117c(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $b61410ca6dc8b1dd$export$dda1d9f60106f0e9(el, size, includeMargins) {
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $b61410ca6dc8b1dd$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $b61410ca6dc8b1dd$export$ffb5f4729a158638(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $b61410ca6dc8b1dd$export$2408f22a0fab9ae5(el, html) {
    if (html === void 0) html = '';
    if (typeof trustedTypes !== 'undefined') el.innerHTML = trustedTypes.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $741eecd46cc7b84e$var$support;
function $741eecd46cc7b84e$var$calcSupport() {
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    const document1 = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $741eecd46cc7b84e$var$getSupport() {
    if (!$741eecd46cc7b84e$var$support) $741eecd46cc7b84e$var$support = $741eecd46cc7b84e$var$calcSupport();
    return $741eecd46cc7b84e$var$support;
}
let $741eecd46cc7b84e$var$deviceCached;
function $741eecd46cc7b84e$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $741eecd46cc7b84e$var$getSupport();
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $741eecd46cc7b84e$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$741eecd46cc7b84e$var$deviceCached) $741eecd46cc7b84e$var$deviceCached = $741eecd46cc7b84e$var$calcDevice(overrides);
    return $741eecd46cc7b84e$var$deviceCached;
}
let $741eecd46cc7b84e$var$browser;
function $741eecd46cc7b84e$var$calcBrowser() {
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    const device = $741eecd46cc7b84e$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $741eecd46cc7b84e$var$getBrowser() {
    if (!$741eecd46cc7b84e$var$browser) $741eecd46cc7b84e$var$browser = $741eecd46cc7b84e$var$calcBrowser();
    return $741eecd46cc7b84e$var$browser;
}
function $741eecd46cc7b84e$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $741eecd46cc7b84e$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $b61410ca6dc8b1dd$export$8b22cf2602fb60ce)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $741eecd46cc7b84e$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $741eecd46cc7b84e$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $b61410ca6dc8b1dd$export$9e5f44173e64f162)(el, 'padding-left') || 0, 10) - parseInt((0, $b61410ca6dc8b1dd$export$9e5f44173e64f162)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $b61410ca6dc8b1dd$export$9e5f44173e64f162)(el, 'padding-top') || 0, 10) - parseInt((0, $b61410ca6dc8b1dd$export$9e5f44173e64f162)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $741eecd46cc7b84e$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $b61410ca6dc8b1dd$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $b61410ca6dc8b1dd$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $b61410ca6dc8b1dd$export$9e5f44173e64f162)(slide, 'display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $b61410ca6dc8b1dd$export$dda1d9f60106f0e9)(slide, 'width', true) : (0, $b61410ca6dc8b1dd$export$dda1d9f60106f0e9)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $b61410ca6dc8b1dd$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $b61410ca6dc8b1dd$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $741eecd46cc7b84e$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $741eecd46cc7b84e$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $741eecd46cc7b84e$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $741eecd46cc7b84e$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $741eecd46cc7b84e$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $741eecd46cc7b84e$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $741eecd46cc7b84e$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $741eecd46cc7b84e$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $741eecd46cc7b84e$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $b61410ca6dc8b1dd$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $b61410ca6dc8b1dd$export$625550452a3fa3ec)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $741eecd46cc7b84e$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $741eecd46cc7b84e$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $741eecd46cc7b84e$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $741eecd46cc7b84e$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $741eecd46cc7b84e$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $741eecd46cc7b84e$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $741eecd46cc7b84e$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $741eecd46cc7b84e$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $741eecd46cc7b84e$var$unlazy(swiper, i);
    }
};
function $741eecd46cc7b84e$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $741eecd46cc7b84e$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $741eecd46cc7b84e$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $741eecd46cc7b84e$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $741eecd46cc7b84e$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $741eecd46cc7b84e$var$update = {
    updateSize: $741eecd46cc7b84e$var$updateSize,
    updateSlides: $741eecd46cc7b84e$var$updateSlides,
    updateAutoHeight: $741eecd46cc7b84e$var$updateAutoHeight,
    updateSlidesOffset: $741eecd46cc7b84e$var$updateSlidesOffset,
    updateSlidesProgress: $741eecd46cc7b84e$var$updateSlidesProgress,
    updateProgress: $741eecd46cc7b84e$var$updateProgress,
    updateSlidesClasses: $741eecd46cc7b84e$var$updateSlidesClasses,
    updateActiveIndex: $741eecd46cc7b84e$var$updateActiveIndex,
    updateClickedSlide: $741eecd46cc7b84e$var$updateClickedSlide
};
function $741eecd46cc7b84e$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $b61410ca6dc8b1dd$export$342063e11d6c3cad)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $741eecd46cc7b84e$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $741eecd46cc7b84e$var$minTranslate() {
    return -this.snapGrid[0];
}
function $741eecd46cc7b84e$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $741eecd46cc7b84e$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $b61410ca6dc8b1dd$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $741eecd46cc7b84e$var$translate = {
    getTranslate: $741eecd46cc7b84e$var$getSwiperTranslate,
    setTranslate: $741eecd46cc7b84e$var$setTranslate,
    minTranslate: $741eecd46cc7b84e$var$minTranslate,
    maxTranslate: $741eecd46cc7b84e$var$maxTranslate,
    translateTo: $741eecd46cc7b84e$var$translateTo
};
function $741eecd46cc7b84e$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $741eecd46cc7b84e$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $741eecd46cc7b84e$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $741eecd46cc7b84e$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $741eecd46cc7b84e$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $741eecd46cc7b84e$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $741eecd46cc7b84e$var$transition = {
    setTransition: $741eecd46cc7b84e$var$setTransition,
    transitionStart: $741eecd46cc7b84e$var$transitionStart,
    transitionEnd: $741eecd46cc7b84e$var$transitionEnd
};
function $741eecd46cc7b84e$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $b61410ca6dc8b1dd$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $741eecd46cc7b84e$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $741eecd46cc7b84e$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $741eecd46cc7b84e$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $741eecd46cc7b84e$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $741eecd46cc7b84e$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $741eecd46cc7b84e$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $741eecd46cc7b84e$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $b61410ca6dc8b1dd$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $b61410ca6dc8b1dd$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $741eecd46cc7b84e$var$slide = {
    slideTo: $741eecd46cc7b84e$var$slideTo,
    slideToLoop: $741eecd46cc7b84e$var$slideToLoop,
    slideNext: $741eecd46cc7b84e$var$slideNext,
    slidePrev: $741eecd46cc7b84e$var$slidePrev,
    slideReset: $741eecd46cc7b84e$var$slideReset,
    slideToClosest: $741eecd46cc7b84e$var$slideToClosest,
    slideToClickedSlide: $741eecd46cc7b84e$var$slideToClickedSlide
};
function $741eecd46cc7b84e$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $b61410ca6dc8b1dd$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $b61410ca6dc8b1dd$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : 'next',
        initial: initial
    });
}
function $741eecd46cc7b84e$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, initialSlide: initialSlide } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = centeredSlides ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $b61410ca6dc8b1dd$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $b61410ca6dc8b1dd$export$90a7f3efeed30595)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $741eecd46cc7b84e$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $741eecd46cc7b84e$var$loop = {
    loopCreate: $741eecd46cc7b84e$var$loopCreate,
    loopFix: $741eecd46cc7b84e$var$loopFix,
    loopDestroy: $741eecd46cc7b84e$var$loopDestroy
};
function $741eecd46cc7b84e$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $741eecd46cc7b84e$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $741eecd46cc7b84e$var$grabCursor = {
    setGrabCursor: $741eecd46cc7b84e$var$setGrabCursor,
    unsetGrabCursor: $741eecd46cc7b84e$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $741eecd46cc7b84e$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $0054b2036b0e0661$export$39b482c5e57630a8)() || el === (0, $0054b2036b0e0661$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $741eecd46cc7b84e$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $741eecd46cc7b84e$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $741eecd46cc7b84e$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $b61410ca6dc8b1dd$export$efccba1c4a2ef57b)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $741eecd46cc7b84e$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$741eecd46cc7b84e$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $741eecd46cc7b84e$var$onTouchMove(event) {
    const document1 = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $741eecd46cc7b84e$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)();
    (0, $b61410ca6dc8b1dd$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $741eecd46cc7b84e$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $741eecd46cc7b84e$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $741eecd46cc7b84e$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $741eecd46cc7b84e$var$onLoad(e) {
    const swiper = this;
    $741eecd46cc7b84e$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $741eecd46cc7b84e$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $741eecd46cc7b84e$var$events = (swiper, method)=>{
    const document1 = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $741eecd46cc7b84e$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $741eecd46cc7b84e$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $741eecd46cc7b84e$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $741eecd46cc7b84e$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $741eecd46cc7b84e$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $741eecd46cc7b84e$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $741eecd46cc7b84e$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $741eecd46cc7b84e$var$onScroll.bind(swiper);
    swiper.onClick = $741eecd46cc7b84e$var$onClick.bind(swiper);
    swiper.onLoad = $741eecd46cc7b84e$var$onLoad.bind(swiper);
    $741eecd46cc7b84e$var$events(swiper, 'on');
}
function $741eecd46cc7b84e$var$detachEvents() {
    const swiper = this;
    $741eecd46cc7b84e$var$events(swiper, 'off');
}
var $741eecd46cc7b84e$var$events$1 = {
    attachEvents: $741eecd46cc7b84e$var$attachEvents,
    detachEvents: $741eecd46cc7b84e$var$detachEvents
};
const $741eecd46cc7b84e$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $741eecd46cc7b84e$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $741eecd46cc7b84e$var$isGridEnabled(swiper, params);
    const isMultiRow = $741eecd46cc7b84e$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $741eecd46cc7b84e$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = 'window';
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $741eecd46cc7b84e$var$breakpoints = {
    setBreakpoint: $741eecd46cc7b84e$var$setBreakpoint,
    getBreakpoint: $741eecd46cc7b84e$var$getBreakpoint
};
function $741eecd46cc7b84e$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $741eecd46cc7b84e$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $741eecd46cc7b84e$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $741eecd46cc7b84e$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $741eecd46cc7b84e$var$classes = {
    addClasses: $741eecd46cc7b84e$var$addClasses,
    removeClasses: $741eecd46cc7b84e$var$removeClasses
};
function $741eecd46cc7b84e$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $741eecd46cc7b84e$var$checkOverflow$1 = {
    checkOverflow: $741eecd46cc7b84e$var$checkOverflow
};
var $741eecd46cc7b84e$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $741eecd46cc7b84e$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $741eecd46cc7b84e$var$prototypes = {
    eventsEmitter: $741eecd46cc7b84e$var$eventsEmitter,
    update: $741eecd46cc7b84e$var$update,
    translate: $741eecd46cc7b84e$var$translate,
    transition: $741eecd46cc7b84e$var$transition,
    slide: $741eecd46cc7b84e$var$slide,
    loop: $741eecd46cc7b84e$var$loop,
    grabCursor: $741eecd46cc7b84e$var$grabCursor,
    events: $741eecd46cc7b84e$var$events$1,
    breakpoints: $741eecd46cc7b84e$var$breakpoints,
    checkOverflow: $741eecd46cc7b84e$var$checkOverflow$1,
    classes: $741eecd46cc7b84e$var$classes
};
const $741eecd46cc7b84e$var$extendedDefaults = {};
class $741eecd46cc7b84e$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)({}, params, {
                    el: containerEl
                });
                swipers.push(new $741eecd46cc7b84e$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $741eecd46cc7b84e$var$getSupport();
        swiper.device = $741eecd46cc7b84e$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $741eecd46cc7b84e$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $741eecd46cc7b84e$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)({}, $741eecd46cc7b84e$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)({}, swiperParams, $741eecd46cc7b84e$var$extendedDefaults, params);
        swiper.originalParams = (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)({}, swiper.params);
        swiper.passedParams = (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $b61410ca6dc8b1dd$export$23f2a1d2818174ef)(slides[0]);
        return (0, $b61410ca6dc8b1dd$export$23f2a1d2818174ef)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = 'current';
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $741eecd46cc7b84e$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $b61410ca6dc8b1dd$export$9e5f44173e64f162)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $b61410ca6dc8b1dd$export$9e5f44173e64f162)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $b61410ca6dc8b1dd$export$9e5f44173e64f162)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $741eecd46cc7b84e$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $741eecd46cc7b84e$var$processLazyPreloader(swiper, e.target);
            });
        });
        $741eecd46cc7b84e$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $741eecd46cc7b84e$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $b61410ca6dc8b1dd$export$4a5767248b18ef41)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $b61410ca6dc8b1dd$export$d141bba7fdc215a3)($741eecd46cc7b84e$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $741eecd46cc7b84e$var$extendedDefaults;
    }
    static get defaults() {
        return $741eecd46cc7b84e$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$741eecd46cc7b84e$export$25ce5a424b770e84.prototype.__modules__) $741eecd46cc7b84e$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $741eecd46cc7b84e$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$741eecd46cc7b84e$export$25ce5a424b770e84.installModule(m));
            return $741eecd46cc7b84e$export$25ce5a424b770e84;
        }
        $741eecd46cc7b84e$export$25ce5a424b770e84.installModule(module);
        return $741eecd46cc7b84e$export$25ce5a424b770e84;
    }
}
Object.keys($741eecd46cc7b84e$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($741eecd46cc7b84e$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $741eecd46cc7b84e$export$25ce5a424b770e84.prototype[protoMethod] = $741eecd46cc7b84e$var$prototypes[prototypeGroup][protoMethod];
    });
});
$741eecd46cc7b84e$export$25ce5a424b770e84.use([
    $741eecd46cc7b84e$var$Resize,
    $741eecd46cc7b84e$var$Observer
]);






function $2952f9d781bf6b26$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                (0, $b61410ca6dc8b1dd$export$2408f22a0fab9ae5)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) (0, $b61410ca6dc8b1dd$export$2408f22a0fab9ae5)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $b61410ca6dc8b1dd$export$407448d2b89b1813)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $fc47eaceb85ed9f7$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
    const window = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && (document.activeElement.isContentEditable || document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $b61410ca6dc8b1dd$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $b61410ca6dc8b1dd$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $b61410ca6dc8b1dd$export$4368d992c4eafac0)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $97cd125ed6c66e4f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $b61410ca6dc8b1dd$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $b61410ca6dc8b1dd$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $b9f352c98bee1336$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $6c4c87b8e88c750e$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $b9f352c98bee1336$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $46e887f495241f2d$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = '';
    return `.${classes.trim().replace(/([\.:!+\/()[\]])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}




function $aceddeaf6c2b22fd$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $46e887f495241f2d$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $b61410ca6dc8b1dd$export$23f2a1d2818174ef)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $b61410ca6dc8b1dd$export$dda1d9f60106f0e9)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $b61410ca6dc8b1dd$export$23f2a1d2818174ef)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $46e887f495241f2d$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $46e887f495241f2d$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $46e887f495241f2d$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $b61410ca6dc8b1dd$export$2408f22a0fab9ae5)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $b61410ca6dc8b1dd$export$2408f22a0fab9ae5)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $46e887f495241f2d$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $b9f352c98bee1336$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $b61410ca6dc8b1dd$export$8b22cf2602fb60ce)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $8b4fc005638ec216$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $b61410ca6dc8b1dd$export$4368d992c4eafac0)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $b61410ca6dc8b1dd$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $b9f352c98bee1336$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $46e887f495241f2d$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $b61410ca6dc8b1dd$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $b61410ca6dc8b1dd$export$35e795649ee09318)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $b61410ca6dc8b1dd$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $b61410ca6dc8b1dd$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $b61410ca6dc8b1dd$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $b61410ca6dc8b1dd$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $b61410ca6dc8b1dd$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $5bda929403dae58a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $b61410ca6dc8b1dd$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $fd85f77d3ef669d7$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $b61410ca6dc8b1dd$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $b61410ca6dc8b1dd$export$342063e11d6c3cad)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $b61410ca6dc8b1dd$export$342063e11d6c3cad)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $b61410ca6dc8b1dd$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $b61410ca6dc8b1dd$export$4368d992c4eafac0)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $b61410ca6dc8b1dd$export$4368d992c4eafac0)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $b61410ca6dc8b1dd$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $b61410ca6dc8b1dd$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $5c3fd6cfbd7cf5f3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $b61410ca6dc8b1dd$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $b61410ca6dc8b1dd$export$882b5998b3b9117c)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $3f8a9fc61494dd15$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $b61410ca6dc8b1dd$export$2408f22a0fab9ae5)(notification, message);
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $46e887f495241f2d$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $46e887f495241f2d$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $b61410ca6dc8b1dd$export$23f2a1d2818174ef)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $46e887f495241f2d$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $b61410ca6dc8b1dd$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $3475dfc8a8bc81e3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $fdc6b9ebcff19514$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
    const window = (0, $0054b2036b0e0661$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $b61410ca6dc8b1dd$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $7b7283f9d1a7b89a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $1994d4ee904c026c$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $b61410ca6dc8b1dd$export$ae1af26003f05816)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $b61410ca6dc8b1dd$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $0054b2036b0e0661$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $3170bcab9c0824c8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $b61410ca6dc8b1dd$export$2d1720544b23b823)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $b61410ca6dc8b1dd$export$882b5998b3b9117c)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $b61410ca6dc8b1dd$export$882b5998b3b9117c)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $b61410ca6dc8b1dd$export$882b5998b3b9117c)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $d83396ad6b044630$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $cb270f46953845a6$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $b61410ca6dc8b1dd$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $b61410ca6dc8b1dd$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $cb270f46953845a6$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $b61410ca6dc8b1dd$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $b61410ca6dc8b1dd$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $cb270f46953845a6$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $cb270f46953845a6$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $cb270f46953845a6$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $cb270f46953845a6$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $cb270f46953845a6$var$appendSlide.bind(swiper),
        prependSlide: $cb270f46953845a6$var$prependSlide.bind(swiper),
        addSlide: $cb270f46953845a6$var$addSlide.bind(swiper),
        removeSlide: $cb270f46953845a6$var$removeSlide.bind(swiper),
        removeAllSlides: $cb270f46953845a6$var$removeAllSlides.bind(swiper)
    });
}


function $b5c588d0c043cc60$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $fddee6e5b067d546$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $b61410ca6dc8b1dd$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $9f6046e62a39606b$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $b61410ca6dc8b1dd$export$882b5998b3b9117c)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $43e182233ae826c7$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $fddee6e5b067d546$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $b61410ca6dc8b1dd$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $9f6046e62a39606b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $b5c588d0c043cc60$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $221ad7d728a6d4dd$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $b61410ca6dc8b1dd$export$ffb5f4729a158638)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $b5c588d0c043cc60$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $6566f260ee9b99dc$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $b61410ca6dc8b1dd$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $b61410ca6dc8b1dd$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $31baa4d840503da8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $6566f260ee9b99dc$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $6566f260ee9b99dc$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $b61410ca6dc8b1dd$export$ffb5f4729a158638)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $fddee6e5b067d546$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $b61410ca6dc8b1dd$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $9f6046e62a39606b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $b5c588d0c043cc60$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $1f881fc133484962$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $b61410ca6dc8b1dd$export$ffb5f4729a158638)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $fddee6e5b067d546$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $6566f260ee9b99dc$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $6566f260ee9b99dc$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $b61410ca6dc8b1dd$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $b5c588d0c043cc60$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $a1c24e335edf6534$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $b61410ca6dc8b1dd$export$ffb5f4729a158638)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $6566f260ee9b99dc$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $fddee6e5b067d546$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $b61410ca6dc8b1dd$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $9f6046e62a39606b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $b5c588d0c043cc60$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $4c1fbb1f5c8bc36f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $6566f260ee9b99dc$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $fddee6e5b067d546$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $b61410ca6dc8b1dd$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $9f6046e62a39606b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $b5c588d0c043cc60$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}









var $37d251801dc1953a$var$V3 = Object.defineProperty;
var $37d251801dc1953a$var$N3 = (l, t, i)=>t in l ? $37d251801dc1953a$var$V3(l, t, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: i
    }) : l[t] = i;
var $37d251801dc1953a$var$v = (l, t, i)=>$37d251801dc1953a$var$N3(l, typeof t != "symbol" ? t + "" : t, i);
var $37d251801dc1953a$var$n2 = class {
    requestAnimationFrame(t) {
        return requestAnimationFrame(t);
    }
    cancelAnimationFrame(t) {
        cancelAnimationFrame(t);
    }
}, $37d251801dc1953a$var$i2 = class {
    constructor(){
        $37d251801dc1953a$var$v(this, "_lastHandleId", 0);
        $37d251801dc1953a$var$v(this, "_lastImmediate", null);
    }
    requestAnimationFrame(t) {
        return this._lastHandleId >= Number.MAX_SAFE_INTEGER && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(()=>{
            t(Date.now());
        }), this._lastHandleId;
    }
    cancelAnimationFrame(t) {
        this._lastImmediate && clearImmediate(this._lastImmediate);
    }
}, $37d251801dc1953a$var$F1 = class {
    constructor(){
        $37d251801dc1953a$var$v(this, "_strategy");
        this._strategy = typeof requestAnimationFrame == "function" ? new $37d251801dc1953a$var$n2 : new $37d251801dc1953a$var$i2;
    }
    requestAnimationFrame(t) {
        return this._strategy.requestAnimationFrame(t);
    }
    cancelAnimationFrame(t) {
        this._strategy.cancelAnimationFrame(t);
    }
};
var $37d251801dc1953a$var$E = typeof window < "u" && typeof window.document < "u";
var $37d251801dc1953a$var$x1 = new Uint8Array([
    80,
    75,
    3,
    4
]), $37d251801dc1953a$var$V2 = [
    "v",
    "ip",
    "op",
    "layers",
    "fr",
    "w",
    "h"
], $37d251801dc1953a$var$r2 = "0.50.1", $37d251801dc1953a$var$a2 = "@lottiefiles/dotlottie-web", $37d251801dc1953a$var$N2 = .75, $37d251801dc1953a$var$G2 = 4;
var $37d251801dc1953a$var$G3 = (()=>{
    var l = typeof document < "u" ? document.currentScript?.src : void 0;
    return function(t = {}) {
        var i, s = t, c, L, z = new Promise((e, n)=>{
            c = e, L = n;
        }), K = Object.assign({}, s), m1 = "./this.program", A = "", l2;
        typeof document < "u" && document.currentScript && (A = document.currentScript.src), l && (A = l), A.startsWith("blob:") ? A = "" : A = A.substr(0, A.replace(/[?#].*/, "").lastIndexOf("/") + 1), l2 = async (e)=>{
            if (e = await fetch(e, {
                credentials: "same-origin"
            }), e.ok) return e.arrayBuffer();
            throw Error(e.status + " : " + e.url);
        };
        var a1 = s.printErr || console.error.bind(console);
        Object.assign(s, K), K = null, s.thisProgram && (m1 = s.thisProgram);
        var g1 = s.wasmBinary, M1, b1 = false, R1, e1, F, t1, s1, Y, C, p2, v2;
        function f2() {
            var e = M1.buffer;
            s.HEAP8 = e1 = new Int8Array(e), s.HEAP16 = t1 = new Int16Array(e), s.HEAPU8 = F = new Uint8Array(e), s.HEAPU16 = s1 = new Uint16Array(e), s.HEAP32 = Y = new Int32Array(e), s.HEAPU32 = C = new Uint32Array(e), s.HEAPF32 = p2 = new Float32Array(e), s.HEAPF64 = v2 = new Float64Array(e);
        }
        var _2 = [], m2 = [], g2 = [];
        function t3() {
            var e = s.preRun.shift();
            _2.unshift(e);
        }
        var X = 0, o1 = null;
        function y1(e) {
            throw s.onAbort?.(e), e = "Aborted(" + e + ")", a1(e), b1 = true, e = new WebAssembly.RuntimeError(e + ". Build with -sASSERTIONS for more info."), L(e), e;
        }
        var M2 = (e)=>e.startsWith("data:application/octet-stream;base64,"), B1;
        async function n3(e) {
            if (!g1) try {
                var n = await l2(e);
                return new Uint8Array(n);
            } catch  {}
            if (e == B1 && g1) e = new Uint8Array(g1);
            else throw "both async and sync fetching of the wasm failed";
            return e;
        }
        async function i3(e, n) {
            try {
                var r = await n3(e);
                return await WebAssembly.instantiate(r, n);
            } catch (a) {
                a1(`failed to asynchronously prepare wasm: ${a}`), y1(a);
            }
        }
        async function r3(e) {
            var n = B1;
            if (!g1 && typeof WebAssembly.instantiateStreaming == "function" && !M2(n) && typeof fetch == "function") try {
                var r = fetch(n, {
                    credentials: "same-origin"
                });
                return await WebAssembly.instantiateStreaming(r, e);
            } catch (a) {
                a1(`wasm streaming compile failed: ${a}`), a1("falling back to ArrayBuffer instantiation");
            }
            return i3(n, e);
        }
        class b2 {
            constructor(n){
                $37d251801dc1953a$var$v(this, "name", "ExitStatus");
                this.message = `Program terminated with exit(${n})`, this.status = n;
            }
        }
        var U1 = (e)=>{
            for(; 0 < e.length;)e.shift()(s);
        }, z1 = s.noExitRuntime || true, y2 = typeof TextDecoder < "u" ? new TextDecoder : void 0, L1 = (e = 0, n = NaN)=>{
            var r = F, a = e + n;
            for(n = e; r[n] && !(n >= a);)++n;
            if (16 < n - e && r.buffer && y2) return y2.decode(r.subarray(e, n));
            for(a = ""; e < n;){
                var o = r[e++];
                if (o & 128) {
                    var u = r[e++] & 63;
                    if ((o & 224) == 192) a += String.fromCharCode((o & 31) << 6 | u);
                    else {
                        var h = r[e++] & 63;
                        o = (o & 240) == 224 ? (o & 15) << 12 | u << 6 | h : (o & 7) << 18 | u << 12 | h << 6 | r[e++] & 63, 65536 > o ? a += String.fromCharCode(o) : (o -= 65536, a += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023));
                    }
                } else a += String.fromCharCode(o);
            }
            return a;
        };
        class a3 {
            constructor(n){
                this.Ca = n - 24;
            }
        }
        var L2 = 0, u1 = (e, n, r)=>{
            var a = F;
            if (0 < r) {
                r = n + r - 1;
                for(var o = 0; o < e.length; ++o){
                    var u = e.charCodeAt(o);
                    if (55296 <= u && 57343 >= u) {
                        var h = e.charCodeAt(++o);
                        u = 65536 + ((u & 1023) << 10) | h & 1023;
                    }
                    if (127 >= u) {
                        if (n >= r) break;
                        a[n++] = u;
                    } else {
                        if (2047 >= u) {
                            if (n + 1 >= r) break;
                            a[n++] = 192 | u >> 6;
                        } else {
                            if (65535 >= u) {
                                if (n + 2 >= r) break;
                                a[n++] = 224 | u >> 12;
                            } else {
                                if (n + 3 >= r) break;
                                a[n++] = 240 | u >> 18, a[n++] = 128 | u >> 12 & 63;
                            }
                            a[n++] = 128 | u >> 6 & 63;
                        }
                        a[n++] = 128 | u & 63;
                    }
                }
                a[n] = 0;
            }
        }, C1 = {}, W1 = (e)=>{
            for(; e.length;){
                var n = e.pop();
                e.pop()(n);
            }
        };
        function d1(e) {
            return this.fromWireType(C[e >> 2]);
        }
        var n1 = {}, Q = {}, w1 = {}, h1, J = (e, n, r)=>{
            function a(d) {
                if (d = r(d), d.length !== e.length) throw new h1("Mismatched type converter count");
                for(var p = 0; p < e.length; ++p)B(e[p], d[p]);
            }
            e.forEach((d)=>w1[d] = n);
            var o = Array(n.length), u = [], h = 0;
            n.forEach((d, p)=>{
                Q.hasOwnProperty(d) ? o[p] = Q[d] : (u.push(d), n1.hasOwnProperty(d) || (n1[d] = []), n1[d].push(()=>{
                    o[p] = Q[d], ++h, h === u.length && a(o);
                }));
            }), u.length === 0 && a(o);
        }, C2, I = (e)=>{
            for(var n = ""; F[e];)n += C2[F[e++]];
            return n;
        }, m;
        function o3(e, n, r = {}) {
            var a = n.name;
            if (!e) throw new m(`type "${a}" must have a positive integer typeid pointer`);
            if (Q.hasOwnProperty(e)) {
                if (r.hb) return;
                throw new m(`Cannot register type '${a}' twice`);
            }
            Q[e] = n, delete w1[e], n1.hasOwnProperty(e) && (n = n1[e], delete n1[e], n.forEach((o)=>o()));
        }
        function B(e, n, r = {}) {
            return o3(e, n, r);
        }
        var $1 = (e)=>{
            throw new m(e.Aa.Da.Ba.name + " instance already deleted");
        }, H1 = false, w2 = ()=>{}, E2 = (e, n, r)=>n === r ? e : r.Ga === void 0 ? null : (e = E2(e, n, r.Ga), e === null ? null : r.$a(e)), S2 = {}, u3 = {}, d3 = (e, n)=>{
            if (n === void 0) throw new m("ptr should not be undefined");
            for(; e.Ga;)n = e.Qa(n), e = e.Ga;
            return u3[n];
        }, E1 = (e, n)=>{
            if (!n.Da || !n.Ca) throw new h1("makeClassHandle requires ptr and ptrType");
            if (!!n.Ha != !!n.Fa) throw new h1("Both smartPtrType and smartPtr must be specified");
            return n.count = {
                value: 1
            }, c1(Object.create(e, {
                Aa: {
                    value: n,
                    writable: true
                }
            }));
        }, c1 = (e)=>typeof FinalizationRegistry > "u" ? (c1 = (n)=>n, e) : (H1 = new FinalizationRegistry((n)=>{
                n = n.Aa, --n.count.value, n.count.value === 0 && (n.Fa ? n.Ha.Ka(n.Fa) : n.Da.Ba.Ka(n.Ca));
            }), c1 = (n)=>{
                var r = n.Aa;
                return r.Fa && H1.register(n, {
                    Aa: r
                }, n), n;
            }, w2 = (n)=>{
                H1.unregister(n);
            }, c1(e));
        function S1() {}
        var l1 = (e, n)=>Object.defineProperty(n, "name", {
                value: e
            }), I2 = (e, n, r)=>{
            if (e[n].Ea === void 0) {
                var a = e[n];
                e[n] = function(...o) {
                    if (!e[n].Ea.hasOwnProperty(o.length)) throw new m(`Function '${r}' called with an invalid number of arguments (${o.length}) - expects one of (${e[n].Ea})!`);
                    return e[n].Ea[o.length].apply(this, o);
                }, e[n].Ea = [], e[n].Ea[a.Na] = a;
            }
        }, j1 = (e, n, r)=>{
            if (s.hasOwnProperty(e)) {
                if (r === void 0 || s[e].Ea !== void 0 && s[e].Ea[r] !== void 0) throw new m(`Cannot register public name '${e}' twice`);
                if (I2(s, e, e), s[e].Ea.hasOwnProperty(r)) throw new m(`Cannot register multiple overloads of a function with the same number of arguments (${r})!`);
                s[e].Ea[r] = n;
            } else s[e] = n, s[e].Na = r;
        }, c3 = (e)=>{
            e = e.replace(/[^a-zA-Z0-9_]/g, "$");
            var n = e.charCodeAt(0);
            return 48 <= n && 57 >= n ? `_${e}` : e;
        };
        function l3(e, n, r, a, o, u, h, d) {
            this.name = e, this.constructor = n, this.Ma = r, this.Ka = a, this.Ga = o, this.bb = u, this.Qa = h, this.$a = d, this.jb = [];
        }
        var V1 = (e, n, r)=>{
            for(; n !== r;){
                if (!n.Qa) throw new m(`Expected null or instance of ${r.name}, got an instance of ${n.name}`);
                e = n.Qa(e), n = n.Ga;
            }
            return e;
        };
        function p3(e, n) {
            if (n === null) {
                if (this.Ta) throw new m(`null is not a valid ${this.name}`);
                return 0;
            }
            if (!n.Aa) throw new m(`Cannot pass "${K1(n)}" as a ${this.name}`);
            if (!n.Aa.Ca) throw new m(`Cannot pass deleted object as a pointer of type ${this.name}`);
            return V1(n.Aa.Ca, n.Aa.Da.Ba, this.Ba);
        }
        function v3(e, n) {
            if (n === null) {
                if (this.Ta) throw new m(`null is not a valid ${this.name}`);
                if (this.Sa) {
                    var r = this.Ua();
                    return e !== null && e.push(this.Ka, r), r;
                }
                return 0;
            }
            if (!n || !n.Aa) throw new m(`Cannot pass "${K1(n)}" as a ${this.name}`);
            if (!n.Aa.Ca) throw new m(`Cannot pass deleted object as a pointer of type ${this.name}`);
            if (!this.Ra && n.Aa.Da.Ra) throw new m(`Cannot convert argument of type ${n.Aa.Ha ? n.Aa.Ha.name : n.Aa.Da.name} to parameter type ${this.name}`);
            if (r = V1(n.Aa.Ca, n.Aa.Da.Ba, this.Ba), this.Sa) {
                if (n.Aa.Fa === void 0) throw new m("Passing raw pointer to smart pointer is illegal");
                switch(this.ob){
                    case 0:
                        if (n.Aa.Ha === this) r = n.Aa.Fa;
                        else throw new m(`Cannot convert argument of type ${n.Aa.Ha ? n.Aa.Ha.name : n.Aa.Da.name} to parameter type ${this.name}`);
                        break;
                    case 1:
                        r = n.Aa.Fa;
                        break;
                    case 2:
                        if (n.Aa.Ha === this) r = n.Aa.Fa;
                        else {
                            var a = n.clone();
                            r = this.kb(r, P1(()=>a.delete())), e !== null && e.push(this.Ka, r);
                        }
                        break;
                    default:
                        throw new m("Unsupporting sharing policy");
                }
            }
            return r;
        }
        function f3(e, n) {
            if (n === null) {
                if (this.Ta) throw new m(`null is not a valid ${this.name}`);
                return 0;
            }
            if (!n.Aa) throw new m(`Cannot pass "${K1(n)}" as a ${this.name}`);
            if (!n.Aa.Ca) throw new m(`Cannot pass deleted object as a pointer of type ${this.name}`);
            if (n.Aa.Da.Ra) throw new m(`Cannot convert argument of type ${n.Aa.Da.name} to parameter type ${this.name}`);
            return V1(n.Aa.Ca, n.Aa.Da.Ba, this.Ba);
        }
        function p1(e, n, r, a, o, u, h, d, p, _, f) {
            this.name = e, this.Ba = n, this.Ta = r, this.Ra = a, this.Sa = o, this.ib = u, this.ob = h, this.Ya = d, this.Ua = p, this.kb = _, this.Ka = f, o || n.Ga !== void 0 ? this.toWireType = v3 : (this.toWireType = a ? p3 : f3, this.Ja = null);
        }
        var P2 = (e, n, r)=>{
            if (!s.hasOwnProperty(e)) throw new h1("Replacing nonexistent public symbol");
            s[e].Ea !== void 0 && r !== void 0 ? s[e].Ea[r] = n : (s[e] = n, s[e].Na = r);
        }, R, _3 = (e, n, r = [])=>(e.includes("j") ? (e = e.replace(/p/g, "i"), n = (0, s["dynCall_" + e])(n, ...r)) : n = R.get(n)(...r), n), m3 = (e, n)=>(...r)=>_3(e, n, r), P = (e, n)=>{
            e = I(e);
            var r = e.includes("j") ? m3(e, n) : R.get(n);
            if (typeof r != "function") throw new m(`unknown function pointer with signature ${e}: ${n}`);
            return r;
        }, O2, T2 = (e)=>{
            e = W2(e);
            var n = I(e);
            return N(e), n;
        }, I1 = (e, n)=>{
            function r(u) {
                o[u] || Q[u] || (w1[u] ? w1[u].forEach(r) : (a.push(u), o[u] = true));
            }
            var a = [], o = {};
            throw n.forEach(r), new O2(`${e}: ` + a.map(T2).join([
                ", "
            ]));
        }, N1 = (e, n)=>{
            for(var r = [], a = 0; a < e; a++)r.push(C[n + 4 * a >> 2]);
            return r;
        };
        function g3(e) {
            for(var n = 1; n < e.length; ++n)if (e[n] !== null && e[n].Ja === void 0) return true;
            return false;
        }
        function G1(e, n, r, a, o) {
            var u = n.length;
            if (2 > u) throw new m("argTypes array size mismatch! Must at least get return value and 'this' types!");
            var h = n[1] !== null && r !== null, d = g3(n), p = n[0].name !== "void", _ = u - 2, f = Array(_), M = [], b = [];
            return l1(e, function(...D) {
                if (b.length = 0, M.length = h ? 2 : 1, M[0] = o, h) {
                    var w = n[1].toWireType(b, this);
                    M[1] = w;
                }
                for(var S = 0; S < _; ++S)f[S] = n[S + 2].toWireType(b, D[S]), M.push(f[S]);
                if (D = a(...M), d) W1(b);
                else for(S = h ? 1 : 2; S < n.length; S++){
                    var U = S === 1 ? w : f[S - 2];
                    n[S].Ja !== null && n[S].Ja(U);
                }
                return w = p ? n[0].fromWireType(D) : void 0, w;
            });
        }
        var A2 = (e)=>{
            e = e.trim();
            let n = e.indexOf("(");
            return n !== -1 ? e.substr(0, n) : e;
        }, J1 = [], V = [], q1 = (e)=>{
            9 < e && --V[e + 1] === 0 && (V[e] = void 0, J1.push(e));
        }, i1 = (e)=>{
            if (!e) throw new m("Cannot use deleted val. handle = " + e);
            return V[e];
        }, P1 = (e)=>{
            switch(e){
                case void 0:
                    return 2;
                case null:
                    return 4;
                case true:
                    return 6;
                case false:
                    return 8;
                default:
                    let n = J1.pop() || V.length;
                    return V[n] = e, V[n + 1] = 1, n;
            }
        }, F2 = {
            name: "emscripten::val",
            fromWireType: (e)=>{
                var n = i1(e);
                return q1(e), n;
            },
            toWireType: (e, n)=>P1(n),
            Ia: 8,
            readValueFromPointer: d1,
            Ja: null
        }, M3 = (e, n, r)=>{
            switch(n){
                case 1:
                    return r ? function(a) {
                        return this.fromWireType(e1[a]);
                    } : function(a) {
                        return this.fromWireType(F[a]);
                    };
                case 2:
                    return r ? function(a) {
                        return this.fromWireType(t1[a >> 1]);
                    } : function(a) {
                        return this.fromWireType(s1[a >> 1]);
                    };
                case 4:
                    return r ? function(a) {
                        return this.fromWireType(Y[a >> 2]);
                    } : function(a) {
                        return this.fromWireType(C[a >> 2]);
                    };
                default:
                    throw new TypeError(`invalid integer width (${n}): ${e}`);
            }
        }, O1 = (e, n)=>{
            var r = Q[e];
            if (r === void 0) throw e = `${n} has unknown type ${T2(e)}`, new m(e);
            return r;
        }, K1 = (e)=>{
            if (e === null) return "null";
            var n = typeof e;
            return n === "object" || n === "array" || n === "function" ? e.toString() : "" + e;
        }, b3 = (e, n)=>{
            switch(n){
                case 4:
                    return function(r) {
                        return this.fromWireType(p2[r >> 2]);
                    };
                case 8:
                    return function(r) {
                        return this.fromWireType(v2[r >> 3]);
                    };
                default:
                    throw new TypeError(`invalid float width (${n}): ${e}`);
            }
        }, y3 = (e, n, r)=>{
            switch(n){
                case 1:
                    return r ? (a)=>e1[a] : (a)=>F[a];
                case 2:
                    return r ? (a)=>t1[a >> 1] : (a)=>s1[a >> 1];
                case 4:
                    return r ? (a)=>Y[a >> 2] : (a)=>C[a >> 2];
                default:
                    throw new TypeError(`invalid integer width (${n}): ${e}`);
            }
        }, L3 = Object.assign({
            optional: true
        }, F2), x2 = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, C3 = (e, n)=>{
            for(var r = e >> 1, a = r + n / 2; !(r >= a) && s1[r];)++r;
            if (r <<= 1, 32 < r - e && x2) return x2.decode(F.subarray(e, r));
            for(r = "", a = 0; !(a >= n / 2); ++a){
                var o = t1[e + 2 * a >> 1];
                if (o == 0) break;
                r += String.fromCharCode(o);
            }
            return r;
        }, w3 = (e, n, r)=>{
            if (r ?? (r = 2147483647), 2 > r) return 0;
            r -= 2;
            var a = n;
            r = r < 2 * e.length ? r / 2 : e.length;
            for(var o = 0; o < r; ++o)t1[n >> 1] = e.charCodeAt(o), n += 2;
            return t1[n >> 1] = 0, n - a;
        }, E3 = (e)=>2 * e.length, S3 = (e, n)=>{
            for(var r = 0, a = ""; !(r >= n / 4);){
                var o = Y[e + 4 * r >> 2];
                if (o == 0) break;
                ++r, 65536 <= o ? (o -= 65536, a += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023)) : a += String.fromCharCode(o);
            }
            return a;
        }, I3 = (e, n, r)=>{
            if (r ?? (r = 2147483647), 4 > r) return 0;
            var a = n;
            r = a + r - 4;
            for(var o = 0; o < e.length; ++o){
                var u = e.charCodeAt(o);
                if (55296 <= u && 57343 >= u) {
                    var h = e.charCodeAt(++o);
                    u = 65536 + ((u & 1023) << 10) | h & 1023;
                }
                if (Y[n >> 2] = u, n += 4, n + 4 > r) break;
            }
            return Y[n >> 2] = 0, n - a;
        }, P3 = (e)=>{
            for(var n = 0, r = 0; r < e.length; ++r){
                var a = e.charCodeAt(r);
                55296 <= a && 57343 >= a && ++r, n += 4;
            }
            return n;
        }, Y1 = 0, D2 = (e, n, r)=>{
            var a = [];
            return e = e.toWireType(a, r), a.length && (C[n >> 2] = P1(a)), e;
        }, X1 = [], O3 = (e)=>{
            var n = X1.length;
            return X1.push(e), n;
        }, T3 = (e, n)=>{
            for(var r = Array(e), a = 0; a < e; ++a)r[a] = O1(C[n + 4 * a >> 2], "parameter " + a);
            return r;
        }, A3 = Reflect.construct, v1 = {}, k2 = (e)=>{
            if (!(e instanceof b2 || e == "unwind")) throw e;
        }, R2 = (e)=>{
            throw R1 = e, z1 || 0 < Y1 || (s.onExit?.(e), b1 = true), new b2(e);
        }, F3 = (e)=>{
            if (!b1) try {
                if (e(), !(z1 || 0 < Y1)) try {
                    R1 = e = R1, R2(e);
                } catch (n) {
                    k2(n);
                }
            } catch (n) {
                k2(n);
            }
        }, Q1 = {}, B2 = ()=>{
            if (!Z1) {
                var e = {
                    USER: "web_user",
                    LOGNAME: "web_user",
                    PATH: "/",
                    PWD: "/",
                    HOME: "/home/web_user",
                    LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                    _: m1 || "./this.program"
                }, n;
                for(n in Q1)Q1[n] === void 0 ? delete e[n] : e[n] = Q1[n];
                var r = [];
                for(n in e)r.push(`${n}=${e[n]}`);
                Z1 = r;
            }
            return Z1;
        }, Z1, x3 = ()=>{
            if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") return (e)=>crypto.getRandomValues(e);
            y1("initRandomDevice");
        }, U2 = (e)=>(U2 = x3())(e);
        h1 = s.InternalError = class extends Error {
            constructor(e){
                super(e), this.name = "InternalError";
            }
        };
        for(var z2 = Array(256), T1 = 0; 256 > T1; ++T1)z2[T1] = String.fromCharCode(T1);
        C2 = z2, m = s.BindingError = class extends Error {
            constructor(e){
                super(e), this.name = "BindingError";
            }
        }, Object.assign(S1.prototype, {
            isAliasOf: function(e) {
                if (!(this instanceof S1 && e instanceof S1)) return false;
                var n = this.Aa.Da.Ba, r = this.Aa.Ca;
                e.Aa = e.Aa;
                var a = e.Aa.Da.Ba;
                for(e = e.Aa.Ca; n.Ga;)r = n.Qa(r), n = n.Ga;
                for(; a.Ga;)e = a.Qa(e), a = a.Ga;
                return n === a && r === e;
            },
            clone: function() {
                if (this.Aa.Ca || $1(this), this.Aa.Pa) return this.Aa.count.value += 1, this;
                var e = c1, n = Object, r = n.create, a = Object.getPrototypeOf(this), o = this.Aa;
                return e = e(r.call(n, a, {
                    Aa: {
                        value: {
                            count: o.count,
                            Oa: o.Oa,
                            Pa: o.Pa,
                            Ca: o.Ca,
                            Da: o.Da,
                            Fa: o.Fa,
                            Ha: o.Ha
                        }
                    }
                })), e.Aa.count.value += 1, e.Aa.Oa = false, e;
            },
            delete () {
                if (this.Aa.Ca || $1(this), this.Aa.Oa && !this.Aa.Pa) throw new m("Object already scheduled for deletion");
                w2(this);
                var e = this.Aa;
                --e.count.value, e.count.value === 0 && (e.Fa ? e.Ha.Ka(e.Fa) : e.Da.Ba.Ka(e.Ca)), this.Aa.Pa || (this.Aa.Fa = void 0, this.Aa.Ca = void 0);
            },
            isDeleted: function() {
                return !this.Aa.Ca;
            },
            deleteLater: function() {
                if (this.Aa.Ca || $1(this), this.Aa.Oa && !this.Aa.Pa) throw new m("Object already scheduled for deletion");
                return this.Aa.Oa = true, this;
            }
        }), Object.assign(p1.prototype, {
            cb (e) {
                return this.Ya && (e = this.Ya(e)), e;
            },
            Wa (e) {
                this.Ka?.(e);
            },
            Ia: 8,
            readValueFromPointer: d1,
            fromWireType: function(e) {
                function n() {
                    return this.Sa ? E1(this.Ba.Ma, {
                        Da: this.ib,
                        Ca: r,
                        Ha: this,
                        Fa: e
                    }) : E1(this.Ba.Ma, {
                        Da: this,
                        Ca: e
                    });
                }
                var r = this.cb(e);
                if (!r) return this.Wa(e), null;
                var a = d3(this.Ba, r);
                if (a !== void 0) return a.Aa.count.value === 0 ? (a.Aa.Ca = r, a.Aa.Fa = e, a.clone()) : (a = a.clone(), this.Wa(e), a);
                if (a = this.Ba.bb(r), a = S2[a], !a) return n.call(this);
                a = this.Ra ? a.Za : a.pointerType;
                var o = E2(r, this.Ba, a.Ba);
                return o === null ? n.call(this) : this.Sa ? E1(a.Ba.Ma, {
                    Da: a,
                    Ca: o,
                    Ha: this,
                    Fa: e
                }) : E1(a.Ba.Ma, {
                    Da: a,
                    Ca: o
                });
            }
        }), O2 = s.UnboundTypeError = ((e, n)=>{
            var r = l1(n, function(a) {
                this.name = n, this.message = a, a = Error(a).stack, a !== void 0 && (this.stack = this.toString() + `
` + a.replace(/^Error(:[^\n]*)?\n/, ""));
            });
            return r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.prototype.toString = function() {
                return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
            }, r;
        })(Error, "UnboundTypeError"), V.push(0, 1, void 0, 1, null, 1, true, 1, false, 1), s.count_emval_handles = ()=>V.length / 2 - 5 - J1.length;
        var D3 = {
            c: (e, n, r, a)=>y1(`Assertion failed: ${e ? L1(e) : ""}, at: ` + [
                    n ? n ? L1(n) : "" : "unknown filename",
                    r,
                    a ? a ? L1(a) : "" : "unknown function"
                ]),
            j: (e, n, r)=>{
                var a = new a3(e);
                throw C[a.Ca + 16 >> 2] = 0, C[a.Ca + 4 >> 2] = n, C[a.Ca + 8 >> 2] = r, L2 = e, L2;
            },
            P: ()=>{},
            M: ()=>{},
            N: ()=>{},
            R: function() {},
            O: ()=>{},
            T: ()=>y1(""),
            w: (e)=>{
                var n = C1[e];
                delete C1[e];
                var r = n.Ua, a = n.Ka, o = n.Xa, u = o.map((h)=>h.gb).concat(o.map((h)=>h.mb));
                J([
                    e
                ], u, (h)=>{
                    var d = {};
                    return o.forEach((p, _)=>{
                        var f = h[_], M = p.eb, b = p.fb, D = h[_ + o.length], w = p.lb, S = p.nb;
                        d[p.ab] = {
                            read: (U)=>f.fromWireType(M(b, U)),
                            write: (U, f1)=>{
                                var k = [];
                                w(S, U, D.toWireType(k, f1)), W1(k);
                            }
                        };
                    }), [
                        {
                            name: n.name,
                            fromWireType: (p)=>{
                                var _ = {}, f;
                                for(f in d)_[f] = d[f].read(p);
                                return a(p), _;
                            },
                            toWireType: (p, _)=>{
                                for(var f in d)if (!(f in _)) throw new TypeError(`Missing field: "${f}"`);
                                var M = r();
                                for(f in d)d[f].write(M, _[f]);
                                return p !== null && p.push(a, M), M;
                            },
                            Ia: 8,
                            readValueFromPointer: d1,
                            Ja: a
                        }
                    ];
                });
            },
            F: ()=>{},
            _: (e, n, r, a)=>{
                n = I(n), B(e, {
                    name: n,
                    fromWireType: function(o) {
                        return !!o;
                    },
                    toWireType: function(o, u) {
                        return u ? r : a;
                    },
                    Ia: 8,
                    readValueFromPointer: function(o) {
                        return this.fromWireType(F[o]);
                    },
                    Ja: null
                });
            },
            m: (e, n, r, a, o, u, h, d, p, _, f, M, b)=>{
                f = I(f), u = P(o, u), d && (d = P(h, d)), _ && (_ = P(p, _)), b = P(M, b);
                var D = c3(f);
                j1(D, function() {
                    I1(`Cannot construct ${f} due to unbound types`, [
                        a
                    ]);
                }), J([
                    e,
                    n,
                    r
                ], a ? [
                    a
                ] : [], (w)=>{
                    if (w = w[0], a) var S = w.Ba, U = S.Ma;
                    else U = S1.prototype;
                    w = l1(f, function(...t2) {
                        if (Object.getPrototypeOf(this) !== f1) throw new m("Use 'new' to construct " + f);
                        if (k.La === void 0) throw new m(f + " has no accessible constructor");
                        var j2 = k.La[t2.length];
                        if (j2 === void 0) throw new m(`Tried to invoke ctor of ${f} with invalid number of parameters (${t2.length}) - expected (${Object.keys(k.La).toString()}) parameters instead!`);
                        return j2.apply(this, t2);
                    });
                    var f1 = Object.create(U, {
                        constructor: {
                            value: w
                        }
                    });
                    w.prototype = f1;
                    var k = new l3(f, w, f1, b, S, u, d, _);
                    if (k.Ga) {
                        var _1;
                        (_1 = k.Ga).Va ?? (_1.Va = []), k.Ga.Va.push(k);
                    }
                    return S = new p1(f, k, true, false, false), _1 = new p1(f + "*", k, false, false, false), U = new p1(f + " const*", k, false, true, false), S2[e] = {
                        pointerType: _1,
                        Za: U
                    }, P2(D, w), [
                        S,
                        _1,
                        U
                    ];
                });
            },
            r: (e, n, r, a, o, u)=>{
                var h = N1(n, r);
                o = P(a, o), J([], [
                    e
                ], (d)=>{
                    d = d[0];
                    var p = `constructor ${d.name}`;
                    if (d.Ba.La === void 0 && (d.Ba.La = []), d.Ba.La[n - 1] !== void 0) throw new m(`Cannot register multiple constructors with identical number of parameters (${n - 1}) for class '${d.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                    return d.Ba.La[n - 1] = ()=>{
                        I1(`Cannot construct ${d.name} due to unbound types`, h);
                    }, J([], h, (_)=>(_.splice(1, 0, null), d.Ba.La[n - 1] = G1(p, _, null, o, u), [])), [];
                });
            },
            d: (e, n, r, a, o, u, h, d)=>{
                var p = N1(r, a);
                n = I(n), n = A2(n), u = P(o, u), J([], [
                    e
                ], (_)=>{
                    function f() {
                        I1(`Cannot call ${M} due to unbound types`, p);
                    }
                    _ = _[0];
                    var M = `${_.name}.${n}`;
                    n.startsWith("@@") && (n = Symbol[n.substring(2)]), d && _.Ba.jb.push(n);
                    var b = _.Ba.Ma, D = b[n];
                    return D === void 0 || D.Ea === void 0 && D.className !== _.name && D.Na === r - 2 ? (f.Na = r - 2, f.className = _.name, b[n] = f) : (I2(b, n, M), b[n].Ea[r - 2] = f), J([], p, (w)=>(w = G1(M, w, _, u, h), b[n].Ea === void 0 ? (w.Na = r - 2, b[n] = w) : b[n].Ea[r - 2] = w, [])), [];
                });
            },
            Y: (e)=>B(e, F2),
            D: (e, n, r, a)=>{
                function o() {}
                n = I(n), o.values = {}, B(e, {
                    name: n,
                    constructor: o,
                    fromWireType: function(u) {
                        return this.constructor.values[u];
                    },
                    toWireType: (u, h)=>h.value,
                    Ia: 8,
                    readValueFromPointer: M3(n, r, a),
                    Ja: null
                }), j1(n, o);
            },
            l: (e, n, r)=>{
                var a = O1(e, "enum");
                n = I(n), e = a.constructor, a = Object.create(a.constructor.prototype, {
                    value: {
                        value: r
                    },
                    constructor: {
                        value: l1(`${a.name}_${n}`, function() {})
                    }
                }), e.values[r] = a, e[n] = a;
            },
            A: (e, n, r)=>{
                n = I(n), B(e, {
                    name: n,
                    fromWireType: (a)=>a,
                    toWireType: (a, o)=>o,
                    Ia: 8,
                    readValueFromPointer: b3(n, r),
                    Ja: null
                });
            },
            v: (e, n, r, a, o, u)=>{
                var h = N1(n, r);
                e = I(e), e = A2(e), o = P(a, o), j1(e, function() {
                    I1(`Cannot call ${e} due to unbound types`, h);
                }, n - 1), J([], h, (d)=>(P2(e, G1(e, [
                        d[0],
                        null
                    ].concat(d.slice(1)), null, o, u), n - 1), []));
            },
            n: (e, n, r, a, o)=>{
                if (n = I(n), o === -1 && (o = 4294967295), o = (d)=>d, a === 0) {
                    var u = 32 - 8 * r;
                    o = (d)=>d << u >>> u;
                }
                var h = n.includes("unsigned") ? function(d, p) {
                    return p >>> 0;
                } : function(d, p) {
                    return p;
                };
                B(e, {
                    name: n,
                    fromWireType: o,
                    toWireType: h,
                    Ia: 8,
                    readValueFromPointer: y3(n, r, a !== 0),
                    Ja: null
                });
            },
            g: (e, n, r)=>{
                function a(u) {
                    return new o(e1.buffer, C[u + 4 >> 2], C[u >> 2]);
                }
                var o = [
                    Int8Array,
                    Uint8Array,
                    Int16Array,
                    Uint16Array,
                    Int32Array,
                    Uint32Array,
                    Float32Array,
                    Float64Array
                ][n];
                r = I(r), B(e, {
                    name: r,
                    fromWireType: a,
                    Ia: 8,
                    readValueFromPointer: a
                }, {
                    hb: true
                });
            },
            q: (e)=>{
                B(e, L3);
            },
            u: (e, n, r, a, o, u, h, d, p, _, f, M)=>{
                r = I(r), u = P(o, u), d = P(h, d), _ = P(p, _), M = P(f, M), J([
                    e
                ], [
                    n
                ], (b)=>(b = b[0], [
                        new p1(r, b.Ba, false, false, true, b, a, u, d, _, M)
                    ]));
            },
            Z: (e, n)=>{
                n = I(n), B(e, {
                    name: n,
                    fromWireType: function(r) {
                        for(var a = C[r >> 2], o = r + 4, u, h = o, d = 0; d <= a; ++d){
                            var p = o + d;
                            (d == a || F[p] == 0) && (h = h ? L1(h, p - h) : "", u === void 0 ? u = h : (u += "\0", u += h), h = p + 1);
                        }
                        return N(r), u;
                    },
                    toWireType: function(r, a) {
                        a instanceof ArrayBuffer && (a = new Uint8Array(a));
                        var o, u = typeof a == "string";
                        if (!(u || a instanceof Uint8Array || a instanceof Uint8ClampedArray || a instanceof Int8Array)) throw new m("Cannot pass non-string to std::string");
                        if (u) for(var h = o = 0; h < a.length; ++h){
                            var d = a.charCodeAt(h);
                            127 >= d ? o++ : 2047 >= d ? o += 2 : 55296 <= d && 57343 >= d ? (o += 4, ++h) : o += 3;
                        }
                        else o = a.length;
                        if (h = e2(4 + o + 1), d = h + 4, C[h >> 2] = o, u) u1(a, d, o + 1);
                        else if (u) for(u = 0; u < o; ++u){
                            var p = a.charCodeAt(u);
                            if (255 < p) throw N(d), new m("String has UTF-16 code units that do not fit in 8 bits");
                            F[d + u] = p;
                        }
                        else for(u = 0; u < o; ++u)F[d + u] = a[u];
                        return r !== null && r.push(N, h), h;
                    },
                    Ia: 8,
                    readValueFromPointer: d1,
                    Ja (r) {
                        N(r);
                    }
                });
            },
            y: (e, n, r)=>{
                if (r = I(r), n === 2) var a = C3, o = w3, u = E3, h = (d)=>s1[d >> 1];
                else n === 4 && (a = S3, o = I3, u = P3, h = (d)=>C[d >> 2]);
                B(e, {
                    name: r,
                    fromWireType: (d)=>{
                        for(var p = C[d >> 2], _, f = d + 4, M = 0; M <= p; ++M){
                            var b = d + 4 + M * n;
                            (M == p || h(b) == 0) && (f = a(f, b - f), _ === void 0 ? _ = f : (_ += "\0", _ += f), f = b + n);
                        }
                        return N(d), _;
                    },
                    toWireType: (d, p)=>{
                        if (typeof p != "string") throw new m(`Cannot pass non-string to C++ string type ${r}`);
                        var _ = u(p), f = e2(4 + _ + n);
                        return C[f >> 2] = _ / n, o(p, f + 4, _ + n), d !== null && d.push(N, f), f;
                    },
                    Ia: 8,
                    readValueFromPointer: d1,
                    Ja (d) {
                        N(d);
                    }
                });
            },
            x: (e, n, r, a, o, u)=>{
                C1[e] = {
                    name: I(n),
                    Ua: P(r, a),
                    Ka: P(o, u),
                    Xa: []
                };
            },
            i: (e, n, r, a, o, u, h, d, p, _)=>{
                C1[e].Xa.push({
                    ab: I(n),
                    gb: r,
                    eb: P(a, o),
                    fb: u,
                    mb: h,
                    lb: P(d, p),
                    nb: _
                });
            },
            $: (e, n)=>{
                n = I(n), B(e, {
                    pb: true,
                    name: n,
                    Ia: 0,
                    fromWireType: ()=>{},
                    toWireType: ()=>{}
                });
            },
            K: ()=>{
                z1 = false, Y1 = 0;
            },
            I: ()=>{
                throw 1 / 0;
            },
            C: (e, n, r)=>(e = i1(e), n = O1(n, "emval::as"), D2(n, r, e)),
            p: (e, n, r, a)=>(e = X1[e], n = i1(n), e(null, n, r, a)),
            W: q1,
            E: (e, n)=>(e = i1(e), n = i1(n), e == n),
            o: (e, n, r)=>{
                var a = T3(e, n), o = a.shift();
                e--;
                var u = Array(e);
                return n = `methodCaller<(${a.map((h)=>h.name).join(", ")}) => ${o.name}>`, O3(l1(n, (h, d, p, _)=>{
                    for(var f = 0, M = 0; M < e; ++M)u[M] = a[M].readValueFromPointer(_ + f), f += a[M].Ia;
                    return h = r === 1 ? A3(d, u) : d.apply(h, u), D2(o, p, h);
                }));
            },
            z: (e)=>{
                9 < e && (V[e + 1] += 1);
            },
            ca: (e)=>{
                var n = i1(e);
                W1(n), q1(e);
            },
            t: (e, n)=>(e = O1(e, "_emval_take_value"), e = e.readValueFromPointer(n), P1(e)),
            G: (e, n)=>{
                if (v1[e] && (clearTimeout(v1[e].id), delete v1[e]), !n) return 0;
                var r = setTimeout(()=>{
                    delete v1[e], F3(()=>$2(e, performance.now()));
                }, n);
                return v1[e] = {
                    id: r,
                    qb: n
                }, 0;
            },
            H: (e, n, r, a)=>{
                var o = new Date().getFullYear(), u = new Date(o, 0, 1).getTimezoneOffset();
                o = new Date(o, 6, 1).getTimezoneOffset(), C[e >> 2] = 60 * Math.max(u, o), Y[n >> 2] = +(u != o), n = (h)=>{
                    var d = Math.abs(h);
                    return `UTC${0 <= h ? "-" : "+"}${String(Math.floor(d / 60)).padStart(2, "0")}${String(d % 60).padStart(2, "0")}`;
                }, e = n(u), n = n(o), o < u ? (u1(e, r, 17), u1(n, a, 17)) : (u1(e, a, 17), u1(n, r, 17));
            },
            ba: ()=>performance.now(),
            J: (e)=>{
                var n = F.length;
                if (e >>>= 0, 2147483648 < e) return false;
                for(var r = 1; 4 >= r; r *= 2){
                    var a = n * (1 + .2 / r);
                    a = Math.min(a, e + 100663296);
                    e: {
                        a = (Math.min(2147483648, 65536 * Math.ceil(Math.max(e, a) / 65536)) - M1.buffer.byteLength + 65535) / 65536 | 0;
                        try {
                            M1.grow(a), f2();
                            var o = 1;
                            break e;
                        } catch  {}
                        o = void 0;
                    }
                    if (o) return true;
                }
                return false;
            },
            V: (e, n)=>{
                var r = 0;
                return B2().forEach((a, o)=>{
                    var u = n + r;
                    for(o = C[e + 4 * o >> 2] = u, u = 0; u < a.length; ++u)e1[o++] = a.charCodeAt(u);
                    e1[o] = 0, r += a.length + 1;
                }), 0;
            },
            X: (e, n)=>{
                var r = B2();
                C[e >> 2] = r.length;
                var a = 0;
                return r.forEach((o)=>a += o.length + 1), C[n >> 2] = a, 0;
            },
            S: ()=>52,
            Q: ()=>52,
            k: k3,
            f: H3,
            e: z3,
            B: R3,
            aa: j3,
            a: B3,
            b: W3,
            h: U3,
            s: $3,
            U: R2,
            L: (e, n)=>(U2(F.subarray(e, e + n)), 0)
        }, y;
        (async function() {
            function e(a) {
                return y = a.exports, M1 = y.da, f2(), R = y.ga, m2.unshift(y.ea), X--, s.monitorRunDependencies?.(X), X == 0 && o1 && (a = o1, o1 = null, a()), y;
            }
            X++, s.monitorRunDependencies?.(X);
            var n = {
                a: D3
            };
            if (s.instantiateWasm) try {
                return s.instantiateWasm(n, e);
            } catch (a) {
                a1(`Module.instantiateWasm callback failed with error: ${a}`), L(a);
            }
            B1 ?? (B1 = M2("DotLottiePlayer.wasm") ? "DotLottiePlayer.wasm" : s.locateFile ? s.locateFile("DotLottiePlayer.wasm", A) : A + "DotLottiePlayer.wasm");
            try {
                var r = await r3(n);
                return e(r.instance), r;
            } catch (a) {
                L(a);
            }
        })();
        var e2 = (e)=>(e2 = y.fa)(e), N = (e)=>(N = y.ha)(e), W2 = (e)=>(W2 = y.ia)(e), $2 = (e, n)=>($2 = y.ja)(e, n), W = (e, n)=>(W = y.ka)(e, n), $ = (e)=>($ = y.la)(e), H = ()=>(H = y.ma)();
        s.dynCall_jiii = (e, n, r, a)=>(s.dynCall_jiii = y.na)(e, n, r, a), s.dynCall_jii = (e, n, r)=>(s.dynCall_jii = y.oa)(e, n, r), s.dynCall_vjii = (e, n, r, a, o)=>(s.dynCall_vjii = y.pa)(e, n, r, a, o), s.dynCall_vjfii = (e, n, r, a, o, u)=>(s.dynCall_vjfii = y.qa)(e, n, r, a, o, u), s.dynCall_vjiii = (e, n, r, a, o, u)=>(s.dynCall_vjiii = y.ra)(e, n, r, a, o, u), s.dynCall_vj = (e, n, r)=>(s.dynCall_vj = y.sa)(e, n, r), s.dynCall_vjiiiii = (e, n, r, a, o, u, h, d)=>(s.dynCall_vjiiiii = y.ta)(e, n, r, a, o, u, h, d), s.dynCall_vjiffii = (e, n, r, a, o, u, h, d)=>(s.dynCall_vjiffii = y.ua)(e, n, r, a, o, u, h, d), s.dynCall_vjiiii = (e, n, r, a, o, u, h)=>(s.dynCall_vjiiii = y.va)(e, n, r, a, o, u, h), s.dynCall_viijii = (e, n, r, a, o, u, h)=>(s.dynCall_viijii = y.wa)(e, n, r, a, o, u, h), s.dynCall_iiiiij = (e, n, r, a, o, u, h)=>(s.dynCall_iiiiij = y.xa)(e, n, r, a, o, u, h), s.dynCall_iiiiijj = (e, n, r, a, o, u, h, d, p)=>(s.dynCall_iiiiijj = y.ya)(e, n, r, a, o, u, h, d, p), s.dynCall_iiiiiijj = (e, n, r, a, o, u, h, d, p, _)=>(s.dynCall_iiiiiijj = y.za)(e, n, r, a, o, u, h, d, p, _);
        function k3(e, n) {
            var r = H();
            try {
                return R.get(e)(n);
            } catch (a) {
                if ($(r), a !== a + 0) throw a;
                W(1, 0);
            }
        }
        function R3(e, n, r, a, o, u) {
            var h = H();
            try {
                return R.get(e)(n, r, a, o, u);
            } catch (d) {
                if ($(h), d !== d + 0) throw d;
                W(1, 0);
            }
        }
        function B3(e, n) {
            var r = H();
            try {
                R.get(e)(n);
            } catch (a) {
                if ($(r), a !== a + 0) throw a;
                W(1, 0);
            }
        }
        function U3(e, n, r, a) {
            var o = H();
            try {
                R.get(e)(n, r, a);
            } catch (u) {
                if ($(o), u !== u + 0) throw u;
                W(1, 0);
            }
        }
        function z3(e, n, r, a) {
            var o = H();
            try {
                return R.get(e)(n, r, a);
            } catch (u) {
                if ($(o), u !== u + 0) throw u;
                W(1, 0);
            }
        }
        function W3(e, n, r) {
            var a = H();
            try {
                R.get(e)(n, r);
            } catch (o) {
                if ($(a), o !== o + 0) throw o;
                W(1, 0);
            }
        }
        function $3(e, n, r, a, o) {
            var u = H();
            try {
                R.get(e)(n, r, a, o);
            } catch (h) {
                if ($(u), h !== h + 0) throw h;
                W(1, 0);
            }
        }
        function H3(e, n, r) {
            var a = H();
            try {
                return R.get(e)(n, r);
            } catch (o) {
                if ($(a), o !== o + 0) throw o;
                W(1, 0);
            }
        }
        function j3(e) {
            var n = H();
            try {
                R.get(e)();
            } catch (r) {
                if ($(n), r !== r + 0) throw r;
                W(1, 0);
            }
        }
        var A1;
        o1 = function e() {
            A1 || H2(), A1 || (o1 = e);
        };
        function H2() {
            function e() {
                if (!A1 && (A1 = true, s.calledRun = true, !b1)) {
                    if (U1(m2), c(s), s.onRuntimeInitialized?.(), s.postRun) for(typeof s.postRun == "function" && (s.postRun = [
                        s.postRun
                    ]); s.postRun.length;){
                        var n = s.postRun.shift();
                        g2.unshift(n);
                    }
                    U1(g2);
                }
            }
            if (!(0 < X)) {
                if (s.preRun) for(typeof s.preRun == "function" && (s.preRun = [
                    s.preRun
                ]); s.preRun.length;)t3();
                U1(_2), 0 < X || (s.setStatus ? (s.setStatus("Running..."), setTimeout(()=>{
                    setTimeout(()=>s.setStatus(""), 1), e();
                }, 1)) : e());
            }
        }
        if (s.preInit) for(typeof s.preInit == "function" && (s.preInit = [
            s.preInit
        ]); 0 < s.preInit.length;)s.preInit.pop()();
        return H2(), i = z, i;
    };
})(), $37d251801dc1953a$var$J2 = $37d251801dc1953a$var$G3;
var $37d251801dc1953a$var$Z = class {
    constructor(){
        throw new Error("RendererLoader is a static class and cannot be instantiated.");
    }
    static async _tryLoad(t) {
        return await $37d251801dc1953a$var$J2({
            locateFile: ()=>t
        });
    }
    static async _loadWithBackup() {
        return this._ModulePromise || (this._ModulePromise = this._tryLoad(this._wasmURL).catch(async (t)=>{
            let i = `https://unpkg.com/${$37d251801dc1953a$var$a2}@${$37d251801dc1953a$var$r2}/dist/dotlottie-player.wasm`;
            console.warn(`Primary WASM load failed from ${this._wasmURL}. Error: ${t.message}`), console.warn(`Attempting to load WASM from backup URL: ${i}`);
            try {
                return await this._tryLoad(i);
            } catch (s) {
                throw console.error(`Primary WASM URL failed: ${t.message}`), console.error(`Backup WASM URL failed: ${s.message}`), new Error("WASM loading failed from all sources.");
            }
        })), this._ModulePromise;
    }
    static async load() {
        return this._loadWithBackup();
    }
    static setWasmUrl(t) {
        t !== this._wasmURL && (this._wasmURL = t, this._ModulePromise = null);
    }
};
$37d251801dc1953a$var$v($37d251801dc1953a$var$Z, "_ModulePromise", null), $37d251801dc1953a$var$v($37d251801dc1953a$var$Z, "_wasmURL", `https://cdn.jsdelivr.net/npm/${$37d251801dc1953a$var$a2}@${$37d251801dc1953a$var$r2}/dist/dotlottie-player.wasm`);
var $37d251801dc1953a$var$r1 = class {
    constructor(){
        $37d251801dc1953a$var$v(this, "_eventListeners", new Map);
    }
    addEventListener(t, i) {
        let s = this._eventListeners.get(t);
        s || (s = new Set, this._eventListeners.set(t, s)), s.add(i);
    }
    removeEventListener(t, i) {
        let s = this._eventListeners.get(t);
        s && (i ? (s.delete(i), s.size === 0 && this._eventListeners.delete(t)) : this._eventListeners.delete(t));
    }
    dispatch(t) {
        this._eventListeners.get(t.type)?.forEach((s)=>s(t));
    }
    removeAllEventListeners() {
        this._eventListeners.clear();
    }
};
var $37d251801dc1953a$var$O = class {
    static _initializeObserver() {
        if (this._observer) return;
        let t = (i)=>{
            i.forEach((s)=>{
                let c = this._observedCanvases.get(s.target);
                c && (s.isIntersecting ? c.unfreeze() : c.freeze());
            });
        };
        this._observer = new IntersectionObserver(t, {
            threshold: 0
        });
    }
    static observe(t, i) {
        this._initializeObserver(), !this._observedCanvases.has(t) && (this._observedCanvases.set(t, i), this._observer?.observe(t));
    }
    static unobserve(t) {
        this._observer?.unobserve(t), this._observedCanvases.delete(t), this._observedCanvases.size === 0 && (this._observer?.disconnect(), this._observer = null);
    }
};
$37d251801dc1953a$var$v($37d251801dc1953a$var$O, "_observer", null), $37d251801dc1953a$var$v($37d251801dc1953a$var$O, "_observedCanvases", new Map);
var $37d251801dc1953a$var$T = class {
    static _initializeObserver() {
        if (this._observer) return;
        let t = (i)=>{
            i.forEach((s)=>{
                let c = this._observedCanvases.get(s.target);
                if (!c) return;
                let [L, z] = c;
                clearTimeout(z);
                let K = setTimeout(()=>{
                    L.resize();
                }, 100);
                this._observedCanvases.set(s.target, [
                    L,
                    K
                ]);
            });
        };
        this._observer = new ResizeObserver(t);
    }
    static observe(t, i) {
        this._initializeObserver(), !this._observedCanvases.has(t) && (this._observedCanvases.set(t, [
            i,
            0
        ]), this._observer?.observe(t));
    }
    static unobserve(t) {
        let i = this._observedCanvases.get(t);
        if (i) {
            let s = i[1];
            s && clearTimeout(s);
        }
        this._observer?.unobserve(t), this._observedCanvases.delete(t), !this._observedCanvases.size && this._observer && (this._observer.disconnect(), this._observer = null);
    }
};
$37d251801dc1953a$var$v($37d251801dc1953a$var$T, "_observer", null), $37d251801dc1953a$var$v($37d251801dc1953a$var$T, "_observedCanvases", new Map);
function $37d251801dc1953a$var$J3(l) {
    return /^#([\da-f]{6}|[\da-f]{8})$/iu.test(l);
}
function $37d251801dc1953a$var$K2(l) {
    if (!$37d251801dc1953a$var$J3(l)) return 0;
    let t = l.replace("#", "");
    return t = t.length === 6 ? `${t}ff` : t, parseInt(t, 16);
}
function $37d251801dc1953a$var$s2(l) {
    if (l.byteLength < 4) return false;
    let t = new Uint8Array(l.slice(0, $37d251801dc1953a$var$x1.byteLength));
    for(let i = 0; i < $37d251801dc1953a$var$x1.length; i += 1)if ($37d251801dc1953a$var$x1[i] !== t[i]) return false;
    return true;
}
function $37d251801dc1953a$var$q2(l) {
    return $37d251801dc1953a$var$V2.every((t)=>Object.prototype.hasOwnProperty.call(l, t));
}
function $37d251801dc1953a$var$o2(l) {
    if (typeof l == "string") try {
        return $37d251801dc1953a$var$q2(JSON.parse(l));
    } catch  {
        return false;
    }
    else return $37d251801dc1953a$var$q2(l);
}
function $37d251801dc1953a$var$G() {
    return 1 + (($37d251801dc1953a$var$E ? window.devicePixelRatio : 1) - 1) * $37d251801dc1953a$var$N2;
}
function $37d251801dc1953a$var$q(l) {
    let t = l.getBoundingClientRect(), i = window.innerHeight || document.documentElement.clientHeight, s = window.innerWidth || document.documentElement.clientWidth;
    return !(t.bottom < 0 || t.top > i || t.right < 0 || t.left > s);
}
function $37d251801dc1953a$var$x(l) {
    let t = l.target;
    if (t instanceof HTMLCanvasElement) {
        let i = t.getBoundingClientRect();
        if (i.width === 0 || i.height === 0 || t.width === 0 || t.height === 0) return null;
        let s = t.width / i.width, c = t.height / i.height, L = (l.clientX - i.left) * s, z = (l.clientY - i.top) * c;
        return !Number.isFinite(L) || !Number.isFinite(z) || Number.isNaN(L) || Number.isNaN(z) ? null : {
            x: L,
            y: z
        };
    }
    return null;
}
function $37d251801dc1953a$var$D1(l) {
    let t = l.replace("OpenUrl: ", ""), i = t.indexOf(" | Target: "), s, c;
    i === -1 ? (s = t, c = "_blank") : (s = t.substring(0, i), c = t.substring(i + 11)), window.open(s, c);
}
var $37d251801dc1953a$var$u2 = (l, t)=>l === "reverse" ? t.Mode.Reverse : l === "bounce" ? t.Mode.Bounce : l === "reverse-bounce" ? t.Mode.ReverseBounce : t.Mode.Forward, $37d251801dc1953a$var$q3 = (l, t)=>l === "contain" ? t.Fit.Contain : l === "cover" ? t.Fit.Cover : l === "fill" ? t.Fit.Fill : l === "fit-height" ? t.Fit.FitHeight : l === "fit-width" ? t.Fit.FitWidth : t.Fit.None, $37d251801dc1953a$var$K3 = (l, t)=>{
    let i = new t.VectorFloat;
    return i.push_back(l[0]), i.push_back(l[1]), i;
}, $37d251801dc1953a$var$d2 = (l, t)=>{
    let i = new t.VectorFloat;
    return l.length !== 2 || (i.push_back(l[0]), i.push_back(l[1])), i;
}, $37d251801dc1953a$var$h2 = (l, t)=>l ? {
        align: $37d251801dc1953a$var$K3(l.align ?? [
            .5,
            .5
        ], t),
        fit: $37d251801dc1953a$var$q3(l.fit ?? "contain", t)
    } : t.createDefaultLayout(), $37d251801dc1953a$var$g = class g {
    constructor(t){
        $37d251801dc1953a$var$v(this, "_canvas");
        $37d251801dc1953a$var$v(this, "_context", null);
        $37d251801dc1953a$var$v(this, "_eventManager");
        $37d251801dc1953a$var$v(this, "_animationFrameId", null);
        $37d251801dc1953a$var$v(this, "_frameManager");
        $37d251801dc1953a$var$v(this, "_dotLottieCore", null);
        $37d251801dc1953a$var$v(this, "_stateMachineId", "");
        $37d251801dc1953a$var$v(this, "_stateMachineConfig", null);
        $37d251801dc1953a$var$v(this, "_isStateMachineRunning", false);
        $37d251801dc1953a$var$v(this, "_stateMachineObserverHandle", null);
        $37d251801dc1953a$var$v(this, "_stateMachineInternalMessageObserver", null);
        $37d251801dc1953a$var$v(this, "_dotLottieObserverHandle", null);
        $37d251801dc1953a$var$v(this, "_renderConfig", {});
        $37d251801dc1953a$var$v(this, "_isFrozen", false);
        $37d251801dc1953a$var$v(this, "_backgroundColor", null);
        $37d251801dc1953a$var$v(this, "_boundOnClick", null);
        $37d251801dc1953a$var$v(this, "_boundOnPointerUp", null);
        $37d251801dc1953a$var$v(this, "_boundOnPointerDown", null);
        $37d251801dc1953a$var$v(this, "_boundOnPointerMove", null);
        $37d251801dc1953a$var$v(this, "_boundOnPointerEnter", null);
        $37d251801dc1953a$var$v(this, "_boundOnPointerLeave", null);
        this._canvas = t.canvas, this._eventManager = new $37d251801dc1953a$var$r1, this._frameManager = new $37d251801dc1953a$var$F1, this._renderConfig = {
            ...t.renderConfig,
            devicePixelRatio: t.renderConfig?.devicePixelRatio || $37d251801dc1953a$var$G(),
            freezeOnOffscreen: t.renderConfig?.freezeOnOffscreen ?? true
        }, $37d251801dc1953a$var$Z.load().then((i)=>{
            g._wasmModule = i;
            let s = new i.CallbackObserver;
            s.setOnLoad(()=>{
                setTimeout(()=>{
                    this._eventManager.dispatch({
                        type: "load"
                    });
                }, 0);
            }), s.setOnLoadError(()=>{
                setTimeout(()=>{
                    this._eventManager.dispatch({
                        type: "loadError",
                        error: new Error("failed to load")
                    });
                }, 0);
            }), s.setOnPlay(()=>{
                setTimeout(()=>{
                    this._eventManager.dispatch({
                        type: "play"
                    });
                }, 0);
            }), s.setOnPause(()=>{
                setTimeout(()=>{
                    this._eventManager.dispatch({
                        type: "pause"
                    });
                }, 0);
            }), s.setOnStop(()=>{
                setTimeout(()=>{
                    this._eventManager.dispatch({
                        type: "stop"
                    });
                }, 0);
            }), s.setOnLoop((c)=>{
                setTimeout(()=>{
                    this._eventManager.dispatch({
                        type: "loop",
                        loopCount: c
                    });
                }, 0);
            }), s.setOnComplete(()=>{
                setTimeout(()=>{
                    this._eventManager.dispatch({
                        type: "complete"
                    });
                }, 0);
            }), s.setOnFrame((c)=>{
                setTimeout(()=>{
                    this._eventManager.dispatch({
                        type: "frame",
                        currentFrame: c
                    });
                }, 0);
            }), s.setOnRender((c)=>{
                setTimeout(()=>{
                    this._eventManager.dispatch({
                        type: "render",
                        currentFrame: c
                    });
                }, 0);
            }), this._dotLottieCore = new i.DotLottiePlayer({
                animationId: t.animationId ?? "",
                themeId: t.themeId ?? "",
                stateMachineId: "",
                autoplay: t.autoplay ?? false,
                backgroundColor: 0,
                loopAnimation: t.loop ?? false,
                mode: $37d251801dc1953a$var$u2(t.mode ?? "forward", i),
                segment: $37d251801dc1953a$var$d2(t.segment ?? [], i),
                speed: t.speed ?? 1,
                useFrameInterpolation: t.useFrameInterpolation ?? true,
                marker: t.marker ?? "",
                layout: $37d251801dc1953a$var$h2(t.layout, i)
            }), this._stateMachineId = t.stateMachineId ?? "", this._stateMachineConfig = t.stateMachineConfig ?? null, this._dotLottieObserverHandle = this._dotLottieCore.subscribe(s), this._eventManager.dispatch({
                type: "ready"
            }), t.data ? this._loadFromData(t.data) : t.src && this._loadFromSrc(t.src), t.backgroundColor && this.setBackgroundColor(t.backgroundColor);
        }).catch((i)=>{
            this._eventManager.dispatch({
                type: "loadError",
                error: new Error(`Failed to load wasm module: ${i}`)
            });
        });
    }
    _dispatchError(t) {
        console.error(t), this._eventManager.dispatch({
            type: "loadError",
            error: new Error(t)
        });
    }
    async _fetchData(t) {
        let i = await fetch(t);
        if (!i.ok) throw new Error(`Failed to fetch animation data from URL: ${t}. ${i.status}: ${i.statusText}`);
        let s = await i.arrayBuffer();
        return $37d251801dc1953a$var$s2(s) ? s : new TextDecoder().decode(s);
    }
    _loadFromData(t) {
        if (this._dotLottieCore === null) return;
        let i = this._canvas.width, s = this._canvas.height, c = false;
        if (typeof t == "string") {
            if (!$37d251801dc1953a$var$o2(t)) {
                this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
                return;
            }
            c = this._dotLottieCore.loadAnimationData(t, i, s);
        } else if (t instanceof ArrayBuffer) {
            if (!$37d251801dc1953a$var$s2(t)) {
                this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
                return;
            }
            c = this._dotLottieCore.loadDotLottieData(t, i, s);
        } else if (typeof t == "object") {
            if (!$37d251801dc1953a$var$o2(t)) {
                this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
                return;
            }
            c = this._dotLottieCore.loadAnimationData(JSON.stringify(t), i, s);
        } else {
            this._dispatchError(`Unsupported data type for animation data. Expected: 
          - string (Lottie JSON),
          - ArrayBuffer (dotLottie),
          - object (Lottie JSON). 
          Received: ${typeof t}`);
            return;
        }
        c && ($37d251801dc1953a$var$E && this.resize(), setTimeout(()=>{
            this._eventManager.dispatch({
                type: "frame",
                currentFrame: this.currentFrame
            });
        }, 0), this._dotLottieCore.render(), this._draw(), this._stateMachineId ? this.stateMachineLoad(this._stateMachineId) && this.stateMachineStart() && this._startAnimationLoop() : this._dotLottieCore.isPlaying() && this._startAnimationLoop(), $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && ($37d251801dc1953a$var$O.observe(this._canvas, this), $37d251801dc1953a$var$q(this._canvas) || this.freeze()), this._renderConfig.autoResize && $37d251801dc1953a$var$T.observe(this._canvas, this)));
    }
    _loadFromSrc(t) {
        this._fetchData(t).then((i)=>this._loadFromData(i)).catch((i)=>this._dispatchError(`Failed to load animation data from URL: ${t}. ${i}`));
    }
    get buffer() {
        return this._dotLottieCore ? this._dotLottieCore.buffer() : null;
    }
    get activeAnimationId() {
        return this._dotLottieCore?.activeAnimationId();
    }
    get activeThemeId() {
        return this._dotLottieCore?.activeThemeId();
    }
    get layout() {
        let t = this._dotLottieCore?.config().layout;
        if (t) return {
            align: [
                t.align.get(0),
                t.align.get(1)
            ],
            fit: (()=>{
                switch(t.fit){
                    case g._wasmModule?.Fit.Contain:
                        return "contain";
                    case g._wasmModule?.Fit.Cover:
                        return "cover";
                    case g._wasmModule?.Fit.Fill:
                        return "fill";
                    case g._wasmModule?.Fit.FitHeight:
                        return "fit-height";
                    case g._wasmModule?.Fit.FitWidth:
                        return "fit-width";
                    case g._wasmModule?.Fit.None:
                        return "none";
                    default:
                        return "contain";
                }
            })()
        };
    }
    get marker() {
        return this._dotLottieCore?.config().marker;
    }
    get manifest() {
        try {
            let t = this._dotLottieCore?.manifestString();
            if (this._dotLottieCore === null || !t) return null;
            let i = JSON.parse(t);
            return Object.keys(i).length === 0 ? null : i;
        } catch  {
            return null;
        }
    }
    get renderConfig() {
        return this._renderConfig;
    }
    get segment() {
        let t = this._dotLottieCore?.config().segment;
        if (t && t.size() === 2) return [
            t.get(0),
            t.get(1)
        ];
    }
    get loop() {
        return this._dotLottieCore?.config().loopAnimation ?? false;
    }
    get mode() {
        let t = this._dotLottieCore?.config().mode;
        return t === g._wasmModule?.Mode.Reverse ? "reverse" : t === g._wasmModule?.Mode.Bounce ? "bounce" : t === g._wasmModule?.Mode.ReverseBounce ? "reverse-bounce" : "forward";
    }
    get isFrozen() {
        return this._isFrozen;
    }
    get isStateMachineRunning() {
        return this._isStateMachineRunning;
    }
    get backgroundColor() {
        return this._backgroundColor ?? "";
    }
    get autoplay() {
        return this._dotLottieCore?.config().autoplay ?? false;
    }
    get useFrameInterpolation() {
        return this._dotLottieCore?.config().useFrameInterpolation ?? false;
    }
    get speed() {
        return this._dotLottieCore?.config().speed ?? 0;
    }
    get isReady() {
        return this._dotLottieCore !== null;
    }
    get isLoaded() {
        return this._dotLottieCore?.isLoaded() ?? false;
    }
    get isPlaying() {
        return this._dotLottieCore?.isPlaying() ?? false;
    }
    get isPaused() {
        return this._dotLottieCore?.isPaused() ?? false;
    }
    get isStopped() {
        return this._dotLottieCore?.isStopped() ?? false;
    }
    get currentFrame() {
        return this._dotLottieCore ? Math.round(this._dotLottieCore.currentFrame() * 100) / 100 : 0;
    }
    get loopCount() {
        return this._dotLottieCore?.loopCount() ?? 0;
    }
    get totalFrames() {
        return this._dotLottieCore?.totalFrames() ?? 0;
    }
    get duration() {
        return this._dotLottieCore?.duration() ?? 0;
    }
    get segmentDuration() {
        return this._dotLottieCore?.segmentDuration() ?? 0;
    }
    get canvas() {
        return this._canvas;
    }
    load(t) {
        this._dotLottieCore === null || g._wasmModule === null || (this._stopAnimationLoop(), $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && ($37d251801dc1953a$var$O.unobserve(this._canvas), $37d251801dc1953a$var$T.unobserve(this._canvas), this._cleanupStateMachineListeners()), this._isFrozen = false, this._dotLottieCore.setConfig({
            animationId: t.animationId ?? "",
            themeId: t.themeId ?? "",
            stateMachineId: "",
            autoplay: t.autoplay ?? false,
            backgroundColor: 0,
            loopAnimation: t.loop ?? false,
            mode: $37d251801dc1953a$var$u2(t.mode ?? "forward", g._wasmModule),
            segment: $37d251801dc1953a$var$d2(t.segment ?? [], g._wasmModule),
            speed: t.speed ?? 1,
            useFrameInterpolation: t.useFrameInterpolation ?? true,
            marker: t.marker ?? "",
            layout: $37d251801dc1953a$var$h2(t.layout, g._wasmModule)
        }), t.data ? this._loadFromData(t.data) : t.src && this._loadFromSrc(t.src), this.setBackgroundColor(t.backgroundColor ?? ""));
    }
    _draw() {
        if (this._dotLottieCore !== null && (!this._context && "getContext" in this._canvas && typeof this._canvas.getContext == "function" && (this._context = this._canvas.getContext("2d")), this._context)) {
            let t = this._dotLottieCore.buffer(), i = this._canvas.width * this._canvas.height * $37d251801dc1953a$var$G2;
            if (t.byteLength !== i) {
                console.warn(`Buffer size mismatch: got ${t.byteLength}, expected ${i}`);
                return;
            }
            let s = null, c = new Uint8ClampedArray(t, 0, t.byteLength);
            typeof ImageData > "u" ? (s = this._context.createImageData(this._canvas.width, this._canvas.height), s.data.set(c)) : s = new ImageData(c, this._canvas.width, this._canvas.height), this._context.putImageData(s, 0, 0);
        }
    }
    _stopAnimationLoop() {
        this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null);
    }
    _startAnimationLoop() {
        this._animationFrameId === null && this._dotLottieCore && !this._isFrozen && (this._dotLottieCore.isPlaying() || this._isStateMachineRunning) && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._animationLoop.bind(this)));
    }
    _animationLoop() {
        if (this._dotLottieCore === null) {
            this._stopAnimationLoop();
            return;
        }
        if (!this._dotLottieCore.isPlaying() && !this._isStateMachineRunning) {
            this._stopAnimationLoop();
            return;
        }
        try {
            (this._dotLottieCore.tick() || this._dotLottieCore.render()) && this._draw(), this._animationFrameId = this._frameManager.requestAnimationFrame(this._animationLoop.bind(this));
        } catch (t) {
            console.error("Error in animation frame:", t), this._eventManager.dispatch({
                type: "renderError",
                error: t
            }), t instanceof WebAssembly.RuntimeError && this.destroy();
        }
    }
    play() {
        if (this._dotLottieCore === null || !this.isLoaded) return;
        this._stopAnimationLoop(), (this._dotLottieCore.play() || this._dotLottieCore.isPlaying()) && (this._isFrozen = false, this._startAnimationLoop()), $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !$37d251801dc1953a$var$q(this._canvas) && this.freeze();
    }
    pause() {
        this._dotLottieCore !== null && (this._dotLottieCore.pause(), this._stopAnimationLoop());
    }
    stop() {
        if (this._dotLottieCore === null) return;
        let t = this._dotLottieCore.stop();
        this._stopAnimationLoop(), t && (this._eventManager.dispatch({
            type: "frame",
            currentFrame: this.currentFrame
        }), this._dotLottieCore.render(), this._draw());
    }
    setFrame(t) {
        if (this._dotLottieCore === null) return;
        this._dotLottieCore.seek(t) && this._dotLottieCore.render() && this._draw();
    }
    setSpeed(t) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            speed: t
        });
    }
    setBackgroundColor(t) {
        this._dotLottieCore !== null && ($37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement ? this._canvas.style.backgroundColor = t : this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            backgroundColor: $37d251801dc1953a$var$K2(t)
        }), this._backgroundColor = t);
    }
    setLoop(t) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            loopAnimation: t
        });
    }
    setUseFrameInterpolation(t) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            useFrameInterpolation: t
        });
    }
    addEventListener(t, i) {
        this._eventManager.addEventListener(t, i);
    }
    removeEventListener(t, i) {
        this._eventManager.removeEventListener(t, i);
    }
    destroy() {
        this._stopAnimationLoop(), this._isStateMachineRunning = false, $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && ($37d251801dc1953a$var$O.unobserve(this._canvas), $37d251801dc1953a$var$T.unobserve(this._canvas)), this._stateMachineObserverHandle && (this._dotLottieCore?.stateMachineUnsubscribe(this._stateMachineObserverHandle), this._stateMachineObserverHandle.delete(), this._stateMachineObserverHandle = null), this._stateMachineInternalMessageObserver && (this._dotLottieCore?.stateMachineInternalUnsubscribe(this._stateMachineInternalMessageObserver), this._stateMachineInternalMessageObserver.delete(), this._stateMachineInternalMessageObserver = null), this._dotLottieObserverHandle && (this._dotLottieCore?.unsubscribe(this._dotLottieObserverHandle), this._dotLottieObserverHandle.delete(), this._dotLottieObserverHandle = null), this._dotLottieCore?.delete(), this._dotLottieCore = null, this._context = null, this._eventManager.dispatch({
            type: "destroy"
        }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
    }
    freeze() {
        this._animationFrameId !== null && (this._stopAnimationLoop(), this._isFrozen = true, this._eventManager.dispatch({
            type: "freeze"
        }));
    }
    unfreeze() {
        this._animationFrameId === null && (this._isFrozen = false, this._eventManager.dispatch({
            type: "unfreeze"
        }), this._startAnimationLoop());
    }
    resize() {
        if (!this._dotLottieCore || !this.isLoaded) return;
        if ($37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement) {
            let i = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, { height: s, width: c } = this._canvas.getBoundingClientRect();
            s !== 0 && c !== 0 && (this._canvas.width = c * i, this._canvas.height = s * i);
        }
        this._dotLottieCore.resize(this._canvas.width, this._canvas.height) && this._draw();
    }
    setSegment(t, i) {
        this._dotLottieCore === null || g._wasmModule === null || this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            segment: $37d251801dc1953a$var$d2([
                t,
                i
            ], g._wasmModule)
        });
    }
    setMode(t) {
        this._dotLottieCore === null || g._wasmModule === null || this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            mode: $37d251801dc1953a$var$u2(t, g._wasmModule)
        });
    }
    setRenderConfig(t) {
        let { devicePixelRatio: i, freezeOnOffscreen: s, ...c } = t;
        this._renderConfig = {
            ...this._renderConfig,
            ...c,
            devicePixelRatio: i || $37d251801dc1953a$var$G(),
            freezeOnOffscreen: s ?? true
        }, $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? $37d251801dc1953a$var$T.observe(this._canvas, this) : $37d251801dc1953a$var$T.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? ($37d251801dc1953a$var$O.observe(this._canvas, this), $37d251801dc1953a$var$q(this._canvas) || this.freeze()) : ($37d251801dc1953a$var$O.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
    }
    loadAnimation(t) {
        if (this._dotLottieCore === null || this._dotLottieCore.activeAnimationId() === t) return;
        this._dotLottieCore.loadAnimation(t, this._canvas.width, this._canvas.height) && this.resize();
    }
    setMarker(t) {
        this._dotLottieCore !== null && this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            marker: t
        });
    }
    markers() {
        let t = this._dotLottieCore?.markers();
        if (t) {
            let i = [];
            for(let s = 0; s < t.size(); s += 1){
                let c = t.get(s);
                i.push({
                    name: c.name,
                    time: c.time,
                    duration: c.duration
                });
            }
            return i;
        }
        return [];
    }
    setTheme(t) {
        if (this._dotLottieCore === null) return false;
        let i = this._dotLottieCore.setTheme(t);
        return i && this._draw(), i;
    }
    resetTheme() {
        if (this._dotLottieCore === null) return false;
        let t = this._dotLottieCore.resetTheme();
        return t && this._draw(), t;
    }
    setThemeData(t) {
        if (this._dotLottieCore === null) return false;
        let i = this._dotLottieCore.setThemeData(t);
        return i && this._draw(), i;
    }
    setSlots(t) {
        this._dotLottieCore !== null && this._dotLottieCore.setSlots(t);
    }
    setLayout(t) {
        this._dotLottieCore === null || g._wasmModule === null || this._dotLottieCore.setConfig({
            ...this._dotLottieCore.config(),
            layout: $37d251801dc1953a$var$h2(t, g._wasmModule)
        });
    }
    setViewport(t, i, s, c) {
        return this._dotLottieCore === null ? false : this._dotLottieCore.setViewport(t, i, s, c);
    }
    static setWasmUrl(t) {
        $37d251801dc1953a$var$Z.setWasmUrl(t);
    }
    tween(t, i) {
        if (!g._wasmModule) return false;
        let s = [
            0,
            0,
            1,
            1
        ], c = new g._wasmModule.VectorFloat;
        for (let L of s)c.push_back(L);
        return this._dotLottieCore?.tween(t, i, c) ?? false;
    }
    tweenToMarker(t, i) {
        if (!g._wasmModule) return false;
        let s = [
            0,
            0,
            1,
            1
        ], c = new g._wasmModule.VectorFloat;
        for (let L of s)c.push_back(L);
        return this._dotLottieCore?.tweenToMarker(t, i, c) ?? false;
    }
    animationSize() {
        let t = this._dotLottieCore?.animationSize().get(0) ?? 0, i = this._dotLottieCore?.animationSize().get(1) ?? 0;
        return {
            width: t,
            height: i
        };
    }
    getLayerBoundingBox(t) {
        let i = this._dotLottieCore?.getLayerBounds(t);
        if (!i || i.size() !== 8) return;
        let s = [];
        for(let c = 0; c < 8; c += 1)s.push(i.get(c));
        return s;
    }
    static transformThemeToLottieSlots(t, i) {
        return g._wasmModule?.transformThemeToLottieSlots(t, i) ?? "";
    }
    _setupStateMachineObservers() {
        if (!this._dotLottieCore || !g._wasmModule) return;
        let t = new g._wasmModule.CallbackStateMachineObserver;
        t.setOnStart(()=>{
            setTimeout(()=>{
                this._isStateMachineRunning = true, this._eventManager.dispatch({
                    type: "stateMachineStart"
                }), this._startAnimationLoop();
            }, 0);
        }), t.setOnStop(()=>{
            setTimeout(()=>{
                this._isStateMachineRunning = false, this._eventManager.dispatch({
                    type: "stateMachineStop"
                }), this._dotLottieCore?.isPlaying() || this._stopAnimationLoop();
            }, 0);
        }), t.setOnCustomEvent((s)=>{
            this._eventManager.dispatch({
                type: "stateMachineCustomEvent",
                eventName: s
            });
        }), t.setOnBooleanInputValueChange((s, c, L)=>{
            this._eventManager.dispatch({
                type: "stateMachineBooleanInputValueChange",
                inputName: s,
                newValue: L,
                oldValue: c
            });
        }), t.setOnNumericInputValueChange((s, c, L)=>{
            this._eventManager.dispatch({
                type: "stateMachineNumericInputValueChange",
                inputName: s,
                newValue: L,
                oldValue: c
            });
        }), t.setOnStringInputValueChange((s, c, L)=>{
            this._eventManager.dispatch({
                type: "stateMachineStringInputValueChange",
                inputName: s,
                newValue: L,
                oldValue: c
            });
        }), t.setOnInputFired((s)=>{
            this._eventManager.dispatch({
                type: "stateMachineInputFired",
                inputName: s
            });
        }), t.setOnTransition((s, c)=>{
            this._eventManager.dispatch({
                type: "stateMachineTransition",
                fromState: s,
                toState: c
            });
        }), t.setOnStateEntered((s)=>{
            this._eventManager.dispatch({
                type: "stateMachineStateEntered",
                state: s
            });
        }), t.setOnStateExit((s)=>{
            this._eventManager.dispatch({
                type: "stateMachineStateExit",
                state: s
            });
        }), t.setOnError((s)=>{
            this._eventManager.dispatch({
                type: "stateMachineError",
                error: s
            });
        });
        let i = new g._wasmModule.CallbackStateMachineInternalObserver;
        i.setOnMessage((s)=>{
            $37d251801dc1953a$var$E ? s.startsWith("OpenUrl: ") && $37d251801dc1953a$var$D1(s) : this._eventManager.dispatch({
                type: "stateMachineInternalMessage",
                message: s
            });
        }), this._stateMachineObserverHandle = this._dotLottieCore.stateMachineSubscribe(t), this._stateMachineInternalMessageObserver = this._dotLottieCore.stateMachineInternalSubscribe(i);
    }
    _cleanupStateMachineObservers() {
        this._stateMachineObserverHandle && (this._dotLottieCore?.stateMachineUnsubscribe(this._stateMachineObserverHandle), this._stateMachineObserverHandle.delete(), this._stateMachineObserverHandle = null), this._stateMachineInternalMessageObserver && (this._dotLottieCore?.stateMachineInternalUnsubscribe(this._stateMachineInternalMessageObserver), this._stateMachineInternalMessageObserver.delete(), this._stateMachineInternalMessageObserver = null);
    }
    stateMachineLoad(t) {
        if (!this._dotLottieCore || !g._wasmModule) return false;
        this._cleanupStateMachineObservers();
        let i = this._dotLottieCore.stateMachineLoad(t);
        return i && this._setupStateMachineObservers(), i;
    }
    stateMachineLoadData(t) {
        if (!this._dotLottieCore || !g._wasmModule) return false;
        this._cleanupStateMachineObservers();
        let i = this._dotLottieCore.stateMachineLoadData(t);
        return i && this._setupStateMachineObservers(), i;
    }
    stateMachineSetConfig(t) {
        this._stateMachineConfig = t;
    }
    stateMachineStart() {
        if (g._wasmModule === null || this._dotLottieCore === null) return false;
        let t = g._wasmModule.createDefaultOpenUrlPolicy();
        if (this._stateMachineConfig) {
            let s = this._stateMachineConfig.openUrlPolicy;
            if (s && typeof s.requireUserInteraction == "boolean" && (t.requireUserInteraction = s.requireUserInteraction), s?.whitelist) {
                t.whitelist = new g._wasmModule.VectorString;
                for (let c of s.whitelist)t.whitelist.push_back(c);
            }
        }
        let i = this._dotLottieCore.stateMachineStart(t);
        return i && (this._isStateMachineRunning = true, this._setupStateMachineListeners(), this._startAnimationLoop()), i;
    }
    stateMachineStop() {
        if (!this._dotLottieCore) return false;
        let t = this._dotLottieCore.stateMachineStop();
        return t && (this._cleanupStateMachineObservers(), this._isStateMachineRunning = false, this._cleanupStateMachineListeners(), this._dotLottieCore.isPlaying() || this._stopAnimationLoop()), t;
    }
    stateMachineGetStatus() {
        return this._dotLottieCore?.stateMachineStatus() ?? "";
    }
    stateMachineGetCurrentState() {
        return this._dotLottieCore?.stateMachineCurrentState() ?? "";
    }
    stateMachineGetActiveId() {
        return this._dotLottieCore?.activeStateMachineId() ?? "";
    }
    stateMachineOverrideState(t, i = false) {
        return this._dotLottieCore?.stateMachineOverrideCurrentState(t, i) ?? false;
    }
    stateMachineGet(t) {
        return this._dotLottieCore?.getStateMachine(t) ?? "";
    }
    stateMachineGetListeners() {
        if (!this._dotLottieCore) return [];
        let t = this._dotLottieCore.stateMachineFrameworkSetup(), i = [];
        for(let s = 0; s < t.size(); s += 1)i.push(t.get(s));
        return i;
    }
    stateMachineSetBooleanInput(t, i) {
        return this._dotLottieCore?.stateMachineSetBooleanInput(t, i) ?? false;
    }
    stateMachineSetNumericInput(t, i) {
        return this._dotLottieCore?.stateMachineSetNumericInput(t, i) ?? false;
    }
    stateMachineSetStringInput(t, i) {
        return this._dotLottieCore?.stateMachineSetStringInput(t, i) ?? false;
    }
    stateMachineGetBooleanInput(t) {
        return this._dotLottieCore?.stateMachineGetBooleanInput(t);
    }
    stateMachineGetNumericInput(t) {
        return this._dotLottieCore?.stateMachineGetNumericInput(t);
    }
    stateMachineGetStringInput(t) {
        return this._dotLottieCore?.stateMachineGetStringInput(t);
    }
    stateMachineFireEvent(t) {
        this._dotLottieCore?.stateMachineFireEvent(t);
    }
    stateMachinePostClickEvent(t, i) {
        this._dotLottieCore?.stateMachinePostClickEvent(t, i);
    }
    stateMachinePostPointerUpEvent(t, i) {
        this._dotLottieCore?.stateMachinePostPointerUpEvent(t, i);
    }
    stateMachinePostPointerDownEvent(t, i) {
        this._dotLottieCore?.stateMachinePostPointerDownEvent(t, i);
    }
    stateMachinePostPointerMoveEvent(t, i) {
        this._dotLottieCore?.stateMachinePostPointerMoveEvent(t, i);
    }
    stateMachinePostPointerEnterEvent(t, i) {
        this._dotLottieCore?.stateMachinePostPointerEnterEvent(t, i);
    }
    stateMachinePostPointerExitEvent(t, i) {
        this._dotLottieCore?.stateMachinePostPointerExitEvent(t, i);
    }
    _onClick(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this.stateMachinePostClickEvent(i.x, i.y);
    }
    _onPointerUp(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this.stateMachinePostPointerUpEvent(i.x, i.y);
    }
    _onPointerDown(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this.stateMachinePostPointerDownEvent(i.x, i.y);
    }
    _onPointerMove(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this.stateMachinePostPointerMoveEvent(i.x, i.y);
    }
    _onPointerEnter(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this.stateMachinePostPointerEnterEvent(i.x, i.y);
    }
    _onPointerLeave(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this.stateMachinePostPointerExitEvent(i.x, i.y);
    }
    _setupStateMachineListeners() {
        if ($37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
            let t = this.stateMachineGetListeners();
            this._cleanupStateMachineListeners(), t.includes("Click") && (this._boundOnClick = this._onClick.bind(this), this._canvas.addEventListener("click", this._boundOnClick)), t.includes("PointerUp") && (this._boundOnPointerUp = this._onPointerUp.bind(this), this._canvas.addEventListener("pointerup", this._boundOnPointerUp)), t.includes("PointerDown") && (this._boundOnPointerDown = this._onPointerDown.bind(this), this._canvas.addEventListener("pointerdown", this._boundOnPointerDown)), t.includes("PointerMove") && (this._boundOnPointerMove = this._onPointerMove.bind(this), this._canvas.addEventListener("pointermove", this._boundOnPointerMove)), t.includes("PointerEnter") && (this._boundOnPointerEnter = this._onPointerEnter.bind(this), this._canvas.addEventListener("pointerenter", this._boundOnPointerEnter)), t.includes("PointerExit") && (this._boundOnPointerLeave = this._onPointerLeave.bind(this), this._canvas.addEventListener("pointerleave", this._boundOnPointerLeave));
        }
    }
    _cleanupStateMachineListeners() {
        $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && (this._boundOnClick && (this._canvas.removeEventListener("click", this._boundOnClick), this._boundOnClick = null), this._boundOnPointerUp && (this._canvas.removeEventListener("pointerup", this._boundOnPointerUp), this._boundOnPointerUp = null), this._boundOnPointerDown && (this._canvas.removeEventListener("pointerdown", this._boundOnPointerDown), this._boundOnPointerDown = null), this._boundOnPointerMove && (this._canvas.removeEventListener("pointermove", this._boundOnPointerMove), this._boundOnPointerMove = null), this._boundOnPointerEnter && (this._canvas.removeEventListener("pointerenter", this._boundOnPointerEnter), this._boundOnPointerEnter = null), this._boundOnPointerLeave && (this._canvas.removeEventListener("pointerleave", this._boundOnPointerLeave), this._boundOnPointerLeave = null));
    }
};
$37d251801dc1953a$var$v($37d251801dc1953a$var$g, "_wasmModule", null);
var $37d251801dc1953a$export$2c434b74e61f4f56 = $37d251801dc1953a$var$g;
var $37d251801dc1953a$var$c2 = class {
    constructor(){
        if (typeof Worker > "u") throw new Error("Worker is not supported in this environment.");
        let t = new Blob([
            new Uint8Array([
                34,
                117,
                115,
                101,
                32,
                115,
                116,
                114,
                105,
                99,
                116,
                34,
                59,
                10,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                100,
                101,
                102,
                80,
                114,
                111,
                112,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                100,
                101,
                102,
                105,
                110,
                101,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                100,
                101,
                102,
                78,
                111,
                114,
                109,
                97,
                108,
                80,
                114,
                111,
                112,
                32,
                61,
                32,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                107,
                101,
                121,
                32,
                105,
                110,
                32,
                111,
                98,
                106,
                32,
                63,
                32,
                95,
                95,
                100,
                101,
                102,
                80,
                114,
                111,
                112,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                123,
                32,
                101,
                110,
                117,
                109,
                101,
                114,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                117,
                114,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                119,
                114,
                105,
                116,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                125,
                41,
                32,
                58,
                32,
                111,
                98,
                106,
                91,
                107,
                101,
                121,
                93,
                32,
                61,
                32,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                32,
                61,
                32,
                40,
                111,
                98,
                106,
                44,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                95,
                95,
                100,
                101,
                102,
                78,
                111,
                114,
                109,
                97,
                108,
                80,
                114,
                111,
                112,
                40,
                111,
                98,
                106,
                44,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                107,
                101,
                121,
                32,
                33,
                61,
                61,
                32,
                34,
                115,
                121,
                109,
                98,
                111,
                108,
                34,
                32,
                63,
                32,
                107,
                101,
                121,
                32,
                43,
                32,
                34,
                34,
                32,
                58,
                32,
                107,
                101,
                121,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                45,
                102,
                114,
                97,
                109,
                101,
                45,
                109,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                87,
                101,
                98,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                78,
                111,
                100,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                34,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                62,
                61,
                32,
                78,
                117,
                109,
                98,
                101,
                114,
                46,
                77,
                65,
                88,
                95,
                83,
                65,
                70,
                69,
                95,
                73,
                78,
                84,
                69,
                71,
                69,
                82,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                32,
                43,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                32,
                61,
                32,
                115,
                101,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                40,
                68,
                97,
                116,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                95,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                101,
                97,
                114,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                97,
                115,
                116,
                73,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                87,
                101,
                98,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                40,
                41,
                32,
                58,
                32,
                110,
                101,
                119,
                32,
                78,
                111,
                100,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                83,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                114,
                97,
                116,
                101,
                103,
                121,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                105,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                110,
                115,
                116,
                97,
                110,
                116,
                115,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                32,
                33,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                38,
                38,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                33,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                91,
                56,
                48,
                44,
                32,
                55,
                53,
                44,
                32,
                51,
                44,
                32,
                52,
                93,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                76,
                79,
                84,
                84,
                73,
                69,
                95,
                74,
                83,
                79,
                78,
                95,
                77,
                65,
                78,
                68,
                65,
                84,
                79,
                82,
                89,
                95,
                70,
                73,
                69,
                76,
                68,
                83,
                32,
                61,
                32,
                91,
                34,
                118,
                34,
                44,
                32,
                34,
                105,
                112,
                34,
                44,
                32,
                34,
                111,
                112,
                34,
                44,
                32,
                34,
                108,
                97,
                121,
                101,
                114,
                115,
                34,
                44,
                32,
                34,
                102,
                114,
                34,
                44,
                32,
                34,
                119,
                34,
                44,
                32,
                34,
                104,
                34,
                93,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                32,
                61,
                32,
                34,
                48,
                46,
                53,
                48,
                46,
                49,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                32,
                61,
                32,
                34,
                64,
                108,
                111,
                116,
                116,
                105,
                101,
                102,
                105,
                108,
                101,
                115,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                119,
                101,
                98,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                69,
                70,
                65,
                85,
                76,
                84,
                95,
                68,
                80,
                82,
                95,
                70,
                65,
                67,
                84,
                79,
                82,
                32,
                61,
                32,
                48,
                46,
                55,
                53,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                66,
                89,
                84,
                69,
                83,
                95,
                80,
                69,
                82,
                95,
                80,
                73,
                88,
                69,
                76,
                32,
                61,
                32,
                52,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                114,
                101,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                106,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                33,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                63,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                63,
                46,
                115,
                114,
                99,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                109,
                111,
                100,
                117,
                108,
                101,
                65,
                114,
                103,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                104,
                32,
                61,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                65,
                114,
                103,
                44,
                32,
                97,
                97,
                44,
                32,
                98,
                97,
                44,
                32,
                99,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                40,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                44,
                32,
                102,
                97,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                123,
                125,
                44,
                32,
                104,
                41,
                44,
                32,
                104,
                97,
                32,
                61,
                32,
                34,
                46,
                47,
                116,
                104,
                105,
                115,
                46,
                112,
                114,
                111,
                103,
                114,
                97,
                109,
                34,
                44,
                32,
                112,
                32,
                61,
                32,
                34,
                34,
                44,
                32,
                105,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                32,
                38,
                38,
                32,
                40,
                112,
                32,
                61,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                99,
                114,
                105,
                112,
                116,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                32,
                38,
                38,
                32,
                40,
                112,
                32,
                61,
                32,
                95,
                115,
                99,
                114,
                105,
                112,
                116,
                78,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                98,
                108,
                111,
                98,
                58,
                34,
                41,
                32,
                63,
                32,
                112,
                32,
                61,
                32,
                34,
                34,
                32,
                58,
                32,
                112,
                32,
                61,
                32,
                112,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                40,
                48,
                44,
                32,
                112,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                91,
                63,
                35,
                93,
                46,
                42,
                47,
                44,
                32,
                34,
                34,
                41,
                46,
                108,
                97,
                115,
                116,
                73,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                34,
                47,
                34,
                41,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                97,
                32,
                61,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                97,
                44,
                32,
                123,
                32,
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108,
                115,
                58,
                32,
                34,
                115,
                97,
                109,
                101,
                45,
                111,
                114,
                105,
                103,
                105,
                110,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                46,
                111,
                107,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                46,
                97,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                97,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                32,
                43,
                32,
                34,
                32,
                58,
                32,
                34,
                32,
                43,
                32,
                97,
                46,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                116,
                32,
                61,
                32,
                104,
                46,
                112,
                114,
                105,
                110,
                116,
                69,
                114,
                114,
                32,
                124,
                124,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                46,
                98,
                105,
                110,
                100,
                40,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                104,
                44,
                32,
                102,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                116,
                104,
                105,
                115,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                32,
                38,
                38,
                32,
                40,
                104,
                97,
                32,
                61,
                32,
                104,
                46,
                116,
                104,
                105,
                115,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                106,
                97,
                32,
                61,
                32,
                104,
                46,
                119,
                97,
                115,
                109,
                66,
                105,
                110,
                97,
                114,
                121,
                44,
                32,
                107,
                97,
                44,
                32,
                108,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                109,
                97,
                44,
                32,
                117,
                44,
                32,
                120,
                44,
                32,
                121,
                44,
                32,
                122,
                44,
                32,
                67,
                44,
                32,
                68,
                44,
                32,
                110,
                97,
                44,
                32,
                111,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                112,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                107,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                72,
                69,
                65,
                80,
                56,
                32,
                61,
                32,
                117,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                72,
                69,
                65,
                80,
                49,
                54,
                32,
                61,
                32,
                121,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                72,
                69,
                65,
                80,
                85,
                56,
                32,
                61,
                32,
                120,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                72,
                69,
                65,
                80,
                85,
                49,
                54,
                32,
                61,
                32,
                122,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                72,
                69,
                65,
                80,
                51,
                50,
                32,
                61,
                32,
                67,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                72,
                69,
                65,
                80,
                85,
                51,
                50,
                32,
                61,
                32,
                68,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                72,
                69,
                65,
                80,
                70,
                51,
                50,
                32,
                61,
                32,
                110,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                108,
                111,
                97,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                72,
                69,
                65,
                80,
                70,
                54,
                52,
                32,
                61,
                32,
                111,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                108,
                111,
                97,
                116,
                54,
                52,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                113,
                97,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                114,
                97,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                115,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                116,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                104,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                70,
                32,
                61,
                32,
                48,
                44,
                32,
                71,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                117,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                111,
                110,
                65,
                98,
                111,
                114,
                116,
                63,
                46,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                34,
                65,
                98,
                111,
                114,
                116,
                101,
                100,
                40,
                34,
                32,
                43,
                32,
                97,
                32,
                43,
                32,
                34,
                41,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                97,
                32,
                43,
                32,
                34,
                46,
                32,
                66,
                117,
                105,
                108,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                45,
                115,
                65,
                83,
                83,
                69,
                82,
                84,
                73,
                79,
                78,
                83,
                32,
                102,
                111,
                114,
                32,
                109,
                111,
                114,
                101,
                32,
                105,
                110,
                102,
                111,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                118,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                97,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                100,
                97,
                116,
                97,
                58,
                97,
                112,
                112,
                108,
                105,
                99,
                97,
                116,
                105,
                111,
                110,
                47,
                111,
                99,
                116,
                101,
                116,
                45,
                115,
                116,
                114,
                101,
                97,
                109,
                59,
                98,
                97,
                115,
                101,
                54,
                52,
                44,
                34,
                41,
                44,
                32,
                119,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                120,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                106,
                97,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                105,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                32,
                61,
                61,
                32,
                119,
                97,
                32,
                38,
                38,
                32,
                106,
                97,
                41,
                32,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                106,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                34,
                98,
                111,
                116,
                104,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                97,
                110,
                100,
                32,
                115,
                121,
                110,
                99,
                32,
                102,
                101,
                116,
                99,
                104,
                105,
                110,
                103,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                119,
                97,
                115,
                109,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                121,
                97,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                120,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                40,
                99,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                40,
                96,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                97,
                115,
                121,
                110,
                99,
                104,
                114,
                111,
                110,
                111,
                117,
                115,
                108,
                121,
                32,
                112,
                114,
                101,
                112,
                97,
                114,
                101,
                32,
                119,
                97,
                115,
                109,
                58,
                32,
                36,
                123,
                100,
                125,
                96,
                41,
                44,
                32,
                117,
                97,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                122,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                119,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                106,
                97,
                32,
                38,
                38,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                83,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                32,
                38,
                38,
                32,
                33,
                118,
                97,
                40,
                98,
                41,
                32,
                38,
                38,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                102,
                101,
                116,
                99,
                104,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                98,
                44,
                32,
                123,
                32,
                99,
                114,
                101,
                100,
                101,
                110,
                116,
                105,
                97,
                108,
                115,
                58,
                32,
                34,
                115,
                97,
                109,
                101,
                45,
                111,
                114,
                105,
                103,
                105,
                110,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                83,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                40,
                99,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                40,
                96,
                119,
                97,
                115,
                109,
                32,
                115,
                116,
                114,
                101,
                97,
                109,
                105,
                110,
                103,
                32,
                99,
                111,
                109,
                112,
                105,
                108,
                101,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                100,
                125,
                96,
                41,
                44,
                32,
                116,
                40,
                34,
                102,
                97,
                108,
                108,
                105,
                110,
                103,
                32,
                98,
                97,
                99,
                107,
                32,
                116,
                111,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                121,
                97,
                40,
                98,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                65,
                97,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                34,
                69,
                120,
                105,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                96,
                80,
                114,
                111,
                103,
                114,
                97,
                109,
                32,
                116,
                101,
                114,
                109,
                105,
                110,
                97,
                116,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                101,
                120,
                105,
                116,
                40,
                36,
                123,
                97,
                125,
                41,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                66,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                48,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                97,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                67,
                97,
                32,
                61,
                32,
                104,
                46,
                110,
                111,
                69,
                120,
                105,
                116,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                32,
                124,
                124,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                68,
                97,
                32,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                69,
                97,
                32,
                61,
                32,
                40,
                97,
                32,
                61,
                32,
                48,
                44,
                32,
                98,
                32,
                61,
                32,
                78,
                97,
                78,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                120,
                44,
                32,
                100,
                32,
                61,
                32,
                97,
                32,
                43,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                98,
                32,
                61,
                32,
                97,
                59,
                32,
                99,
                91,
                98,
                93,
                32,
                38,
                38,
                32,
                33,
                40,
                98,
                32,
                62,
                61,
                32,
                100,
                41,
                59,
                32,
                41,
                32,
                43,
                43,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                54,
                32,
                60,
                32,
                98,
                32,
                45,
                32,
                97,
                32,
                38,
                38,
                32,
                99,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                32,
                38,
                38,
                32,
                68,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                68,
                97,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                99,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                97,
                44,
                32,
                98,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                100,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                97,
                32,
                60,
                32,
                98,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                99,
                91,
                97,
                43,
                43,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                38,
                32,
                49,
                50,
                56,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                99,
                91,
                97,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                57,
                50,
                32,
                61,
                61,
                32,
                40,
                101,
                32,
                38,
                32,
                50,
                50,
                52,
                41,
                41,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                40,
                101,
                32,
                38,
                32,
                51,
                49,
                41,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                99,
                91,
                97,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                50,
                50,
                52,
                32,
                61,
                61,
                32,
                40,
                101,
                32,
                38,
                32,
                50,
                52,
                48,
                41,
                32,
                63,
                32,
                40,
                101,
                32,
                38,
                32,
                49,
                53,
                41,
                32,
                60,
                60,
                32,
                49,
                50,
                32,
                124,
                32,
                102,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                107,
                32,
                58,
                32,
                40,
                101,
                32,
                38,
                32,
                55,
                41,
                32,
                60,
                60,
                32,
                49,
                56,
                32,
                124,
                32,
                102,
                32,
                60,
                60,
                32,
                49,
                50,
                32,
                124,
                32,
                107,
                32,
                60,
                60,
                32,
                54,
                32,
                124,
                32,
                99,
                91,
                97,
                43,
                43,
                93,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                62,
                32,
                101,
                32,
                63,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                32,
                58,
                32,
                40,
                101,
                32,
                45,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                44,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                124,
                32,
                101,
                32,
                62,
                62,
                32,
                49,
                48,
                44,
                32,
                53,
                54,
                51,
                50,
                48,
                32,
                124,
                32,
                101,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                70,
                97,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                67,
                97,
                32,
                61,
                32,
                97,
                32,
                45,
                32,
                50,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                71,
                97,
                32,
                61,
                32,
                48,
                44,
                32,
                72,
                97,
                32,
                61,
                32,
                48,
                44,
                32,
                72,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                60,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                32,
                45,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                102,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                43,
                43,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                43,
                32,
                40,
                40,
                102,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                32,
                60,
                60,
                32,
                49,
                48,
                41,
                32,
                124,
                32,
                107,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                49,
                50,
                55,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                48,
                52,
                55,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                49,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                57,
                50,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                54,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                54,
                53,
                53,
                51,
                53,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                50,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                50,
                50,
                52,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                51,
                32,
                62,
                61,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                50,
                52,
                48,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                49,
                50,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                62,
                62,
                32,
                54,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                43,
                43,
                93,
                32,
                61,
                32,
                49,
                50,
                56,
                32,
                124,
                32,
                102,
                32,
                38,
                32,
                54,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                91,
                98,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                73,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                74,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                112,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                112,
                111,
                112,
                40,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                73,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                68,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                74,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                75,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                75,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                76,
                44,
                32,
                78,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                99,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                76,
                40,
                34,
                77,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                101,
                100,
                32,
                116,
                121,
                112,
                101,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                101,
                114,
                32,
                99,
                111,
                117,
                110,
                116,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                48,
                59,
                32,
                108,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                108,
                41,
                32,
                77,
                40,
                97,
                91,
                108,
                93,
                44,
                32,
                103,
                91,
                108,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                75,
                97,
                91,
                103,
                93,
                32,
                61,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                44,
                32,
                102,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                107,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                103,
                41,
                32,
                63,
                32,
                101,
                91,
                108,
                93,
                32,
                61,
                32,
                75,
                91,
                103,
                93,
                32,
                58,
                32,
                40,
                102,
                46,
                112,
                117,
                115,
                104,
                40,
                103,
                41,
                44,
                32,
                74,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                103,
                41,
                32,
                124,
                124,
                32,
                40,
                74,
                91,
                103,
                93,
                32,
                61,
                32,
                91,
                93,
                41,
                44,
                32,
                74,
                91,
                103,
                93,
                46,
                112,
                117,
                115,
                104,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                91,
                108,
                93,
                32,
                61,
                32,
                75,
                91,
                103,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                43,
                43,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                32,
                61,
                61,
                61,
                32,
                102,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                100,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                102,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                100,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                76,
                97,
                44,
                32,
                79,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                120,
                91,
                97,
                93,
                59,
                32,
                41,
                32,
                98,
                32,
                43,
                61,
                32,
                76,
                97,
                91,
                120,
                91,
                97,
                43,
                43,
                93,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                80,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                77,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                116,
                121,
                112,
                101,
                32,
                34,
                36,
                123,
                100,
                125,
                34,
                32,
                109,
                117,
                115,
                116,
                32,
                104,
                97,
                118,
                101,
                32,
                97,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                118,
                101,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                105,
                100,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                75,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                46,
                104,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                39,
                36,
                123,
                100,
                125,
                39,
                32,
                116,
                119,
                105,
                99,
                101,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                75,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                32,
                38,
                38,
                32,
                40,
                98,
                32,
                61,
                32,
                74,
                91,
                97,
                93,
                44,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                74,
                91,
                97,
                93,
                44,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                41,
                32,
                61,
                62,
                32,
                101,
                40,
                41,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                77,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                123,
                125,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                77,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                79,
                97,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                97,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                66,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                43,
                32,
                34,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                80,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                81,
                97,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                61,
                61,
                61,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                46,
                71,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                82,
                97,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                46,
                71,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                97,
                32,
                63,
                32,
                110,
                117,
                108,
                108,
                32,
                58,
                32,
                99,
                46,
                36,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                83,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                84,
                97,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                85,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                34,
                112,
                116,
                114,
                32,
                115,
                104,
                111,
                117,
                108,
                100,
                32,
                110,
                111,
                116,
                32,
                98,
                101,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                97,
                46,
                71,
                97,
                59,
                32,
                41,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                81,
                97,
                40,
                98,
                41,
                44,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                71,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                84,
                97,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                86,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                68,
                97,
                32,
                124,
                124,
                32,
                33,
                98,
                46,
                67,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                76,
                40,
                34,
                109,
                97,
                107,
                101,
                67,
                108,
                97,
                115,
                115,
                72,
                97,
                110,
                100,
                108,
                101,
                32,
                114,
                101,
                113,
                117,
                105,
                114,
                101,
                115,
                32,
                112,
                116,
                114,
                32,
                97,
                110,
                100,
                32,
                112,
                116,
                114,
                84,
                121,
                112,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                33,
                98,
                46,
                72,
                97,
                32,
                33,
                61,
                61,
                32,
                33,
                33,
                98,
                46,
                70,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                76,
                40,
                34,
                66,
                111,
                116,
                104,
                32,
                115,
                109,
                97,
                114,
                116,
                80,
                116,
                114,
                84,
                121,
                112,
                101,
                32,
                97,
                110,
                100,
                32,
                115,
                109,
                97,
                114,
                116,
                80,
                116,
                114,
                32,
                109,
                117,
                115,
                116,
                32,
                98,
                101,
                32,
                115,
                112,
                101,
                99,
                105,
                102,
                105,
                101,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                32,
                61,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                49,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                81,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                97,
                44,
                32,
                123,
                32,
                65,
                97,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                98,
                44,
                32,
                119,
                114,
                105,
                116,
                97,
                98,
                108,
                101,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                32,
                125,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                81,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                61,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                70,
                105,
                110,
                97,
                108,
                105,
                122,
                97,
                116,
                105,
                111,
                110,
                82,
                101,
                103,
                105,
                115,
                116,
                114,
                121,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                81,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                98,
                44,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                105,
                110,
                97,
                108,
                105,
                122,
                97,
                116,
                105,
                111,
                110,
                82,
                101,
                103,
                105,
                115,
                116,
                114,
                121,
                40,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                65,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                45,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                38,
                38,
                32,
                40,
                98,
                46,
                70,
                97,
                32,
                63,
                32,
                98,
                46,
                72,
                97,
                46,
                75,
                97,
                40,
                98,
                46,
                70,
                97,
                41,
                32,
                58,
                32,
                98,
                46,
                68,
                97,
                46,
                66,
                97,
                46,
                75,
                97,
                40,
                98,
                46,
                67,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                65,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                70,
                97,
                32,
                38,
                38,
                32,
                80,
                97,
                46,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                40,
                98,
                44,
                32,
                123,
                32,
                65,
                97,
                58,
                32,
                99,
                32,
                125,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                97,
                32,
                61,
                32,
                40,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                97,
                46,
                117,
                110,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                81,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                87,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                88,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                89,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                100,
                101,
                102,
                105,
                110,
                101,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                98,
                44,
                32,
                34,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                97,
                32,
                125,
                41,
                44,
                32,
                90,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                46,
                69,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                91,
                98,
                93,
                46,
                69,
                97,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                70,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                39,
                36,
                123,
                99,
                125,
                39,
                32,
                99,
                97,
                108,
                108,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                97,
                110,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                115,
                32,
                40,
                36,
                123,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                125,
                41,
                32,
                45,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                115,
                32,
                111,
                110,
                101,
                32,
                111,
                102,
                32,
                40,
                36,
                123,
                97,
                91,
                98,
                93,
                46,
                69,
                97,
                125,
                41,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                91,
                98,
                93,
                46,
                69,
                97,
                91,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                46,
                69,
                97,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                46,
                69,
                97,
                91,
                100,
                46,
                78,
                97,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                36,
                97,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                104,
                91,
                97,
                93,
                46,
                69,
                97,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                104,
                91,
                97,
                93,
                46,
                69,
                97,
                91,
                99,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                112,
                117,
                98,
                108,
                105,
                99,
                32,
                110,
                97,
                109,
                101,
                32,
                39,
                36,
                123,
                97,
                125,
                39,
                32,
                116,
                119,
                105,
                99,
                101,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                90,
                97,
                40,
                104,
                44,
                32,
                97,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                91,
                97,
                93,
                46,
                69,
                97,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                99,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                109,
                117,
                108,
                116,
                105,
                112,
                108,
                101,
                32,
                111,
                118,
                101,
                114,
                108,
                111,
                97,
                100,
                115,
                32,
                111,
                102,
                32,
                97,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                119,
                105,
                116,
                104,
                32,
                116,
                104,
                101,
                32,
                115,
                97,
                109,
                101,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                115,
                32,
                40,
                36,
                123,
                99,
                125,
                41,
                33,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                91,
                97,
                93,
                46,
                69,
                97,
                91,
                99,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                104,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                44,
                32,
                104,
                91,
                97,
                93,
                46,
                78,
                97,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                97,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                91,
                94,
                97,
                45,
                122,
                65,
                45,
                90,
                48,
                45,
                57,
                95,
                93,
                47,
                103,
                44,
                32,
                34,
                36,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                52,
                56,
                32,
                60,
                61,
                32,
                98,
                32,
                38,
                38,
                32,
                53,
                55,
                32,
                62,
                61,
                32,
                98,
                32,
                63,
                32,
                96,
                95,
                36,
                123,
                97,
                125,
                96,
                32,
                58,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                98,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                77,
                97,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                75,
                97,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                71,
                97,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                98,
                98,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                81,
                97,
                32,
                61,
                32,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                36,
                97,
                32,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                106,
                98,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                98,
                32,
                33,
                61,
                61,
                32,
                99,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                81,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                69,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                110,
                117,
                108,
                108,
                32,
                111,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                111,
                102,
                32,
                36,
                123,
                99,
                46,
                110,
                97,
                109,
                101,
                125,
                44,
                32,
                103,
                111,
                116,
                32,
                97,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                111,
                102,
                32,
                36,
                123,
                98,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                98,
                46,
                81,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                71,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                84,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                65,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                101,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                65,
                97,
                46,
                67,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                98,
                40,
                98,
                46,
                65,
                97,
                46,
                67,
                97,
                44,
                32,
                98,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                66,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                66,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                102,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                84,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                83,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                85,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                32,
                38,
                38,
                32,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                46,
                75,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                32,
                124,
                124,
                32,
                33,
                98,
                46,
                65,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                101,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                65,
                97,
                46,
                67,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                82,
                97,
                32,
                38,
                38,
                32,
                98,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                82,
                97,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                65,
                97,
                46,
                72,
                97,
                32,
                63,
                32,
                98,
                46,
                65,
                97,
                46,
                72,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                98,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                99,
                98,
                40,
                98,
                46,
                65,
                97,
                46,
                67,
                97,
                44,
                32,
                98,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                66,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                66,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                83,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                98,
                46,
                65,
                97,
                46,
                70,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                34,
                80,
                97,
                115,
                115,
                105,
                110,
                103,
                32,
                114,
                97,
                119,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                116,
                111,
                32,
                115,
                109,
                97,
                114,
                116,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                105,
                115,
                32,
                105,
                108,
                108,
                101,
                103,
                97,
                108,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                111,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                48,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                65,
                97,
                46,
                72,
                97,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                65,
                97,
                46,
                70,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                65,
                97,
                46,
                72,
                97,
                32,
                63,
                32,
                98,
                46,
                65,
                97,
                46,
                72,
                97,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                98,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                65,
                97,
                46,
                70,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                65,
                97,
                46,
                72,
                97,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                65,
                97,
                46,
                70,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                107,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                98,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                100,
                91,
                34,
                100,
                101,
                108,
                101,
                116,
                101,
                34,
                93,
                40,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                32,
                38,
                38,
                32,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                46,
                75,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                34,
                85,
                110,
                115,
                117,
                112,
                112,
                111,
                114,
                116,
                105,
                110,
                103,
                32,
                115,
                104,
                97,
                114,
                105,
                110,
                103,
                32,
                112,
                111,
                108,
                105,
                99,
                121,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                84,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                110,
                117,
                108,
                108,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                97,
                32,
                118,
                97,
                108,
                105,
                100,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                65,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                34,
                36,
                123,
                101,
                98,
                40,
                98,
                41,
                125,
                34,
                32,
                97,
                115,
                32,
                97,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                46,
                65,
                97,
                46,
                67,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                115,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                82,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                118,
                101,
                114,
                116,
                32,
                97,
                114,
                103,
                117,
                109,
                101,
                110,
                116,
                32,
                111,
                102,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                98,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                116,
                111,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                98,
                40,
                98,
                46,
                65,
                97,
                46,
                67,
                97,
                44,
                32,
                98,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                66,
                97,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                66,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                110,
                44,
                32,
                109,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                66,
                97,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                84,
                97,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                82,
                97,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                83,
                97,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                98,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                111,
                98,
                32,
                61,
                32,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                32,
                61,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                85,
                97,
                32,
                61,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                107,
                98,
                32,
                61,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                75,
                97,
                32,
                61,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                98,
                46,
                71,
                97,
                32,
                63,
                32,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                32,
                61,
                32,
                102,
                98,
                32,
                58,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                32,
                61,
                32,
                100,
                32,
                63,
                32,
                100,
                98,
                32,
                58,
                32,
                104,
                98,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                74,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                106,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                104,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                40,
                97,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                76,
                40,
                34,
                82,
                101,
                112,
                108,
                97,
                99,
                105,
                110,
                103,
                32,
                110,
                111,
                110,
                101,
                120,
                105,
                115,
                116,
                101,
                110,
                116,
                32,
                112,
                117,
                98,
                108,
                105,
                99,
                32,
                115,
                121,
                109,
                98,
                111,
                108,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                104,
                91,
                97,
                93,
                46,
                69,
                97,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                63,
                32,
                104,
                91,
                97,
                93,
                46,
                69,
                97,
                91,
                99,
                93,
                32,
                61,
                32,
                98,
                32,
                58,
                32,
                40,
                104,
                91,
                97,
                93,
                32,
                61,
                32,
                98,
                44,
                32,
                104,
                91,
                97,
                93,
                46,
                78,
                97,
                32,
                61,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                44,
                32,
                107,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                106,
                34,
                41,
                32,
                63,
                32,
                40,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                112,
                47,
                103,
                44,
                32,
                34,
                105,
                34,
                41,
                44,
                32,
                98,
                32,
                61,
                32,
                40,
                48,
                44,
                32,
                104,
                91,
                34,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                34,
                32,
                43,
                32,
                97,
                93,
                41,
                40,
                98,
                44,
                32,
                46,
                46,
                46,
                99,
                41,
                41,
                32,
                58,
                32,
                98,
                32,
                61,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                98,
                41,
                40,
                46,
                46,
                46,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                108,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                46,
                46,
                46,
                99,
                41,
                32,
                61,
                62,
                32,
                107,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                44,
                32,
                83,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                79,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                106,
                34,
                41,
                32,
                63,
                32,
                108,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                119,
                105,
                116,
                104,
                32,
                115,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                32,
                36,
                123,
                97,
                125,
                58,
                32,
                36,
                123,
                98,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                109,
                98,
                44,
                32,
                111,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                110,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                79,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                112,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                99,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                91,
                102,
                93,
                32,
                124,
                124,
                32,
                75,
                91,
                102,
                93,
                32,
                124,
                124,
                32,
                40,
                75,
                97,
                91,
                102,
                93,
                32,
                63,
                32,
                75,
                97,
                91,
                102,
                93,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                99,
                41,
                32,
                58,
                32,
                40,
                100,
                46,
                112,
                117,
                115,
                104,
                40,
                102,
                41,
                44,
                32,
                101,
                91,
                102,
                93,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                101,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                109,
                98,
                40,
                96,
                36,
                123,
                97,
                125,
                58,
                32,
                96,
                32,
                43,
                32,
                100,
                46,
                109,
                97,
                112,
                40,
                111,
                98,
                41,
                46,
                106,
                111,
                105,
                110,
                40,
                91,
                34,
                44,
                32,
                34,
                93,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                113,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                100,
                32,
                60,
                32,
                97,
                59,
                32,
                100,
                43,
                43,
                41,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                68,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                114,
                98,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                49,
                59,
                32,
                98,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                98,
                41,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                32,
                38,
                38,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                91,
                98,
                93,
                46,
                74,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                115,
                98,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                62,
                32,
                102,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                34,
                97,
                114,
                103,
                84,
                121,
                112,
                101,
                115,
                32,
                97,
                114,
                114,
                97,
                121,
                32,
                115,
                105,
                122,
                101,
                32,
                109,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                33,
                32,
                77,
                117,
                115,
                116,
                32,
                97,
                116,
                32,
                108,
                101,
                97,
                115,
                116,
                32,
                103,
                101,
                116,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                97,
                110,
                100,
                32,
                39,
                116,
                104,
                105,
                115,
                39,
                32,
                116,
                121,
                112,
                101,
                115,
                33,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                49,
                93,
                32,
                38,
                38,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                99,
                44,
                32,
                103,
                32,
                61,
                32,
                114,
                98,
                40,
                98,
                41,
                44,
                32,
                108,
                32,
                61,
                32,
                34,
                118,
                111,
                105,
                100,
                34,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                48,
                93,
                46,
                110,
                97,
                109,
                101,
                44,
                32,
                110,
                32,
                61,
                32,
                102,
                32,
                45,
                32,
                50,
                44,
                32,
                109,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                110,
                41,
                44,
                32,
                113,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                114,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                89,
                97,
                40,
                97,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                65,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                107,
                32,
                63,
                32,
                50,
                32,
                58,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                91,
                48,
                93,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                118,
                32,
                61,
                32,
                98,
                91,
                49,
                93,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                114,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                91,
                49,
                93,
                32,
                61,
                32,
                118,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                119,
                32,
                61,
                32,
                48,
                59,
                32,
                119,
                32,
                60,
                32,
                110,
                59,
                32,
                43,
                43,
                119,
                41,
                32,
                109,
                91,
                119,
                93,
                32,
                61,
                32,
                98,
                91,
                119,
                32,
                43,
                32,
                50,
                93,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                114,
                44,
                32,
                65,
                91,
                119,
                93,
                41,
                44,
                32,
                113,
                46,
                112,
                117,
                115,
                104,
                40,
                109,
                91,
                119,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                32,
                61,
                32,
                100,
                40,
                46,
                46,
                46,
                113,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                41,
                32,
                74,
                97,
                40,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                119,
                32,
                61,
                32,
                107,
                32,
                63,
                32,
                49,
                32,
                58,
                32,
                50,
                59,
                32,
                119,
                32,
                60,
                32,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                119,
                43,
                43,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                32,
                61,
                32,
                49,
                32,
                61,
                61,
                61,
                32,
                119,
                32,
                63,
                32,
                118,
                32,
                58,
                32,
                109,
                91,
                119,
                32,
                45,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                98,
                91,
                119,
                93,
                46,
                74,
                97,
                32,
                38,
                38,
                32,
                98,
                91,
                119,
                93,
                46,
                74,
                97,
                40,
                69,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                108,
                32,
                63,
                32,
                98,
                91,
                48,
                93,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                65,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                116,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                116,
                114,
                105,
                109,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                32,
                61,
                32,
                97,
                46,
                105,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                34,
                40,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                45,
                49,
                32,
                33,
                61,
                61,
                32,
                98,
                32,
                63,
                32,
                97,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                40,
                48,
                44,
                32,
                98,
                41,
                32,
                58,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                118,
                98,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                85,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                119,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                57,
                32,
                60,
                32,
                97,
                32,
                38,
                38,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                45,
                45,
                85,
                91,
                97,
                32,
                43,
                32,
                49,
                93,
                32,
                38,
                38,
                32,
                40,
                85,
                91,
                97,
                93,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                118,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                86,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                34,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                117,
                115,
                101,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                100,
                32,
                118,
                97,
                108,
                46,
                32,
                104,
                97,
                110,
                100,
                108,
                101,
                32,
                61,
                32,
                34,
                32,
                43,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                85,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                103,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                110,
                117,
                108,
                108,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                116,
                114,
                117,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                54,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                102,
                97,
                108,
                115,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                56,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                32,
                61,
                32,
                118,
                98,
                46,
                112,
                111,
                112,
                40,
                41,
                32,
                124,
                124,
                32,
                85,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                91,
                98,
                93,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                91,
                98,
                32,
                43,
                32,
                49,
                93,
                32,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                120,
                98,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                34,
                101,
                109,
                115,
                99,
                114,
                105,
                112,
                116,
                101,
                110,
                58,
                58,
                118,
                97,
                108,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                86,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                103,
                98,
                40,
                98,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                73,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                121,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                117,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                120,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                121,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                122,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                67,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                68,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                122,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                75,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                99,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                32,
                61,
                32,
                96,
                36,
                123,
                98,
                125,
                32,
                104,
                97,
                115,
                32,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                111,
                98,
                40,
                97,
                41,
                125,
                96,
                44,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                101,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                110,
                117,
                108,
                108,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                124,
                124,
                32,
                34,
                97,
                114,
                114,
                97,
                121,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                124,
                124,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                63,
                32,
                97,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                43,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                65,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                110,
                97,
                91,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                56,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                111,
                97,
                91,
                99,
                32,
                62,
                62,
                32,
                51,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                102,
                108,
                111,
                97,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                66,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                49,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                117,
                91,
                100,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                120,
                91,
                100,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                50,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                121,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                122,
                91,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                52,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                32,
                63,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                67,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                68,
                91,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                105,
                110,
                116,
                101,
                103,
                101,
                114,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                40,
                36,
                123,
                98,
                125,
                41,
                58,
                32,
                36,
                123,
                97,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                67,
                98,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                123,
                32,
                111,
                112,
                116,
                105,
                111,
                110,
                97,
                108,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                44,
                32,
                120,
                98,
                41,
                44,
                32,
                68,
                98,
                32,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                32,
                63,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                34,
                117,
                116,
                102,
                45,
                49,
                54,
                108,
                101,
                34,
                41,
                32,
                58,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                69,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                32,
                62,
                62,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                99,
                32,
                43,
                32,
                98,
                32,
                47,
                32,
                50,
                59,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                100,
                41,
                32,
                38,
                38,
                32,
                122,
                91,
                99,
                93,
                59,
                32,
                41,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                60,
                60,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                51,
                50,
                32,
                60,
                32,
                99,
                32,
                45,
                32,
                97,
                32,
                38,
                38,
                32,
                68,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                68,
                98,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                120,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                97,
                44,
                32,
                99,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                33,
                40,
                100,
                32,
                62,
                61,
                32,
                98,
                32,
                47,
                32,
                50,
                41,
                59,
                32,
                43,
                43,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                121,
                91,
                97,
                32,
                43,
                32,
                50,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                32,
                101,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                70,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                63,
                63,
                32,
                40,
                99,
                32,
                61,
                32,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                55,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                62,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                45,
                61,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                99,
                32,
                60,
                32,
                50,
                32,
                42,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                63,
                32,
                99,
                32,
                47,
                32,
                50,
                32,
                58,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                99,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                121,
                91,
                98,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                44,
                32,
                98,
                32,
                43,
                61,
                32,
                50,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                91,
                98,
                32,
                62,
                62,
                32,
                49,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                45,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                71,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                50,
                32,
                42,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                44,
                32,
                72,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                48,
                44,
                32,
                100,
                32,
                61,
                32,
                34,
                34,
                59,
                32,
                33,
                40,
                99,
                32,
                62,
                61,
                32,
                98,
                32,
                47,
                32,
                52,
                41,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                67,
                91,
                97,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                32,
                101,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                60,
                61,
                32,
                101,
                32,
                63,
                32,
                40,
                101,
                32,
                45,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                44,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                124,
                32,
                101,
                32,
                62,
                62,
                32,
                49,
                48,
                44,
                32,
                53,
                54,
                51,
                50,
                48,
                32,
                124,
                32,
                101,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                41,
                32,
                58,
                32,
                100,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                73,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                63,
                63,
                32,
                40,
                99,
                32,
                61,
                32,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                55,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                52,
                32,
                62,
                32,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                100,
                32,
                43,
                32,
                99,
                32,
                45,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                101,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                102,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                43,
                43,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                43,
                32,
                40,
                40,
                102,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                41,
                32,
                60,
                60,
                32,
                49,
                48,
                41,
                32,
                124,
                32,
                107,
                32,
                38,
                32,
                49,
                48,
                50,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                32,
                43,
                32,
                52,
                32,
                62,
                32,
                99,
                41,
                32,
                98,
                114,
                101,
                97,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                45,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                74,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                99,
                32,
                61,
                32,
                48,
                59,
                32,
                99,
                32,
                60,
                32,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                43,
                43,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                43,
                61,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                75,
                98,
                32,
                61,
                32,
                48,
                44,
                32,
                76,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                100,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                38,
                38,
                32,
                40,
                68,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                103,
                98,
                40,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                77,
                98,
                32,
                61,
                32,
                91,
                93,
                44,
                32,
                78,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                77,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                79,
                98,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                44,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                32,
                100,
                32,
                60,
                32,
                97,
                59,
                32,
                43,
                43,
                100,
                41,
                32,
                99,
                91,
                100,
                93,
                32,
                61,
                32,
                122,
                98,
                40,
                68,
                91,
                98,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                100,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                34,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                34,
                32,
                43,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                80,
                98,
                32,
                61,
                32,
                82,
                101,
                102,
                108,
                101,
                99,
                116,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                44,
                32,
                81,
                98,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                82,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                65,
                97,
                32,
                124,
                124,
                32,
                34,
                117,
                110,
                119,
                105,
                110,
                100,
                34,
                32,
                61,
                61,
                32,
                97,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                83,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                32,
                124,
                124,
                32,
                48,
                32,
                60,
                32,
                75,
                98,
                32,
                124,
                124,
                32,
                40,
                104,
                46,
                111,
                110,
                69,
                120,
                105,
                116,
                63,
                46,
                40,
                97,
                41,
                44,
                32,
                108,
                97,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                65,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                84,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                97,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                40,
                41,
                44,
                32,
                33,
                40,
                67,
                97,
                32,
                124,
                124,
                32,
                48,
                32,
                60,
                32,
                75,
                98,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                32,
                61,
                32,
                97,
                32,
                61,
                32,
                109,
                97,
                44,
                32,
                83,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                85,
                98,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                87,
                98,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                86,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                83,
                69,
                82,
                58,
                32,
                34,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                79,
                71,
                78,
                65,
                77,
                69,
                58,
                32,
                34,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                65,
                84,
                72,
                58,
                32,
                34,
                47,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                87,
                68,
                58,
                32,
                34,
                47,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                79,
                77,
                69,
                58,
                32,
                34,
                47,
                104,
                111,
                109,
                101,
                47,
                119,
                101,
                98,
                95,
                117,
                115,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                65,
                78,
                71,
                58,
                32,
                40,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                32,
                38,
                38,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                46,
                108,
                97,
                110,
                103,
                117,
                97,
                103,
                101,
                115,
                32,
                38,
                38,
                32,
                110,
                97,
                118,
                105,
                103,
                97,
                116,
                111,
                114,
                46,
                108,
                97,
                110,
                103,
                117,
                97,
                103,
                101,
                115,
                91,
                48,
                93,
                32,
                124,
                124,
                32,
                34,
                67,
                34,
                41,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                45,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                95,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                32,
                43,
                32,
                34,
                46,
                85,
                84,
                70,
                45,
                56,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                58,
                32,
                104,
                97,
                32,
                124,
                124,
                32,
                34,
                46,
                47,
                116,
                104,
                105,
                115,
                46,
                112,
                114,
                111,
                103,
                114,
                97,
                109,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                98,
                32,
                105,
                110,
                32,
                85,
                98,
                41,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                85,
                98,
                91,
                98,
                93,
                32,
                63,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                97,
                91,
                98,
                93,
                32,
                58,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                85,
                98,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                98,
                32,
                105,
                110,
                32,
                97,
                41,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                96,
                36,
                123,
                98,
                125,
                61,
                36,
                123,
                97,
                91,
                98,
                93,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                98,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                86,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                86,
                98,
                44,
                32,
                88,
                98,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                32,
                38,
                38,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                46,
                103,
                101,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                86,
                97,
                108,
                117,
                101,
                115,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                99,
                114,
                121,
                112,
                116,
                111,
                46,
                103,
                101,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                86,
                97,
                108,
                117,
                101,
                115,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                97,
                40,
                34,
                105,
                110,
                105,
                116,
                82,
                97,
                110,
                100,
                111,
                109,
                68,
                101,
                118,
                105,
                99,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                89,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                89,
                98,
                32,
                61,
                32,
                88,
                98,
                40,
                41,
                41,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                32,
                61,
                32,
                104,
                46,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                101,
                120,
                116,
                101,
                110,
                100,
                115,
                32,
                69,
                114,
                114,
                111,
                114,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                112,
                101,
                114,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                34,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                90,
                98,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                50,
                53,
                54,
                41,
                44,
                32,
                36,
                98,
                32,
                61,
                32,
                48,
                59,
                32,
                50,
                53,
                54,
                32,
                62,
                32,
                36,
                98,
                59,
                32,
                43,
                43,
                36,
                98,
                41,
                32,
                90,
                98,
                91,
                36,
                98,
                93,
                32,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                36,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                97,
                32,
                61,
                32,
                90,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                32,
                61,
                32,
                104,
                46,
                66,
                105,
                110,
                100,
                105,
                110,
                103,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                101,
                120,
                116,
                101,
                110,
                100,
                115,
                32,
                69,
                114,
                114,
                111,
                114,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                112,
                101,
                114,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                34,
                66,
                105,
                110,
                100,
                105,
                110,
                103,
                69,
                114,
                114,
                111,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                88,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                65,
                108,
                105,
                97,
                115,
                79,
                102,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                116,
                104,
                105,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                88,
                97,
                32,
                38,
                38,
                32,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                88,
                97,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                66,
                97,
                44,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                67,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                65,
                97,
                32,
                61,
                32,
                97,
                46,
                65,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                97,
                46,
                65,
                97,
                46,
                68,
                97,
                46,
                66,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                97,
                32,
                61,
                32,
                97,
                46,
                65,
                97,
                46,
                67,
                97,
                59,
                32,
                98,
                46,
                71,
                97,
                59,
                32,
                41,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                81,
                97,
                40,
                99,
                41,
                44,
                32,
                98,
                32,
                61,
                32,
                98,
                46,
                71,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                59,
                32,
                100,
                46,
                71,
                97,
                59,
                32,
                41,
                32,
                97,
                32,
                61,
                32,
                100,
                46,
                81,
                97,
                40,
                97,
                41,
                44,
                32,
                100,
                32,
                61,
                32,
                100,
                46,
                71,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                32,
                61,
                61,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                99,
                32,
                61,
                61,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                111,
                110,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                67,
                97,
                32,
                124,
                124,
                32,
                79,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                80,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                43,
                61,
                32,
                49,
                44,
                32,
                116,
                104,
                105,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                81,
                44,
                32,
                98,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                44,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                44,
                32,
                100,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                103,
                101,
                116,
                80,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                79,
                102,
                40,
                116,
                104,
                105,
                115,
                41,
                44,
                32,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                99,
                97,
                108,
                108,
                40,
                98,
                44,
                32,
                100,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                97,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                123,
                32,
                99,
                111,
                117,
                110,
                116,
                58,
                32,
                101,
                46,
                99,
                111,
                117,
                110,
                116,
                44,
                32,
                79,
                97,
                58,
                32,
                101,
                46,
                79,
                97,
                44,
                32,
                80,
                97,
                58,
                32,
                101,
                46,
                80,
                97,
                44,
                32,
                67,
                97,
                58,
                32,
                101,
                46,
                67,
                97,
                44,
                32,
                68,
                97,
                58,
                32,
                101,
                46,
                68,
                97,
                44,
                32,
                70,
                97,
                58,
                32,
                101,
                46,
                70,
                97,
                44,
                32,
                72,
                97,
                58,
                32,
                101,
                46,
                72,
                97,
                32,
                125,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                65,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                43,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                65,
                97,
                46,
                79,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                91,
                34,
                100,
                101,
                108,
                101,
                116,
                101,
                34,
                93,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                67,
                97,
                32,
                124,
                124,
                32,
                79,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                79,
                97,
                32,
                38,
                38,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                80,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                34,
                79,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                115,
                99,
                104,
                101,
                100,
                117,
                108,
                101,
                100,
                32,
                102,
                111,
                114,
                32,
                100,
                101,
                108,
                101,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                45,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                32,
                38,
                38,
                32,
                40,
                97,
                46,
                70,
                97,
                32,
                63,
                32,
                97,
                46,
                72,
                97,
                46,
                75,
                97,
                40,
                97,
                46,
                70,
                97,
                41,
                32,
                58,
                32,
                97,
                46,
                68,
                97,
                46,
                66,
                97,
                46,
                75,
                97,
                40,
                97,
                46,
                67,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                80,
                97,
                32,
                124,
                124,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                70,
                97,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                67,
                97,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                68,
                101,
                108,
                101,
                116,
                101,
                100,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                67,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                76,
                97,
                116,
                101,
                114,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                67,
                97,
                32,
                124,
                124,
                32,
                79,
                97,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                79,
                97,
                32,
                38,
                38,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                80,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                34,
                79,
                98,
                106,
                101,
                99,
                116,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                115,
                99,
                104,
                101,
                100,
                117,
                108,
                101,
                100,
                32,
                102,
                111,
                114,
                32,
                100,
                101,
                108,
                101,
                116,
                105,
                111,
                110,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                65,
                97,
                46,
                79,
                97,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                97,
                115,
                115,
                105,
                103,
                110,
                40,
                105,
                98,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                98,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                32,
                38,
                38,
                32,
                40,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                89,
                97,
                40,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                97,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                75,
                97,
                63,
                46,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                73,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                98,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                83,
                97,
                32,
                63,
                32,
                86,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                66,
                97,
                46,
                77,
                97,
                44,
                32,
                123,
                32,
                68,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                98,
                44,
                32,
                67,
                97,
                58,
                32,
                99,
                44,
                32,
                72,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                70,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                32,
                58,
                32,
                86,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                66,
                97,
                46,
                77,
                97,
                44,
                32,
                123,
                32,
                68,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                67,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                99,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                87,
                97,
                40,
                97,
                41,
                44,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                85,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                66,
                97,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                61,
                32,
                100,
                46,
                65,
                97,
                46,
                99,
                111,
                117,
                110,
                116,
                46,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                46,
                65,
                97,
                46,
                67,
                97,
                32,
                61,
                32,
                99,
                44,
                32,
                100,
                46,
                65,
                97,
                46,
                70,
                97,
                32,
                61,
                32,
                97,
                44,
                32,
                100,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                100,
                46,
                99,
                108,
                111,
                110,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                87,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                66,
                97,
                46,
                98,
                98,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                83,
                97,
                91,
                100,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                98,
                46,
                99,
                97,
                108,
                108,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                82,
                97,
                32,
                63,
                32,
                100,
                46,
                90,
                97,
                32,
                58,
                32,
                100,
                46,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                84,
                121,
                112,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                82,
                97,
                40,
                99,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                66,
                97,
                44,
                32,
                100,
                46,
                66,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                32,
                61,
                61,
                61,
                32,
                101,
                32,
                63,
                32,
                98,
                46,
                99,
                97,
                108,
                108,
                40,
                116,
                104,
                105,
                115,
                41,
                32,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                83,
                97,
                32,
                63,
                32,
                86,
                97,
                40,
                100,
                46,
                66,
                97,
                46,
                77,
                97,
                44,
                32,
                123,
                32,
                68,
                97,
                58,
                32,
                100,
                44,
                32,
                67,
                97,
                58,
                32,
                101,
                44,
                32,
                72,
                97,
                58,
                32,
                116,
                104,
                105,
                115,
                44,
                32,
                70,
                97,
                58,
                32,
                97,
                32,
                125,
                41,
                32,
                58,
                32,
                86,
                97,
                40,
                100,
                46,
                66,
                97,
                46,
                77,
                97,
                44,
                32,
                123,
                32,
                68,
                97,
                58,
                32,
                100,
                44,
                32,
                67,
                97,
                58,
                32,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                98,
                32,
                61,
                32,
                104,
                46,
                85,
                110,
                98,
                111,
                117,
                110,
                100,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                32,
                61,
                32,
                40,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                89,
                97,
                40,
                98,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                100,
                41,
                46,
                115,
                116,
                97,
                99,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                38,
                38,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                99,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                32,
                43,
                32,
                34,
                92,
                110,
                34,
                32,
                43,
                32,
                100,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                47,
                94,
                69,
                114,
                114,
                111,
                114,
                40,
                58,
                91,
                94,
                92,
                110,
                93,
                42,
                41,
                63,
                92,
                110,
                47,
                44,
                32,
                34,
                34,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                63,
                32,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                32,
                58,
                32,
                96,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                110,
                97,
                109,
                101,
                125,
                58,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                69,
                114,
                114,
                111,
                114,
                44,
                32,
                34,
                85,
                110,
                98,
                111,
                117,
                110,
                100,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                46,
                112,
                117,
                115,
                104,
                40,
                48,
                44,
                32,
                49,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                44,
                32,
                49,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                49,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                49,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                99,
                111,
                117,
                110,
                116,
                95,
                101,
                109,
                118,
                97,
                108,
                95,
                104,
                97,
                110,
                100,
                108,
                101,
                115,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                85,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                47,
                32,
                50,
                32,
                45,
                32,
                53,
                32,
                45,
                32,
                118,
                98,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                99,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                117,
                97,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                65,
                115,
                115,
                101,
                114,
                116,
                105,
                111,
                110,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                97,
                32,
                63,
                32,
                69,
                97,
                40,
                97,
                41,
                32,
                58,
                32,
                34,
                34,
                125,
                44,
                32,
                97,
                116,
                58,
                32,
                96,
                32,
                43,
                32,
                91,
                98,
                32,
                63,
                32,
                98,
                32,
                63,
                32,
                69,
                97,
                40,
                98,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                58,
                32,
                34,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                105,
                108,
                101,
                110,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                44,
                32,
                100,
                32,
                63,
                32,
                100,
                32,
                63,
                32,
                69,
                97,
                40,
                100,
                41,
                32,
                58,
                32,
                34,
                34,
                32,
                58,
                32,
                34,
                117,
                110,
                107,
                110,
                111,
                119,
                110,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                93,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                106,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                70,
                97,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                100,
                46,
                67,
                97,
                32,
                43,
                32,
                49,
                54,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                100,
                46,
                67,
                97,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                100,
                46,
                67,
                97,
                32,
                43,
                32,
                56,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                71,
                97,
                32,
                61,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                97,
                43,
                43,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                71,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                80,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                117,
                97,
                40,
                34,
                34,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                73,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                73,
                97,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                98,
                46,
                85,
                97,
                44,
                32,
                100,
                32,
                61,
                32,
                98,
                46,
                75,
                97,
                44,
                32,
                101,
                32,
                61,
                32,
                98,
                46,
                88,
                97,
                44,
                32,
                102,
                32,
                61,
                32,
                101,
                46,
                109,
                97,
                112,
                40,
                40,
                107,
                41,
                32,
                61,
                62,
                32,
                107,
                46,
                103,
                98,
                41,
                46,
                99,
                111,
                110,
                99,
                97,
                116,
                40,
                101,
                46,
                109,
                97,
                112,
                40,
                40,
                107,
                41,
                32,
                61,
                62,
                32,
                107,
                46,
                109,
                98,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                91,
                97,
                93,
                44,
                32,
                102,
                44,
                32,
                40,
                107,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                108,
                44,
                32,
                110,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                107,
                91,
                110,
                93,
                44,
                32,
                113,
                32,
                61,
                32,
                108,
                46,
                101,
                98,
                44,
                32,
                114,
                32,
                61,
                32,
                108,
                46,
                102,
                98,
                44,
                32,
                65,
                32,
                61,
                32,
                107,
                91,
                110,
                32,
                43,
                32,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                44,
                32,
                118,
                32,
                61,
                32,
                108,
                46,
                108,
                98,
                44,
                32,
                119,
                32,
                61,
                32,
                108,
                46,
                110,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                91,
                108,
                46,
                97,
                98,
                93,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                58,
                32,
                40,
                69,
                41,
                32,
                61,
                62,
                32,
                109,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                113,
                40,
                114,
                44,
                32,
                69,
                41,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                114,
                105,
                116,
                101,
                58,
                32,
                40,
                69,
                44,
                32,
                100,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                66,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                40,
                119,
                44,
                32,
                69,
                44,
                32,
                65,
                46,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                66,
                44,
                32,
                100,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                40,
                66,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                46,
                110,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                110,
                32,
                61,
                32,
                123,
                125,
                44,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                109,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                110,
                91,
                109,
                93,
                32,
                61,
                32,
                103,
                91,
                109,
                93,
                46,
                114,
                101,
                97,
                100,
                40,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                40,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                108,
                44,
                32,
                110,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                109,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                109,
                32,
                105,
                110,
                32,
                110,
                41,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                84,
                121,
                112,
                101,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                77,
                105,
                115,
                115,
                105,
                110,
                103,
                32,
                102,
                105,
                101,
                108,
                100,
                58,
                32,
                34,
                36,
                123,
                109,
                125,
                34,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                113,
                32,
                61,
                32,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                109,
                32,
                105,
                110,
                32,
                103,
                41,
                32,
                103,
                91,
                109,
                93,
                46,
                119,
                114,
                105,
                116,
                101,
                40,
                113,
                44,
                32,
                110,
                91,
                109,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                108,
                32,
                38,
                38,
                32,
                108,
                46,
                112,
                117,
                115,
                104,
                40,
                100,
                44,
                32,
                113,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                113,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                73,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                58,
                32,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                79,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                33,
                33,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                44,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                32,
                63,
                32,
                99,
                32,
                58,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                40,
                120,
                91,
                101,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                110,
                44,
                32,
                109,
                44,
                32,
                113,
                44,
                32,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                61,
                32,
                79,
                40,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                83,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                38,
                38,
                32,
                40,
                103,
                32,
                61,
                32,
                83,
                40,
                107,
                44,
                32,
                103,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                32,
                38,
                38,
                32,
                40,
                110,
                32,
                61,
                32,
                83,
                40,
                108,
                44,
                32,
                110,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                32,
                61,
                32,
                83,
                40,
                113,
                44,
                32,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                65,
                32,
                61,
                32,
                97,
                98,
                40,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                36,
                97,
                40,
                65,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                36,
                123,
                109,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                91,
                100,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                91,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                93,
                44,
                32,
                100,
                32,
                63,
                32,
                91,
                100,
                93,
                32,
                58,
                32,
                91,
                93,
                44,
                32,
                40,
                118,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                118,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                119,
                32,
                61,
                32,
                118,
                46,
                66,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                32,
                61,
                32,
                119,
                46,
                77,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                69,
                32,
                61,
                32,
                88,
                97,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                89,
                97,
                40,
                109,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                46,
                46,
                46,
                78,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                103,
                101,
                116,
                80,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                79,
                102,
                40,
                116,
                104,
                105,
                115,
                41,
                32,
                33,
                61,
                61,
                32,
                100,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                34,
                85,
                115,
                101,
                32,
                39,
                110,
                101,
                119,
                39,
                32,
                116,
                111,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                34,
                32,
                43,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                66,
                46,
                76,
                97,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                109,
                32,
                43,
                32,
                34,
                32,
                104,
                97,
                115,
                32,
                110,
                111,
                32,
                97,
                99,
                99,
                101,
                115,
                115,
                105,
                98,
                108,
                101,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                117,
                98,
                32,
                61,
                32,
                66,
                46,
                76,
                97,
                91,
                78,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                117,
                98,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                84,
                114,
                105,
                101,
                100,
                32,
                116,
                111,
                32,
                105,
                110,
                118,
                111,
                107,
                101,
                32,
                99,
                116,
                111,
                114,
                32,
                111,
                102,
                32,
                36,
                123,
                109,
                125,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                40,
                36,
                123,
                78,
                97,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                125,
                41,
                32,
                45,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                40,
                36,
                123,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                107,
                101,
                121,
                115,
                40,
                66,
                46,
                76,
                97,
                41,
                46,
                116,
                111,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                125,
                41,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                105,
                110,
                115,
                116,
                101,
                97,
                100,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                117,
                98,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                78,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                97,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                69,
                44,
                32,
                123,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                118,
                32,
                125,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                32,
                61,
                32,
                100,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                66,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                98,
                98,
                40,
                109,
                44,
                32,
                118,
                44,
                32,
                100,
                97,
                44,
                32,
                114,
                44,
                32,
                119,
                44,
                32,
                102,
                44,
                32,
                103,
                44,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                66,
                46,
                71,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                101,
                97,
                32,
                61,
                32,
                66,
                46,
                71,
                97,
                41,
                46,
                86,
                97,
                32,
                63,
                63,
                32,
                40,
                101,
                97,
                46,
                86,
                97,
                32,
                61,
                32,
                91,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                46,
                71,
                97,
                46,
                86,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                66,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                105,
                98,
                40,
                109,
                44,
                32,
                66,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                105,
                98,
                40,
                109,
                32,
                43,
                32,
                34,
                42,
                34,
                44,
                32,
                66,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                105,
                98,
                40,
                109,
                32,
                43,
                32,
                34,
                32,
                99,
                111,
                110,
                115,
                116,
                42,
                34,
                44,
                32,
                66,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                97,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                84,
                121,
                112,
                101,
                58,
                32,
                101,
                97,
                44,
                32,
                90,
                97,
                58,
                32,
                69,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                106,
                98,
                40,
                65,
                44,
                32,
                118,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                119,
                44,
                32,
                101,
                97,
                44,
                32,
                69,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                113,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                83,
                40,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                91,
                93,
                44,
                32,
                91,
                97,
                93,
                44,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                103,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                96,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                32,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                103,
                46,
                66,
                97,
                46,
                76,
                97,
                32,
                38,
                38,
                32,
                40,
                103,
                46,
                66,
                97,
                46,
                76,
                97,
                32,
                61,
                32,
                91,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                103,
                46,
                66,
                97,
                46,
                76,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                114,
                101,
                103,
                105,
                115,
                116,
                101,
                114,
                32,
                109,
                117,
                108,
                116,
                105,
                112,
                108,
                101,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                115,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                101,
                110,
                116,
                105,
                99,
                97,
                108,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                32,
                111,
                102,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                115,
                32,
                40,
                36,
                123,
                98,
                32,
                45,
                32,
                49,
                125,
                41,
                32,
                102,
                111,
                114,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                39,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                39,
                33,
                32,
                79,
                118,
                101,
                114,
                108,
                111,
                97,
                100,
                32,
                114,
                101,
                115,
                111,
                108,
                117,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                108,
                121,
                32,
                111,
                110,
                108,
                121,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                101,
                100,
                32,
                117,
                115,
                105,
                110,
                103,
                32,
                116,
                104,
                101,
                32,
                112,
                97,
                114,
                97,
                109,
                101,
                116,
                101,
                114,
                32,
                99,
                111,
                117,
                110,
                116,
                44,
                32,
                110,
                111,
                116,
                32,
                97,
                99,
                116,
                117,
                97,
                108,
                32,
                116,
                121,
                112,
                101,
                32,
                105,
                110,
                102,
                111,
                33,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                46,
                66,
                97,
                46,
                76,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                32,
                36,
                123,
                103,
                46,
                110,
                97,
                109,
                101,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                91,
                93,
                44,
                32,
                107,
                44,
                32,
                40,
                110,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                46,
                115,
                112,
                108,
                105,
                99,
                101,
                40,
                49,
                44,
                32,
                48,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                46,
                66,
                97,
                46,
                76,
                97,
                91,
                98,
                32,
                45,
                32,
                49,
                93,
                32,
                61,
                32,
                115,
                98,
                40,
                108,
                44,
                32,
                110,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                113,
                98,
                40,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                79,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                116,
                98,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                83,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                91,
                93,
                44,
                32,
                91,
                97,
                93,
                44,
                32,
                40,
                110,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                109,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                97,
                108,
                108,
                32,
                36,
                123,
                113,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                32,
                61,
                32,
                110,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                113,
                32,
                61,
                32,
                96,
                36,
                123,
                110,
                46,
                110,
                97,
                109,
                101,
                125,
                46,
                36,
                123,
                98,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                64,
                64,
                34,
                41,
                32,
                38,
                38,
                32,
                40,
                98,
                32,
                61,
                32,
                83,
                121,
                109,
                98,
                111,
                108,
                91,
                98,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                105,
                110,
                103,
                40,
                50,
                41,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                38,
                38,
                32,
                110,
                46,
                66,
                97,
                46,
                106,
                98,
                46,
                112,
                117,
                115,
                104,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                114,
                32,
                61,
                32,
                110,
                46,
                66,
                97,
                46,
                77,
                97,
                44,
                32,
                65,
                32,
                61,
                32,
                114,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                65,
                32,
                124,
                124,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                65,
                46,
                69,
                97,
                32,
                38,
                38,
                32,
                65,
                46,
                99,
                108,
                97,
                115,
                115,
                78,
                97,
                109,
                101,
                32,
                33,
                61,
                61,
                32,
                110,
                46,
                110,
                97,
                109,
                101,
                32,
                38,
                38,
                32,
                65,
                46,
                78,
                97,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                32,
                63,
                32,
                40,
                109,
                46,
                78,
                97,
                32,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                44,
                32,
                109,
                46,
                99,
                108,
                97,
                115,
                115,
                78,
                97,
                109,
                101,
                32,
                61,
                32,
                110,
                46,
                110,
                97,
                109,
                101,
                44,
                32,
                114,
                91,
                98,
                93,
                32,
                61,
                32,
                109,
                41,
                32,
                58,
                32,
                40,
                90,
                97,
                40,
                114,
                44,
                32,
                98,
                44,
                32,
                113,
                41,
                44,
                32,
                114,
                91,
                98,
                93,
                46,
                69,
                97,
                91,
                99,
                32,
                45,
                32,
                50,
                93,
                32,
                61,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                91,
                93,
                44,
                32,
                108,
                44,
                32,
                40,
                118,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                32,
                61,
                32,
                115,
                98,
                40,
                113,
                44,
                32,
                118,
                44,
                32,
                110,
                44,
                32,
                102,
                44,
                32,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                114,
                91,
                98,
                93,
                46,
                69,
                97,
                32,
                63,
                32,
                40,
                118,
                46,
                78,
                97,
                32,
                61,
                32,
                99,
                32,
                45,
                32,
                50,
                44,
                32,
                114,
                91,
                98,
                93,
                32,
                61,
                32,
                118,
                41,
                32,
                58,
                32,
                114,
                91,
                98,
                93,
                46,
                69,
                97,
                91,
                99,
                32,
                45,
                32,
                50,
                93,
                32,
                61,
                32,
                118,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                77,
                40,
                97,
                44,
                32,
                120,
                98,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                79,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                32,
                61,
                32,
                123,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                91,
                102,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                102,
                44,
                32,
                107,
                41,
                32,
                61,
                62,
                32,
                107,
                46,
                118,
                97,
                108,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                121,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                36,
                97,
                40,
                98,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                122,
                98,
                40,
                97,
                44,
                32,
                34,
                101,
                110,
                117,
                109,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                79,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                100,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                40,
                100,
                46,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                99,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                58,
                32,
                123,
                32,
                118,
                97,
                108,
                117,
                101,
                58,
                32,
                89,
                97,
                40,
                96,
                36,
                123,
                100,
                46,
                110,
                97,
                109,
                101,
                125,
                95,
                36,
                123,
                98,
                125,
                96,
                44,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                46,
                118,
                97,
                108,
                117,
                101,
                115,
                91,
                99,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                91,
                98,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                65,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                79,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                100,
                41,
                32,
                61,
                62,
                32,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                65,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                113,
                98,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                79,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                116,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                83,
                40,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                36,
                97,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                98,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                99,
                97,
                108,
                108,
                32,
                36,
                123,
                97,
                125,
                32,
                100,
                117,
                101,
                32,
                116,
                111,
                32,
                117,
                110,
                98,
                111,
                117,
                110,
                100,
                32,
                116,
                121,
                112,
                101,
                115,
                96,
                44,
                32,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                45,
                32,
                49,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                91,
                93,
                44,
                32,
                107,
                44,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                106,
                98,
                40,
                97,
                44,
                32,
                115,
                98,
                40,
                97,
                44,
                32,
                91,
                103,
                91,
                48,
                93,
                44,
                32,
                110,
                117,
                108,
                108,
                93,
                46,
                99,
                111,
                110,
                99,
                97,
                116,
                40,
                103,
                46,
                115,
                108,
                105,
                99,
                101,
                40,
                49,
                41,
                41,
                44,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                44,
                32,
                98,
                32,
                45,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                79,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                49,
                32,
                61,
                61,
                61,
                32,
                101,
                32,
                38,
                38,
                32,
                40,
                101,
                32,
                61,
                32,
                52,
                50,
                57,
                52,
                57,
                54,
                55,
                50,
                57,
                53,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                48,
                32,
                61,
                61,
                61,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                51,
                50,
                32,
                45,
                32,
                56,
                32,
                42,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                103,
                32,
                60,
                60,
                32,
                102,
                32,
                62,
                62,
                62,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                98,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                117,
                110,
                115,
                105,
                103,
                110,
                101,
                100,
                34,
                41,
                32,
                63,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                32,
                62,
                62,
                62,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                40,
                97,
                44,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                101,
                44,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                107,
                44,
                32,
                73,
                97,
                58,
                32,
                56,
                44,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                66,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                48,
                32,
                33,
                61,
                61,
                32,
                100,
                41,
                44,
                32,
                74,
                97,
                58,
                32,
                110,
                117,
                108,
                108,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                101,
                40,
                117,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                68,
                91,
                102,
                32,
                43,
                32,
                52,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                68,
                91,
                102,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                91,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                73,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                49,
                54,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                73,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                85,
                105,
                110,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                70,
                108,
                111,
                97,
                116,
                51,
                50,
                65,
                114,
                114,
                97,
                121,
                44,
                32,
                70,
                108,
                111,
                97,
                116,
                54,
                52,
                65,
                114,
                114,
                97,
                121,
                93,
                91,
                98,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                79,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                40,
                97,
                44,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                99,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                100,
                44,
                32,
                73,
                97,
                58,
                32,
                56,
                44,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                100,
                32,
                125,
                44,
                32,
                123,
                32,
                104,
                98,
                58,
                32,
                116,
                114,
                117,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                40,
                97,
                44,
                32,
                67,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                110,
                44,
                32,
                109,
                44,
                32,
                113,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                79,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                32,
                61,
                32,
                83,
                40,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                83,
                40,
                107,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                32,
                61,
                32,
                83,
                40,
                108,
                44,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                113,
                32,
                61,
                32,
                83,
                40,
                109,
                44,
                32,
                113,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                78,
                40,
                91,
                97,
                93,
                44,
                32,
                91,
                98,
                93,
                44,
                32,
                40,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                32,
                61,
                32,
                114,
                91,
                48,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                110,
                101,
                119,
                32,
                105,
                98,
                40,
                99,
                44,
                32,
                114,
                46,
                66,
                97,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                114,
                44,
                32,
                100,
                44,
                32,
                102,
                44,
                32,
                103,
                44,
                32,
                110,
                44,
                32,
                113,
                41,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                90,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                79,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                68,
                91,
                99,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                101,
                32,
                61,
                32,
                99,
                32,
                43,
                32,
                52,
                44,
                32,
                102,
                44,
                32,
                107,
                32,
                61,
                32,
                101,
                44,
                32,
                103,
                32,
                61,
                32,
                48,
                59,
                32,
                103,
                32,
                60,
                61,
                32,
                100,
                59,
                32,
                43,
                43,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                101,
                32,
                43,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                32,
                61,
                61,
                32,
                100,
                32,
                124,
                124,
                32,
                48,
                32,
                61,
                61,
                32,
                120,
                91,
                108,
                93,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                32,
                61,
                32,
                107,
                32,
                63,
                32,
                69,
                97,
                40,
                107,
                44,
                32,
                108,
                32,
                45,
                32,
                107,
                41,
                32,
                58,
                32,
                34,
                34,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                102,
                32,
                63,
                32,
                102,
                32,
                61,
                32,
                107,
                32,
                58,
                32,
                40,
                102,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                48,
                41,
                44,
                32,
                102,
                32,
                43,
                61,
                32,
                107,
                41,
                44,
                32,
                107,
                32,
                61,
                32,
                108,
                32,
                43,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                38,
                38,
                32,
                40,
                100,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                44,
                32,
                102,
                32,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                102,
                32,
                124,
                124,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                32,
                124,
                124,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                85,
                105,
                110,
                116,
                56,
                67,
                108,
                97,
                109,
                112,
                101,
                100,
                65,
                114,
                114,
                97,
                121,
                32,
                124,
                124,
                32,
                100,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                73,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                34,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                110,
                111,
                110,
                45,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                115,
                116,
                100,
                58,
                58,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                101,
                32,
                61,
                32,
                48,
                59,
                32,
                107,
                32,
                60,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                100,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                49,
                50,
                55,
                32,
                62,
                61,
                32,
                103,
                32,
                63,
                32,
                101,
                43,
                43,
                32,
                58,
                32,
                50,
                48,
                52,
                55,
                32,
                62,
                61,
                32,
                103,
                32,
                63,
                32,
                101,
                32,
                43,
                61,
                32,
                50,
                32,
                58,
                32,
                53,
                53,
                50,
                57,
                54,
                32,
                60,
                61,
                32,
                103,
                32,
                38,
                38,
                32,
                53,
                55,
                51,
                52,
                51,
                32,
                62,
                61,
                32,
                103,
                32,
                63,
                32,
                40,
                101,
                32,
                43,
                61,
                32,
                52,
                44,
                32,
                43,
                43,
                107,
                41,
                32,
                58,
                32,
                101,
                32,
                43,
                61,
                32,
                51,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                101,
                32,
                61,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                32,
                61,
                32,
                97,
                99,
                40,
                52,
                32,
                43,
                32,
                101,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                103,
                32,
                61,
                32,
                107,
                32,
                43,
                32,
                52,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                107,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                41,
                32,
                72,
                40,
                100,
                44,
                32,
                103,
                44,
                32,
                101,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                101,
                59,
                32,
                43,
                43,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                100,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                53,
                53,
                32,
                60,
                32,
                108,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                84,
                40,
                103,
                41,
                44,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                34,
                83,
                116,
                114,
                105,
                110,
                103,
                32,
                104,
                97,
                115,
                32,
                85,
                84,
                70,
                45,
                49,
                54,
                32,
                99,
                111,
                100,
                101,
                32,
                117,
                110,
                105,
                116,
                115,
                32,
                116,
                104,
                97,
                116,
                32,
                100,
                111,
                32,
                110,
                111,
                116,
                32,
                102,
                105,
                116,
                32,
                105,
                110,
                32,
                56,
                32,
                98,
                105,
                116,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                91,
                103,
                32,
                43,
                32,
                102,
                93,
                32,
                61,
                32,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                108,
                115,
                101,
                32,
                102,
                111,
                114,
                32,
                40,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                101,
                59,
                32,
                43,
                43,
                102,
                41,
                32,
                120,
                91,
                103,
                32,
                43,
                32,
                102,
                93,
                32,
                61,
                32,
                100,
                91,
                102,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                38,
                38,
                32,
                99,
                46,
                112,
                117,
                115,
                104,
                40,
                84,
                44,
                32,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                73,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                121,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                61,
                32,
                79,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                32,
                61,
                61,
                61,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                69,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                70,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                71,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                122,
                91,
                103,
                32,
                62,
                62,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                52,
                32,
                61,
                61,
                61,
                32,
                98,
                32,
                38,
                38,
                32,
                40,
                100,
                32,
                61,
                32,
                72,
                98,
                44,
                32,
                101,
                32,
                61,
                32,
                73,
                98,
                44,
                32,
                102,
                32,
                61,
                32,
                74,
                98,
                44,
                32,
                107,
                32,
                61,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                68,
                91,
                103,
                32,
                62,
                62,
                32,
                50,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                40,
                97,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                103,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                108,
                32,
                61,
                32,
                68,
                91,
                103,
                32,
                62,
                62,
                32,
                50,
                93,
                44,
                32,
                110,
                44,
                32,
                109,
                32,
                61,
                32,
                103,
                32,
                43,
                32,
                52,
                44,
                32,
                113,
                32,
                61,
                32,
                48,
                59,
                32,
                113,
                32,
                60,
                61,
                32,
                108,
                59,
                32,
                43,
                43,
                113,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                114,
                32,
                61,
                32,
                103,
                32,
                43,
                32,
                52,
                32,
                43,
                32,
                113,
                32,
                42,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                113,
                32,
                61,
                61,
                32,
                108,
                32,
                124,
                124,
                32,
                48,
                32,
                61,
                61,
                32,
                107,
                40,
                114,
                41,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                32,
                61,
                32,
                100,
                40,
                109,
                44,
                32,
                114,
                32,
                45,
                32,
                109,
                41,
                44,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                32,
                61,
                61,
                61,
                32,
                110,
                32,
                63,
                32,
                110,
                32,
                61,
                32,
                109,
                32,
                58,
                32,
                40,
                110,
                32,
                43,
                61,
                32,
                83,
                116,
                114,
                105,
                110,
                103,
                46,
                102,
                114,
                111,
                109,
                67,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                40,
                48,
                41,
                44,
                32,
                110,
                32,
                43,
                61,
                32,
                109,
                41,
                44,
                32,
                109,
                32,
                61,
                32,
                114,
                32,
                43,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                32,
                33,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                108,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                80,
                40,
                96,
                67,
                97,
                110,
                110,
                111,
                116,
                32,
                112,
                97,
                115,
                115,
                32,
                110,
                111,
                110,
                45,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                67,
                43,
                43,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                116,
                121,
                112,
                101,
                32,
                36,
                123,
                99,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                110,
                32,
                61,
                32,
                102,
                40,
                108,
                41,
                44,
                32,
                109,
                32,
                61,
                32,
                97,
                99,
                40,
                52,
                32,
                43,
                32,
                110,
                32,
                43,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                109,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                110,
                32,
                47,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                40,
                108,
                44,
                32,
                109,
                32,
                43,
                32,
                52,
                44,
                32,
                110,
                32,
                43,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                117,
                108,
                108,
                32,
                33,
                61,
                61,
                32,
                103,
                32,
                38,
                38,
                32,
                103,
                46,
                112,
                117,
                115,
                104,
                40,
                84,
                44,
                32,
                109,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                58,
                32,
                56,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                58,
                32,
                73,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                40,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                120,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                79,
                40,
                98,
                41,
                44,
                32,
                85,
                97,
                58,
                32,
                83,
                40,
                99,
                44,
                32,
                100,
                41,
                44,
                32,
                75,
                97,
                58,
                32,
                83,
                40,
                101,
                44,
                32,
                102,
                41,
                44,
                32,
                88,
                97,
                58,
                32,
                91,
                93,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                110,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                97,
                91,
                97,
                93,
                46,
                88,
                97,
                46,
                112,
                117,
                115,
                104,
                40,
                123,
                32,
                97,
                98,
                58,
                32,
                79,
                40,
                98,
                41,
                44,
                32,
                103,
                98,
                58,
                32,
                99,
                44,
                32,
                101,
                98,
                58,
                32,
                83,
                40,
                100,
                44,
                32,
                101,
                41,
                44,
                32,
                102,
                98,
                58,
                32,
                102,
                44,
                32,
                109,
                98,
                58,
                32,
                107,
                44,
                32,
                108,
                98,
                58,
                32,
                83,
                40,
                103,
                44,
                32,
                108,
                41,
                44,
                32,
                110,
                98,
                58,
                32,
                110,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                36,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                79,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                77,
                40,
                97,
                44,
                32,
                123,
                32,
                112,
                98,
                58,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                98,
                44,
                32,
                73,
                97,
                58,
                32,
                48,
                44,
                32,
                102,
                114,
                111,
                109,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                116,
                111,
                87,
                105,
                114,
                101,
                84,
                121,
                112,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                75,
                98,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                73,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                73,
                110,
                102,
                105,
                110,
                105,
                116,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                86,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                122,
                98,
                40,
                98,
                44,
                32,
                34,
                101,
                109,
                118,
                97,
                108,
                58,
                58,
                97,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                76,
                98,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                77,
                98,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                86,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                40,
                110,
                117,
                108,
                108,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                58,
                32,
                119,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                69,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                86,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                86,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                32,
                61,
                61,
                32,
                98,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                111,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                79,
                98,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                101,
                32,
                61,
                32,
                100,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                45,
                45,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                65,
                114,
                114,
                97,
                121,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                96,
                109,
                101,
                116,
                104,
                111,
                100,
                67,
                97,
                108,
                108,
                101,
                114,
                60,
                40,
                36,
                123,
                100,
                46,
                109,
                97,
                112,
                40,
                40,
                107,
                41,
                32,
                61,
                62,
                32,
                107,
                46,
                110,
                97,
                109,
                101,
                41,
                46,
                106,
                111,
                105,
                110,
                40,
                34,
                44,
                32,
                34,
                41,
                125,
                41,
                32,
                61,
                62,
                32,
                36,
                123,
                101,
                46,
                110,
                97,
                109,
                101,
                125,
                62,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                78,
                98,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                97,
                40,
                98,
                44,
                32,
                40,
                107,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                110,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                109,
                32,
                61,
                32,
                48,
                44,
                32,
                113,
                32,
                61,
                32,
                48,
                59,
                32,
                113,
                32,
                60,
                32,
                97,
                59,
                32,
                43,
                43,
                113,
                41,
                32,
                102,
                91,
                113,
                93,
                32,
                61,
                32,
                100,
                91,
                113,
                93,
                46,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                40,
                110,
                32,
                43,
                32,
                109,
                41,
                44,
                32,
                109,
                32,
                43,
                61,
                32,
                100,
                91,
                113,
                93,
                46,
                73,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                32,
                61,
                32,
                49,
                32,
                61,
                61,
                61,
                32,
                99,
                32,
                63,
                32,
                80,
                98,
                40,
                103,
                44,
                32,
                102,
                41,
                32,
                58,
                32,
                103,
                46,
                97,
                112,
                112,
                108,
                121,
                40,
                107,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                76,
                98,
                40,
                101,
                44,
                32,
                108,
                44,
                32,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                122,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                57,
                32,
                60,
                32,
                97,
                32,
                38,
                38,
                32,
                40,
                85,
                91,
                97,
                32,
                43,
                32,
                49,
                93,
                32,
                43,
                61,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                86,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                97,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                122,
                98,
                40,
                97,
                44,
                32,
                34,
                95,
                101,
                109,
                118,
                97,
                108,
                95,
                116,
                97,
                107,
                101,
                95,
                118,
                97,
                108,
                117,
                101,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                97,
                46,
                114,
                101,
                97,
                100,
                86,
                97,
                108,
                117,
                101,
                70,
                114,
                111,
                109,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                103,
                98,
                40,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                71,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                98,
                91,
                97,
                93,
                32,
                38,
                38,
                32,
                40,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                81,
                98,
                91,
                97,
                93,
                46,
                105,
                100,
                41,
                44,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                81,
                98,
                91,
                97,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                108,
                101,
                116,
                101,
                32,
                81,
                98,
                91,
                97,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                84,
                98,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                98,
                99,
                40,
                97,
                44,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                97,
                110,
                99,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                98,
                91,
                97,
                93,
                32,
                61,
                32,
                123,
                32,
                105,
                100,
                58,
                32,
                99,
                44,
                32,
                113,
                98,
                58,
                32,
                98,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                72,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                40,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                41,
                41,
                46,
                103,
                101,
                116,
                70,
                117,
                108,
                108,
                89,
                101,
                97,
                114,
                40,
                41,
                44,
                32,
                102,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                101,
                44,
                32,
                48,
                44,
                32,
                49,
                41,
                46,
                103,
                101,
                116,
                84,
                105,
                109,
                101,
                122,
                111,
                110,
                101,
                79,
                102,
                102,
                115,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                97,
                116,
                101,
                40,
                101,
                44,
                32,
                54,
                44,
                32,
                49,
                41,
                46,
                103,
                101,
                116,
                84,
                105,
                109,
                101,
                122,
                111,
                110,
                101,
                79,
                102,
                102,
                115,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                54,
                48,
                32,
                42,
                32,
                77,
                97,
                116,
                104,
                46,
                109,
                97,
                120,
                40,
                102,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                78,
                117,
                109,
                98,
                101,
                114,
                40,
                102,
                32,
                33,
                61,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                40,
                107,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                103,
                32,
                61,
                32,
                77,
                97,
                116,
                104,
                46,
                97,
                98,
                115,
                40,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                96,
                85,
                84,
                67,
                36,
                123,
                48,
                32,
                60,
                61,
                32,
                107,
                32,
                63,
                32,
                34,
                45,
                34,
                32,
                58,
                32,
                34,
                43,
                34,
                125,
                36,
                123,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                77,
                97,
                116,
                104,
                46,
                102,
                108,
                111,
                111,
                114,
                40,
                103,
                32,
                47,
                32,
                54,
                48,
                41,
                41,
                46,
                112,
                97,
                100,
                83,
                116,
                97,
                114,
                116,
                40,
                50,
                44,
                32,
                34,
                48,
                34,
                41,
                125,
                36,
                123,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                103,
                32,
                37,
                32,
                54,
                48,
                41,
                46,
                112,
                97,
                100,
                83,
                116,
                97,
                114,
                116,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                48,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                125,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                61,
                32,
                98,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                32,
                61,
                32,
                98,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                60,
                32,
                102,
                32,
                63,
                32,
                40,
                72,
                40,
                97,
                44,
                32,
                99,
                44,
                32,
                49,
                55,
                41,
                44,
                32,
                72,
                40,
                98,
                44,
                32,
                100,
                44,
                32,
                49,
                55,
                41,
                41,
                32,
                58,
                32,
                40,
                72,
                40,
                97,
                44,
                32,
                100,
                44,
                32,
                49,
                55,
                41,
                44,
                32,
                72,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                49,
                55,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                112,
                101,
                114,
                102,
                111,
                114,
                109,
                97,
                110,
                99,
                101,
                46,
                110,
                111,
                119,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                74,
                58,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                120,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                32,
                62,
                62,
                62,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                56,
                32,
                60,
                32,
                97,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                49,
                59,
                32,
                52,
                32,
                62,
                61,
                32,
                99,
                59,
                32,
                99,
                32,
                42,
                61,
                32,
                50,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                98,
                32,
                42,
                32,
                40,
                49,
                32,
                43,
                32,
                48,
                46,
                50,
                32,
                47,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                77,
                97,
                116,
                104,
                46,
                109,
                105,
                110,
                40,
                100,
                44,
                32,
                97,
                32,
                43,
                32,
                49,
                48,
                48,
                54,
                54,
                51,
                50,
                57,
                54,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                32,
                61,
                32,
                40,
                77,
                97,
                116,
                104,
                46,
                109,
                105,
                110,
                40,
                50,
                49,
                52,
                55,
                52,
                56,
                51,
                54,
                52,
                56,
                44,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                42,
                32,
                77,
                97,
                116,
                104,
                46,
                99,
                101,
                105,
                108,
                40,
                77,
                97,
                116,
                104,
                46,
                109,
                97,
                120,
                40,
                97,
                44,
                32,
                100,
                41,
                32,
                47,
                32,
                54,
                53,
                53,
                51,
                54,
                41,
                41,
                32,
                45,
                32,
                107,
                97,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                54,
                53,
                53,
                51,
                53,
                41,
                32,
                47,
                32,
                54,
                53,
                53,
                51,
                54,
                32,
                124,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                97,
                46,
                103,
                114,
                111,
                119,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                114,
                101,
                97,
                107,
                32,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                86,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                98,
                40,
                41,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                98,
                32,
                43,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                32,
                61,
                32,
                68,
                91,
                97,
                32,
                43,
                32,
                52,
                32,
                42,
                32,
                101,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                102,
                32,
                61,
                32,
                48,
                59,
                32,
                102,
                32,
                60,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                43,
                43,
                102,
                41,
                32,
                117,
                91,
                101,
                43,
                43,
                93,
                32,
                61,
                32,
                100,
                46,
                99,
                104,
                97,
                114,
                67,
                111,
                100,
                101,
                65,
                116,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                91,
                101,
                93,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                32,
                43,
                61,
                32,
                100,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                87,
                98,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                97,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                99,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                41,
                32,
                61,
                62,
                32,
                100,
                32,
                43,
                61,
                32,
                101,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                43,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                91,
                98,
                32,
                62,
                62,
                32,
                50,
                93,
                32,
                61,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                83,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                53,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                81,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                53,
                50,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                58,
                32,
                99,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                58,
                32,
                100,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                58,
                32,
                101,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                58,
                32,
                102,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                58,
                32,
                103,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                58,
                32,
                104,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                58,
                32,
                105,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                58,
                32,
                106,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                58,
                32,
                107,
                99,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                85,
                58,
                32,
                83,
                98,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                76,
                58,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                98,
                40,
                120,
                46,
                115,
                117,
                98,
                97,
                114,
                114,
                97,
                121,
                40,
                97,
                44,
                32,
                97,
                32,
                43,
                32,
                98,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                87,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                40,
                97,
                115,
                121,
                110,
                99,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                97,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                87,
                32,
                61,
                32,
                100,
                46,
                101,
                120,
                112,
                111,
                114,
                116,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                107,
                97,
                32,
                61,
                32,
                87,
                46,
                100,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                32,
                61,
                32,
                87,
                46,
                103,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                87,
                46,
                101,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                45,
                45,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                109,
                111,
                110,
                105,
                116,
                111,
                114,
                82,
                117,
                110,
                68,
                101,
                112,
                101,
                110,
                100,
                101,
                110,
                99,
                105,
                101,
                115,
                63,
                46,
                40,
                70,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                61,
                61,
                32,
                70,
                32,
                38,
                38,
                32,
                71,
                32,
                38,
                38,
                32,
                40,
                100,
                32,
                61,
                32,
                71,
                44,
                32,
                71,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                44,
                32,
                100,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                87,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                70,
                43,
                43,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                109,
                111,
                110,
                105,
                116,
                111,
                114,
                82,
                117,
                110,
                68,
                101,
                112,
                101,
                110,
                100,
                101,
                110,
                99,
                105,
                101,
                115,
                63,
                46,
                40,
                70,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                123,
                32,
                97,
                58,
                32,
                108,
                99,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                104,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                40,
                98,
                44,
                32,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                40,
                96,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                87,
                97,
                115,
                109,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                119,
                105,
                116,
                104,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                36,
                123,
                100,
                125,
                96,
                41,
                44,
                32,
                98,
                97,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                97,
                32,
                63,
                63,
                32,
                40,
                119,
                97,
                32,
                61,
                32,
                118,
                97,
                40,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                41,
                32,
                63,
                32,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                32,
                58,
                32,
                104,
                46,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                32,
                63,
                32,
                104,
                46,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                40,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                44,
                32,
                112,
                41,
                32,
                58,
                32,
                112,
                32,
                43,
                32,
                34,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                122,
                97,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                40,
                99,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                97,
                99,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                97,
                99,
                32,
                61,
                32,
                87,
                46,
                102,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                84,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                84,
                32,
                61,
                32,
                87,
                46,
                104,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                110,
                98,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                110,
                98,
                32,
                61,
                32,
                87,
                46,
                105,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                98,
                99,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                98,
                99,
                32,
                61,
                32,
                87,
                46,
                106,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                88,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                61,
                62,
                32,
                40,
                88,
                32,
                61,
                32,
                87,
                46,
                107,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                41,
                44,
                32,
                89,
                32,
                61,
                32,
                40,
                97,
                41,
                32,
                61,
                62,
                32,
                40,
                89,
                32,
                61,
                32,
                87,
                46,
                108,
                97,
                41,
                40,
                97,
                41,
                44,
                32,
                90,
                32,
                61,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                40,
                90,
                32,
                61,
                32,
                87,
                46,
                109,
                97,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                110,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                111,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                112,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                102,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                102,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                113,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                114,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                32,
                61,
                32,
                87,
                46,
                115,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                116,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                102,
                102,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                102,
                102,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                117,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                106,
                105,
                105,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                118,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                105,
                106,
                105,
                105,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                118,
                105,
                105,
                106,
                105,
                105,
                32,
                61,
                32,
                87,
                46,
                119,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                32,
                61,
                32,
                87,
                46,
                120,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                44,
                32,
                108,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                121,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                44,
                32,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                110,
                41,
                32,
                61,
                62,
                32,
                40,
                104,
                46,
                100,
                121,
                110,
                67,
                97,
                108,
                108,
                95,
                105,
                105,
                105,
                105,
                105,
                105,
                106,
                106,
                32,
                61,
                32,
                87,
                46,
                122,
                97,
                41,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                44,
                32,
                107,
                44,
                32,
                103,
                44,
                32,
                108,
                44,
                32,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                99,
                99,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                102,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                107,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                44,
                32,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                103,
                32,
                33,
                61,
                61,
                32,
                103,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                99,
                40,
                97,
                44,
                32,
                98,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                100,
                32,
                33,
                61,
                61,
                32,
                100,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                106,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                32,
                33,
                61,
                61,
                32,
                102,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                102,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                32,
                33,
                61,
                61,
                32,
                102,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                102,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                33,
                61,
                61,
                32,
                101,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                107,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                102,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                44,
                32,
                100,
                44,
                32,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                102,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                107,
                32,
                33,
                61,
                61,
                32,
                107,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                107,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                100,
                99,
                40,
                97,
                44,
                32,
                98,
                44,
                32,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                98,
                44,
                32,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                32,
                33,
                61,
                61,
                32,
                101,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                103,
                99,
                40,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                90,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                46,
                103,
                101,
                116,
                40,
                97,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                89,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                32,
                33,
                61,
                61,
                32,
                99,
                32,
                43,
                32,
                48,
                41,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                88,
                40,
                49,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                109,
                99,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                71,
                32,
                61,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                110,
                99,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                99,
                32,
                124,
                124,
                32,
                111,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                99,
                32,
                124,
                124,
                32,
                40,
                71,
                32,
                61,
                32,
                110,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                111,
                99,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                97,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                109,
                99,
                32,
                38,
                38,
                32,
                40,
                109,
                99,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                104,
                46,
                99,
                97,
                108,
                108,
                101,
                100,
                82,
                117,
                110,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                44,
                32,
                33,
                108,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                97,
                40,
                114,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                97,
                40,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                46,
                111,
                110,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                73,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                100,
                63,
                46,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                104,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                32,
                38,
                38,
                32,
                40,
                104,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                32,
                61,
                32,
                91,
                104,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                93,
                41,
                59,
                32,
                104,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                118,
                97,
                114,
                32,
                98,
                32,
                61,
                32,
                104,
                46,
                112,
                111,
                115,
                116,
                82,
                117,
                110,
                46,
                115,
                104,
                105,
                102,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                97,
                46,
                117,
                110,
                115,
                104,
                105,
                102,
                116,
                40,
                98,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                97,
                40,
                115,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                40,
                48,
                32,
                60,
                32,
                70,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                41,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                104,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                32,
                38,
                38,
                32,
                40,
                104,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                32,
                61,
                32,
                91,
                104,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                93,
                41,
                59,
                32,
                104,
                46,
                112,
                114,
                101,
                82,
                117,
                110,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                116,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                66,
                97,
                40,
                113,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                48,
                32,
                60,
                32,
                70,
                32,
                124,
                124,
                32,
                40,
                104,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                32,
                63,
                32,
                40,
                104,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                34,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                46,
                46,
                46,
                34,
                41,
                44,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                104,
                46,
                115,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                34,
                34,
                41,
                44,
                32,
                49,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                49,
                41,
                41,
                32,
                58,
                32,
                97,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                104,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                32,
                61,
                61,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                104,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                32,
                38,
                38,
                32,
                40,
                104,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                32,
                61,
                32,
                91,
                104,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                93,
                41,
                59,
                32,
                48,
                32,
                60,
                32,
                104,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                41,
                32,
                104,
                46,
                112,
                114,
                101,
                73,
                110,
                105,
                116,
                46,
                112,
                111,
                112,
                40,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                111,
                99,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                32,
                61,
                32,
                99,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                82,
                116,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                125,
                41,
                40,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                112,
                108,
                97,
                121,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                61,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                77,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                99,
                111,
                114,
                101,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                119,
                97,
                115,
                109,
                45,
                108,
                111,
                97,
                100,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                82,
                101,
                110,
                100,
                101,
                114,
                101,
                114,
                76,
                111,
                97,
                100,
                101,
                114,
                32,
                105,
                115,
                32,
                97,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                97,
                110,
                100,
                32,
                99,
                97,
                110,
                110,
                111,
                116,
                32,
                98,
                101,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                116,
                105,
                97,
                116,
                101,
                100,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                112,
                108,
                97,
                121,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                40,
                123,
                32,
                108,
                111,
                99,
                97,
                116,
                101,
                70,
                105,
                108,
                101,
                58,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                117,
                114,
                108,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                84,
                114,
                105,
                101,
                115,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                102,
                114,
                111,
                109,
                32,
                116,
                104,
                101,
                32,
                112,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                85,
                82,
                76,
                44,
                32,
                102,
                97,
                108,
                108,
                105,
                110,
                103,
                32,
                98,
                97,
                99,
                107,
                32,
                116,
                111,
                32,
                97,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                32,
                105,
                102,
                32,
                110,
                101,
                99,
                101,
                115,
                115,
                97,
                114,
                121,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                84,
                104,
                114,
                111,
                119,
                115,
                32,
                97,
                110,
                32,
                101,
                114,
                114,
                111,
                114,
                32,
                105,
                102,
                32,
                98,
                111,
                116,
                104,
                32,
                85,
                82,
                76,
                115,
                32,
                102,
                97,
                105,
                108,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                60,
                77,
                111,
                100,
                117,
                108,
                101,
                62,
                32,
                45,
                32,
                65,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                116,
                104,
                97,
                116,
                32,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                115,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                95,
                108,
                111,
                97,
                100,
                87,
                105,
                116,
                104,
                66,
                97,
                99,
                107,
                117,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                97,
                115,
                121,
                110,
                99,
                32,
                40,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                32,
                61,
                32,
                96,
                104,
                116,
                116,
                112,
                115,
                58,
                47,
                47,
                117,
                110,
                112,
                107,
                103,
                46,
                99,
                111,
                109,
                47,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                125,
                64,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                125,
                47,
                100,
                105,
                115,
                116,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                96,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                80,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                87,
                65,
                83,
                77,
                32,
                108,
                111,
                97,
                100,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                102,
                114,
                111,
                109,
                32,
                36,
                123,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                125,
                46,
                32,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                36,
                123,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                65,
                116,
                116,
                101,
                109,
                112,
                116,
                105,
                110,
                103,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                114,
                111,
                109,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                116,
                114,
                121,
                76,
                111,
                97,
                100,
                40,
                98,
                97,
                99,
                107,
                117,
                112,
                85,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                98,
                97,
                99,
                107,
                117,
                112,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                96,
                80,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                87,
                65,
                83,
                77,
                32,
                85,
                82,
                76,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                96,
                66,
                97,
                99,
                107,
                117,
                112,
                32,
                87,
                65,
                83,
                77,
                32,
                85,
                82,
                76,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                58,
                32,
                36,
                123,
                98,
                97,
                99,
                107,
                117,
                112,
                69,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                87,
                65,
                83,
                77,
                32,
                108,
                111,
                97,
                100,
                105,
                110,
                103,
                32,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                102,
                114,
                111,
                109,
                32,
                97,
                108,
                108,
                32,
                115,
                111,
                117,
                114,
                99,
                101,
                115,
                46,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                80,
                117,
                98,
                108,
                105,
                99,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                85,
                116,
                105,
                108,
                105,
                122,
                101,
                115,
                32,
                97,
                32,
                112,
                114,
                105,
                109,
                97,
                114,
                121,
                32,
                97,
                110,
                100,
                32,
                98,
                97,
                99,
                107,
                117,
                112,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                114,
                111,
                98,
                117,
                115,
                116,
                110,
                101,
                115,
                115,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                60,
                77,
                111,
                100,
                117,
                108,
                101,
                62,
                32,
                45,
                32,
                65,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                116,
                104,
                97,
                116,
                32,
                114,
                101,
                115,
                111,
                108,
                118,
                101,
                115,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                108,
                111,
                97,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                87,
                105,
                116,
                104,
                66,
                97,
                99,
                107,
                117,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                101,
                116,
                115,
                32,
                97,
                32,
                110,
                101,
                119,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                32,
                97,
                110,
                100,
                32,
                105,
                110,
                118,
                97,
                108,
                105,
                100,
                97,
                116,
                101,
                115,
                32,
                116,
                104,
                101,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                32,
                112,
                114,
                111,
                109,
                105,
                115,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                45,
                32,
                32,
                84,
                104,
                101,
                32,
                110,
                101,
                119,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                46,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                117,
                114,
                108,
                32,
                61,
                61,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                32,
                61,
                32,
                117,
                114,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                47,
                47,
                32,
                101,
                115,
                108,
                105,
                110,
                116,
                45,
                100,
                105,
                115,
                97,
                98,
                108,
                101,
                45,
                110,
                101,
                120,
                116,
                45,
                108,
                105,
                110,
                101,
                32,
                64,
                116,
                121,
                112,
                101,
                115,
                99,
                114,
                105,
                112,
                116,
                45,
                101,
                115,
                108,
                105,
                110,
                116,
                47,
                110,
                97,
                109,
                105,
                110,
                103,
                45,
                99,
                111,
                110,
                118,
                101,
                110,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                44,
                32,
                34,
                95,
                77,
                111,
                100,
                117,
                108,
                101,
                80,
                114,
                111,
                109,
                105,
                115,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                47,
                47,
                32,
                85,
                82,
                76,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                87,
                65,
                83,
                77,
                32,
                102,
                105,
                108,
                101,
                44,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                101,
                100,
                32,
                117,
                115,
                105,
                110,
                103,
                32,
                112,
                97,
                99,
                107,
                97,
                103,
                101,
                32,
                105,
                110,
                102,
                111,
                114,
                109,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                44,
                32,
                34,
                95,
                119,
                97,
                115,
                109,
                85,
                82,
                76,
                34,
                44,
                32,
                96,
                104,
                116,
                116,
                112,
                115,
                58,
                47,
                47,
                99,
                100,
                110,
                46,
                106,
                115,
                100,
                101,
                108,
                105,
                118,
                114,
                46,
                110,
                101,
                116,
                47,
                110,
                112,
                109,
                47,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                78,
                65,
                77,
                69,
                125,
                64,
                36,
                123,
                80,
                65,
                67,
                75,
                65,
                71,
                69,
                95,
                86,
                69,
                82,
                83,
                73,
                79,
                78,
                125,
                47,
                100,
                105,
                115,
                116,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                45,
                112,
                108,
                97,
                121,
                101,
                114,
                46,
                119,
                97,
                115,
                109,
                96,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                101,
                118,
                101,
                110,
                116,
                45,
                109,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                69,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                83,
                101,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                115,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                97,
                100,
                100,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                116,
                121,
                112,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                63,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                61,
                62,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                65,
                108,
                108,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                99,
                108,
                101,
                97,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                111,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                45,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                32,
                61,
                32,
                40,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                110,
                116,
                114,
                121,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                105,
                115,
                73,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                110,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                105,
                110,
                116,
                101,
                114,
                115,
                101,
                99,
                116,
                105,
                111,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                44,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                101,
                115,
                104,
                111,
                108,
                100,
                58,
                32,
                48,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                104,
                97,
                115,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                100,
                105,
                115,
                99,
                111,
                110,
                110,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                114,
                101,
                115,
                105,
                122,
                101,
                45,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                82,
                69,
                83,
                73,
                90,
                69,
                95,
                68,
                69,
                66,
                79,
                85,
                78,
                67,
                69,
                95,
                84,
                73,
                77,
                69,
                32,
                61,
                32,
                49,
                48,
                48,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                32,
                61,
                32,
                40,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                110,
                116,
                114,
                105,
                101,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                110,
                116,
                114,
                121,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                93,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                101,
                119,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                32,
                61,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                82,
                69,
                83,
                73,
                90,
                69,
                95,
                68,
                69,
                66,
                79,
                85,
                78,
                67,
                69,
                95,
                84,
                73,
                77,
                69,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                101,
                110,
                116,
                114,
                121,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                44,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                110,
                101,
                119,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                114,
                101,
                115,
                105,
                122,
                101,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                110,
                105,
                116,
                105,
                97,
                108,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                104,
                97,
                115,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                91,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                44,
                32,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                103,
                101,
                116,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                73,
                100,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                73,
                100,
                41,
                32,
                99,
                108,
                101,
                97,
                114,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                116,
                105,
                109,
                101,
                111,
                117,
                116,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                63,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                46,
                115,
                105,
                122,
                101,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                100,
                105,
                115,
                99,
                111,
                110,
                110,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                44,
                32,
                34,
                95,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                100,
                67,
                97,
                110,
                118,
                97,
                115,
                101,
                115,
                34,
                44,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                41,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                117,
                116,
                105,
                108,
                115,
                46,
                116,
                115,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                72,
                101,
                120,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                47,
                94,
                35,
                40,
                91,
                92,
                100,
                97,
                45,
                102,
                93,
                123,
                54,
                125,
                124,
                91,
                92,
                100,
                97,
                45,
                102,
                93,
                123,
                56,
                125,
                41,
                36,
                47,
                105,
                117,
                46,
                116,
                101,
                115,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                101,
                120,
                83,
                116,
                114,
                105,
                110,
                103,
                84,
                111,
                82,
                71,
                66,
                65,
                73,
                110,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                72,
                101,
                120,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                104,
                101,
                120,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                72,
                101,
                120,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                34,
                35,
                34,
                44,
                32,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                104,
                101,
                120,
                32,
                61,
                32,
                104,
                101,
                120,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                61,
                61,
                32,
                54,
                32,
                63,
                32,
                96,
                36,
                123,
                104,
                101,
                120,
                125,
                102,
                102,
                96,
                32,
                58,
                32,
                104,
                101,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                112,
                97,
                114,
                115,
                101,
                73,
                110,
                116,
                40,
                104,
                101,
                120,
                44,
                32,
                49,
                54,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                60,
                32,
                52,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                105,
                108,
                101,
                83,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                65,
                114,
                114,
                97,
                121,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                46,
                115,
                108,
                105,
                99,
                101,
                40,
                48,
                44,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                90,
                73,
                80,
                95,
                83,
                73,
                71,
                78,
                65,
                84,
                85,
                82,
                69,
                91,
                105,
                93,
                32,
                33,
                61,
                61,
                32,
                102,
                105,
                108,
                101,
                83,
                105,
                103,
                110,
                97,
                116,
                117,
                114,
                101,
                91,
                105,
                93,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                106,
                115,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                76,
                79,
                84,
                84,
                73,
                69,
                95,
                74,
                83,
                79,
                78,
                95,
                77,
                65,
                78,
                68,
                65,
                84,
                79,
                82,
                89,
                95,
                70,
                73,
                69,
                76,
                68,
                83,
                46,
                101,
                118,
                101,
                114,
                121,
                40,
                40,
                102,
                105,
                101,
                108,
                100,
                41,
                32,
                61,
                62,
                32,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                112,
                114,
                111,
                116,
                111,
                116,
                121,
                112,
                101,
                46,
                104,
                97,
                115,
                79,
                119,
                110,
                80,
                114,
                111,
                112,
                101,
                114,
                116,
                121,
                46,
                99,
                97,
                108,
                108,
                40,
                106,
                115,
                111,
                110,
                44,
                32,
                102,
                105,
                101,
                108,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                74,
                83,
                79,
                78,
                46,
                112,
                97,
                114,
                115,
                101,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                95,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                74,
                83,
                79,
                78,
                40,
                102,
                105,
                108,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                112,
                114,
                32,
                61,
                32,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                63,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                58,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                49,
                32,
                43,
                32,
                40,
                100,
                112,
                114,
                32,
                45,
                32,
                49,
                41,
                32,
                42,
                32,
                68,
                69,
                70,
                65,
                85,
                76,
                84,
                95,
                68,
                80,
                82,
                95,
                70,
                65,
                67,
                84,
                79,
                82,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                73,
                110,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                99,
                116,
                32,
                61,
                32,
                101,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                118,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                105,
                110,
                110,
                101,
                114,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                124,
                124,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                118,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                105,
                110,
                110,
                101,
                114,
                87,
                105,
                100,
                116,
                104,
                32,
                124,
                124,
                32,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                46,
                100,
                111,
                99,
                117,
                109,
                101,
                110,
                116,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                33,
                40,
                114,
                101,
                99,
                116,
                46,
                98,
                111,
                116,
                116,
                111,
                109,
                32,
                60,
                32,
                48,
                32,
                124,
                124,
                32,
                114,
                101,
                99,
                116,
                46,
                116,
                111,
                112,
                32,
                62,
                32,
                118,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                124,
                124,
                32,
                114,
                101,
                99,
                116,
                46,
                114,
                105,
                103,
                104,
                116,
                32,
                60,
                32,
                48,
                32,
                124,
                124,
                32,
                114,
                101,
                99,
                116,
                46,
                108,
                101,
                102,
                116,
                32,
                62,
                32,
                118,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                87,
                105,
                100,
                116,
                104,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                116,
                97,
                114,
                103,
                101,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                99,
                116,
                32,
                61,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                114,
                101,
                99,
                116,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                61,
                61,
                32,
                48,
                32,
                124,
                124,
                32,
                114,
                101,
                99,
                116,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                61,
                61,
                32,
                48,
                32,
                124,
                124,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                61,
                61,
                32,
                48,
                32,
                124,
                124,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                99,
                97,
                108,
                101,
                88,
                32,
                61,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                47,
                32,
                114,
                101,
                99,
                116,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                99,
                97,
                108,
                101,
                89,
                32,
                61,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                47,
                32,
                114,
                101,
                99,
                116,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                88,
                32,
                45,
                32,
                114,
                101,
                99,
                116,
                46,
                108,
                101,
                102,
                116,
                41,
                32,
                42,
                32,
                115,
                99,
                97,
                108,
                101,
                88,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                99,
                108,
                105,
                101,
                110,
                116,
                89,
                32,
                45,
                32,
                114,
                101,
                99,
                116,
                46,
                116,
                111,
                112,
                41,
                32,
                42,
                32,
                115,
                99,
                97,
                108,
                101,
                89,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                78,
                117,
                109,
                98,
                101,
                114,
                46,
                105,
                115,
                70,
                105,
                110,
                105,
                116,
                101,
                40,
                120,
                41,
                32,
                124,
                124,
                32,
                33,
                78,
                117,
                109,
                98,
                101,
                114,
                46,
                105,
                115,
                70,
                105,
                110,
                105,
                116,
                101,
                40,
                121,
                41,
                32,
                124,
                124,
                32,
                78,
                117,
                109,
                98,
                101,
                114,
                46,
                105,
                115,
                78,
                97,
                78,
                40,
                120,
                41,
                32,
                124,
                124,
                32,
                78,
                117,
                109,
                98,
                101,
                114,
                46,
                105,
                115,
                78,
                97,
                78,
                40,
                121,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                32,
                120,
                44,
                32,
                121,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                104,
                97,
                110,
                100,
                108,
                101,
                79,
                112,
                101,
                110,
                85,
                114,
                108,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                110,
                116,
                101,
                110,
                116,
                32,
                61,
                32,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                46,
                114,
                101,
                112,
                108,
                97,
                99,
                101,
                40,
                34,
                79,
                112,
                101,
                110,
                85,
                114,
                108,
                58,
                32,
                34,
                44,
                32,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                97,
                114,
                103,
                101,
                116,
                83,
                101,
                112,
                97,
                114,
                97,
                116,
                111,
                114,
                73,
                110,
                100,
                101,
                120,
                32,
                61,
                32,
                99,
                111,
                110,
                116,
                101,
                110,
                116,
                46,
                105,
                110,
                100,
                101,
                120,
                79,
                102,
                40,
                34,
                32,
                124,
                32,
                84,
                97,
                114,
                103,
                101,
                116,
                58,
                32,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                117,
                114,
                108,
                84,
                111,
                79,
                112,
                101,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                116,
                97,
                114,
                103,
                101,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                97,
                114,
                103,
                101,
                116,
                83,
                101,
                112,
                97,
                114,
                97,
                116,
                111,
                114,
                73,
                110,
                100,
                101,
                120,
                32,
                61,
                61,
                61,
                32,
                45,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                114,
                108,
                84,
                111,
                79,
                112,
                101,
                110,
                32,
                61,
                32,
                99,
                111,
                110,
                116,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                97,
                114,
                103,
                101,
                116,
                32,
                61,
                32,
                34,
                95,
                98,
                108,
                97,
                110,
                107,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                114,
                108,
                84,
                111,
                79,
                112,
                101,
                110,
                32,
                61,
                32,
                99,
                111,
                110,
                116,
                101,
                110,
                116,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                105,
                110,
                103,
                40,
                48,
                44,
                32,
                116,
                97,
                114,
                103,
                101,
                116,
                83,
                101,
                112,
                97,
                114,
                97,
                116,
                111,
                114,
                73,
                110,
                100,
                101,
                120,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                97,
                114,
                103,
                101,
                116,
                32,
                61,
                32,
                99,
                111,
                110,
                116,
                101,
                110,
                116,
                46,
                115,
                117,
                98,
                115,
                116,
                114,
                105,
                110,
                103,
                40,
                116,
                97,
                114,
                103,
                101,
                116,
                83,
                101,
                112,
                97,
                114,
                97,
                116,
                111,
                114,
                73,
                110,
                100,
                101,
                120,
                32,
                43,
                32,
                34,
                32,
                124,
                32,
                84,
                97,
                114,
                103,
                101,
                116,
                58,
                32,
                34,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                111,
                112,
                101,
                110,
                40,
                117,
                114,
                108,
                84,
                111,
                79,
                112,
                101,
                110,
                44,
                32,
                116,
                97,
                114,
                103,
                101,
                116,
                41,
                59,
                10,
                32,
                32,
                125,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                32,
                61,
                32,
                40,
                109,
                111,
                100,
                101,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                66,
                111,
                117,
                110,
                99,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                45,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                66,
                111,
                117,
                110,
                99,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                77,
                111,
                100,
                101,
                46,
                70,
                111,
                114,
                119,
                97,
                114,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                70,
                105,
                116,
                32,
                61,
                32,
                40,
                102,
                105,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                110,
                116,
                97,
                105,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                99,
                111,
                118,
                101,
                114,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                118,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                108,
                108,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                116,
                45,
                104,
                101,
                105,
                103,
                104,
                116,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                102,
                105,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                105,
                116,
                45,
                119,
                105,
                100,
                116,
                104,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                87,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                70,
                105,
                116,
                46,
                78,
                111,
                110,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                32,
                61,
                32,
                40,
                97,
                108,
                105,
                103,
                110,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                70,
                108,
                111,
                97,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                97,
                108,
                105,
                103,
                110,
                91,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                97,
                108,
                105,
                103,
                110,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                70,
                108,
                111,
                97,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                50,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                48,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                114,
                101,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                108,
                105,
                103,
                110,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                65,
                108,
                105,
                103,
                110,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                32,
                63,
                63,
                32,
                91,
                48,
                46,
                53,
                44,
                32,
                48,
                46,
                53,
                93,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                105,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                70,
                105,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                102,
                105,
                116,
                32,
                63,
                63,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                61,
                32,
                99,
                108,
                97,
                115,
                115,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                114,
                117,
                99,
                116,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                34,
                44,
                32,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                111,
                110,
                102,
                105,
                103,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                105,
                115,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                34,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                34,
                44,
                32,
                123,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                34,
                44,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                66,
                111,
                117,
                110,
                100,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                102,
                111,
                114,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                67,
                108,
                105,
                99,
                107,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                116,
                104,
                105,
                115,
                44,
                32,
                34,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                69,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                63,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                105,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                98,
                121,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                116,
                111,
                32,
                112,
                114,
                101,
                118,
                101,
                110,
                116,
                32,
                117,
                110,
                110,
                101,
                99,
                101,
                115,
                115,
                97,
                114,
                121,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                105,
                110,
                103,
                32,
                119,
                104,
                101,
                110,
                32,
                116,
                104,
                101,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                115,
                32,
                111,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                63,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                46,
                108,
                111,
                97,
                100,
                40,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                40,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                76,
                111,
                97,
                100,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                76,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                34,
                102,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                34,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                80,
                108,
                97,
                121,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                80,
                97,
                117,
                115,
                101,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                112,
                97,
                117,
                115,
                101,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                83,
                116,
                111,
                112,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                111,
                112,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                76,
                111,
                111,
                112,
                40,
                40,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                67,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                40,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                82,
                101,
                110,
                100,
                101,
                114,
                40,
                40,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                46,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                80,
                108,
                97,
                121,
                101,
                114,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                70,
                73,
                88,
                77,
                69,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                105,
                100,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                117,
                115,
                101,
                102,
                117,
                108,
                44,
                32,
                115,
                105,
                110,
                99,
                101,
                32,
                116,
                104,
                101,
                32,
                108,
                111,
                97,
                100,
                32,
                97,
                110,
                100,
                32,
                115,
                116,
                97,
                114,
                116,
                32,
                111,
                102,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                114,
                101,
                113,
                117,
                105,
                114,
                101,
                32,
                116,
                111,
                32,
                98,
                101,
                32,
                99,
                111,
                110,
                116,
                114,
                111,
                108,
                108,
                101,
                100,
                32,
                98,
                121,
                32,
                116,
                104,
                101,
                32,
                102,
                114,
                97,
                109,
                101,
                119,
                111,
                114,
                107,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                48,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                111,
                111,
                112,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                111,
                100,
                101,
                32,
                63,
                63,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                63,
                63,
                32,
                91,
                93,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                112,
                101,
                101,
                100,
                32,
                63,
                63,
                32,
                49,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                63,
                63,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                117,
                98,
                115,
                99,
                114,
                105,
                98,
                101,
                40,
                99,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                97,
                100,
                121,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                119,
                97,
                115,
                109,
                32,
                109,
                111,
                100,
                117,
                108,
                101,
                58,
                32,
                36,
                123,
                101,
                114,
                114,
                111,
                114,
                125,
                96,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                115,
                121,
                110,
                99,
                32,
                95,
                102,
                101,
                116,
                99,
                104,
                68,
                97,
                116,
                97,
                40,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                102,
                101,
                116,
                99,
                104,
                40,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                102,
                101,
                116,
                99,
                104,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                32,
                102,
                114,
                111,
                109,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                115,
                114,
                99,
                125,
                46,
                32,
                36,
                123,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                125,
                58,
                32,
                36,
                123,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                115,
                116,
                97,
                116,
                117,
                115,
                84,
                101,
                120,
                116,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                32,
                97,
                119,
                97,
                105,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                46,
                97,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                100,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                101,
                119,
                32,
                84,
                101,
                120,
                116,
                68,
                101,
                99,
                111,
                100,
                101,
                114,
                40,
                41,
                46,
                100,
                101,
                99,
                111,
                100,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                115,
                116,
                114,
                105,
                110,
                103,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                100,
                97,
                116,
                97,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                111,
                98,
                106,
                101,
                99,
                116,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                73,
                110,
                118,
                97,
                108,
                105,
                100,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                58,
                32,
                84,
                104,
                101,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                99,
                111,
                110,
                102,
                111,
                114,
                109,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                32,
                102,
                111,
                114,
                109,
                97,
                116,
                46,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                68,
                97,
                116,
                97,
                40,
                74,
                83,
                79,
                78,
                46,
                115,
                116,
                114,
                105,
                110,
                103,
                105,
                102,
                121,
                40,
                100,
                97,
                116,
                97,
                41,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                96,
                85,
                110,
                115,
                117,
                112,
                112,
                111,
                114,
                116,
                101,
                100,
                32,
                100,
                97,
                116,
                97,
                32,
                116,
                121,
                112,
                101,
                32,
                102,
                111,
                114,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                46,
                32,
                69,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                58,
                32,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                40,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                65,
                114,
                114,
                97,
                121,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                40,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                45,
                32,
                111,
                98,
                106,
                101,
                99,
                116,
                32,
                40,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                74,
                83,
                79,
                78,
                41,
                46,
                32,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                82,
                101,
                99,
                101,
                105,
                118,
                101,
                100,
                58,
                32,
                36,
                123,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                100,
                97,
                116,
                97,
                125,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                109,
                83,
                116,
                97,
                114,
                116,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                109,
                83,
                116,
                97,
                114,
                116,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                114,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                114,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                73,
                110,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                82,
                101,
                115,
                105,
                122,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                101,
                116,
                99,
                104,
                68,
                97,
                116,
                97,
                40,
                115,
                114,
                99,
                41,
                46,
                116,
                104,
                101,
                110,
                40,
                40,
                100,
                97,
                116,
                97,
                41,
                32,
                61,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                100,
                97,
                116,
                97,
                41,
                41,
                46,
                99,
                97,
                116,
                99,
                104,
                40,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                70,
                97,
                105,
                108,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                100,
                97,
                116,
                97,
                32,
                102,
                114,
                111,
                109,
                32,
                85,
                82,
                76,
                58,
                32,
                36,
                123,
                115,
                114,
                99,
                125,
                46,
                32,
                36,
                123,
                101,
                114,
                114,
                111,
                114,
                125,
                96,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                98,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                108,
                105,
                103,
                110,
                58,
                32,
                91,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                44,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                97,
                108,
                105,
                103,
                110,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                93,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                105,
                116,
                58,
                32,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                119,
                105,
                116,
                99,
                104,
                32,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                46,
                102,
                105,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                110,
                116,
                97,
                105,
                110,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                67,
                111,
                118,
                101,
                114,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                118,
                101,
                114,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                108,
                108,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                108,
                108,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                116,
                45,
                104,
                101,
                105,
                103,
                104,
                116,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                70,
                105,
                116,
                87,
                105,
                100,
                116,
                104,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                105,
                116,
                45,
                119,
                105,
                100,
                116,
                104,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                97,
                115,
                101,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                70,
                105,
                116,
                46,
                78,
                111,
                110,
                101,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                110,
                111,
                110,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                58,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                99,
                111,
                110,
                116,
                97,
                105,
                110,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                40,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                33,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                32,
                61,
                32,
                74,
                83,
                79,
                78,
                46,
                112,
                97,
                114,
                115,
                101,
                40,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                79,
                98,
                106,
                101,
                99,
                116,
                46,
                107,
                101,
                121,
                115,
                40,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                41,
                46,
                108,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                61,
                61,
                32,
                48,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                74,
                115,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                95,
                101,
                114,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                61,
                61,
                61,
                32,
                50,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                44,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                111,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                109,
                111,
                100,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                109,
                111,
                100,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                77,
                111,
                100,
                101,
                46,
                66,
                111,
                117,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                109,
                111,
                100,
                101,
                32,
                61,
                61,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                77,
                111,
                100,
                101,
                46,
                82,
                101,
                118,
                101,
                114,
                115,
                101,
                66,
                111,
                117,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                114,
                101,
                118,
                101,
                114,
                115,
                101,
                45,
                98,
                111,
                117,
                110,
                99,
                101,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                112,
                101,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                46,
                115,
                112,
                101,
                101,
                100,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                40,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                77,
                97,
                116,
                104,
                46,
                114,
                111,
                117,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                41,
                32,
                42,
                32,
                49,
                48,
                48,
                41,
                32,
                47,
                32,
                49,
                48,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                40,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                32,
                99,
                97,
                110,
                118,
                97,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                48,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                111,
                111,
                112,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                111,
                100,
                101,
                32,
                63,
                63,
                32,
                34,
                102,
                111,
                114,
                119,
                97,
                114,
                100,
                34,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                63,
                63,
                32,
                91,
                93,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                112,
                101,
                101,
                100,
                32,
                63,
                63,
                32,
                49,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                68,
                97,
                116,
                97,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                105,
                102,
                32,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                108,
                111,
                97,
                100,
                70,
                114,
                111,
                109,
                83,
                114,
                99,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                115,
                114,
                99,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                63,
                63,
                32,
                34,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                38,
                38,
                32,
                34,
                103,
                101,
                116,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                34,
                32,
                105,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                38,
                38,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                67,
                111,
                110,
                116,
                101,
                120,
                116,
                40,
                34,
                50,
                100,
                34,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                117,
                102,
                102,
                101,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                98,
                117,
                102,
                102,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                42,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                42,
                32,
                66,
                89,
                84,
                69,
                83,
                95,
                80,
                69,
                82,
                95,
                80,
                73,
                88,
                69,
                76,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                76,
                101,
                110,
                103,
                116,
                104,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                119,
                97,
                114,
                110,
                40,
                96,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                115,
                105,
                122,
                101,
                32,
                109,
                105,
                115,
                109,
                97,
                116,
                99,
                104,
                58,
                32,
                103,
                111,
                116,
                32,
                36,
                123,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                125,
                44,
                32,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                32,
                36,
                123,
                101,
                120,
                112,
                101,
                99,
                116,
                101,
                100,
                76,
                101,
                110,
                103,
                116,
                104,
                125,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                101,
                116,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                85,
                105,
                110,
                116,
                56,
                67,
                108,
                97,
                109,
                112,
                101,
                100,
                65,
                114,
                114,
                97,
                121,
                40,
                98,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                48,
                44,
                32,
                98,
                117,
                102,
                102,
                101,
                114,
                46,
                98,
                121,
                116,
                101,
                76,
                101,
                110,
                103,
                116,
                104,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                61,
                61,
                32,
                34,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                46,
                100,
                97,
                116,
                97,
                46,
                115,
                101,
                116,
                40,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                99,
                108,
                97,
                109,
                112,
                101,
                100,
                66,
                117,
                102,
                102,
                101,
                114,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                112,
                117,
                116,
                73,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                40,
                105,
                109,
                97,
                103,
                101,
                68,
                97,
                116,
                97,
                44,
                32,
                48,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                99,
                97,
                110,
                99,
                101,
                108,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                115,
                116,
                97,
                114,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                38,
                38,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                38,
                38,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                32,
                38,
                38,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                97,
                100,
                118,
                97,
                110,
                99,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                116,
                105,
                99,
                107,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                97,
                100,
                118,
                97,
                110,
                99,
                101,
                100,
                32,
                124,
                124,
                32,
                47,
                47,
                32,
                70,
                73,
                88,
                77,
                69,
                58,
                32,
                84,
                104,
                105,
                115,
                32,
                105,
                115,
                32,
                97,
                32,
                119,
                111,
                114,
                107,
                97,
                114,
                111,
                117,
                110,
                100,
                32,
                116,
                111,
                32,
                102,
                105,
                120,
                32,
                116,
                104,
                101,
                32,
                83,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                32,
                97,
                99,
                116,
                105,
                111,
                110,
                32,
                105,
                110,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                102,
                114,
                97,
                109,
                101,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                111,
                108,
                101,
                46,
                101,
                114,
                114,
                111,
                114,
                40,
                34,
                69,
                114,
                114,
                111,
                114,
                32,
                105,
                110,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                102,
                114,
                97,
                109,
                101,
                58,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                101,
                114,
                114,
                111,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                87,
                101,
                98,
                65,
                115,
                115,
                101,
                109,
                98,
                108,
                121,
                46,
                82,
                117,
                110,
                116,
                105,
                109,
                101,
                69,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                108,
                97,
                121,
                105,
                110,
                103,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                108,
                97,
                121,
                105,
                110,
                103,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                114,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                38,
                38,
                32,
                33,
                105,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                73,
                110,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                116,
                104,
                105,
                115,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                97,
                109,
                101,
                85,
                112,
                100,
                97,
                116,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                101,
                107,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                102,
                114,
                97,
                109,
                101,
                85,
                112,
                100,
                97,
                116,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                40,
                115,
                112,
                101,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                115,
                116,
                121,
                108,
                101,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                104,
                101,
                120,
                83,
                116,
                114,
                105,
                110,
                103,
                84,
                111,
                82,
                71,
                66,
                65,
                73,
                110,
                116,
                40,
                99,
                111,
                108,
                111,
                114,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                99,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                108,
                111,
                111,
                112,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                108,
                111,
                111,
                112,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                116,
                121,
                112,
                101,
                44,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                85,
                110,
                115,
                117,
                98,
                115,
                99,
                114,
                105,
                98,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                85,
                110,
                115,
                117,
                98,
                115,
                99,
                114,
                105,
                98,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                117,
                110,
                115,
                117,
                98,
                115,
                99,
                114,
                105,
                98,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                65,
                108,
                108,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                73,
                100,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                114,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                124,
                124,
                32,
                33,
                116,
                104,
                105,
                115,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                112,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                119,
                105,
                110,
                100,
                111,
                119,
                46,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                49,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                58,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                58,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                125,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                103,
                101,
                116,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                67,
                108,
                105,
                101,
                110,
                116,
                82,
                101,
                99,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                33,
                61,
                61,
                32,
                48,
                32,
                38,
                38,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                33,
                61,
                61,
                32,
                48,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                87,
                105,
                100,
                116,
                104,
                32,
                42,
                32,
                100,
                112,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                99,
                108,
                105,
                101,
                110,
                116,
                72,
                101,
                105,
                103,
                104,
                116,
                32,
                42,
                32,
                100,
                112,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                114,
                101,
                115,
                105,
                122,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                115,
                116,
                97,
                114,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                32,
                101,
                110,
                100,
                70,
                114,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                91,
                115,
                116,
                97,
                114,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                32,
                101,
                110,
                100,
                70,
                114,
                97,
                109,
                101,
                93,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                44,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                44,
                32,
                46,
                46,
                46,
                114,
                101,
                115,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                125,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                114,
                101,
                115,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                105,
                115,
                32,
                97,
                32,
                115,
                112,
                101,
                99,
                105,
                97,
                108,
                32,
                99,
                97,
                115,
                101,
                44,
                32,
                105,
                116,
                32,
                115,
                104,
                111,
                117,
                108,
                100,
                32,
                98,
                101,
                32,
                115,
                101,
                116,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                105,
                102,
                32,
                105,
                116,
                39,
                115,
                32,
                110,
                111,
                116,
                32,
                112,
                114,
                111,
                118,
                105,
                100,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                58,
                32,
                100,
                101,
                118,
                105,
                99,
                101,
                80,
                105,
                120,
                101,
                108,
                82,
                97,
                116,
                105,
                111,
                32,
                124,
                124,
                32,
                103,
                101,
                116,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                68,
                80,
                82,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                58,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                32,
                63,
                63,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                97,
                117,
                116,
                111,
                82,
                101,
                115,
                105,
                122,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                67,
                97,
                110,
                118,
                97,
                115,
                82,
                101,
                115,
                105,
                122,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                79,
                110,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                44,
                32,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                73,
                110,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                79,
                102,
                102,
                115,
                99,
                114,
                101,
                101,
                110,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                117,
                110,
                111,
                98,
                115,
                101,
                114,
                118,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                40,
                41,
                32,
                61,
                61,
                61,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                46,
                112,
                117,
                115,
                104,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                110,
                97,
                109,
                101,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                110,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                105,
                109,
                101,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                116,
                105,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                76,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                101,
                109,
                101,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                101,
                109,
                101,
                76,
                111,
                97,
                100,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                82,
                101,
                115,
                101,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                114,
                101,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                101,
                109,
                101,
                82,
                101,
                115,
                101,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                101,
                109,
                101,
                82,
                101,
                115,
                101,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                76,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                101,
                109,
                101,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                114,
                97,
                119,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                101,
                109,
                101,
                76,
                111,
                97,
                100,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                108,
                111,
                116,
                115,
                40,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                83,
                108,
                111,
                116,
                115,
                40,
                115,
                108,
                111,
                116,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                46,
                46,
                46,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                67,
                111,
                114,
                101,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                87,
                97,
                115,
                109,
                76,
                111,
                97,
                100,
                101,
                114,
                46,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                116,
                97,
                114,
                116,
                32,
                97,
                32,
                116,
                119,
                101,
                101,
                110,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                98,
                101,
                116,
                119,
                101,
                101,
                110,
                32,
                116,
                119,
                111,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                118,
                97,
                108,
                117,
                101,
                115,
                32,
                119,
                105,
                116,
                104,
                32,
                99,
                117,
                115,
                116,
                111,
                109,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                45,
                32,
                83,
                116,
                97,
                114,
                116,
                105,
                110,
                103,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                118,
                97,
                108,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                32,
                45,
                32,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                116,
                119,
                101,
                101,
                110,
                32,
                105,
                110,
                32,
                115,
                101,
                99,
                111,
                110,
                100,
                115,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                105,
                102,
                32,
                116,
                119,
                101,
                101,
                110,
                32,
                119,
                97,
                115,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                102,
                117,
                108,
                108,
                121,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                116,
                119,
                101,
                101,
                110,
                40,
                102,
                114,
                97,
                109,
                101,
                44,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                32,
                61,
                32,
                91,
                48,
                44,
                32,
                48,
                44,
                32,
                49,
                44,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                86,
                101,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                70,
                108,
                111,
                97,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                99,
                111,
                110,
                115,
                116,
                32,
                118,
                97,
                108,
                32,
                111,
                102,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                86,
                101,
                99,
                116,
                111,
                114,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                118,
                97,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                116,
                119,
                101,
                101,
                110,
                40,
                102,
                114,
                97,
                109,
                101,
                44,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                44,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                86,
                101,
                99,
                116,
                111,
                114,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                116,
                97,
                114,
                116,
                32,
                97,
                32,
                116,
                119,
                101,
                101,
                110,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                32,
                116,
                111,
                32,
                97,
                32,
                115,
                112,
                101,
                99,
                105,
                102,
                105,
                99,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                110,
                97,
                109,
                101,
                32,
                116,
                111,
                32,
                116,
                119,
                101,
                101,
                110,
                32,
                116,
                111,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                105,
                102,
                32,
                116,
                119,
                101,
                101,
                110,
                32,
                119,
                97,
                115,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                102,
                117,
                108,
                108,
                121,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                116,
                119,
                101,
                101,
                110,
                84,
                111,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                44,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                32,
                61,
                32,
                91,
                48,
                44,
                32,
                48,
                44,
                32,
                49,
                44,
                32,
                49,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                86,
                101,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                70,
                108,
                111,
                97,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                99,
                111,
                110,
                115,
                116,
                32,
                118,
                97,
                108,
                32,
                111,
                102,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                86,
                101,
                99,
                116,
                111,
                114,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                118,
                97,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                116,
                119,
                101,
                101,
                110,
                84,
                111,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                44,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                44,
                32,
                101,
                97,
                115,
                105,
                110,
                103,
                86,
                101,
                99,
                116,
                111,
                114,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                46,
                103,
                101,
                116,
                40,
                48,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                46,
                103,
                101,
                116,
                40,
                49,
                41,
                32,
                63,
                63,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                116,
                104,
                101,
                32,
                79,
                114,
                105,
                101,
                110,
                116,
                101,
                100,
                32,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                32,
                66,
                111,
                120,
                32,
                40,
                79,
                66,
                66,
                41,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                32,
                111,
                102,
                32,
                97,
                32,
                108,
                97,
                121,
                101,
                114,
                32,
                98,
                121,
                32,
                105,
                116,
                115,
                32,
                110,
                97,
                109,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                108,
                97,
                121,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                65,
                110,
                32,
                97,
                114,
                114,
                97,
                121,
                32,
                111,
                102,
                32,
                56,
                32,
                110,
                117,
                109,
                98,
                101,
                114,
                115,
                32,
                114,
                101,
                112,
                114,
                101,
                115,
                101,
                110,
                116,
                105,
                110,
                103,
                32,
                52,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                32,
                40,
                120,
                44,
                121,
                41,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                79,
                66,
                66,
                32,
                105,
                110,
                32,
                99,
                108,
                111,
                99,
                107,
                119,
                105,
                115,
                101,
                32,
                111,
                114,
                100,
                101,
                114,
                32,
                115,
                116,
                97,
                114,
                116,
                105,
                110,
                103,
                32,
                102,
                114,
                111,
                109,
                32,
                116,
                111,
                112,
                45,
                108,
                101,
                102,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                91,
                120,
                48,
                44,
                32,
                121,
                48,
                44,
                32,
                120,
                49,
                44,
                32,
                121,
                49,
                44,
                32,
                120,
                50,
                44,
                32,
                121,
                50,
                44,
                32,
                120,
                51,
                44,
                32,
                121,
                51,
                93,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                97,
                109,
                112,
                108,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                96,
                96,
                96,
                116,
                121,
                112,
                101,
                115,
                99,
                114,
                105,
                112,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                47,
                47,
                32,
                68,
                114,
                97,
                119,
                32,
                97,
                32,
                112,
                111,
                108,
                121,
                103,
                111,
                110,
                32,
                97,
                114,
                111,
                117,
                110,
                100,
                32,
                116,
                104,
                101,
                32,
                108,
                97,
                121,
                101,
                114,
                32,
                39,
                76,
                97,
                121,
                101,
                114,
                32,
                49,
                39,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                39,
                114,
                101,
                110,
                100,
                101,
                114,
                39,
                44,
                32,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                32,
                61,
                32,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                40,
                39,
                76,
                97,
                121,
                101,
                114,
                32,
                49,
                39,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                98,
                101,
                103,
                105,
                110,
                80,
                97,
                116,
                104,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                109,
                111,
                118,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                48,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                49,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                70,
                105,
                114,
                115,
                116,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                108,
                105,
                110,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                50,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                51,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                83,
                101,
                99,
                111,
                110,
                100,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                108,
                105,
                110,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                52,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                53,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                84,
                104,
                105,
                114,
                100,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                108,
                105,
                110,
                101,
                84,
                111,
                40,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                54,
                93,
                44,
                32,
                111,
                98,
                98,
                80,
                111,
                105,
                110,
                116,
                115,
                91,
                55,
                93,
                41,
                59,
                32,
                47,
                47,
                32,
                70,
                111,
                117,
                114,
                116,
                104,
                32,
                112,
                111,
                105,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                99,
                108,
                111,
                115,
                101,
                80,
                97,
                116,
                104,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                116,
                101,
                120,
                116,
                46,
                115,
                116,
                114,
                111,
                107,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                96,
                96,
                96,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                105,
                110,
                103,
                66,
                111,
                120,
                40,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                111,
                117,
                110,
                100,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                103,
                101,
                116,
                76,
                97,
                121,
                101,
                114,
                66,
                111,
                117,
                110,
                100,
                115,
                40,
                108,
                97,
                121,
                101,
                114,
                78,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                98,
                111,
                117,
                110,
                100,
                115,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                32,
                33,
                61,
                61,
                32,
                56,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                118,
                111,
                105,
                100,
                32,
                48,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                56,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                46,
                112,
                117,
                115,
                104,
                40,
                98,
                111,
                117,
                110,
                100,
                115,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                112,
                111,
                105,
                110,
                116,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                105,
                99,
                32,
                116,
                114,
                97,
                110,
                115,
                102,
                111,
                114,
                109,
                84,
                104,
                101,
                109,
                101,
                84,
                111,
                76,
                111,
                116,
                116,
                105,
                101,
                83,
                108,
                111,
                116,
                115,
                40,
                116,
                104,
                101,
                109,
                101,
                44,
                32,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                63,
                46,
                116,
                114,
                97,
                110,
                115,
                102,
                111,
                114,
                109,
                84,
                104,
                101,
                109,
                101,
                84,
                111,
                76,
                111,
                116,
                116,
                105,
                101,
                83,
                108,
                111,
                116,
                115,
                40,
                116,
                104,
                101,
                109,
                101,
                44,
                32,
                115,
                108,
                111,
                116,
                115,
                41,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                35,
                114,
                101,
                103,
                105,
                111,
                110,
                32,
                83,
                116,
                97,
                116,
                101,
                32,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                124,
                124,
                32,
                33,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                83,
                116,
                97,
                114,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                114,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                83,
                116,
                111,
                112,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                105,
                109,
                101,
                111,
                117,
                116,
                40,
                40,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                34,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                44,
                32,
                48,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                67,
                117,
                115,
                116,
                111,
                109,
                69,
                118,
                101,
                110,
                116,
                40,
                40,
                101,
                118,
                101,
                110,
                116,
                78,
                97,
                109,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                117,
                115,
                116,
                111,
                109,
                69,
                118,
                101,
                110,
                116,
                34,
                44,
                32,
                101,
                118,
                101,
                110,
                116,
                78,
                97,
                109,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                40,
                40,
                105,
                110,
                112,
                117,
                116,
                78,
                97,
                109,
                101,
                44,
                32,
                111,
                108,
                100,
                86,
                97,
                108,
                117,
                101,
                44,
                32,
                110,
                101,
                119,
                86,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                34,
                44,
                32,
                105,
                110,
                112,
                117,
                116,
                78,
                97,
                109,
                101,
                44,
                32,
                110,
                101,
                119,
                86,
                97,
                108,
                117,
                101,
                44,
                32,
                111,
                108,
                100,
                86,
                97,
                108,
                117,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                40,
                40,
                105,
                110,
                112,
                117,
                116,
                78,
                97,
                109,
                101,
                44,
                32,
                111,
                108,
                100,
                86,
                97,
                108,
                117,
                101,
                44,
                32,
                110,
                101,
                119,
                86,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                34,
                44,
                32,
                105,
                110,
                112,
                117,
                116,
                78,
                97,
                109,
                101,
                44,
                32,
                110,
                101,
                119,
                86,
                97,
                108,
                117,
                101,
                44,
                32,
                111,
                108,
                100,
                86,
                97,
                108,
                117,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                40,
                40,
                105,
                110,
                112,
                117,
                116,
                78,
                97,
                109,
                101,
                44,
                32,
                111,
                108,
                100,
                86,
                97,
                108,
                117,
                101,
                44,
                32,
                110,
                101,
                119,
                86,
                97,
                108,
                117,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                34,
                44,
                32,
                105,
                110,
                112,
                117,
                116,
                78,
                97,
                109,
                101,
                44,
                32,
                110,
                101,
                119,
                86,
                97,
                108,
                117,
                101,
                44,
                32,
                111,
                108,
                100,
                86,
                97,
                108,
                117,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                73,
                110,
                112,
                117,
                116,
                70,
                105,
                114,
                101,
                100,
                40,
                40,
                105,
                110,
                112,
                117,
                116,
                78,
                97,
                109,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                112,
                117,
                116,
                70,
                105,
                114,
                101,
                100,
                34,
                44,
                32,
                105,
                110,
                112,
                117,
                116,
                78,
                97,
                109,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                84,
                114,
                97,
                110,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                40,
                102,
                114,
                111,
                109,
                83,
                116,
                97,
                116,
                101,
                44,
                32,
                116,
                111,
                83,
                116,
                97,
                116,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                84,
                114,
                97,
                110,
                115,
                105,
                116,
                105,
                111,
                110,
                34,
                44,
                32,
                102,
                114,
                111,
                109,
                83,
                116,
                97,
                116,
                101,
                44,
                32,
                116,
                111,
                83,
                116,
                97,
                116,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                83,
                116,
                97,
                116,
                101,
                69,
                110,
                116,
                101,
                114,
                101,
                100,
                40,
                40,
                115,
                116,
                97,
                116,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                110,
                116,
                101,
                114,
                101,
                100,
                34,
                44,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                83,
                116,
                97,
                116,
                101,
                69,
                120,
                105,
                116,
                40,
                40,
                115,
                116,
                97,
                116,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                120,
                105,
                116,
                34,
                44,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                69,
                114,
                114,
                111,
                114,
                40,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                32,
                101,
                114,
                114,
                111,
                114,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                109,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                109,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                115,
                101,
                116,
                79,
                110,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                46,
                115,
                116,
                97,
                114,
                116,
                115,
                87,
                105,
                116,
                104,
                40,
                34,
                79,
                112,
                101,
                110,
                85,
                114,
                108,
                58,
                32,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                97,
                110,
                100,
                108,
                101,
                79,
                112,
                101,
                110,
                85,
                114,
                108,
                40,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                101,
                118,
                101,
                110,
                116,
                77,
                97,
                110,
                97,
                103,
                101,
                114,
                46,
                100,
                105,
                115,
                112,
                97,
                116,
                99,
                104,
                40,
                123,
                32,
                116,
                121,
                112,
                101,
                58,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                34,
                44,
                32,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                117,
                98,
                115,
                99,
                114,
                105,
                98,
                101,
                40,
                115,
                109,
                67,
                97,
                108,
                108,
                98,
                97,
                99,
                107,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                83,
                117,
                98,
                115,
                99,
                114,
                105,
                98,
                101,
                40,
                115,
                109,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                85,
                110,
                115,
                117,
                98,
                115,
                99,
                114,
                105,
                98,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                72,
                97,
                110,
                100,
                108,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                85,
                110,
                115,
                117,
                98,
                115,
                99,
                114,
                105,
                98,
                101,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                76,
                111,
                97,
                100,
                32,
                97,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                98,
                121,
                32,
                73,
                68,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                73,
                68,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                116,
                111,
                32,
                108,
                111,
                97,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                105,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                119,
                97,
                115,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                102,
                117,
                108,
                108,
                121,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                124,
                124,
                32,
                33,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                76,
                111,
                97,
                100,
                32,
                97,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                102,
                114,
                111,
                109,
                32,
                100,
                97,
                116,
                97,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                100,
                97,
                116,
                97,
                32,
                97,
                115,
                32,
                97,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                105,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                119,
                97,
                115,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                102,
                117,
                108,
                108,
                121,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                124,
                124,
                32,
                33,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                111,
                97,
                100,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                101,
                116,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                116,
                97,
                114,
                116,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                105,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                119,
                97,
                115,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                102,
                117,
                108,
                108,
                121,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                124,
                124,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                61,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                114,
                101,
                79,
                112,
                101,
                110,
                85,
                114,
                108,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                99,
                114,
                101,
                97,
                116,
                101,
                68,
                101,
                102,
                97,
                117,
                108,
                116,
                79,
                112,
                101,
                110,
                85,
                114,
                108,
                80,
                111,
                108,
                105,
                99,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                111,
                110,
                102,
                105,
                103,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                80,
                111,
                108,
                105,
                99,
                121,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                111,
                110,
                102,
                105,
                103,
                46,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                80,
                111,
                108,
                105,
                99,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                80,
                111,
                108,
                105,
                99,
                121,
                32,
                38,
                38,
                32,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                80,
                111,
                108,
                105,
                99,
                121,
                46,
                114,
                101,
                113,
                117,
                105,
                114,
                101,
                85,
                115,
                101,
                114,
                73,
                110,
                116,
                101,
                114,
                97,
                99,
                116,
                105,
                111,
                110,
                32,
                61,
                61,
                61,
                32,
                34,
                98,
                111,
                111,
                108,
                101,
                97,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                79,
                112,
                101,
                110,
                85,
                114,
                108,
                46,
                114,
                101,
                113,
                117,
                105,
                114,
                101,
                85,
                115,
                101,
                114,
                73,
                110,
                116,
                101,
                114,
                97,
                99,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                80,
                111,
                108,
                105,
                99,
                121,
                46,
                114,
                101,
                113,
                117,
                105,
                114,
                101,
                85,
                115,
                101,
                114,
                73,
                110,
                116,
                101,
                114,
                97,
                99,
                116,
                105,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                80,
                111,
                108,
                105,
                99,
                121,
                63,
                46,
                119,
                104,
                105,
                116,
                101,
                108,
                105,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                79,
                112,
                101,
                110,
                85,
                114,
                108,
                46,
                119,
                104,
                105,
                116,
                101,
                108,
                105,
                115,
                116,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                46,
                86,
                101,
                99,
                116,
                111,
                114,
                83,
                116,
                114,
                105,
                110,
                103,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                114,
                108,
                32,
                111,
                102,
                32,
                111,
                112,
                101,
                110,
                85,
                114,
                108,
                80,
                111,
                108,
                105,
                99,
                121,
                46,
                119,
                104,
                105,
                116,
                101,
                108,
                105,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                114,
                101,
                79,
                112,
                101,
                110,
                85,
                114,
                108,
                46,
                119,
                104,
                105,
                116,
                101,
                108,
                105,
                115,
                116,
                46,
                112,
                117,
                115,
                104,
                95,
                98,
                97,
                99,
                107,
                40,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                40,
                99,
                111,
                114,
                101,
                79,
                112,
                101,
                110,
                85,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                32,
                61,
                32,
                116,
                114,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                97,
                114,
                116,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                115,
                116,
                97,
                114,
                116,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                116,
                111,
                112,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                105,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                119,
                97,
                115,
                32,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                102,
                117,
                108,
                108,
                121,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                98,
                115,
                101,
                114,
                118,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                105,
                115,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                82,
                117,
                110,
                110,
                105,
                110,
                103,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                40,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                115,
                116,
                111,
                112,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                76,
                111,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                115,
                116,
                111,
                112,
                112,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                116,
                104,
                101,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                32,
                115,
                116,
                97,
                116,
                117,
                115,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                32,
                115,
                116,
                97,
                116,
                117,
                115,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                97,
                115,
                32,
                97,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                41,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                116,
                104,
                101,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                97,
                115,
                32,
                97,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                67,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                116,
                97,
                116,
                101,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                116,
                97,
                116,
                101,
                40,
                41,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                116,
                104,
                101,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                73,
                68,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                73,
                68,
                32,
                97,
                115,
                32,
                97,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                65,
                99,
                116,
                105,
                118,
                101,
                73,
                100,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                40,
                41,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                79,
                118,
                101,
                114,
                114,
                105,
                100,
                101,
                32,
                116,
                104,
                101,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                116,
                111,
                32,
                111,
                118,
                101,
                114,
                114,
                105,
                100,
                101,
                32,
                116,
                111,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                105,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                32,
                45,
                32,
                87,
                104,
                101,
                116,
                104,
                101,
                114,
                32,
                116,
                111,
                32,
                105,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                108,
                121,
                32,
                116,
                114,
                97,
                110,
                115,
                105,
                116,
                105,
                111,
                110,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                116,
                114,
                117,
                101,
                32,
                105,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                111,
                118,
                101,
                114,
                114,
                105,
                100,
                101,
                32,
                119,
                97,
                115,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                102,
                117,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                118,
                101,
                114,
                114,
                105,
                100,
                101,
                83,
                116,
                97,
                116,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                44,
                32,
                105,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                32,
                61,
                32,
                102,
                97,
                108,
                115,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                118,
                101,
                114,
                114,
                105,
                100,
                101,
                67,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                116,
                97,
                116,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                44,
                32,
                105,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                97,
                32,
                115,
                112,
                101,
                99,
                105,
                102,
                105,
                99,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                98,
                121,
                32,
                73,
                68,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                73,
                68,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                116,
                111,
                32,
                103,
                101,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                100,
                97,
                116,
                97,
                32,
                97,
                115,
                32,
                97,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                103,
                101,
                116,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                32,
                63,
                63,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                116,
                104,
                101,
                32,
                108,
                105,
                115,
                116,
                32,
                111,
                102,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                65,
                114,
                114,
                97,
                121,
                32,
                111,
                102,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                32,
                110,
                97,
                109,
                101,
                115,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                70,
                114,
                97,
                109,
                101,
                119,
                111,
                114,
                107,
                83,
                101,
                116,
                117,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                91,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                102,
                111,
                114,
                32,
                40,
                108,
                101,
                116,
                32,
                105,
                32,
                61,
                32,
                48,
                59,
                32,
                105,
                32,
                60,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                46,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                32,
                105,
                32,
                43,
                61,
                32,
                49,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                112,
                117,
                115,
                104,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                86,
                101,
                99,
                116,
                111,
                114,
                46,
                103,
                101,
                116,
                40,
                105,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                101,
                116,
                32,
                97,
                32,
                98,
                111,
                111,
                108,
                101,
                97,
                110,
                32,
                105,
                110,
                112,
                117,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                110,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                98,
                111,
                111,
                108,
                101,
                97,
                110,
                32,
                105,
                110,
                112,
                117,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                98,
                111,
                111,
                108,
                101,
                97,
                110,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                116,
                111,
                32,
                115,
                101,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                101,
                116,
                32,
                97,
                32,
                110,
                117,
                109,
                101,
                114,
                105,
                99,
                32,
                105,
                110,
                112,
                117,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                110,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                110,
                117,
                109,
                101,
                114,
                105,
                99,
                32,
                105,
                110,
                112,
                117,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                117,
                109,
                101,
                114,
                105,
                99,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                116,
                111,
                32,
                115,
                101,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                83,
                101,
                116,
                32,
                97,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                105,
                110,
                112,
                117,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                102,
                111,
                114,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                110,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                105,
                110,
                112,
                117,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                116,
                111,
                32,
                115,
                101,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                32,
                63,
                63,
                32,
                102,
                97,
                108,
                115,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                97,
                32,
                98,
                111,
                111,
                108,
                101,
                97,
                110,
                32,
                105,
                110,
                112,
                117,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                102,
                114,
                111,
                109,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                110,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                98,
                111,
                111,
                108,
                101,
                97,
                110,
                32,
                105,
                110,
                112,
                117,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                98,
                111,
                111,
                108,
                101,
                97,
                110,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                111,
                114,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                32,
                105,
                102,
                32,
                110,
                111,
                116,
                32,
                102,
                111,
                117,
                110,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                97,
                32,
                110,
                117,
                109,
                101,
                114,
                105,
                99,
                32,
                105,
                110,
                112,
                117,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                102,
                114,
                111,
                109,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                110,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                110,
                117,
                109,
                101,
                114,
                105,
                99,
                32,
                105,
                110,
                112,
                117,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                110,
                117,
                109,
                101,
                114,
                105,
                99,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                111,
                114,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                32,
                105,
                102,
                32,
                110,
                111,
                116,
                32,
                102,
                111,
                117,
                110,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                71,
                101,
                116,
                32,
                97,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                105,
                110,
                112,
                117,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                102,
                114,
                111,
                109,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                110,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                105,
                110,
                112,
                117,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                115,
                116,
                114,
                105,
                110,
                103,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                111,
                114,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                32,
                105,
                102,
                32,
                110,
                111,
                116,
                32,
                102,
                111,
                117,
                110,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                70,
                105,
                114,
                101,
                32,
                97,
                110,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                105,
                110,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                110,
                97,
                109,
                101,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                110,
                97,
                109,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                116,
                111,
                32,
                102,
                105,
                114,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                70,
                105,
                114,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                70,
                105,
                114,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                80,
                111,
                115,
                116,
                32,
                97,
                32,
                99,
                108,
                105,
                99,
                107,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                120,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                120,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                99,
                108,
                105,
                99,
                107,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                121,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                121,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                99,
                108,
                105,
                99,
                107,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                111,
                114,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                67,
                108,
                105,
                99,
                107,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                67,
                108,
                105,
                99,
                107,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                80,
                111,
                115,
                116,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                117,
                112,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                120,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                120,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                121,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                121,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                111,
                114,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                80,
                111,
                115,
                116,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                100,
                111,
                119,
                110,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                120,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                120,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                121,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                121,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                111,
                114,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                80,
                111,
                115,
                116,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                109,
                111,
                118,
                101,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                120,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                120,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                121,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                121,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                111,
                114,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                80,
                111,
                115,
                116,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                101,
                110,
                116,
                101,
                114,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                120,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                120,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                121,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                121,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                111,
                114,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                42,
                42,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                101,
                120,
                112,
                101,
                114,
                105,
                109,
                101,
                110,
                116,
                97,
                108,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                80,
                111,
                115,
                116,
                32,
                97,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                32,
                101,
                120,
                105,
                116,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                116,
                111,
                32,
                116,
                104,
                101,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                109,
                97,
                99,
                104,
                105,
                110,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                120,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                120,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                112,
                97,
                114,
                97,
                109,
                32,
                121,
                32,
                45,
                32,
                84,
                104,
                101,
                32,
                121,
                32,
                99,
                111,
                111,
                114,
                100,
                105,
                110,
                97,
                116,
                101,
                32,
                111,
                102,
                32,
                116,
                104,
                101,
                32,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                32,
                64,
                114,
                101,
                116,
                117,
                114,
                110,
                115,
                32,
                84,
                104,
                101,
                32,
                101,
                118,
                101,
                110,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                111,
                114,
                32,
                117,
                110,
                100,
                101,
                102,
                105,
                110,
                101,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                42,
                47,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                63,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                67,
                108,
                105,
                99,
                107,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                67,
                108,
                105,
                99,
                107,
                69,
                118,
                101,
                110,
                116,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                120,
                44,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                120,
                44,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                120,
                44,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                120,
                44,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                120,
                44,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                103,
                101,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                80,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                120,
                44,
                32,
                112,
                111,
                115,
                105,
                116,
                105,
                111,
                110,
                46,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                115,
                101,
                116,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                100,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                67,
                111,
                114,
                101,
                32,
                33,
                61,
                61,
                32,
                110,
                117,
                108,
                108,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                67,
                108,
                105,
                99,
                107,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                67,
                108,
                105,
                99,
                107,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                67,
                108,
                105,
                99,
                107,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                99,
                108,
                105,
                99,
                107,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                67,
                108,
                105,
                99,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                117,
                112,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                100,
                111,
                119,
                110,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                109,
                111,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                101,
                110,
                116,
                101,
                114,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                108,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                46,
                105,
                110,
                99,
                108,
                117,
                100,
                101,
                115,
                40,
                34,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                34,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                32,
                61,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                111,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                46,
                98,
                105,
                110,
                100,
                40,
                116,
                104,
                105,
                115,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                108,
                101,
                97,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                95,
                99,
                108,
                101,
                97,
                110,
                117,
                112,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                73,
                83,
                95,
                66,
                82,
                79,
                87,
                83,
                69,
                82,
                32,
                38,
                38,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                111,
                102,
                32,
                72,
                84,
                77,
                76,
                67,
                97,
                110,
                118,
                97,
                115,
                69,
                108,
                101,
                109,
                101,
                110,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                67,
                108,
                105,
                99,
                107,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                99,
                108,
                105,
                99,
                107,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                67,
                108,
                105,
                99,
                107,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                67,
                108,
                105,
                99,
                107,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                117,
                112,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                100,
                111,
                119,
                110,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                109,
                111,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                101,
                110,
                116,
                101,
                114,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                114,
                101,
                109,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                34,
                112,
                111,
                105,
                110,
                116,
                101,
                114,
                108,
                101,
                97,
                118,
                101,
                34,
                44,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                105,
                115,
                46,
                95,
                98,
                111,
                117,
                110,
                100,
                79,
                110,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                76,
                101,
                97,
                118,
                101,
                32,
                61,
                32,
                110,
                117,
                108,
                108,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                35,
                101,
                110,
                100,
                114,
                101,
                103,
                105,
                111,
                110,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                95,
                95,
                112,
                117,
                98,
                108,
                105,
                99,
                70,
                105,
                101,
                108,
                100,
                40,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                44,
                32,
                34,
                95,
                119,
                97,
                115,
                109,
                77,
                111,
                100,
                117,
                108,
                101,
                34,
                44,
                32,
                110,
                117,
                108,
                108,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                32,
                61,
                32,
                95,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                59,
                10,
                10,
                32,
                32,
                47,
                47,
                32,
                115,
                114,
                99,
                47,
                119,
                111,
                114,
                107,
                101,
                114,
                47,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                46,
                119,
                111,
                114,
                107,
                101,
                114,
                46,
                116,
                115,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                32,
                61,
                32,
                47,
                42,
                32,
                64,
                95,
                95,
                80,
                85,
                82,
                69,
                95,
                95,
                32,
                42,
                47,
                32,
                110,
                101,
                119,
                32,
                77,
                97,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                101,
                118,
                101,
                110,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                77,
                97,
                112,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                97,
                100,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                97,
                100,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                67,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                97,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                97,
                100,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                76,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                108,
                111,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                108,
                97,
                121,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                80,
                108,
                97,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                112,
                108,
                97,
                121,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                112,
                97,
                117,
                115,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                80,
                97,
                117,
                115,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                112,
                97,
                117,
                115,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                97,
                109,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                97,
                109,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                70,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                102,
                114,
                97,
                109,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                82,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                70,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                85,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                68,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                84,
                114,
                97,
                110,
                115,
                105,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                84,
                114,
                97,
                110,
                115,
                105,
                116,
                105,
                111,
                110,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                84,
                114,
                97,
                110,
                115,
                105,
                116,
                105,
                111,
                110,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                84,
                114,
                97,
                110,
                115,
                105,
                116,
                105,
                111,
                110,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                110,
                116,
                101,
                114,
                101,
                100,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                110,
                116,
                101,
                114,
                101,
                100,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                110,
                116,
                101,
                114,
                101,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                110,
                116,
                101,
                114,
                101,
                100,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                120,
                105,
                116,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                120,
                105,
                116,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                117,
                115,
                116,
                111,
                109,
                69,
                118,
                101,
                110,
                116,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                117,
                115,
                116,
                111,
                109,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                117,
                115,
                116,
                111,
                109,
                69,
                118,
                101,
                110,
                116,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                117,
                115,
                116,
                111,
                109,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                69,
                114,
                114,
                111,
                114,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                69,
                114,
                114,
                111,
                114,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                47,
                47,
                32,
                101,
                115,
                108,
                105,
                110,
                116,
                45,
                100,
                105,
                115,
                97,
                98,
                108,
                101,
                45,
                110,
                101,
                120,
                116,
                45,
                108,
                105,
                110,
                101,
                32,
                110,
                111,
                45,
                115,
                101,
                99,
                114,
                101,
                116,
                115,
                47,
                110,
                111,
                45,
                115,
                101,
                99,
                114,
                101,
                116,
                115,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                112,
                117,
                116,
                70,
                105,
                114,
                101,
                100,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                112,
                117,
                116,
                70,
                105,
                114,
                101,
                100,
                69,
                118,
                101,
                110,
                116,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                112,
                117,
                116,
                70,
                105,
                114,
                101,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                112,
                117,
                116,
                70,
                105,
                114,
                101,
                100,
                69,
                118,
                101,
                110,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                58,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                32,
                61,
                62,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                101,
                118,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                34,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                34,
                111,
                110,
                83,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                58,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                58,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                103,
                101,
                116,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                83,
                116,
                97,
                116,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                111,
                112,
                67,
                111,
                117,
                110,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                76,
                111,
                97,
                100,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                80,
                97,
                117,
                115,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                80,
                108,
                97,
                121,
                105,
                110,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                83,
                116,
                111,
                112,
                112,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                70,
                114,
                111,
                122,
                101,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                111,
                111,
                112,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                111,
                112,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                111,
                100,
                101,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                111,
                100,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                112,
                101,
                101,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                112,
                101,
                101,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                117,
                114,
                114,
                101,
                110,
                116,
                70,
                114,
                97,
                109,
                101,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                116,
                111,
                116,
                97,
                108,
                70,
                114,
                97,
                109,
                101,
                115,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                115,
                40,
                41,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                99,
                116,
                105,
                118,
                101,
                84,
                104,
                101,
                109,
                101,
                73,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                117,
                116,
                111,
                112,
                108,
                97,
                121,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                68,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                105,
                115,
                82,
                101,
                97,
                100,
                121,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                58,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                109,
                97,
                110,
                105,
                102,
                101,
                115,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                97,
                121,
                111,
                117,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                108,
                97,
                121,
                111,
                117,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                76,
                97,
                121,
                111,
                117,
                116,
                40,
                108,
                97,
                121,
                111,
                117,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                68,
                97,
                116,
                97,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                76,
                111,
                97,
                100,
                68,
                97,
                116,
                97,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                67,
                108,
                105,
                99,
                107,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                67,
                108,
                105,
                99,
                107,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                85,
                112,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                68,
                111,
                119,
                110,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                77,
                111,
                118,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                110,
                116,
                101,
                114,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                80,
                111,
                115,
                116,
                80,
                111,
                105,
                110,
                116,
                101,
                114,
                69,
                120,
                105,
                116,
                69,
                118,
                101,
                110,
                116,
                40,
                120,
                44,
                32,
                121,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                118,
                97,
                108,
                117,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                118,
                97,
                108,
                117,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                101,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                44,
                32,
                118,
                97,
                108,
                117,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                70,
                105,
                114,
                101,
                69,
                118,
                101,
                110,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                110,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                110,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                70,
                105,
                114,
                101,
                69,
                118,
                101,
                110,
                116,
                40,
                110,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                83,
                116,
                97,
                116,
                117,
                115,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                67,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                116,
                97,
                116,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                67,
                117,
                114,
                114,
                101,
                110,
                116,
                83,
                116,
                97,
                116,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                65,
                99,
                116,
                105,
                118,
                101,
                73,
                100,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                65,
                99,
                116,
                105,
                118,
                101,
                73,
                100,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                118,
                101,
                114,
                114,
                105,
                100,
                101,
                83,
                116,
                97,
                116,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                79,
                118,
                101,
                114,
                114,
                105,
                100,
                101,
                83,
                116,
                97,
                116,
                101,
                40,
                115,
                116,
                97,
                116,
                101,
                44,
                32,
                105,
                109,
                109,
                101,
                100,
                105,
                97,
                116,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                71,
                101,
                116,
                40,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                99,
                114,
                101,
                97,
                116,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                104,
                97,
                115,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                97,
                108,
                114,
                101,
                97,
                100,
                121,
                32,
                101,
                120,
                105,
                115,
                116,
                115,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                110,
                101,
                119,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                115,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                44,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                118,
                101,
                110,
                116,
                115,
                32,
                61,
                32,
                91,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                99,
                111,
                109,
                112,
                108,
                101,
                116,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                102,
                114,
                97,
                109,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                97,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                97,
                100,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                108,
                111,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                112,
                97,
                117,
                115,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                112,
                108,
                97,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                110,
                100,
                101,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                114,
                101,
                97,
                100,
                121,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                114,
                116,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                111,
                112,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                84,
                114,
                97,
                110,
                115,
                105,
                116,
                105,
                111,
                110,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                110,
                116,
                101,
                114,
                101,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                97,
                116,
                101,
                69,
                120,
                105,
                116,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                67,
                117,
                115,
                116,
                111,
                109,
                69,
                118,
                101,
                110,
                116,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                69,
                114,
                114,
                111,
                114,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                66,
                111,
                111,
                108,
                101,
                97,
                110,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                78,
                117,
                109,
                101,
                114,
                105,
                99,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                83,
                116,
                114,
                105,
                110,
                103,
                73,
                110,
                112,
                117,
                116,
                86,
                97,
                108,
                117,
                101,
                67,
                104,
                97,
                110,
                103,
                101,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                112,
                117,
                116,
                70,
                105,
                114,
                101,
                100,
                34,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                34,
                115,
                116,
                97,
                116,
                101,
                77,
                97,
                99,
                104,
                105,
                110,
                101,
                73,
                110,
                116,
                101,
                114,
                110,
                97,
                108,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                34,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                93,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                118,
                101,
                110,
                116,
                115,
                46,
                102,
                111,
                114,
                69,
                97,
                99,
                104,
                40,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                100,
                100,
                69,
                118,
                101,
                110,
                116,
                76,
                105,
                115,
                116,
                101,
                110,
                101,
                114,
                40,
                101,
                118,
                101,
                110,
                116,
                44,
                32,
                101,
                118,
                101,
                110,
                116,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                77,
                97,
                112,
                91,
                101,
                118,
                101,
                110,
                116,
                93,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                100,
                101,
                115,
                116,
                114,
                111,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                100,
                101,
                108,
                101,
                116,
                101,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                99,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                99,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                40,
                99,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                108,
                111,
                97,
                100,
                65,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                40,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                40,
                116,
                104,
                101,
                109,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                84,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                40,
                116,
                104,
                101,
                109,
                101,
                68,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                97,
                117,
                115,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                97,
                117,
                115,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                112,
                108,
                97,
                121,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                112,
                108,
                97,
                121,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                105,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                99,
                97,
                110,
                118,
                97,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                114,
                101,
                115,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                66,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                40,
                98,
                97,
                99,
                107,
                103,
                114,
                111,
                117,
                110,
                100,
                67,
                111,
                108,
                111,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                102,
                114,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                70,
                114,
                97,
                109,
                101,
                40,
                102,
                114,
                97,
                109,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                111,
                100,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                109,
                111,
                100,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                77,
                111,
                100,
                101,
                40,
                109,
                111,
                100,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                82,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                40,
                114,
                101,
                110,
                100,
                101,
                114,
                67,
                111,
                110,
                102,
                105,
                103,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                83,
                101,
                103,
                109,
                101,
                110,
                116,
                40,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                48,
                93,
                44,
                32,
                115,
                101,
                103,
                109,
                101,
                110,
                116,
                91,
                49,
                93,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                115,
                112,
                101,
                101,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                115,
                112,
                101,
                101,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                83,
                112,
                101,
                101,
                100,
                40,
                115,
                112,
                101,
                101,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                85,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                40,
                117,
                115,
                101,
                70,
                114,
                97,
                109,
                101,
                73,
                110,
                116,
                101,
                114,
                112,
                111,
                108,
                97,
                116,
                105,
                111,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                68,
                111,
                116,
                76,
                111,
                116,
                116,
                105,
                101,
                46,
                115,
                101,
                116,
                87,
                97,
                115,
                109,
                85,
                114,
                108,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                117,
                114,
                108,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                116,
                111,
                112,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                116,
                111,
                112,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                117,
                110,
                102,
                114,
                101,
                101,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                116,
                119,
                101,
                101,
                110,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                102,
                114,
                97,
                109,
                101,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                102,
                114,
                97,
                109,
                101,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                116,
                119,
                101,
                101,
                110,
                40,
                102,
                114,
                97,
                109,
                101,
                44,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                116,
                119,
                101,
                101,
                110,
                84,
                111,
                77,
                97,
                114,
                107,
                101,
                114,
                58,
                32,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                116,
                119,
                101,
                101,
                110,
                84,
                111,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                44,
                32,
                100,
                117,
                114,
                97,
                116,
                105,
                111,
                110,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                120,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                120,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                121,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                121,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                119,
                105,
                100,
                116,
                104,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                104,
                101,
                105,
                103,
                104,
                116,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                86,
                105,
                101,
                119,
                112,
                111,
                114,
                116,
                40,
                120,
                44,
                32,
                121,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                44,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                123,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                44,
                32,
                119,
                105,
                100,
                116,
                104,
                32,
                125,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                97,
                110,
                105,
                109,
                97,
                116,
                105,
                111,
                110,
                83,
                105,
                122,
                101,
                40,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                104,
                101,
                105,
                103,
                104,
                116,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                119,
                105,
                100,
                116,
                104,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                97,
                114,
                107,
                101,
                114,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                109,
                97,
                114,
                107,
                101,
                114,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                77,
                97,
                114,
                107,
                101,
                114,
                40,
                109,
                97,
                114,
                107,
                101,
                114,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                44,
                10,
                32,
                32,
                32,
                32,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                108,
                111,
                111,
                112,
                32,
                61,
                32,
                114,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                112,
                97,
                114,
                97,
                109,
                115,
                46,
                108,
                111,
                111,
                112,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                61,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                115,
                77,
                97,
                112,
                46,
                103,
                101,
                116,
                40,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                33,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                73,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                32,
                119,
                105,
                116,
                104,
                32,
                105,
                100,
                32,
                36,
                123,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                73,
                100,
                125,
                32,
                100,
                111,
                101,
                115,
                32,
                110,
                111,
                116,
                32,
                101,
                120,
                105,
                115,
                116,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                110,
                115,
                116,
                97,
                110,
                99,
                101,
                46,
                115,
                101,
                116,
                76,
                111,
                111,
                112,
                40,
                108,
                111,
                111,
                112,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                117,
                99,
                99,
                101,
                115,
                115,
                58,
                32,
                116,
                114,
                117,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                32,
                101,
                120,
                101,
                99,
                117,
                116,
                101,
                67,
                111,
                109,
                109,
                97,
                110,
                100,
                40,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                32,
                61,
                32,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                59,
                10,
                32,
                32,
                32,
                32,
                105,
                102,
                32,
                40,
                116,
                121,
                112,
                101,
                111,
                102,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                91,
                109,
                101,
                116,
                104,
                111,
                100,
                93,
                32,
                61,
                61,
                61,
                32,
                34,
                102,
                117,
                110,
                99,
                116,
                105,
                111,
                110,
                34,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                116,
                117,
                114,
                110,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                91,
                109,
                101,
                116,
                104,
                111,
                100,
                93,
                40,
                114,
                112,
                99,
                82,
                101,
                113,
                117,
                101,
                115,
                116,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                101,
                108,
                115,
                101,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                116,
                104,
                114,
                111,
                119,
                32,
                110,
                101,
                119,
                32,
                69,
                114,
                114,
                111,
                114,
                40,
                96,
                77,
                101,
                116,
                104,
                111,
                100,
                32,
                36,
                123,
                109,
                101,
                116,
                104,
                111,
                100,
                125,
                32,
                105,
                115,
                32,
                110,
                111,
                116,
                32,
                105,
                109,
                112,
                108,
                101,
                109,
                101,
                110,
                116,
                101,
                100,
                32,
                105,
                110,
                32,
                99,
                111,
                109,
                109,
                97,
                110,
                100,
                115,
                46,
                96,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                10,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                111,
                110,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                32,
                61,
                32,
                40,
                101,
                118,
                101,
                110,
                116,
                41,
                32,
                61,
                62,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                116,
                114,
                121,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                32,
                61,
                32,
                101,
                120,
                101,
                99,
                117,
                116,
                101,
                67,
                111,
                109,
                109,
                97,
                110,
                100,
                40,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                105,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                114,
                101,
                115,
                117,
                108,
                116,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                114,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                32,
                99,
                97,
                116,
                99,
                104,
                32,
                40,
                101,
                114,
                114,
                111,
                114,
                41,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                99,
                111,
                110,
                115,
                116,
                32,
                101,
                114,
                114,
                111,
                114,
                82,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                32,
                61,
                32,
                123,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                105,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                105,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                109,
                101,
                116,
                104,
                111,
                100,
                58,
                32,
                101,
                118,
                101,
                110,
                116,
                46,
                100,
                97,
                116,
                97,
                46,
                109,
                101,
                116,
                104,
                111,
                100,
                44,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                32,
                101,
                114,
                114,
                111,
                114,
                58,
                32,
                101,
                114,
                114,
                111,
                114,
                46,
                109,
                101,
                115,
                115,
                97,
                103,
                101,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                32,
                32,
                32,
                32,
                115,
                101,
                108,
                102,
                46,
                112,
                111,
                115,
                116,
                77,
                101,
                115,
                115,
                97,
                103,
                101,
                40,
                101,
                114,
                114,
                111,
                114,
                82,
                101,
                115,
                112,
                111,
                110,
                115,
                101,
                41,
                59,
                10,
                32,
                32,
                32,
                32,
                125,
                10,
                32,
                32,
                125,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                117,
                109,
                109,
                121,
                32,
                61,
                32,
                34,
                34,
                59,
                10,
                32,
                32,
                118,
                97,
                114,
                32,
                100,
                111,
                116,
                108,
                111,
                116,
                116,
                105,
                101,
                95,
                119,
                111,
                114,
                107,
                101,
                114,
                95,
                100,
                101,
                102,
                97,
                117,
                108,
                116,
                32,
                61,
                32,
                100,
                117,
                109,
                109,
                121,
                59,
                10,
                125,
                41,
                40,
                41,
                59,
                10
            ])
        ], {
            type: "application/javascript"
        }), i = URL.createObjectURL(t), s = new Worker(i);
        return URL.revokeObjectURL(i), s;
    }
}, $37d251801dc1953a$var$X2 = $37d251801dc1953a$var$c2;
var $37d251801dc1953a$var$k1 = class {
    constructor(){
        $37d251801dc1953a$var$v(this, "_workers", new Map);
        $37d251801dc1953a$var$v(this, "_animationWorkerMap", new Map);
    }
    getWorker(t) {
        return this._workers.has(t) || this._workers.set(t, new $37d251801dc1953a$var$X2), this._workers.get(t);
    }
    assignAnimationToWorker(t, i) {
        this._animationWorkerMap.set(t, i);
    }
    unassignAnimationFromWorker(t) {
        this._animationWorkerMap.delete(t);
    }
    sendMessage(t, i, s) {
        this.getWorker(t).postMessage(i, s || []);
    }
    terminateWorker(t) {
        let i = this._workers.get(t);
        i && (i.terminate(), this._workers.delete(t));
    }
};
function $37d251801dc1953a$var$Q2(l, t) {
    if (l instanceof HTMLCanvasElement) {
        let { height: i, width: s } = l.getBoundingClientRect();
        if (i !== 0 && s !== 0) return {
            width: s * t,
            height: i * t
        };
    }
    return {
        width: l.width,
        height: l.height
    };
}
function $37d251801dc1953a$var$Z2() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var $37d251801dc1953a$var$j = class j {
    constructor(t){
        $37d251801dc1953a$var$v(this, "_eventManager", new $37d251801dc1953a$var$r1);
        $37d251801dc1953a$var$v(this, "_id");
        $37d251801dc1953a$var$v(this, "_worker");
        $37d251801dc1953a$var$v(this, "_canvas");
        $37d251801dc1953a$var$v(this, "_dotLottieInstanceState", {
            loopCount: 0,
            markers: [],
            autoplay: false,
            backgroundColor: "",
            currentFrame: 0,
            duration: 0,
            loop: false,
            mode: "forward",
            segment: [
                0,
                0
            ],
            segmentDuration: 0,
            speed: 1,
            totalFrames: 0,
            isLoaded: false,
            isPlaying: false,
            isPaused: false,
            isStopped: true,
            isFrozen: false,
            useFrameInterpolation: false,
            renderConfig: {
                devicePixelRatio: $37d251801dc1953a$var$G()
            },
            activeAnimationId: "",
            activeThemeId: "",
            layout: void 0,
            marker: void 0,
            isReady: false,
            manifest: null
        });
        $37d251801dc1953a$var$v(this, "_created", false);
        $37d251801dc1953a$var$v(this, "_boundOnClick", null);
        $37d251801dc1953a$var$v(this, "_boundOnPointerUp", null);
        $37d251801dc1953a$var$v(this, "_boundOnPointerDown", null);
        $37d251801dc1953a$var$v(this, "_boundOnPointerMove", null);
        $37d251801dc1953a$var$v(this, "_boundOnPointerEnter", null);
        $37d251801dc1953a$var$v(this, "_boundOnPointerLeave", null);
        this._canvas = t.canvas, this._id = `dotlottie-${$37d251801dc1953a$var$Z2()}`;
        let i = t.workerId || "defaultWorker";
        this._worker = j._workerManager.getWorker(i), j._workerManager.assignAnimationToWorker(this._id, i), j._wasmUrl && this._sendMessage("setWasmUrl", {
            url: j._wasmUrl
        }), this._create({
            ...t,
            renderConfig: {
                ...t.renderConfig,
                devicePixelRatio: t.renderConfig?.devicePixelRatio || $37d251801dc1953a$var$G(),
                freezeOnOffscreen: t.renderConfig?.freezeOnOffscreen ?? true
            }
        }), this._worker.addEventListener("message", this._handleWorkerEvent.bind(this));
    }
    async _handleWorkerEvent(t) {
        let i = t.data;
        if (!i.id && (i.method === "onLoad" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event), $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && ($37d251801dc1953a$var$O.observe(this._canvas, this), $37d251801dc1953a$var$q(this._canvas) || await this.freeze()), this._dotLottieInstanceState.renderConfig.autoResize && $37d251801dc1953a$var$T.observe(this._canvas, this))), i.method === "onComplete" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onDestroy" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onUnfreeze" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._dotLottieInstanceState.isFrozen = false, this._eventManager.dispatch(i.result.event)), i.method === "onFrame" && i.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = i.result.event.currentFrame, this._eventManager.dispatch(i.result.event)), i.method === "onRender" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onFreeze" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onPause" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onPlay" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStop" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onLoadError" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onRenderError" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onReady" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onLoop" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineStart" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._setupStateMachineListeners(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineStop" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._cleanupStateMachineListeners(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineTransition" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineStateEntered" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineStateExit" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineCustomEvent" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineError" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineBooleanInputValueChange" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineNumericInputValueChange" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineStringInputValueChange" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineInputFired" && i.result.instanceId === this._id && (await this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStateMachineInternalMessage" && i.result.instanceId === this._id)) {
            await this._updateDotLottieInstanceState();
            let s = i.result.event;
            s.message.startsWith("OpenUrl: ") && $37d251801dc1953a$var$D1(s.message);
        }
    }
    async _create(t) {
        let i;
        this._canvas instanceof HTMLCanvasElement ? i = this._canvas.transferControlToOffscreen() : i = this._canvas;
        let { instanceId: s } = await this._sendMessage("create", {
            instanceId: this._id,
            config: {
                ...t,
                canvas: i
            },
            ...$37d251801dc1953a$var$Q2(this._canvas, t.renderConfig?.devicePixelRatio || $37d251801dc1953a$var$G())
        }, [
            i
        ]);
        if (s !== this._id) throw new Error("Instance ID mismatch");
        this._created = true, await this._updateDotLottieInstanceState();
    }
    get loopCount() {
        return this._dotLottieInstanceState.loopCount;
    }
    get isLoaded() {
        return this._dotLottieInstanceState.isLoaded;
    }
    get isPlaying() {
        return this._dotLottieInstanceState.isPlaying;
    }
    get isPaused() {
        return this._dotLottieInstanceState.isPaused;
    }
    get isStopped() {
        return this._dotLottieInstanceState.isStopped;
    }
    get currentFrame() {
        return this._dotLottieInstanceState.currentFrame;
    }
    get isFrozen() {
        return this._dotLottieInstanceState.isFrozen;
    }
    get segmentDuration() {
        return this._dotLottieInstanceState.segmentDuration;
    }
    get totalFrames() {
        return this._dotLottieInstanceState.totalFrames;
    }
    get segment() {
        return this._dotLottieInstanceState.segment;
    }
    get speed() {
        return this._dotLottieInstanceState.speed;
    }
    get duration() {
        return this._dotLottieInstanceState.duration;
    }
    get isReady() {
        return this._dotLottieInstanceState.isReady;
    }
    get mode() {
        return this._dotLottieInstanceState.mode;
    }
    get canvas() {
        return this._canvas;
    }
    get autoplay() {
        return this._dotLottieInstanceState.autoplay;
    }
    get backgroundColor() {
        return this._dotLottieInstanceState.backgroundColor;
    }
    get loop() {
        return this._dotLottieInstanceState.loop;
    }
    get useFrameInterpolation() {
        return this._dotLottieInstanceState.useFrameInterpolation;
    }
    get renderConfig() {
        return this._dotLottieInstanceState.renderConfig;
    }
    get manifest() {
        return this._dotLottieInstanceState.manifest;
    }
    get activeAnimationId() {
        return this._dotLottieInstanceState.activeAnimationId;
    }
    get marker() {
        return this._dotLottieInstanceState.marker;
    }
    get activeThemeId() {
        return this._dotLottieInstanceState.activeThemeId;
    }
    get layout() {
        return this._dotLottieInstanceState.layout;
    }
    async play() {
        this._created && (await this._sendMessage("play", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState(), $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !$37d251801dc1953a$var$q(this._canvas) && await this.freeze());
    }
    async pause() {
        this._created && (await this._sendMessage("pause", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async stop() {
        this._created && (await this._sendMessage("stop", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setSpeed(t) {
        this._created && (await this._sendMessage("setSpeed", {
            instanceId: this._id,
            speed: t
        }), await this._updateDotLottieInstanceState());
    }
    async setMode(t) {
        this._created && (await this._sendMessage("setMode", {
            instanceId: this._id,
            mode: t
        }), await this._updateDotLottieInstanceState());
    }
    async setFrame(t) {
        this._created && (await this._sendMessage("setFrame", {
            frame: t,
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setSegment(t, i) {
        this._created && (await this._sendMessage("setSegment", {
            instanceId: this._id,
            segment: [
                t,
                i
            ]
        }), await this._updateDotLottieInstanceState());
    }
    async setRenderConfig(t) {
        if (!this._created) return;
        let { devicePixelRatio: i, freezeOnOffscreen: s, ...c } = t;
        await this._sendMessage("setRenderConfig", {
            instanceId: this._id,
            renderConfig: {
                ...this._dotLottieInstanceState.renderConfig,
                ...c,
                devicePixelRatio: i || $37d251801dc1953a$var$G(),
                freezeOnOffscreen: s ?? true
            }
        }), await this._updateDotLottieInstanceState(), $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.autoResize ? $37d251801dc1953a$var$T.observe(this._canvas, this) : $37d251801dc1953a$var$T.unobserve(this._canvas), this._dotLottieInstanceState.renderConfig.freezeOnOffscreen ? ($37d251801dc1953a$var$O.observe(this._canvas, this), $37d251801dc1953a$var$q(this._canvas) || await this.freeze()) : ($37d251801dc1953a$var$O.unobserve(this._canvas), this._dotLottieInstanceState.isFrozen && await this.unfreeze()));
    }
    async setUseFrameInterpolation(t) {
        this._created && (await this._sendMessage("setUseFrameInterpolation", {
            instanceId: this._id,
            useFrameInterpolation: t
        }), await this._updateDotLottieInstanceState());
    }
    async setTheme(t) {
        if (!this._created) return false;
        let i = this._sendMessage("setTheme", {
            instanceId: this._id,
            themeId: t
        });
        return await this._updateDotLottieInstanceState(), i;
    }
    async load(t) {
        this._created && (await this._sendMessage("load", {
            config: t,
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setLoop(t) {
        this._created && (await this._sendMessage("setLoop", {
            instanceId: this._id,
            loop: t
        }), await this._updateDotLottieInstanceState());
    }
    async resize() {
        if (!this._created) return;
        let { height: t, width: i } = $37d251801dc1953a$var$Q2(this._canvas, this._dotLottieInstanceState.renderConfig.devicePixelRatio || $37d251801dc1953a$var$G());
        await this._sendMessage("resize", {
            height: t,
            instanceId: this._id,
            width: i
        }), await this._updateDotLottieInstanceState();
    }
    async destroy() {
        this._created && (this._created = false, await this._sendMessage("destroy", {
            instanceId: this._id
        }), this._cleanupStateMachineListeners(), j._workerManager.unassignAnimationFromWorker(this._id), this._eventManager.removeAllEventListeners(), $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && ($37d251801dc1953a$var$O.unobserve(this._canvas), $37d251801dc1953a$var$T.unobserve(this._canvas)));
    }
    async freeze() {
        this._created && (await this._sendMessage("freeze", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async unfreeze() {
        this._created && (await this._sendMessage("unfreeze", {
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setBackgroundColor(t) {
        this._created && (await this._sendMessage("setBackgroundColor", {
            instanceId: this._id,
            backgroundColor: t
        }), await this._updateDotLottieInstanceState());
    }
    async loadAnimation(t) {
        this._created && (await this._sendMessage("loadAnimation", {
            animationId: t,
            instanceId: this._id
        }), await this._updateDotLottieInstanceState());
    }
    async setLayout(t) {
        this._created && (await this._sendMessage("setLayout", {
            instanceId: this._id,
            layout: t
        }), await this._updateDotLottieInstanceState());
    }
    async _updateDotLottieInstanceState() {
        if (!this._created) return;
        let t = await this._sendMessage("getDotLottieInstanceState", {
            instanceId: this._id
        });
        this._dotLottieInstanceState = t.state;
    }
    markers() {
        return this._dotLottieInstanceState.markers;
    }
    async setMarker(t) {
        this._created && (await this._sendMessage("setMarker", {
            instanceId: this._id,
            marker: t
        }), await this._updateDotLottieInstanceState());
    }
    async setThemeData(t) {
        if (!this._created) return false;
        let i = await this._sendMessage("setThemeData", {
            instanceId: this._id,
            themeData: t
        });
        return await this._updateDotLottieInstanceState(), i;
    }
    async setViewport(t, i, s, c) {
        return this._created ? this._sendMessage("setViewport", {
            x: t,
            y: i,
            width: s,
            height: c,
            instanceId: this._id
        }) : false;
    }
    async animationSize() {
        return this._created ? this._sendMessage("animationSize", {
            instanceId: this._id
        }) : {
            height: 0,
            width: 0
        };
    }
    async tween(t, i) {
        return this._created ? this._sendMessage("tween", {
            instanceId: this._id,
            frame: t,
            duration: i
        }) : false;
    }
    async tweenToMarker(t, i) {
        return this._created ? this._sendMessage("tweenToMarker", {
            instanceId: this._id,
            marker: t,
            duration: i
        }) : false;
    }
    async _sendMessage(t, i, s) {
        let c = {
            id: `dotlottie-request-${$37d251801dc1953a$var$Z2()}`,
            method: t,
            params: i
        };
        return this._worker.postMessage(c, s || []), new Promise((L, z)=>{
            let K = (m1)=>{
                let A = m1.data;
                A.id === c.id && (this._worker.removeEventListener("message", K), A.error ? z(new Error(`Failed to execute method ${t}: ${A.error}`)) : L(A.result));
            };
            this._worker.addEventListener("message", K);
        });
    }
    addEventListener(t, i) {
        this._eventManager.addEventListener(t, i);
    }
    removeEventListener(t, i) {
        this._eventManager.removeEventListener(t, i);
    }
    static setWasmUrl(t) {
        j._wasmUrl = t;
    }
    async stateMachineLoad(t) {
        if (!this._created) return false;
        let i = await this._sendMessage("stateMachineLoad", {
            instanceId: this._id,
            stateMachineId: t
        });
        return await this._updateDotLottieInstanceState(), i;
    }
    async stateMachineLoadData(t) {
        if (!this._created) return false;
        let i = await this._sendMessage("stateMachineLoadData", {
            instanceId: this._id,
            stateMachineData: t
        });
        return await this._updateDotLottieInstanceState(), i;
    }
    async stateMachineStart() {
        if (!this._created) return false;
        let t = await this._sendMessage("stateMachineStart", {
            instanceId: this._id
        });
        return t && (this._setupStateMachineListeners(), await this._updateDotLottieInstanceState()), t;
    }
    async stateMachineStop() {
        return this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stateMachineStop", {
            instanceId: this._id
        })) : false;
    }
    async stateMachineSetNumericInput(t, i) {
        return this._created ? this._sendMessage("stateMachineSetNumericInput", {
            instanceId: this._id,
            name: t,
            value: i
        }) : false;
    }
    async stateMachineSetBooleanInput(t, i) {
        return this._created ? this._sendMessage("stateMachineSetBooleanInput", {
            instanceId: this._id,
            name: t,
            value: i
        }) : false;
    }
    async stateMachineSetConfig(t) {
        this._created && this._sendMessage("stateMachineSetConfig", {
            instanceId: this._id,
            config: t
        });
    }
    async stateMachineSetStringInput(t, i) {
        return this._created ? this._sendMessage("stateMachineSetStringInput", {
            instanceId: this._id,
            name: t,
            value: i
        }) : false;
    }
    async stateMachineGetNumericInput(t) {
        if (this._created) return this._sendMessage("stateMachineGetNumericInput", {
            instanceId: this._id,
            name: t
        });
    }
    async stateMachineGetBooleanInput(t) {
        if (this._created) return this._sendMessage("stateMachineGetBooleanInput", {
            instanceId: this._id,
            name: t
        });
    }
    async stateMachineGetStringInput(t) {
        if (this._created) return this._sendMessage("stateMachineGetStringInput", {
            instanceId: this._id,
            name: t
        });
    }
    async stateMachineFireEvent(t) {
        this._created && this._sendMessage("stateMachineFireEvent", {
            instanceId: this._id,
            name: t
        });
    }
    async stateMachineGetStatus() {
        return this._created ? this._sendMessage("stateMachineGetStatus", {
            instanceId: this._id
        }) : "";
    }
    async stateMachineGetCurrentState() {
        return this._created ? this._sendMessage("stateMachineGetCurrentState", {
            instanceId: this._id
        }) : "";
    }
    async stateMachineGetActiveId() {
        return this._created ? this._sendMessage("stateMachineGetActiveId", {
            instanceId: this._id
        }) : "";
    }
    async stateMachineOverrideState(t, i = false) {
        return this._created ? this._sendMessage("stateMachineOverrideState", {
            instanceId: this._id,
            state: t,
            immediate: i
        }) : false;
    }
    async stateMachineGet(t) {
        return this._created ? this._sendMessage("stateMachineGet", {
            instanceId: this._id,
            stateMachineId: t
        }) : "";
    }
    async stateMachineGetListeners() {
        return this._created ? this._sendMessage("stateMachineGetListeners", {
            instanceId: this._id
        }) : [];
    }
    async stateMachinePostClickEvent(t, i) {
        if (this._created) return this._sendMessage("stateMachinePostClickEvent", {
            instanceId: this._id,
            x: t,
            y: i
        });
    }
    async stateMachinePostPointerUpEvent(t, i) {
        if (this._created) return this._sendMessage("stateMachinePostPointerUpEvent", {
            instanceId: this._id,
            x: t,
            y: i
        });
    }
    async stateMachinePostPointerDownEvent(t, i) {
        if (this._created) return this._sendMessage("stateMachinePostPointerDownEvent", {
            instanceId: this._id,
            x: t,
            y: i
        });
    }
    async stateMachinePostPointerMoveEvent(t, i) {
        if (this._created) return this._sendMessage("stateMachinePostPointerMoveEvent", {
            instanceId: this._id,
            x: t,
            y: i
        });
    }
    async stateMachinePostPointerEnterEvent(t, i) {
        if (this._created) return this._sendMessage("stateMachinePostPointerEnterEvent", {
            instanceId: this._id,
            x: t,
            y: i
        });
    }
    async stateMachinePostPointerExitEvent(t, i) {
        if (this._created) return this._sendMessage("stateMachinePostPointerExitEvent", {
            instanceId: this._id,
            x: t,
            y: i
        });
    }
    _onClick(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this._sendMessage("stateMachinePostClickEvent", {
            instanceId: this._id,
            x: i.x,
            y: i.y
        });
    }
    _onPointerUp(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this._sendMessage("stateMachinePostPointerUpEvent", {
            instanceId: this._id,
            x: i.x,
            y: i.y
        });
    }
    _onPointerDown(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this._sendMessage("stateMachinePostPointerDownEvent", {
            instanceId: this._id,
            x: i.x,
            y: i.y
        });
    }
    _onPointerMove(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this._sendMessage("stateMachinePostPointerMoveEvent", {
            instanceId: this._id,
            x: i.x,
            y: i.y
        });
    }
    _onPointerEnter(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this._sendMessage("stateMachinePostPointerEnterEvent", {
            instanceId: this._id,
            x: i.x,
            y: i.y
        });
    }
    _onPointerLeave(t) {
        let i = $37d251801dc1953a$var$x(t);
        i && this._sendMessage("stateMachinePostPointerExitEvent", {
            instanceId: this._id,
            x: i.x,
            y: i.y
        });
    }
    async _setupStateMachineListeners() {
        if ($37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && this.isLoaded) {
            let t = await this._sendMessage("stateMachineGetListeners", {
                instanceId: this._id
            });
            if (t.length === 0) return;
            this._cleanupStateMachineListeners(), t.includes("Click") && (this._boundOnClick = this._onClick.bind(this), this._canvas.addEventListener("click", this._boundOnClick)), t.includes("PointerUp") && (this._boundOnPointerUp = this._onPointerUp.bind(this), this._canvas.addEventListener("pointerup", this._boundOnPointerUp)), t.includes("PointerDown") && (this._boundOnPointerDown = this._onPointerDown.bind(this), this._canvas.addEventListener("pointerdown", this._boundOnPointerDown)), t.includes("PointerMove") && (this._boundOnPointerMove = this._onPointerMove.bind(this), this._canvas.addEventListener("pointermove", this._boundOnPointerMove)), t.includes("PointerEnter") && (this._boundOnPointerEnter = this._onPointerEnter.bind(this), this._canvas.addEventListener("pointerenter", this._boundOnPointerEnter)), t.includes("PointerExit") && (this._boundOnPointerLeave = this._onPointerLeave.bind(this), this._canvas.addEventListener("pointerleave", this._boundOnPointerLeave));
        }
    }
    _cleanupStateMachineListeners() {
        $37d251801dc1953a$var$E && this._canvas instanceof HTMLCanvasElement && (this._boundOnClick && (this._canvas.removeEventListener("click", this._boundOnClick), this._boundOnClick = null), this._boundOnPointerUp && (this._canvas.removeEventListener("pointerup", this._boundOnPointerUp), this._boundOnPointerUp = null), this._boundOnPointerDown && (this._canvas.removeEventListener("pointerdown", this._boundOnPointerDown), this._boundOnPointerDown = null), this._boundOnPointerMove && (this._canvas.removeEventListener("pointermove", this._boundOnPointerMove), this._boundOnPointerMove = null), this._boundOnPointerEnter && (this._canvas.removeEventListener("pointerenter", this._boundOnPointerEnter), this._boundOnPointerEnter = null), this._boundOnPointerLeave && (this._canvas.removeEventListener("pointerleave", this._boundOnPointerLeave), this._boundOnPointerLeave = null));
    }
};
$37d251801dc1953a$var$v($37d251801dc1953a$var$j, "_workerManager", new $37d251801dc1953a$var$k1), $37d251801dc1953a$var$v($37d251801dc1953a$var$j, "_wasmUrl", "");
var $37d251801dc1953a$export$ab8c8a3fed0b35de = $37d251801dc1953a$var$j;
 //# sourceMappingURL=index.js.map


var $4565420568d42cac$exports = {};
!function(t, e) {
    e($4565420568d42cac$exports);
}($4565420568d42cac$exports, function(t) {
    "use strict";
    function e(t, e) {
        -1 === t.indexOf(e) && t.push(e);
    }
    function n(t, e) {
        const n = t.indexOf(e);
        n > -1 && t.splice(n, 1);
    }
    const s = (t, e, n)=>n > e ? e : n < t ? t : n;
    let i = ()=>{};
    const r = {}, o = (t)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);
    function a(t) {
        return "object" == typeof t && null !== t;
    }
    const l = (t)=>/^0[^.\s]+$/u.test(t);
    function u(t) {
        let e;
        return ()=>(void 0 === e && (e = t()), e);
    }
    const c = (t)=>t, h = (t, e)=>(n)=>e(t(n)), d = (...t)=>t.reduce(h), p = (t, e, n)=>{
        const s = e - t;
        return 0 === s ? 1 : (n - t) / s;
    };
    class f {
        constructor(){
            this.subscriptions = [];
        }
        add(t) {
            return e(this.subscriptions, t), ()=>n(this.subscriptions, t);
        }
        notify(t, e, n) {
            const s = this.subscriptions.length;
            if (s) {
                if (1 === s) this.subscriptions[0](t, e, n);
                else for(let i = 0; i < s; i++){
                    const s = this.subscriptions[i];
                    s && s(t, e, n);
                }
            }
        }
        getSize() {
            return this.subscriptions.length;
        }
        clear() {
            this.subscriptions.length = 0;
        }
    }
    const m = (t)=>1e3 * t, g = (t)=>t / 1e3;
    function y(t, e) {
        return e ? t * (1e3 / e) : 0;
    }
    const v = new Set;
    const w = (t, e, n)=>{
        const s = e - t;
        return ((n - t) % s + s) % s + t;
    }, b = (t, e, n)=>(((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t;
    function T(t, e, n, s) {
        if (t === e && n === s) return c;
        const i = (e)=>(function(t, e, n, s, i) {
                let r, o, a = 0;
                do o = e + (n - e) / 2, r = b(o, s, i) - t, r > 0 ? n = o : e = o;
                while (Math.abs(r) > 1e-7 && ++a < 12);
                return o;
            })(e, 0, 1, t, n);
        return (t)=>0 === t || 1 === t ? t : b(i(t), e, s);
    }
    const x = (t)=>(e)=>e <= .5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, V = (t)=>(e)=>1 - t(1 - e), M = T(.33, 1.53, .69, .99), S = V(M), A = x(S), k = (t)=>(t *= 2) < 1 ? .5 * S(t) : .5 * (2 - Math.pow(2, -10 * (t - 1))), E = (t)=>1 - Math.sin(Math.acos(t)), P = V(E), C = x(E), O = T(.42, 0, 1, 1), F = T(0, 0, .58, 1), R = T(.42, 0, .58, 1);
    const B = (t)=>Array.isArray(t) && "number" != typeof t[0];
    function L(t, e) {
        return B(t) ? t[w(0, t.length, e)] : t;
    }
    const D = (t)=>Array.isArray(t) && "number" == typeof t[0], I = {
        linear: c,
        easeIn: O,
        easeInOut: R,
        easeOut: F,
        circIn: E,
        circInOut: C,
        circOut: P,
        backIn: S,
        backInOut: A,
        backOut: M,
        anticipate: k
    }, W = (t)=>{
        if (D(t)) {
            t.length;
            const [e, n, s, i] = t;
            return T(e, n, s, i);
        }
        return "string" == typeof t ? I[t] : t;
    }, j = [
        "setup",
        "read",
        "resolveKeyframes",
        "preUpdate",
        "update",
        "preRender",
        "render",
        "postRender"
    ], N = {
        value: null,
        addProjectionMetrics: null
    };
    function K(t, e) {
        let n = !1, s = !0;
        const i = {
            delta: 0,
            timestamp: 0,
            isProcessing: !1
        }, o = ()=>n = !0, a = j.reduce((t, n)=>(t[n] = function(t, e) {
                let n = new Set, s = new Set, i = !1, r = !1;
                const o = new WeakSet;
                let a = {
                    delta: 0,
                    timestamp: 0,
                    isProcessing: !1
                }, l = 0;
                function u(e) {
                    o.has(e) && (c.schedule(e), t()), l++, e(a);
                }
                const c = {
                    schedule: (t, e = !1, r = !1)=>{
                        const a = r && i ? n : s;
                        return e && o.add(t), a.has(t) || a.add(t), t;
                    },
                    cancel: (t)=>{
                        s.delete(t), o.delete(t);
                    },
                    process: (t)=>{
                        a = t, i ? r = !0 : (i = !0, [n, s] = [
                            s,
                            n
                        ], n.forEach(u), e && N.value && N.value.frameloop[e].push(l), l = 0, n.clear(), i = !1, r && (r = !1, c.process(t)));
                    }
                };
                return c;
            }(o, e ? n : void 0), t), {}), { setup: l, read: u, resolveKeyframes: c, preUpdate: h, update: d, preRender: p, render: f, postRender: m } = a, g = ()=>{
            const o = r.useManualTiming ? i.timestamp : performance.now();
            n = !1, r.useManualTiming || (i.delta = s ? 1e3 / 60 : Math.max(Math.min(o - i.timestamp, 40), 1)), i.timestamp = o, i.isProcessing = !0, l.process(i), u.process(i), c.process(i), h.process(i), d.process(i), p.process(i), f.process(i), m.process(i), i.isProcessing = !1, n && e && (s = !1, t(g));
        };
        return {
            schedule: j.reduce((e, r)=>{
                const o = a[r];
                return e[r] = (e, r = !1, a = !1)=>(n || (n = !0, s = !0, i.isProcessing || t(g)), o.schedule(e, r, a)), e;
            }, {}),
            cancel: (t)=>{
                for(let e = 0; e < j.length; e++)a[j[e]].cancel(t);
            },
            state: i,
            steps: a
        };
    }
    const { schedule: $, cancel: U, state: Y, steps: z } = K("undefined" != typeof requestAnimationFrame ? requestAnimationFrame : c, !0);
    let X;
    function H() {
        X = void 0;
    }
    const G = {
        now: ()=>(void 0 === X && G.set(Y.isProcessing || r.useManualTiming ? Y.timestamp : performance.now()), X),
        set: (t)=>{
            X = t, queueMicrotask(H);
        }
    }, Z = {
        layout: 0,
        mainThread: 0,
        waapi: 0
    }, q = (t)=>(e)=>"string" == typeof e && e.startsWith(t), _ = q("--"), J = q("var(--"), Q = (t)=>!!J(t) && tt.test(t.split("/*")[0].trim()), tt = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, et = {
        test: (t)=>"number" == typeof t,
        parse: parseFloat,
        transform: (t)=>t
    }, nt = {
        ...et,
        transform: (t)=>s(0, 1, t)
    }, st = {
        ...et,
        default: 1
    }, it = (t)=>Math.round(1e5 * t) / 1e5, rt = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
    const ot = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, at = (t, e)=>(n)=>Boolean("string" == typeof n && ot.test(n) && n.startsWith(t) || e && !function(t) {
                return null == t;
            }(n) && Object.prototype.hasOwnProperty.call(n, e)), lt = (t, e, n)=>(s)=>{
            if ("string" != typeof s) return s;
            const [i, r, o, a] = s.match(rt);
            return {
                [t]: parseFloat(i),
                [e]: parseFloat(r),
                [n]: parseFloat(o),
                alpha: void 0 !== a ? parseFloat(a) : 1
            };
        }, ut = {
        ...et,
        transform: (t)=>Math.round(((t)=>s(0, 255, t))(t))
    }, ct = {
        test: at("rgb", "red"),
        parse: lt("red", "green", "blue"),
        transform: ({ red: t, green: e, blue: n, alpha: s = 1 })=>"rgba(" + ut.transform(t) + ", " + ut.transform(e) + ", " + ut.transform(n) + ", " + it(nt.transform(s)) + ")"
    };
    const ht = {
        test: at("#"),
        parse: function(t) {
            let e = "", n = "", s = "", i = "";
            return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), s = t.substring(5, 7), i = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), s = t.substring(3, 4), i = t.substring(4, 5), e += e, n += n, s += s, i += i), {
                red: parseInt(e, 16),
                green: parseInt(n, 16),
                blue: parseInt(s, 16),
                alpha: i ? parseInt(i, 16) / 255 : 1
            };
        },
        transform: ct.transform
    }, dt = (t)=>({
            test: (e)=>"string" == typeof e && e.endsWith(t) && 1 === e.split(" ").length,
            parse: parseFloat,
            transform: (e)=>`${e}${t}`
        }), pt = dt("deg"), ft = dt("%"), mt = dt("px"), gt = dt("vh"), yt = dt("vw"), vt = (()=>({
            ...ft,
            parse: (t)=>ft.parse(t) / 100,
            transform: (t)=>ft.transform(100 * t)
        }))(), wt = {
        test: at("hsl", "hue"),
        parse: lt("hue", "saturation", "lightness"),
        transform: ({ hue: t, saturation: e, lightness: n, alpha: s = 1 })=>"hsla(" + Math.round(t) + ", " + ft.transform(it(e)) + ", " + ft.transform(it(n)) + ", " + it(nt.transform(s)) + ")"
    }, bt = {
        test: (t)=>ct.test(t) || ht.test(t) || wt.test(t),
        parse: (t)=>ct.test(t) ? ct.parse(t) : wt.test(t) ? wt.parse(t) : ht.parse(t),
        transform: (t)=>"string" == typeof t ? t : t.hasOwnProperty("red") ? ct.transform(t) : wt.transform(t),
        getAnimatableNone: (t)=>{
            const e = bt.parse(t);
            return e.alpha = 0, bt.transform(e);
        }
    }, Tt = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
    const xt = "number", Vt = "color", Mt = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
    function St(t) {
        const e = t.toString(), n = [], s = {
            color: [],
            number: [],
            var: []
        }, i = [];
        let r = 0;
        const o = e.replace(Mt, (t)=>(bt.test(t) ? (s.color.push(r), i.push(Vt), n.push(bt.parse(t))) : t.startsWith("var(") ? (s.var.push(r), i.push("var"), n.push(t)) : (s.number.push(r), i.push(xt), n.push(parseFloat(t))), ++r, "${}")).split("${}");
        return {
            values: n,
            split: o,
            indexes: s,
            types: i
        };
    }
    function At(t) {
        return St(t).values;
    }
    function kt(t) {
        const { split: e, types: n } = St(t), s = e.length;
        return (t)=>{
            let i = "";
            for(let r = 0; r < s; r++)if (i += e[r], void 0 !== t[r]) {
                const e = n[r];
                i += e === xt ? it(t[r]) : e === Vt ? bt.transform(t[r]) : t[r];
            }
            return i;
        };
    }
    const Et = (t)=>"number" == typeof t ? 0 : bt.test(t) ? bt.getAnimatableNone(t) : t;
    const Pt = {
        test: function(t) {
            return isNaN(t) && "string" == typeof t && (t.match(rt)?.length || 0) + (t.match(Tt)?.length || 0) > 0;
        },
        parse: At,
        createTransformer: kt,
        getAnimatableNone: function(t) {
            const e = At(t);
            return kt(t)(e.map(Et));
        }
    };
    function Ct(t, e, n) {
        return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
    }
    function Ot({ hue: t, saturation: e, lightness: n, alpha: s }) {
        t /= 360, n /= 100;
        let i = 0, r = 0, o = 0;
        if (e /= 100) {
            const s = n < .5 ? n * (1 + e) : n + e - n * e, a = 2 * n - s;
            i = Ct(a, s, t + 1 / 3), r = Ct(a, s, t), o = Ct(a, s, t - 1 / 3);
        } else i = r = o = n;
        return {
            red: Math.round(255 * i),
            green: Math.round(255 * r),
            blue: Math.round(255 * o),
            alpha: s
        };
    }
    function Ft(t, e) {
        return (n)=>n > 0 ? e : t;
    }
    const Rt = (t, e, n)=>t + (e - t) * n, Bt = (t, e, n)=>{
        const s = t * t, i = n * (e * e - s) + s;
        return i < 0 ? 0 : Math.sqrt(i);
    }, Lt = [
        ht,
        ct,
        wt
    ];
    function Dt(t) {
        const e = (n = t, Lt.find((t)=>t.test(n)));
        var n;
        if (!Boolean(e)) return !1;
        let s = e.parse(t);
        return e === wt && (s = Ot(s)), s;
    }
    const It = (t, e)=>{
        const n = Dt(t), s = Dt(e);
        if (!n || !s) return Ft(t, e);
        const i = {
            ...n
        };
        return (t)=>(i.red = Bt(n.red, s.red, t), i.green = Bt(n.green, s.green, t), i.blue = Bt(n.blue, s.blue, t), i.alpha = Rt(n.alpha, s.alpha, t), ct.transform(i));
    }, Wt = new Set([
        "none",
        "hidden"
    ]);
    function jt(t, e) {
        return Wt.has(t) ? (n)=>n <= 0 ? t : e : (n)=>n >= 1 ? e : t;
    }
    function Nt(t, e) {
        return (n)=>Rt(t, e, n);
    }
    function Kt(t) {
        return "number" == typeof t ? Nt : "string" == typeof t ? Q(t) ? Ft : bt.test(t) ? It : Yt : Array.isArray(t) ? $t : "object" == typeof t ? bt.test(t) ? It : Ut : Ft;
    }
    function $t(t, e) {
        const n = [
            ...t
        ], s = n.length, i = t.map((t, n)=>Kt(t)(t, e[n]));
        return (t)=>{
            for(let e = 0; e < s; e++)n[e] = i[e](t);
            return n;
        };
    }
    function Ut(t, e) {
        const n = {
            ...t,
            ...e
        }, s = {};
        for(const i in n)void 0 !== t[i] && void 0 !== e[i] && (s[i] = Kt(t[i])(t[i], e[i]));
        return (t)=>{
            for(const e in s)n[e] = s[e](t);
            return n;
        };
    }
    const Yt = (t, e)=>{
        const n = Pt.createTransformer(e), s = St(t), i = St(e);
        return s.indexes.var.length === i.indexes.var.length && s.indexes.color.length === i.indexes.color.length && s.indexes.number.length >= i.indexes.number.length ? Wt.has(t) && !i.values.length || Wt.has(e) && !s.values.length ? jt(t, e) : d($t(function(t, e) {
            const n = [], s = {
                color: 0,
                var: 0,
                number: 0
            };
            for(let i = 0; i < e.values.length; i++){
                const r = e.types[i], o = t.indexes[r][s[r]], a = t.values[o] ?? 0;
                n[i] = a, s[r]++;
            }
            return n;
        }(s, i), i.values), n) : Ft(t, e);
    };
    function zt(t, e, n) {
        if ("number" == typeof t && "number" == typeof e && "number" == typeof n) return Rt(t, e, n);
        return Kt(t)(t, e);
    }
    const Xt = (t)=>{
        const e = ({ timestamp: e })=>t(e);
        return {
            start: (t = !0)=>$.update(e, t),
            stop: ()=>U(e),
            now: ()=>Y.isProcessing ? Y.timestamp : G.now()
        };
    }, Ht = (t, e, n = 10)=>{
        let s = "";
        const i = Math.max(Math.round(e / n), 2);
        for(let e = 0; e < i; e++)s += Math.round(1e4 * t(e / (i - 1))) / 1e4 + ", ";
        return `linear(${s.substring(0, s.length - 2)})`;
    }, Gt = 2e4;
    function Zt(t) {
        let e = 0;
        let n = t.next(e);
        for(; !n.done && e < Gt;)e += 50, n = t.next(e);
        return e >= Gt ? 1 / 0 : e;
    }
    function qt(t, e = 100, n) {
        const s = n({
            ...t,
            keyframes: [
                0,
                e
            ]
        }), i = Math.min(Zt(s), Gt);
        return {
            type: "keyframes",
            ease: (t)=>s.next(i * t).value / e,
            duration: g(i)
        };
    }
    function _t(t, e, n) {
        const s = Math.max(e - 5, 0);
        return y(n - t(s), e - s);
    }
    const Jt = 100, Qt = 10, te = 1, ee = 0, ne = 800, se = .3, ie = .3, re = {
        granular: .01,
        default: 2
    }, oe = {
        granular: .005,
        default: .5
    }, ae = .01, le = 10, ue = .05, ce = 1, he = .001;
    function de({ duration: t = ne, bounce: e = se, velocity: n = ee, mass: i = te }) {
        let r, o, a = 1 - e;
        a = s(ue, ce, a), t = s(ae, le, g(t)), a < 1 ? (r = (e)=>{
            const s = e * a, i = s * t, r = s - n, o = fe(e, a), l = Math.exp(-i);
            return he - r / o * l;
        }, o = (e)=>{
            const s = e * a * t, i = s * n + n, o = Math.pow(a, 2) * Math.pow(e, 2) * t, l = Math.exp(-s), u = fe(Math.pow(e, 2), a);
            return (-r(e) + he > 0 ? -1 : 1) * ((i - o) * l) / u;
        }) : (r = (e)=>Math.exp(-e * t) * ((e - n) * t + 1) - .001, o = (e)=>Math.exp(-e * t) * (t * t * (n - e)));
        const l = function(t, e, n) {
            let s = n;
            for(let n = 1; n < pe; n++)s -= t(s) / e(s);
            return s;
        }(r, o, 5 / t);
        if (t = m(t), isNaN(l)) return {
            stiffness: Jt,
            damping: Qt,
            duration: t
        };
        {
            const e = Math.pow(l, 2) * i;
            return {
                stiffness: e,
                damping: 2 * a * Math.sqrt(i * e),
                duration: t
            };
        }
    }
    const pe = 12;
    function fe(t, e) {
        return t * Math.sqrt(1 - e * e);
    }
    const me = [
        "duration",
        "bounce"
    ], ge = [
        "stiffness",
        "damping",
        "mass"
    ];
    function ye(t, e) {
        return e.some((e)=>void 0 !== t[e]);
    }
    function ve(t = ie, e = se) {
        const n = "object" != typeof t ? {
            visualDuration: t,
            keyframes: [
                0,
                1
            ],
            bounce: e
        } : t;
        let { restSpeed: i, restDelta: r } = n;
        const o = n.keyframes[0], a = n.keyframes[n.keyframes.length - 1], l = {
            done: !1,
            value: o
        }, { stiffness: u, damping: c, mass: h, duration: d, velocity: p, isResolvedFromDuration: f } = function(t) {
            let e = {
                velocity: ee,
                stiffness: Jt,
                damping: Qt,
                mass: te,
                isResolvedFromDuration: !1,
                ...t
            };
            if (!ye(t, ge) && ye(t, me)) {
                if (t.visualDuration) {
                    const n = t.visualDuration, i = 2 * Math.PI / (1.2 * n), r = i * i, o = 2 * s(.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(r);
                    e = {
                        ...e,
                        mass: te,
                        stiffness: r,
                        damping: o
                    };
                } else {
                    const n = de(t);
                    e = {
                        ...e,
                        ...n,
                        mass: te
                    }, e.isResolvedFromDuration = !0;
                }
            }
            return e;
        }({
            ...n,
            velocity: -g(n.velocity || 0)
        }), y = p || 0, v = c / (2 * Math.sqrt(u * h)), w = a - o, b = g(Math.sqrt(u / h)), T = Math.abs(w) < 5;
        let x;
        if (i || (i = T ? re.granular : re.default), r || (r = T ? oe.granular : oe.default), v < 1) {
            const t = fe(b, v);
            x = (e)=>{
                const n = Math.exp(-v * b * e);
                return a - n * ((y + v * b * w) / t * Math.sin(t * e) + w * Math.cos(t * e));
            };
        } else if (1 === v) x = (t)=>a - Math.exp(-b * t) * (w + (y + b * w) * t);
        else {
            const t = b * Math.sqrt(v * v - 1);
            x = (e)=>{
                const n = Math.exp(-v * b * e), s = Math.min(t * e, 300);
                return a - n * ((y + v * b * w) * Math.sinh(s) + t * w * Math.cosh(s)) / t;
            };
        }
        const V = {
            calculatedDuration: f && d || null,
            next: (t)=>{
                const e = x(t);
                if (f) l.done = t >= d;
                else {
                    let n = 0 === t ? y : 0;
                    v < 1 && (n = 0 === t ? m(y) : _t(x, t, e));
                    const s = Math.abs(n) <= i, o = Math.abs(a - e) <= r;
                    l.done = s && o;
                }
                return l.value = l.done ? a : e, l;
            },
            toString: ()=>{
                const t = Math.min(Zt(V), Gt), e = Ht((e)=>V.next(t * e).value, t, 30);
                return t + "ms " + e;
            },
            toTransition: ()=>{}
        };
        return V;
    }
    function we({ keyframes: t, velocity: e = 0, power: n = .8, timeConstant: s = 325, bounceDamping: i = 10, bounceStiffness: r = 500, modifyTarget: o, min: a, max: l, restDelta: u = .5, restSpeed: c }) {
        const h = t[0], d = {
            done: !1,
            value: h
        }, p = (t)=>void 0 === a ? l : void 0 === l || Math.abs(a - t) < Math.abs(l - t) ? a : l;
        let f = n * e;
        const m = h + f, g = void 0 === o ? m : o(m);
        g !== m && (f = g - h);
        const y = (t)=>-f * Math.exp(-t / s), v = (t)=>g + y(t), w = (t)=>{
            const e = y(t), n = v(t);
            d.done = Math.abs(e) <= u, d.value = d.done ? g : n;
        };
        let b, T;
        const x = (t)=>{
            var e;
            (e = d.value, void 0 !== a && e < a || void 0 !== l && e > l) && (b = t, T = ve({
                keyframes: [
                    d.value,
                    p(d.value)
                ],
                velocity: _t(v, t, d.value),
                damping: i,
                stiffness: r,
                restDelta: u,
                restSpeed: c
            }));
        };
        return x(0), {
            calculatedDuration: null,
            next: (t)=>{
                let e = !1;
                return T || void 0 !== b || (e = !0, w(t), x(t)), void 0 !== b && t >= b ? T.next(t - b) : (!e && w(t), d);
            }
        };
    }
    function be(t, e, { clamp: n = !0, ease: i, mixer: o } = {}) {
        const a = t.length;
        if (e.length, 1 === a) return ()=>e[0];
        if (2 === a && e[0] === e[1]) return ()=>e[1];
        const l = t[0] === t[1];
        t[0] > t[a - 1] && (t = [
            ...t
        ].reverse(), e = [
            ...e
        ].reverse());
        const u = function(t, e, n) {
            const s = [], i = n || r.mix || zt, o = t.length - 1;
            for(let n = 0; n < o; n++){
                let r = i(t[n], t[n + 1]);
                if (e) {
                    const t = Array.isArray(e) ? e[n] || c : e;
                    r = d(t, r);
                }
                s.push(r);
            }
            return s;
        }(e, i, o), h = u.length, f = (n)=>{
            if (l && n < t[0]) return e[0];
            let s = 0;
            if (h > 1) for(; s < t.length - 2 && !(n < t[s + 1]); s++);
            const i = p(t[s], t[s + 1], n);
            return u[s](i);
        };
        return n ? (e)=>f(s(t[0], t[a - 1], e)) : f;
    }
    function Te(t, e) {
        const n = t[t.length - 1];
        for(let s = 1; s <= e; s++){
            const i = p(0, e, s);
            t.push(Rt(n, 1, i));
        }
    }
    function xe(t) {
        const e = [
            0
        ];
        return Te(e, t.length - 1), e;
    }
    function Ve(t, e) {
        return t.map((t)=>t * e);
    }
    function Me(t, e) {
        return t.map(()=>e || R).splice(0, t.length - 1);
    }
    function Se({ duration: t = 300, keyframes: e, times: n, ease: s = "easeInOut" }) {
        const i = B(s) ? s.map(W) : W(s), r = {
            done: !1,
            value: e[0]
        }, o = be(Ve(n && n.length === e.length ? n : xe(e), t), e, {
            ease: Array.isArray(i) ? i : Me(e, i)
        });
        return {
            calculatedDuration: t,
            next: (e)=>(r.value = o(e), r.done = e >= t, r)
        };
    }
    ve.applyToOptions = (t)=>{
        const e = qt(t, 100, ve);
        return t.ease = e.ease, t.duration = m(e.duration), t.type = "keyframes", t;
    };
    const Ae = (t)=>null !== t;
    function ke(t, { repeat: e, repeatType: n = "loop" }, s, i = 1) {
        const r = t.filter(Ae), o = i < 0 || e && "loop" !== n && e % 2 == 1 ? 0 : r.length - 1;
        return o && void 0 !== s ? s : r[o];
    }
    const Ee = {
        decay: we,
        inertia: we,
        tween: Se,
        keyframes: Se,
        spring: ve
    };
    function Pe(t) {
        "string" == typeof t.type && (t.type = Ee[t.type]);
    }
    class Ce {
        constructor(){
            this.updateFinished();
        }
        get finished() {
            return this._finished;
        }
        updateFinished() {
            this._finished = new Promise((t)=>{
                this.resolve = t;
            });
        }
        notifyFinished() {
            this.resolve();
        }
        then(t, e) {
            return this.finished.then(t, e);
        }
    }
    const Oe = (t)=>t / 100;
    class Fe extends Ce {
        constructor(t){
            super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = ()=>{
                const { motionValue: t } = this.options;
                t && t.updatedAt !== G.now() && this.tick(G.now()), this.isStopped = !0, "idle" !== this.state && (this.teardown(), this.options.onStop?.());
            }, Z.mainThread++, this.options = t, this.initAnimation(), this.play(), !1 === t.autoplay && this.pause();
        }
        initAnimation() {
            const { options: t } = this;
            Pe(t);
            const { type: e = Se, repeat: n = 0, repeatDelay: s = 0, repeatType: i, velocity: r = 0 } = t;
            let { keyframes: o } = t;
            const a = e || Se;
            a !== Se && "number" != typeof o[0] && (this.mixKeyframes = d(Oe, zt(o[0], o[1])), o = [
                0,
                100
            ]);
            const l = a({
                ...t,
                keyframes: o
            });
            "mirror" === i && (this.mirroredGenerator = a({
                ...t,
                keyframes: [
                    ...o
                ].reverse(),
                velocity: -r
            })), null === l.calculatedDuration && (l.calculatedDuration = Zt(l));
            const { calculatedDuration: u } = l;
            this.calculatedDuration = u, this.resolvedDuration = u + s, this.totalDuration = this.resolvedDuration * (n + 1) - s, this.generator = l;
        }
        updateTime(t) {
            const e = Math.round(t - this.startTime) * this.playbackSpeed;
            null !== this.holdTime ? this.currentTime = this.holdTime : this.currentTime = e;
        }
        tick(t, e = !1) {
            const { generator: n, totalDuration: i, mixKeyframes: r, mirroredGenerator: o, resolvedDuration: a, calculatedDuration: l } = this;
            if (null === this.startTime) return n.next(0);
            const { delay: u = 0, keyframes: c, repeat: h, repeatType: d, repeatDelay: p, type: f, onUpdate: m, finalKeyframe: g } = this.options;
            this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - i / this.speed, this.startTime)), e ? this.currentTime = t : this.updateTime(t);
            const y = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), v = this.playbackSpeed >= 0 ? y < 0 : y > i;
            this.currentTime = Math.max(y, 0), "finished" === this.state && null === this.holdTime && (this.currentTime = i);
            let w = this.currentTime, b = n;
            if (h) {
                const t = Math.min(this.currentTime, i) / a;
                let e = Math.floor(t), n = t % 1;
                !n && t >= 1 && (n = 1), 1 === n && e--, e = Math.min(e, h + 1);
                Boolean(e % 2) && ("reverse" === d ? (n = 1 - n, p && (n -= p / a)) : "mirror" === d && (b = o)), w = s(0, 1, n) * a;
            }
            const T = v ? {
                done: !1,
                value: c[0]
            } : b.next(w);
            r && (T.value = r(T.value));
            let { done: x } = T;
            v || null === l || (x = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
            const V = null === this.holdTime && ("finished" === this.state || "running" === this.state && x);
            return V && f !== we && (T.value = ke(c, this.options, g, this.speed)), m && m(T.value), V && this.finish(), T;
        }
        then(t, e) {
            return this.finished.then(t, e);
        }
        get duration() {
            return g(this.calculatedDuration);
        }
        get time() {
            return g(this.currentTime);
        }
        set time(t) {
            t = m(t), this.currentTime = t, null === this.startTime || null !== this.holdTime || 0 === this.playbackSpeed ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver?.start(!1);
        }
        get speed() {
            return this.playbackSpeed;
        }
        set speed(t) {
            this.updateTime(G.now());
            const e = this.playbackSpeed !== t;
            this.playbackSpeed = t, e && (this.time = g(this.currentTime));
        }
        play() {
            if (this.isStopped) return;
            const { driver: t = Xt, startTime: e } = this.options;
            this.driver || (this.driver = t((t)=>this.tick(t))), this.options.onPlay?.();
            const n = this.driver.now();
            "finished" === this.state ? (this.updateFinished(), this.startTime = n) : null !== this.holdTime ? this.startTime = n - this.holdTime : this.startTime || (this.startTime = e ?? n), "finished" === this.state && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
        }
        pause() {
            this.state = "paused", this.updateTime(G.now()), this.holdTime = this.currentTime;
        }
        complete() {
            "running" !== this.state && this.play(), this.state = "finished", this.holdTime = null;
        }
        finish() {
            this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
        }
        cancel() {
            this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
        }
        teardown() {
            this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null, Z.mainThread--;
        }
        stopDriver() {
            this.driver && (this.driver.stop(), this.driver = void 0);
        }
        sample(t) {
            return this.startTime = 0, this.tick(t, !0);
        }
        attachTimeline(t) {
            return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), t.observe(this);
        }
    }
    function Re(t) {
        for(let e = 1; e < t.length; e++)t[e] ?? (t[e] = t[e - 1]);
    }
    const Be = (t)=>180 * t / Math.PI, Le = (t)=>{
        const e = Be(Math.atan2(t[1], t[0]));
        return Ie(e);
    }, De = {
        x: 4,
        y: 5,
        translateX: 4,
        translateY: 5,
        scaleX: 0,
        scaleY: 3,
        scale: (t)=>(Math.abs(t[0]) + Math.abs(t[3])) / 2,
        rotate: Le,
        rotateZ: Le,
        skewX: (t)=>Be(Math.atan(t[1])),
        skewY: (t)=>Be(Math.atan(t[2])),
        skew: (t)=>(Math.abs(t[1]) + Math.abs(t[2])) / 2
    }, Ie = (t)=>((t %= 360) < 0 && (t += 360), t), We = (t)=>Math.sqrt(t[0] * t[0] + t[1] * t[1]), je = (t)=>Math.sqrt(t[4] * t[4] + t[5] * t[5]), Ne = {
        x: 12,
        y: 13,
        z: 14,
        translateX: 12,
        translateY: 13,
        translateZ: 14,
        scaleX: We,
        scaleY: je,
        scale: (t)=>(We(t) + je(t)) / 2,
        rotateX: (t)=>Ie(Be(Math.atan2(t[6], t[5]))),
        rotateY: (t)=>Ie(Be(Math.atan2(-t[2], t[0]))),
        rotateZ: Le,
        rotate: Le,
        skewX: (t)=>Be(Math.atan(t[4])),
        skewY: (t)=>Be(Math.atan(t[1])),
        skew: (t)=>(Math.abs(t[1]) + Math.abs(t[4])) / 2
    };
    function Ke(t) {
        return t.includes("scale") ? 1 : 0;
    }
    function $e(t, e) {
        if (!t || "none" === t) return Ke(e);
        const n = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
        let s, i;
        if (n) s = Ne, i = n;
        else {
            const e = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
            s = De, i = e;
        }
        if (!i) return Ke(e);
        const r = s[e], o = i[1].split(",").map(Ye);
        return "function" == typeof r ? r(o) : o[r];
    }
    const Ue = (t, e)=>{
        const { transform: n = "none" } = getComputedStyle(t);
        return $e(n, e);
    };
    function Ye(t) {
        return parseFloat(t.trim());
    }
    const ze = [
        "transformPerspective",
        "x",
        "y",
        "z",
        "translateX",
        "translateY",
        "translateZ",
        "scale",
        "scaleX",
        "scaleY",
        "rotate",
        "rotateX",
        "rotateY",
        "rotateZ",
        "skew",
        "skewX",
        "skewY"
    ], Xe = (()=>new Set(ze))(), He = (t)=>t === et || t === mt, Ge = new Set([
        "x",
        "y",
        "z"
    ]), Ze = ze.filter((t)=>!Ge.has(t));
    const qe = {
        width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" })=>t.max - t.min - parseFloat(e) - parseFloat(n),
        height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" })=>t.max - t.min - parseFloat(e) - parseFloat(n),
        top: (t, { top: e })=>parseFloat(e),
        left: (t, { left: e })=>parseFloat(e),
        bottom: ({ y: t }, { top: e })=>parseFloat(e) + (t.max - t.min),
        right: ({ x: t }, { left: e })=>parseFloat(e) + (t.max - t.min),
        x: (t, { transform: e })=>$e(e, "x"),
        y: (t, { transform: e })=>$e(e, "y")
    };
    qe.translateX = qe.x, qe.translateY = qe.y;
    const _e = new Set;
    let Je = !1, Qe = !1, tn = !1;
    function en() {
        if (Qe) {
            const t = Array.from(_e).filter((t)=>t.needsMeasurement), e = new Set(t.map((t)=>t.element)), n = new Map;
            e.forEach((t)=>{
                const e = function(t) {
                    const e = [];
                    return Ze.forEach((n)=>{
                        const s = t.getValue(n);
                        void 0 !== s && (e.push([
                            n,
                            s.get()
                        ]), s.set(n.startsWith("scale") ? 1 : 0));
                    }), e;
                }(t);
                e.length && (n.set(t, e), t.render());
            }), t.forEach((t)=>t.measureInitialState()), e.forEach((t)=>{
                t.render();
                const e = n.get(t);
                e && e.forEach(([e, n])=>{
                    t.getValue(e)?.set(n);
                });
            }), t.forEach((t)=>t.measureEndState()), t.forEach((t)=>{
                void 0 !== t.suspendedScrollY && window.scrollTo(0, t.suspendedScrollY);
            });
        }
        Qe = !1, Je = !1, _e.forEach((t)=>t.complete(tn)), _e.clear();
    }
    function nn() {
        _e.forEach((t)=>{
            t.readKeyframes(), t.needsMeasurement && (Qe = !0);
        });
    }
    function sn() {
        tn = !0, nn(), en(), tn = !1;
    }
    class rn {
        constructor(t, e, n, s, i, r = !1){
            this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [
                ...t
            ], this.onComplete = e, this.name = n, this.motionValue = s, this.element = i, this.isAsync = r;
        }
        scheduleResolve() {
            this.state = "scheduled", this.isAsync ? (_e.add(this), Je || (Je = !0, $.read(nn), $.resolveKeyframes(en))) : (this.readKeyframes(), this.complete());
        }
        readKeyframes() {
            const { unresolvedKeyframes: t, name: e, element: n, motionValue: s } = this;
            if (null === t[0]) {
                const i = s?.get(), r = t[t.length - 1];
                if (void 0 !== i) t[0] = i;
                else if (n && e) {
                    const s = n.readValue(e, r);
                    null != s && (t[0] = s);
                }
                void 0 === t[0] && (t[0] = r), s && void 0 === i && s.set(t[0]);
            }
            Re(t);
        }
        setFinalKeyframe() {}
        measureInitialState() {}
        renderEndStyles() {}
        measureEndState() {}
        complete(t = !1) {
            this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), _e.delete(this);
        }
        cancel() {
            "scheduled" === this.state && (_e.delete(this), this.state = "pending");
        }
        resume() {
            "pending" === this.state && this.scheduleResolve();
        }
    }
    const on = (t)=>t.startsWith("--");
    function an(t, e, n) {
        on(e) ? t.style.setProperty(e, n) : t.style[e] = n;
    }
    const ln = u(()=>void 0 !== window.ScrollTimeline), un = {};
    function cn(t, e) {
        const n = u(t);
        return ()=>un[e] ?? n();
    }
    const hn = cn(()=>{
        try {
            document.createElement("div").animate({
                opacity: 0
            }, {
                easing: "linear(0, 1)"
            });
        } catch (t) {
            return !1;
        }
        return !0;
    }, "linearEasing"), dn = ([t, e, n, s])=>`cubic-bezier(${t}, ${e}, ${n}, ${s})`, pn = {
        linear: "linear",
        ease: "ease",
        easeIn: "ease-in",
        easeOut: "ease-out",
        easeInOut: "ease-in-out",
        circIn: dn([
            0,
            .65,
            .55,
            1
        ]),
        circOut: dn([
            .55,
            0,
            1,
            .45
        ]),
        backIn: dn([
            .31,
            .01,
            .66,
            -0.59
        ]),
        backOut: dn([
            .33,
            1.53,
            .69,
            .99
        ])
    };
    function fn(t, e) {
        return t ? "function" == typeof t ? hn() ? Ht(t, e) : "ease-out" : D(t) ? dn(t) : Array.isArray(t) ? t.map((t)=>fn(t, e) || pn.easeOut) : pn[t] : void 0;
    }
    function mn(t, e, n, { delay: s = 0, duration: i = 300, repeat: r = 0, repeatType: o = "loop", ease: a = "easeOut", times: l } = {}, u) {
        const c = {
            [e]: n
        };
        l && (c.offset = l);
        const h = fn(a, i);
        Array.isArray(h) && (c.easing = h), N.value && Z.waapi++;
        const d = {
            delay: s,
            duration: i,
            easing: Array.isArray(h) ? "linear" : h,
            fill: "both",
            iterations: r + 1,
            direction: "reverse" === o ? "alternate" : "normal"
        };
        u && (d.pseudoElement = u);
        const p = t.animate(c, d);
        return N.value && p.finished.finally(()=>{
            Z.waapi--;
        }), p;
    }
    function gn(t) {
        return "function" == typeof t && "applyToOptions" in t;
    }
    function yn({ type: t, ...e }) {
        return gn(t) && hn() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
    }
    class vn extends Ce {
        constructor(t){
            if (super(), this.finishedTime = null, this.isStopped = !1, !t) return;
            const { element: e, name: n, keyframes: s, pseudoElement: i, allowFlatten: r = !1, finalKeyframe: o, onComplete: a } = t;
            this.isPseudoElement = Boolean(i), this.allowFlatten = r, this.options = t, t.type;
            const l = yn(t);
            this.animation = mn(e, n, s, l, i), !1 === l.autoplay && this.animation.pause(), this.animation.onfinish = ()=>{
                if (this.finishedTime = this.time, !i) {
                    const t = ke(s, this.options, o, this.speed);
                    this.updateMotionValue ? this.updateMotionValue(t) : an(e, n, t), this.animation.cancel();
                }
                a?.(), this.notifyFinished();
            };
        }
        play() {
            this.isStopped || (this.animation.play(), "finished" === this.state && this.updateFinished());
        }
        pause() {
            this.animation.pause();
        }
        complete() {
            this.animation.finish?.();
        }
        cancel() {
            try {
                this.animation.cancel();
            } catch (t) {}
        }
        stop() {
            if (this.isStopped) return;
            this.isStopped = !0;
            const { state: t } = this;
            "idle" !== t && "finished" !== t && (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
        }
        commitStyles() {
            this.isPseudoElement || this.animation.commitStyles?.();
        }
        get duration() {
            const t = this.animation.effect?.getComputedTiming?.().duration || 0;
            return g(Number(t));
        }
        get time() {
            return g(Number(this.animation.currentTime) || 0);
        }
        set time(t) {
            this.finishedTime = null, this.animation.currentTime = m(t);
        }
        get speed() {
            return this.animation.playbackRate;
        }
        set speed(t) {
            t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
        }
        get state() {
            return null !== this.finishedTime ? "finished" : this.animation.playState;
        }
        get startTime() {
            return Number(this.animation.startTime);
        }
        set startTime(t) {
            this.animation.startTime = t;
        }
        attachTimeline({ timeline: t, observe: e }) {
            return this.allowFlatten && this.animation.effect?.updateTiming({
                easing: "linear"
            }), this.animation.onfinish = null, t && ln() ? (this.animation.timeline = t, c) : e(this);
        }
    }
    const wn = {
        anticipate: k,
        backInOut: A,
        circInOut: C
    };
    function bn(t) {
        "string" == typeof t.ease && t.ease in wn && (t.ease = wn[t.ease]);
    }
    class Tn extends vn {
        constructor(t){
            bn(t), Pe(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
        }
        updateMotionValue(t) {
            const { motionValue: e, onUpdate: n, onComplete: s, element: i, ...r } = this.options;
            if (!e) return;
            if (void 0 !== t) return void e.set(t);
            const o = new Fe({
                ...r,
                autoplay: !1
            }), a = m(this.finishedTime ?? this.time);
            e.setWithVelocity(o.sample(a - 10).value, o.sample(a).value, 10), o.stop();
        }
    }
    const xn = (t, e)=>"zIndex" !== e && (!("number" != typeof t && !Array.isArray(t)) || !("string" != typeof t || !Pt.test(t) && "0" !== t || t.startsWith("url(")));
    function Vn(t) {
        t.duration = 0, t.type;
    }
    const Mn = new Set([
        "opacity",
        "clipPath",
        "filter",
        "transform"
    ]), Sn = u(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
    function An(t) {
        const { motionValue: e, name: n, repeatDelay: s, repeatType: i, damping: r, type: o } = t, a = e?.owner?.current;
        if (!(a instanceof HTMLElement)) return !1;
        const { onUpdate: l, transformTemplate: u } = e.owner.getProps();
        return Sn() && n && Mn.has(n) && ("transform" !== n || !u) && !l && !s && "mirror" !== i && 0 !== r && "inertia" !== o;
    }
    class kn extends Ce {
        constructor({ autoplay: t = !0, delay: e = 0, type: n = "keyframes", repeat: s = 0, repeatDelay: i = 0, repeatType: r = "loop", keyframes: o, name: a, motionValue: l, element: u, ...c }){
            super(), this.stop = ()=>{
                this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
            }, this.createdAt = G.now();
            const h = {
                autoplay: t,
                delay: e,
                type: n,
                repeat: s,
                repeatDelay: i,
                repeatType: r,
                name: a,
                motionValue: l,
                element: u,
                ...c
            }, d = u?.KeyframeResolver || rn;
            this.keyframeResolver = new d(o, (t, e, n)=>this.onKeyframesResolved(t, e, h, !n), a, l, u), this.keyframeResolver?.scheduleResolve();
        }
        onKeyframesResolved(t, e, n, s) {
            this.keyframeResolver = void 0;
            const { name: i, type: o, velocity: a, delay: l, isHandoff: u, onUpdate: h } = n;
            this.resolvedAt = G.now(), function(t, e, n, s) {
                const i = t[0];
                if (null === i) return !1;
                if ("display" === e || "visibility" === e) return !0;
                const r = t[t.length - 1], o = xn(i, e), a = xn(r, e);
                return !(!o || !a) && (function(t) {
                    const e = t[0];
                    if (1 === t.length) return !0;
                    for(let n = 0; n < t.length; n++)if (t[n] !== e) return !0;
                }(t) || ("spring" === n || gn(n)) && s);
            }(t, i, o, a) || (!r.instantAnimations && l || h?.(ke(t, n, e)), t[0] = t[t.length - 1], Vn(n), n.repeat = 0);
            const d = {
                startTime: s ? this.resolvedAt && this.resolvedAt - this.createdAt > 40 ? this.resolvedAt : this.createdAt : void 0,
                finalKeyframe: e,
                ...n,
                keyframes: t
            }, p = !u && An(d) ? new Tn({
                ...d,
                element: d.motionValue.owner.current
            }) : new Fe(d);
            p.finished.then(()=>this.notifyFinished()).catch(c), this.pendingTimeline && (this.stopTimeline = p.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = p;
        }
        get finished() {
            return this._animation ? this.animation.finished : this._finished;
        }
        then(t, e) {
            return this.finished.finally(t).then(()=>{});
        }
        get animation() {
            return this._animation || (this.keyframeResolver?.resume(), sn()), this._animation;
        }
        get duration() {
            return this.animation.duration;
        }
        get time() {
            return this.animation.time;
        }
        set time(t) {
            this.animation.time = t;
        }
        get speed() {
            return this.animation.speed;
        }
        get state() {
            return this.animation.state;
        }
        set speed(t) {
            this.animation.speed = t;
        }
        get startTime() {
            return this.animation.startTime;
        }
        attachTimeline(t) {
            return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, ()=>this.stop();
        }
        play() {
            this.animation.play();
        }
        pause() {
            this.animation.pause();
        }
        complete() {
            this.animation.complete();
        }
        cancel() {
            this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
        }
    }
    class En {
        constructor(t){
            this.stop = ()=>this.runAll("stop"), this.animations = t.filter(Boolean);
        }
        get finished() {
            return Promise.all(this.animations.map((t)=>t.finished));
        }
        getAll(t) {
            return this.animations[0][t];
        }
        setAll(t, e) {
            for(let n = 0; n < this.animations.length; n++)this.animations[n][t] = e;
        }
        attachTimeline(t) {
            const e = this.animations.map((e)=>e.attachTimeline(t));
            return ()=>{
                e.forEach((t, e)=>{
                    t && t(), this.animations[e].stop();
                });
            };
        }
        get time() {
            return this.getAll("time");
        }
        set time(t) {
            this.setAll("time", t);
        }
        get speed() {
            return this.getAll("speed");
        }
        set speed(t) {
            this.setAll("speed", t);
        }
        get state() {
            return this.getAll("state");
        }
        get startTime() {
            return this.getAll("startTime");
        }
        get duration() {
            let t = 0;
            for(let e = 0; e < this.animations.length; e++)t = Math.max(t, this.animations[e].duration);
            return t;
        }
        runAll(t) {
            this.animations.forEach((e)=>e[t]());
        }
        play() {
            this.runAll("play");
        }
        pause() {
            this.runAll("pause");
        }
        cancel() {
            this.runAll("cancel");
        }
        complete() {
            this.runAll("complete");
        }
    }
    class Pn extends En {
        then(t, e) {
            return this.finished.finally(t).then(()=>{});
        }
    }
    class Cn extends vn {
        constructor(t){
            super(), this.animation = t, t.onfinish = ()=>{
                this.finishedTime = this.time, this.notifyFinished();
            };
        }
    }
    const On = new WeakMap, Fn = (t, e = "")=>`${t}:${e}`;
    function Rn(t) {
        const e = On.get(t) || new Map;
        return On.set(t, e), e;
    }
    const Bn = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
    function Ln(t) {
        const e = Bn.exec(t);
        if (!e) return [
            , 
        ];
        const [, n, s, i] = e;
        return [
            `--${n ?? s}`,
            i
        ];
    }
    function Dn(t, e, n = 1) {
        const [s, i] = Ln(t);
        if (!s) return;
        const r = window.getComputedStyle(e).getPropertyValue(s);
        if (r) {
            const t = r.trim();
            return o(t) ? parseFloat(t) : t;
        }
        return Q(i) ? Dn(i, e, n + 1) : i;
    }
    function In(t, e) {
        return t?.[e] ?? t?.default ?? t;
    }
    const Wn = new Set([
        "width",
        "height",
        "top",
        "left",
        "right",
        "bottom",
        ...ze
    ]), jn = (t)=>(e)=>e.test(t), Nn = [
        et,
        mt,
        ft,
        pt,
        yt,
        gt,
        {
            test: (t)=>"auto" === t,
            parse: (t)=>t
        }
    ], Kn = (t)=>Nn.find(jn(t));
    function $n(t) {
        return "number" == typeof t ? 0 === t : null === t || "none" === t || "0" === t || l(t);
    }
    const Un = new Set([
        "brightness",
        "contrast",
        "saturate",
        "opacity"
    ]);
    function Yn(t) {
        const [e, n] = t.slice(0, -1).split("(");
        if ("drop-shadow" === e) return t;
        const [s] = n.match(rt) || [];
        if (!s) return t;
        const i = n.replace(s, "");
        let r = Un.has(e) ? 1 : 0;
        return s !== n && (r *= 100), e + "(" + r + i + ")";
    }
    const zn = /\b([a-z-]*)\(.*?\)/gu, Xn = {
        ...Pt,
        getAnimatableNone: (t)=>{
            const e = t.match(zn);
            return e ? e.map(Yn).join(" ") : t;
        }
    }, Hn = {
        ...et,
        transform: Math.round
    }, Gn = {
        rotate: pt,
        rotateX: pt,
        rotateY: pt,
        rotateZ: pt,
        scale: st,
        scaleX: st,
        scaleY: st,
        scaleZ: st,
        skew: pt,
        skewX: pt,
        skewY: pt,
        distance: mt,
        translateX: mt,
        translateY: mt,
        translateZ: mt,
        x: mt,
        y: mt,
        z: mt,
        perspective: mt,
        transformPerspective: mt,
        opacity: nt,
        originX: vt,
        originY: vt,
        originZ: mt
    }, Zn = {
        borderWidth: mt,
        borderTopWidth: mt,
        borderRightWidth: mt,
        borderBottomWidth: mt,
        borderLeftWidth: mt,
        borderRadius: mt,
        radius: mt,
        borderTopLeftRadius: mt,
        borderTopRightRadius: mt,
        borderBottomRightRadius: mt,
        borderBottomLeftRadius: mt,
        width: mt,
        maxWidth: mt,
        height: mt,
        maxHeight: mt,
        top: mt,
        right: mt,
        bottom: mt,
        left: mt,
        padding: mt,
        paddingTop: mt,
        paddingRight: mt,
        paddingBottom: mt,
        paddingLeft: mt,
        margin: mt,
        marginTop: mt,
        marginRight: mt,
        marginBottom: mt,
        marginLeft: mt,
        backgroundPositionX: mt,
        backgroundPositionY: mt,
        ...Gn,
        zIndex: Hn,
        fillOpacity: nt,
        strokeOpacity: nt,
        numOctaves: Hn
    }, qn = {
        ...Zn,
        color: bt,
        backgroundColor: bt,
        outlineColor: bt,
        fill: bt,
        stroke: bt,
        borderColor: bt,
        borderTopColor: bt,
        borderRightColor: bt,
        borderBottomColor: bt,
        borderLeftColor: bt,
        filter: Xn,
        WebkitFilter: Xn
    }, _n = (t)=>qn[t];
    function Jn(t, e) {
        let n = _n(t);
        return n !== Xn && (n = Pt), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
    }
    const Qn = new Set([
        "auto",
        "none",
        "0"
    ]);
    class ts extends rn {
        constructor(t, e, n, s, i){
            super(t, e, n, s, i, !0);
        }
        readKeyframes() {
            const { unresolvedKeyframes: t, element: e, name: n } = this;
            if (!e || !e.current) return;
            super.readKeyframes();
            for(let n = 0; n < t.length; n++){
                let s = t[n];
                if ("string" == typeof s && (s = s.trim(), Q(s))) {
                    const i = Dn(s, e.current);
                    void 0 !== i && (t[n] = i), n === t.length - 1 && (this.finalKeyframe = s);
                }
            }
            if (this.resolveNoneKeyframes(), !Wn.has(n) || 2 !== t.length) return;
            const [s, i] = t, r = Kn(s), o = Kn(i);
            if (r !== o) {
                if (He(r) && He(o)) for(let e = 0; e < t.length; e++){
                    const n = t[e];
                    "string" == typeof n && (t[e] = parseFloat(n));
                }
                else qe[n] && (this.needsMeasurement = !0);
            }
        }
        resolveNoneKeyframes() {
            const { unresolvedKeyframes: t, name: e } = this, n = [];
            for(let e = 0; e < t.length; e++)(null === t[e] || $n(t[e])) && n.push(e);
            n.length && function(t, e, n) {
                let s, i = 0;
                for(; i < t.length && !s;){
                    const e = t[i];
                    "string" == typeof e && !Qn.has(e) && St(e).values.length && (s = t[i]), i++;
                }
                if (s && n) for (const i of e)t[i] = Jn(n, s);
            }(t, n, e);
        }
        measureInitialState() {
            const { element: t, unresolvedKeyframes: e, name: n } = this;
            if (!t || !t.current) return;
            "height" === n && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = qe[n](t.measureViewportBox(), window.getComputedStyle(t.current)), e[0] = this.measuredOrigin;
            const s = e[e.length - 1];
            void 0 !== s && t.getValue(n, s).jump(s, !1);
        }
        measureEndState() {
            const { element: t, name: e, unresolvedKeyframes: n } = this;
            if (!t || !t.current) return;
            const s = t.getValue(e);
            s && s.jump(this.measuredOrigin, !1);
            const i = n.length - 1, r = n[i];
            n[i] = qe[e](t.measureViewportBox(), window.getComputedStyle(t.current)), null !== r && void 0 === this.finalKeyframe && (this.finalKeyframe = r), this.removedTransforms?.length && this.removedTransforms.forEach(([e, n])=>{
                t.getValue(e).set(n);
            }), this.resolveNoneKeyframes();
        }
    }
    const es = new Set([
        "borderWidth",
        "borderTopWidth",
        "borderRightWidth",
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRadius",
        "radius",
        "borderTopLeftRadius",
        "borderTopRightRadius",
        "borderBottomRightRadius",
        "borderBottomLeftRadius",
        "width",
        "maxWidth",
        "height",
        "maxHeight",
        "top",
        "right",
        "bottom",
        "left",
        "padding",
        "paddingTop",
        "paddingRight",
        "paddingBottom",
        "paddingLeft",
        "margin",
        "marginTop",
        "marginRight",
        "marginBottom",
        "marginLeft",
        "backgroundPositionX",
        "backgroundPositionY"
    ]);
    function ns(t, e) {
        for(let n = 0; n < t.length; n++)"number" == typeof t[n] && es.has(e) && (t[n] = t[n] + "px");
    }
    const ss = u(()=>{
        try {
            document.createElement("div").animate({
                opacity: [
                    1
                ]
            });
        } catch (t) {
            return !1;
        }
        return !0;
    }), is = new Set([
        "opacity",
        "clipPath",
        "filter",
        "transform"
    ]);
    function rs(t, e, n) {
        if (t instanceof EventTarget) return [
            t
        ];
        if ("string" == typeof t) {
            let s = document;
            e && (s = e.current);
            const i = n?.[t] ?? s.querySelectorAll(t);
            return i ? Array.from(i) : [];
        }
        return Array.from(t);
    }
    function os(t) {
        return (e, n)=>{
            const s = rs(e), i = [];
            for (const e of s){
                const s = t(e, n);
                i.push(s);
            }
            return ()=>{
                for (const t of i)t();
            };
        };
    }
    const as = (t, e)=>e && "number" == typeof t ? e.transform(t) : t;
    class ls {
        constructor(){
            this.latest = {}, this.values = new Map;
        }
        set(t, e, n, s, i = !0) {
            const r = this.values.get(t);
            r && r.onRemove();
            const o = ()=>{
                const s = e.get();
                this.latest[t] = i ? as(s, Zn[t]) : s, n && $.render(n);
            };
            o();
            const a = e.on("change", o);
            s && e.addDependent(s);
            const l = ()=>{
                a(), n && U(n), this.values.delete(t), s && e.removeDependent(s);
            };
            return this.values.set(t, {
                value: e,
                onRemove: l
            }), l;
        }
        get(t) {
            return this.values.get(t)?.value;
        }
        destroy() {
            for (const t of this.values.values())t.onRemove();
        }
    }
    function us(t) {
        const e = new WeakMap, n = [];
        return (s, i)=>{
            const r = e.get(s) ?? new ls;
            e.set(s, r);
            for(const e in i){
                const o = i[e], a = t(s, r, e, o);
                n.push(a);
            }
            return ()=>{
                for (const t of n)t();
            };
        };
    }
    const cs = (t, e, n, s)=>{
        const i = function(t, e) {
            if (!(e in t)) return !1;
            const n = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(t), e) || Object.getOwnPropertyDescriptor(t, e);
            return n && "function" == typeof n.set;
        }(t, n), r = i ? n : n.startsWith("data") || n.startsWith("aria") ? n.replace(/([A-Z])/g, (t)=>`-${t.toLowerCase()}`) : n;
        const o = i ? ()=>{
            t[r] = e.latest[n];
        } : ()=>{
            const s = e.latest[n];
            null == s ? t.removeAttribute(r) : t.setAttribute(r, String(s));
        };
        return e.set(n, s, o);
    }, hs = os(us(cs)), ds = us((t, e, n, s)=>e.set(n, s, ()=>{
            t[n] = e.latest[n];
        }, void 0, !1));
    function ps(t) {
        return a(t) && "offsetHeight" in t;
    }
    const fs = {
        current: void 0
    };
    class ms {
        constructor(t, e = {}){
            this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (t)=>{
                const e = G.now();
                if (this.updatedAt !== e && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(t), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents)) for (const t of this.dependents)t.dirty();
            }, this.hasAnimated = !1, this.setCurrent(t), this.owner = e.owner;
        }
        setCurrent(t) {
            var e;
            this.current = t, this.updatedAt = G.now(), null === this.canTrackVelocity && void 0 !== t && (this.canTrackVelocity = (e = this.current, !isNaN(parseFloat(e))));
        }
        setPrevFrameValue(t = this.current) {
            this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
        }
        onChange(t) {
            return this.on("change", t);
        }
        on(t, e) {
            this.events[t] || (this.events[t] = new f);
            const n = this.events[t].add(e);
            return "change" === t ? ()=>{
                n(), $.read(()=>{
                    this.events.change.getSize() || this.stop();
                });
            } : n;
        }
        clearListeners() {
            for(const t in this.events)this.events[t].clear();
        }
        attach(t, e) {
            this.passiveEffect = t, this.stopPassiveEffect = e;
        }
        set(t) {
            this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
        }
        setWithVelocity(t, e, n) {
            this.set(e), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - n;
        }
        jump(t, e = !0) {
            this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, e && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
        }
        dirty() {
            this.events.change?.notify(this.current);
        }
        addDependent(t) {
            this.dependents || (this.dependents = new Set), this.dependents.add(t);
        }
        removeDependent(t) {
            this.dependents && this.dependents.delete(t);
        }
        get() {
            return fs.current && fs.current.push(this), this.current;
        }
        getPrevious() {
            return this.prev;
        }
        getVelocity() {
            const t = G.now();
            if (!this.canTrackVelocity || void 0 === this.prevFrameValue || t - this.updatedAt > 30) return 0;
            const e = Math.min(this.updatedAt - this.prevUpdatedAt, 30);
            return y(parseFloat(this.current) - parseFloat(this.prevFrameValue), e);
        }
        start(t) {
            return this.stop(), new Promise((e)=>{
                this.hasAnimated = !0, this.animation = t(e), this.events.animationStart && this.events.animationStart.notify();
            }).then(()=>{
                this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
            });
        }
        stop() {
            this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
        }
        isAnimating() {
            return !!this.animation;
        }
        clearAnimation() {
            delete this.animation;
        }
        destroy() {
            this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
        }
    }
    function gs(t, e) {
        return new ms(t, e);
    }
    const ys = {
        x: "translateX",
        y: "translateY",
        z: "translateZ",
        transformPerspective: "perspective"
    };
    const vs = new Set([
        "originX",
        "originY",
        "originZ"
    ]), ws = (t, e, n, s)=>{
        let i, r;
        return Xe.has(n) ? (e.get("transform") || (ps(t) || e.get("transformBox") || ws(t, e, "transformBox", new ms("fill-box")), e.set("transform", new ms("none"), ()=>{
            t.style.transform = function(t) {
                let e = "", n = !0;
                for(let s = 0; s < ze.length; s++){
                    const i = ze[s], r = t.latest[i];
                    if (void 0 === r) continue;
                    let o = !0;
                    o = "number" == typeof r ? r === (i.startsWith("scale") ? 1 : 0) : 0 === parseFloat(r), o || (n = !1, e += `${ys[i] || i}(${t.latest[i]}) `);
                }
                return n ? "none" : e.trim();
            }(e);
        })), r = e.get("transform")) : vs.has(n) ? (e.get("transformOrigin") || e.set("transformOrigin", new ms(""), ()=>{
            const n = e.latest.originX ?? "50%", s = e.latest.originY ?? "50%", i = e.latest.originZ ?? 0;
            t.style.transformOrigin = `${n} ${s} ${i}`;
        }), r = e.get("transformOrigin")) : i = on(n) ? ()=>{
            t.style.setProperty(n, e.latest[n]);
        } : ()=>{
            t.style[n] = e.latest[n];
        }, e.set(n, s, i, r);
    }, bs = os(us(ws)), Ts = mt.transform;
    const xs = os(us((t, e, n, s)=>{
        if (n.startsWith("path")) return function(t, e, n, s) {
            return $.render(()=>t.setAttribute("pathLength", "1")), "pathOffset" === n ? e.set(n, s, ()=>t.setAttribute("stroke-dashoffset", Ts(-e.latest[n]))) : (e.get("stroke-dasharray") || e.set("stroke-dasharray", new ms("1 1"), ()=>{
                const { pathLength: n = 1, pathSpacing: s } = e.latest;
                t.setAttribute("stroke-dasharray", `${Ts(n)} ${Ts(s ?? 1 - Number(n))}`);
            }), e.set(n, s, void 0, e.get("stroke-dasharray")));
        }(t, e, n, s);
        if (n.startsWith("attr")) return cs(t, e, function(t) {
            return t.replace(/^attr([A-Z])/, (t, e)=>e.toLowerCase());
        }(n), s);
        return (n in t.style ? ws : cs)(t, e, n, s);
    }));
    const { schedule: Vs, cancel: Ms } = K(queueMicrotask, !1), Ss = {
        x: !1,
        y: !1
    };
    function As() {
        return Ss.x || Ss.y;
    }
    function ks(t, e) {
        const n = rs(t), s = new AbortController;
        return [
            n,
            {
                passive: !0,
                ...e,
                signal: s.signal
            },
            ()=>s.abort()
        ];
    }
    function Es(t) {
        return !("touch" === t.pointerType || As());
    }
    const Ps = (t, e)=>!!e && (t === e || Ps(t, e.parentElement)), Cs = (t)=>"mouse" === t.pointerType ? "number" != typeof t.button || t.button <= 0 : !1 !== t.isPrimary, Os = new Set([
        "BUTTON",
        "INPUT",
        "SELECT",
        "TEXTAREA",
        "A"
    ]);
    const Fs = new WeakSet;
    function Rs(t) {
        return (e)=>{
            "Enter" === e.key && t(e);
        };
    }
    function Bs(t, e) {
        t.dispatchEvent(new PointerEvent("pointer" + e, {
            isPrimary: !0,
            bubbles: !0
        }));
    }
    function Ls(t) {
        return Cs(t) && !As();
    }
    function Ds(t, e) {
        const n = window.getComputedStyle(t);
        return on(e) ? n.getPropertyValue(e) : n[e];
    }
    function Is(t) {
        return a(t) && "ownerSVGElement" in t;
    }
    const Ws = new WeakMap;
    let js;
    const Ns = (t, e, n)=>(s, i)=>i && i[0] ? i[0][t + "Size"] : Is(s) && "getBBox" in s ? s.getBBox()[e] : s[n], Ks = Ns("inline", "width", "offsetWidth"), $s = Ns("block", "height", "offsetHeight");
    function Us({ target: t, borderBoxSize: e }) {
        Ws.get(t)?.forEach((n)=>{
            n(t, {
                get width () {
                    return Ks(t, e);
                },
                get height () {
                    return $s(t, e);
                }
            });
        });
    }
    function Ys(t) {
        t.forEach(Us);
    }
    function zs(t, e) {
        js || "undefined" != typeof ResizeObserver && (js = new ResizeObserver(Ys));
        const n = rs(t);
        return n.forEach((t)=>{
            let n = Ws.get(t);
            n || (n = new Set, Ws.set(t, n)), n.add(e), js?.observe(t);
        }), ()=>{
            n.forEach((t)=>{
                const n = Ws.get(t);
                n?.delete(e), n?.size || js?.unobserve(t);
            });
        };
    }
    const Xs = new Set;
    let Hs;
    function Gs(t) {
        return Xs.add(t), Hs || (Hs = ()=>{
            const t = {
                get width () {
                    return window.innerWidth;
                },
                get height () {
                    return window.innerHeight;
                }
            };
            Xs.forEach((e)=>e(t));
        }, window.addEventListener("resize", Hs)), ()=>{
            Xs.delete(t), Xs.size || "function" != typeof Hs || (window.removeEventListener("resize", Hs), Hs = void 0);
        };
    }
    function Zs(t, e) {
        return "function" == typeof t ? Gs(t) : zs(t, e);
    }
    function qs(t, e) {
        let n;
        const s = ()=>{
            const { currentTime: s } = e, i = (null === s ? 0 : s.value) / 100;
            n !== i && t(i), n = i;
        };
        return $.preUpdate(s, !0), ()=>U(s);
    }
    function _s() {
        const { value: t } = N;
        null !== t ? (t.frameloop.rate.push(Y.delta), t.animations.mainThread.push(Z.mainThread), t.animations.waapi.push(Z.waapi), t.animations.layout.push(Z.layout)) : U(_s);
    }
    function Js(t) {
        return t.reduce((t, e)=>t + e, 0) / t.length;
    }
    function Qs(t, e = Js) {
        return 0 === t.length ? {
            min: 0,
            max: 0,
            avg: 0
        } : {
            min: Math.min(...t),
            max: Math.max(...t),
            avg: e(t)
        };
    }
    const ti = (t)=>Math.round(1e3 / t);
    function ei() {
        N.value = null, N.addProjectionMetrics = null;
    }
    function ni() {
        const { value: t } = N;
        if (!t) throw new Error("Stats are not being measured");
        ei(), U(_s);
        const e = {
            frameloop: {
                setup: Qs(t.frameloop.setup),
                rate: Qs(t.frameloop.rate),
                read: Qs(t.frameloop.read),
                resolveKeyframes: Qs(t.frameloop.resolveKeyframes),
                preUpdate: Qs(t.frameloop.preUpdate),
                update: Qs(t.frameloop.update),
                preRender: Qs(t.frameloop.preRender),
                render: Qs(t.frameloop.render),
                postRender: Qs(t.frameloop.postRender)
            },
            animations: {
                mainThread: Qs(t.animations.mainThread),
                waapi: Qs(t.animations.waapi),
                layout: Qs(t.animations.layout)
            },
            layoutProjection: {
                nodes: Qs(t.layoutProjection.nodes),
                calculatedTargetDeltas: Qs(t.layoutProjection.calculatedTargetDeltas),
                calculatedProjections: Qs(t.layoutProjection.calculatedProjections)
            }
        }, { rate: n } = e.frameloop;
        return n.min = ti(n.min), n.max = ti(n.max), n.avg = ti(n.avg), [n.min, n.max] = [
            n.max,
            n.min
        ], e;
    }
    function si(t) {
        return Is(t) && "svg" === t.tagName;
    }
    function ii(t, e) {
        if ("first" === t) return 0;
        {
            const n = e - 1;
            return "last" === t ? n : n / 2;
        }
    }
    function ri(...t) {
        const e = !Array.isArray(t[0]), n = e ? 0 : -1, s = t[0 + n], i = be(t[1 + n], t[2 + n], t[3 + n]);
        return e ? i(s) : i;
    }
    function oi(t) {
        const e = [];
        fs.current = e;
        const n = t();
        fs.current = void 0;
        const s = gs(n);
        return function(t, e, n) {
            const s = ()=>e.set(n()), i = ()=>$.preRender(s, !1, !0), r = t.map((t)=>t.on("change", i));
            e.on("destroy", ()=>{
                r.forEach((t)=>t()), U(s);
            });
        }(e, s, t), s;
    }
    const ai = (t)=>Boolean(t && t.getVelocity);
    function li(t, e, n) {
        const s = t.get();
        let i, r = null, o = s;
        const a = "string" == typeof s ? s.replace(/[\d.-]/g, "") : void 0, l = ()=>{
            r && (r.stop(), r = null);
        }, u = ()=>{
            l(), r = new Fe({
                keyframes: [
                    ci(t.get()),
                    ci(o)
                ],
                velocity: t.getVelocity(),
                type: "spring",
                restDelta: .001,
                restSpeed: .01,
                ...n,
                onUpdate: i
            });
        };
        if (t.attach((e, n)=>(o = e, i = (t)=>n(ui(t, a)), $.postRender(u), t.get()), l), ai(e)) {
            const n = e.on("change", (e)=>t.set(ui(e, a))), s = t.on("destroy", n);
            return ()=>{
                n(), s();
            };
        }
        return l;
    }
    function ui(t, e) {
        return e ? t + e : t;
    }
    function ci(t) {
        return "number" == typeof t ? t : parseFloat(t);
    }
    const hi = [
        ...Nn,
        bt,
        Pt
    ], di = (t)=>hi.find(jn(t));
    function pi(t) {
        return "layout" === t ? "group" : "enter" === t || "new" === t ? "new" : "exit" === t || "old" === t ? "old" : "group";
    }
    let fi = {}, mi = null;
    const gi = (t, e)=>{
        fi[t] = e;
    }, yi = ()=>{
        mi || (mi = document.createElement("style"), mi.id = "motion-view");
        let t = "";
        for(const e in fi){
            const n = fi[e];
            t += `${e} {\n`;
            for (const [e, s] of Object.entries(n))t += `  ${e}: ${s};\n`;
            t += "}\n";
        }
        mi.textContent = t, document.head.appendChild(mi), fi = {};
    }, vi = ()=>{
        mi && mi.parentElement && mi.parentElement.removeChild(mi);
    };
    function wi(t) {
        const e = t.match(/::view-transition-(old|new|group|image-pair)\((.*?)\)/);
        return e ? {
            layer: e[2],
            type: e[1]
        } : null;
    }
    function bi(t) {
        const { effect: e } = t;
        return !!e && e.target === document.documentElement && e.pseudoElement?.startsWith("::view-transition");
    }
    function Ti() {
        return document.getAnimations().filter(bi);
    }
    const xi = [
        "layout",
        "enter",
        "exit",
        "new",
        "old"
    ];
    function Vi(t) {
        const { update: e, targets: n, options: s } = t;
        if (!document.startViewTransition) return new Promise(async (t)=>{
            await e(), t(new En([]));
        });
        (function(t, e) {
            return e.has(t) && Object.keys(e.get(t)).length > 0;
        })("root", n) || gi(":root", {
            "view-transition-name": "none"
        }), gi("::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)", {
            "animation-timing-function": "linear !important"
        }), yi();
        const i = document.startViewTransition(async ()=>{
            await e();
        });
        return i.finished.finally(()=>{
            vi();
        }), new Promise((t)=>{
            i.ready.then(()=>{
                const e = Ti(), i = [];
                n.forEach((t, e)=>{
                    for (const n of xi){
                        if (!t[n]) continue;
                        const { keyframes: r, options: o } = t[n];
                        for (let [t, a] of Object.entries(r)){
                            if (!a) continue;
                            const r = {
                                ...In(s, t),
                                ...In(o, t)
                            }, l = pi(n);
                            if ("opacity" === t && !Array.isArray(a)) a = [
                                "new" === l ? 0 : 1,
                                a
                            ];
                            "function" == typeof r.delay && (r.delay = r.delay(0, 1)), r.duration && (r.duration = m(r.duration)), r.delay && (r.delay = m(r.delay));
                            const u = new vn({
                                ...r,
                                element: document.documentElement,
                                name: t,
                                pseudoElement: `::view-transition-${l}(${e})`,
                                keyframes: a
                            });
                            i.push(u);
                        }
                    }
                });
                for (const t of e){
                    if ("finished" === t.playState) continue;
                    const { effect: e } = t;
                    if (!(e && e instanceof KeyframeEffect)) continue;
                    const { pseudoElement: r } = e;
                    if (!r) continue;
                    const o = wi(r);
                    if (!o) continue;
                    const a = n.get(o.layer);
                    if (a) Mi(a, "enter") && Mi(a, "exit") && e.getKeyframes().some((t)=>t.mixBlendMode) ? i.push(new Cn(t)) : t.cancel();
                    else {
                        const n = "group" === o.type ? "layout" : "";
                        let r = {
                            ...In(s, n)
                        };
                        r.duration && (r.duration = m(r.duration)), r = yn(r);
                        const a = fn(r.ease, r.duration);
                        e.updateTiming({
                            delay: m(r.delay ?? 0),
                            duration: r.duration,
                            easing: a
                        }), i.push(new Cn(t));
                    }
                }
                t(new En(i));
            });
        });
    }
    function Mi(t, e) {
        return t?.[e]?.keyframes.opacity;
    }
    let Si = [], Ai = null;
    function ki() {
        Ai = null;
        const [t] = Si;
        var e;
        t && (n(Si, e = t), Ai = e, Vi(e).then((t)=>{
            e.notifyReady(t), t.finished.finally(ki);
        }));
    }
    function Ei() {
        for(let t = Si.length - 1; t >= 0; t--){
            const e = Si[t], { interrupt: n } = e.options;
            if ("immediate" === n) {
                const n = Si.slice(0, t + 1).map((t)=>t.update), s = Si.slice(t + 1);
                e.update = ()=>{
                    n.forEach((t)=>t());
                }, Si = [
                    e,
                    ...s
                ];
                break;
            }
        }
        Ai && "immediate" !== Si[0]?.options.interrupt || ki();
    }
    class Pi {
        constructor(t, e = {}){
            var n;
            this.currentSubject = "root", this.targets = new Map, this.notifyReady = c, this.readyPromise = new Promise((t)=>{
                this.notifyReady = t;
            }), this.update = t, this.options = {
                interrupt: "wait",
                ...e
            }, n = this, Si.push(n), Vs.render(Ei);
        }
        get(t) {
            return this.currentSubject = t, this;
        }
        layout(t, e) {
            return this.updateTarget("layout", t, e), this;
        }
        new(t, e) {
            return this.updateTarget("new", t, e), this;
        }
        old(t, e) {
            return this.updateTarget("old", t, e), this;
        }
        enter(t, e) {
            return this.updateTarget("enter", t, e), this;
        }
        exit(t, e) {
            return this.updateTarget("exit", t, e), this;
        }
        crossfade(t) {
            return this.updateTarget("enter", {
                opacity: 1
            }, t), this.updateTarget("exit", {
                opacity: 0
            }, t), this;
        }
        updateTarget(t, e, n = {}) {
            const { currentSubject: s, targets: i } = this;
            i.has(s) || i.set(s, {});
            i.get(s)[t] = {
                keyframes: e,
                options: n
            };
        }
        then(t, e) {
            return this.readyPromise.then(t, e);
        }
    }
    const Ci = $, Oi = j.reduce((t, e)=>(t[e] = (t)=>U(t), t), {});
    function Fi(t) {
        return "object" == typeof t && !Array.isArray(t);
    }
    function Ri(t, e, n, s) {
        return "string" == typeof t && Fi(e) ? rs(t, n, s) : t instanceof NodeList ? Array.from(t) : Array.isArray(t) ? t : [
            t
        ];
    }
    function Bi(t, e, n) {
        return t * (e + 1);
    }
    function Li(t, e, n, s) {
        return "number" == typeof e ? e : e.startsWith("-") || e.startsWith("+") ? Math.max(0, t + parseFloat(e)) : "<" === e ? n : e.startsWith("<") ? Math.max(0, n + parseFloat(e.slice(1))) : s.get(e) ?? t;
    }
    function Di(t, e, s, i, r, o) {
        !function(t, e, s) {
            for(let i = 0; i < t.length; i++){
                const r = t[i];
                r.at > e && r.at < s && (n(t, r), i--);
            }
        }(t, r, o);
        for(let n = 0; n < e.length; n++)t.push({
            value: e[n],
            at: Rt(r, o, i[n]),
            easing: L(s, n)
        });
    }
    function Ii(t, e) {
        for(let n = 0; n < t.length; n++)t[n] = t[n] / (e + 1);
    }
    function Wi(t, e) {
        return t.at === e.at ? null === t.value ? 1 : null === e.value ? -1 : 0 : t.at - e.at;
    }
    function ji(t, e) {
        return !e.has(t) && e.set(t, {}), e.get(t);
    }
    function Ni(t, e) {
        return e[t] || (e[t] = []), e[t];
    }
    function Ki(t) {
        return Array.isArray(t) ? t : [
            t
        ];
    }
    function $i(t, e) {
        return t && t[e] ? {
            ...t,
            ...t[e]
        } : {
            ...t
        };
    }
    const Ui = (t)=>"number" == typeof t, Yi = (t)=>t.every(Ui), zi = new WeakMap;
    function Xi(t) {
        const e = [
            {},
            {}
        ];
        return t?.values.forEach((t, n)=>{
            e[0][n] = t.get(), e[1][n] = t.getVelocity();
        }), e;
    }
    function Hi(t, e, n, s) {
        if ("function" == typeof e) {
            const [i, r] = Xi(s);
            e = e(void 0 !== n ? n : t.custom, i, r);
        }
        if ("string" == typeof e && (e = t.variants && t.variants[e]), "function" == typeof e) {
            const [i, r] = Xi(s);
            e = e(void 0 !== n ? n : t.custom, i, r);
        }
        return e;
    }
    function Gi(t, e, n) {
        t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, gs(n));
    }
    function Zi(t) {
        return ((t)=>Array.isArray(t))(t) ? t[t.length - 1] || 0 : t;
    }
    function qi(t, e) {
        const n = function(t, e, n) {
            const s = t.getProps();
            return Hi(s, e, void 0 !== n ? n : s.custom, t);
        }(t, e);
        let { transitionEnd: s = {}, transition: i = {}, ...r } = n || {};
        r = {
            ...r,
            ...s
        };
        for(const e in r)Gi(t, e, Zi(r[e]));
    }
    function _i(t, e) {
        const n = t.getValue("willChange");
        if (s = n, Boolean(ai(s) && s.add)) return n.add(e);
        if (!n && r.WillChange) {
            const n = new r.WillChange("auto");
            t.addValue("willChange", n), n.add(e);
        }
        var s;
    }
    const Ji = (t)=>t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), Qi = "data-" + Ji("framerAppearId");
    function tr(t) {
        return t.props[Qi];
    }
    const er = (t)=>null !== t;
    const nr = {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restSpeed: 10
    }, sr = {
        type: "keyframes",
        duration: .8
    }, ir = {
        type: "keyframes",
        ease: [
            .25,
            .1,
            .35,
            1
        ],
        duration: .3
    }, rr = (t, { keyframes: e })=>e.length > 2 ? sr : Xe.has(t) ? t.startsWith("scale") ? {
            type: "spring",
            stiffness: 550,
            damping: 0 === e[1] ? 2 * Math.sqrt(550) : 30,
            restSpeed: 10
        } : nr : ir;
    const or = (t, e, n, s = {}, i, o)=>(a)=>{
            const l = In(s, t) || {}, u = l.delay || s.delay || 0;
            let { elapsed: c = 0 } = s;
            c -= m(u);
            const h = {
                keyframes: Array.isArray(n) ? n : [
                    null,
                    n
                ],
                ease: "easeOut",
                velocity: e.getVelocity(),
                ...l,
                delay: -c,
                onUpdate: (t)=>{
                    e.set(t), l.onUpdate && l.onUpdate(t);
                },
                onComplete: ()=>{
                    a(), l.onComplete && l.onComplete();
                },
                name: t,
                motionValue: e,
                element: o ? void 0 : i
            };
            (function({ when: t, delay: e, delayChildren: n, staggerChildren: s, staggerDirection: i, repeat: r, repeatType: o, repeatDelay: a, from: l, elapsed: u, ...c }) {
                return !!Object.keys(c).length;
            })(l) || Object.assign(h, rr(t, h)), h.duration && (h.duration = m(h.duration)), h.repeatDelay && (h.repeatDelay = m(h.repeatDelay)), void 0 !== h.from && (h.keyframes[0] = h.from);
            let d = !1;
            if ((!1 === h.type || 0 === h.duration && !h.repeatDelay) && (Vn(h), 0 === h.delay && (d = !0)), (r.instantAnimations || r.skipAnimations) && (d = !0, Vn(h), h.delay = 0), h.allowFlatten = !l.type && !l.ease, d && !o && void 0 !== e.get()) {
                const t = function(t, { repeat: e, repeatType: n = "loop" }, s) {
                    const i = t.filter(er), r = e && "loop" !== n && e % 2 == 1 ? 0 : i.length - 1;
                    return r && void 0 !== s ? s : i[r];
                }(h.keyframes, l);
                if (void 0 !== t) return void $.update(()=>{
                    h.onUpdate(t), h.onComplete();
                });
            }
            return l.isSync ? new Fe(h) : new kn(h);
        };
    function ar({ protectedKeys: t, needsAnimating: e }, n) {
        const s = t.hasOwnProperty(n) && !0 !== e[n];
        return e[n] = !1, s;
    }
    function lr(t, e, { delay: n = 0, transitionOverride: s, type: i } = {}) {
        let { transition: r = t.getDefaultTransition(), transitionEnd: o, ...a } = e;
        s && (r = s);
        const l = [], u = i && t.animationState && t.animationState.getState()[i];
        for(const e in a){
            const s = t.getValue(e, t.latestValues[e] ?? null), i = a[e];
            if (void 0 === i || u && ar(u, e)) continue;
            const o = {
                delay: n,
                ...In(r || {}, e)
            }, c = s.get();
            if (void 0 !== c && !s.isAnimating && !Array.isArray(i) && i === c && !o.velocity) continue;
            let h = !1;
            if (window.MotionHandoffAnimation) {
                const n = tr(t);
                if (n) {
                    const t = window.MotionHandoffAnimation(n, e, $);
                    null !== t && (o.startTime = t, h = !0);
                }
            }
            _i(t, e), s.start(or(e, s, i, t.shouldReduceMotion && Wn.has(e) ? {
                type: !1
            } : o, t, h));
            const d = s.animation;
            d && l.push(d);
        }
        return o && Promise.all(l).then(()=>{
            $.update(()=>{
                o && qi(t, o);
            });
        }), l;
    }
    const ur = {
        animation: [
            "animate",
            "variants",
            "whileHover",
            "whileTap",
            "exit",
            "whileInView",
            "whileFocus",
            "whileDrag"
        ],
        exit: [
            "exit"
        ],
        drag: [
            "drag",
            "dragControls"
        ],
        focus: [
            "whileFocus"
        ],
        hover: [
            "whileHover",
            "onHoverStart",
            "onHoverEnd"
        ],
        tap: [
            "whileTap",
            "onTap",
            "onTapStart",
            "onTapCancel"
        ],
        pan: [
            "onPan",
            "onPanStart",
            "onPanSessionStart",
            "onPanEnd"
        ],
        inView: [
            "whileInView",
            "onViewportEnter",
            "onViewportLeave"
        ],
        layout: [
            "layout",
            "layoutId"
        ]
    }, cr = {};
    for(const t in ur)cr[t] = {
        isEnabled: (e)=>ur[t].some((t)=>!!e[t])
    };
    const hr = ()=>({
            x: {
                min: 0,
                max: 0
            },
            y: {
                min: 0,
                max: 0
            }
        }), dr = "undefined" != typeof window, pr = {
        current: null
    }, fr = {
        current: !1
    };
    const mr = [
        "initial",
        "animate",
        "whileInView",
        "whileFocus",
        "whileHover",
        "whileTap",
        "whileDrag",
        "exit"
    ];
    function gr(t) {
        var e;
        return null !== (e = t.animate) && "object" == typeof e && "function" == typeof e.start || mr.some((e)=>(function(t) {
                return "string" == typeof t || Array.isArray(t);
            })(t[e]));
    }
    const yr = [
        "AnimationStart",
        "AnimationComplete",
        "Update",
        "BeforeLayoutMeasure",
        "LayoutMeasure",
        "LayoutAnimationStart",
        "LayoutAnimationComplete"
    ];
    class vr {
        scrapeMotionValuesFromProps(t, e, n) {
            return {};
        }
        constructor({ parent: t, props: e, presenceContext: n, reducedMotionConfig: s, blockInitialAnimation: i, visualState: r }, o = {}){
            this.current = null, this.children = new Set, this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = new Map, this.KeyframeResolver = rn, this.features = {}, this.valueSubscriptions = new Map, this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = ()=>this.notify("Update", this.latestValues), this.render = ()=>{
                this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
            }, this.renderScheduledAt = 0, this.scheduleRender = ()=>{
                const t = G.now();
                this.renderScheduledAt < t && (this.renderScheduledAt = t, $.render(this.render, !1, !0));
            };
            const { latestValues: a, renderState: l } = r;
            this.latestValues = a, this.baseTarget = {
                ...a
            }, this.initialValues = e.initial ? {
                ...a
            } : {}, this.renderState = l, this.parent = t, this.props = e, this.presenceContext = n, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = s, this.options = o, this.blockInitialAnimation = Boolean(i), this.isControllingVariants = gr(e), this.isVariantNode = function(t) {
                return Boolean(gr(t) || t.variants);
            }(e), this.isVariantNode && (this.variantChildren = new Set), this.manuallyAnimateOnMount = Boolean(t && t.current);
            const { willChange: u, ...c } = this.scrapeMotionValuesFromProps(e, {}, this);
            for(const t in c){
                const e = c[t];
                void 0 !== a[t] && ai(e) && e.set(a[t]);
            }
        }
        mount(t) {
            this.current = t, zi.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((t, e)=>this.bindToMotionValue(e, t)), fr.current || function() {
                if (fr.current = !0, dr) {
                    if (window.matchMedia) {
                        const t = window.matchMedia("(prefers-reduced-motion)"), e = ()=>pr.current = t.matches;
                        t.addEventListener("change", e), e();
                    } else pr.current = !1;
                }
            }(), this.shouldReduceMotion = "never" !== this.reducedMotionConfig && ("always" === this.reducedMotionConfig || pr.current), this.parent?.addChild(this), this.update(this.props, this.presenceContext);
        }
        unmount() {
            this.projection && this.projection.unmount(), U(this.notifyUpdate), U(this.render), this.valueSubscriptions.forEach((t)=>t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
            for(const t in this.events)this.events[t].clear();
            for(const t in this.features){
                const e = this.features[t];
                e && (e.unmount(), e.isMounted = !1);
            }
            this.current = null;
        }
        addChild(t) {
            this.children.add(t), this.enteringChildren ?? (this.enteringChildren = new Set), this.enteringChildren.add(t);
        }
        removeChild(t) {
            this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
        }
        bindToMotionValue(t, e) {
            this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
            const n = Xe.has(t);
            n && this.onBindTransform && this.onBindTransform();
            const s = e.on("change", (e)=>{
                this.latestValues[t] = e, this.props.onUpdate && $.preRender(this.notifyUpdate), n && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
            });
            let i;
            window.MotionCheckAppearSync && (i = window.MotionCheckAppearSync(this, t, e)), this.valueSubscriptions.set(t, ()=>{
                s(), i && i(), e.owner && e.stop();
            });
        }
        sortNodePosition(t) {
            return this.current && this.sortInstanceNodePosition && this.type === t.type ? this.sortInstanceNodePosition(this.current, t.current) : 0;
        }
        updateFeatures() {
            let t = "animation";
            for(t in cr){
                const e = cr[t];
                if (!e) continue;
                const { isEnabled: n, Feature: s } = e;
                if (!this.features[t] && s && n(this.props) && (this.features[t] = new s(this)), this.features[t]) {
                    const e = this.features[t];
                    e.isMounted ? e.update() : (e.mount(), e.isMounted = !0);
                }
            }
        }
        triggerBuild() {
            this.build(this.renderState, this.latestValues, this.props);
        }
        measureViewportBox() {
            return this.current ? this.measureInstanceViewportBox(this.current, this.props) : {
                x: {
                    min: 0,
                    max: 0
                },
                y: {
                    min: 0,
                    max: 0
                }
            };
        }
        getStaticValue(t) {
            return this.latestValues[t];
        }
        setStaticValue(t, e) {
            this.latestValues[t] = e;
        }
        update(t, e) {
            (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = e;
            for(let e = 0; e < yr.length; e++){
                const n = yr[e];
                this.propEventSubscriptions[n] && (this.propEventSubscriptions[n](), delete this.propEventSubscriptions[n]);
                const s = t["on" + n];
                s && (this.propEventSubscriptions[n] = this.on(n, s));
            }
            this.prevMotionValues = function(t, e, n) {
                for(const s in e){
                    const i = e[s], r = n[s];
                    if (ai(i)) t.addValue(s, i);
                    else if (ai(r)) t.addValue(s, gs(i, {
                        owner: t
                    }));
                    else if (r !== i) {
                        if (t.hasValue(s)) {
                            const e = t.getValue(s);
                            !0 === e.liveStyle ? e.jump(i) : e.hasAnimated || e.set(i);
                        } else {
                            const e = t.getStaticValue(s);
                            t.addValue(s, gs(void 0 !== e ? e : i, {
                                owner: t
                            }));
                        }
                    }
                }
                for(const s in n)void 0 === e[s] && t.removeValue(s);
                return e;
            }(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
        }
        getProps() {
            return this.props;
        }
        getVariant(t) {
            return this.props.variants ? this.props.variants[t] : void 0;
        }
        getDefaultTransition() {
            return this.props.transition;
        }
        getTransformPagePoint() {
            return this.props.transformPagePoint;
        }
        getClosestVariantNode() {
            return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
        }
        addVariantChild(t) {
            const e = this.getClosestVariantNode();
            if (e) return e.variantChildren && e.variantChildren.add(t), ()=>e.variantChildren.delete(t);
        }
        addValue(t, e) {
            const n = this.values.get(t);
            e !== n && (n && this.removeValue(t), this.bindToMotionValue(t, e), this.values.set(t, e), this.latestValues[t] = e.get());
        }
        removeValue(t) {
            this.values.delete(t);
            const e = this.valueSubscriptions.get(t);
            e && (e(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
        }
        hasValue(t) {
            return this.values.has(t);
        }
        getValue(t, e) {
            if (this.props.values && this.props.values[t]) return this.props.values[t];
            let n = this.values.get(t);
            return void 0 === n && void 0 !== e && (n = gs(null === e ? void 0 : e, {
                owner: this
            }), this.addValue(t, n)), n;
        }
        readValue(t, e) {
            let n = void 0 === this.latestValues[t] && this.current ? this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options) : this.latestValues[t];
            return null != n && ("string" == typeof n && (o(n) || l(n)) ? n = parseFloat(n) : !di(n) && Pt.test(e) && (n = Jn(t, e)), this.setBaseTarget(t, ai(n) ? n.get() : n)), ai(n) ? n.get() : n;
        }
        setBaseTarget(t, e) {
            this.baseTarget[t] = e;
        }
        getBaseTarget(t) {
            const { initial: e } = this.props;
            let n;
            if ("string" == typeof e || "object" == typeof e) {
                const s = Hi(this.props, e, this.presenceContext?.custom);
                s && (n = s[t]);
            }
            if (e && void 0 !== n) return n;
            const s = this.getBaseTargetFromProps(this.props, t);
            return void 0 === s || ai(s) ? void 0 !== this.initialValues[t] && void 0 === n ? void 0 : this.baseTarget[t] : s;
        }
        on(t, e) {
            return this.events[t] || (this.events[t] = new f), this.events[t].add(e);
        }
        notify(t, ...e) {
            this.events[t] && this.events[t].notify(...e);
        }
        scheduleRenderMicrotask() {
            Vs.render(this.render);
        }
    }
    class wr extends vr {
        constructor(){
            super(...arguments), this.KeyframeResolver = ts;
        }
        sortInstanceNodePosition(t, e) {
            return 2 & t.compareDocumentPosition(e) ? 1 : -1;
        }
        getBaseTargetFromProps(t, e) {
            return t.style ? t.style[e] : void 0;
        }
        removeValueFromRenderState(t, { vars: e, style: n }) {
            delete e[t], delete n[t];
        }
        handleChildMotionValue() {
            this.childSubscription && (this.childSubscription(), delete this.childSubscription);
            const { children: t } = this.props;
            ai(t) && (this.childSubscription = t.on("change", (t)=>{
                this.current && (this.current.textContent = `${t}`);
            }));
        }
    }
    const br = {
        x: "translateX",
        y: "translateY",
        z: "translateZ",
        transformPerspective: "perspective"
    }, Tr = ze.length;
    function xr(t, e, n) {
        const { style: s, vars: i, transformOrigin: r } = t;
        let o = !1, a = !1;
        for(const t in e){
            const n = e[t];
            if (Xe.has(t)) o = !0;
            else if (_(t)) i[t] = n;
            else {
                const e = as(n, Zn[t]);
                t.startsWith("origin") ? (a = !0, r[t] = e) : s[t] = e;
            }
        }
        if (e.transform || (o || n ? s.transform = function(t, e, n) {
            let s = "", i = !0;
            for(let r = 0; r < Tr; r++){
                const o = ze[r], a = t[o];
                if (void 0 === a) continue;
                let l = !0;
                if (l = "number" == typeof a ? a === (o.startsWith("scale") ? 1 : 0) : 0 === parseFloat(a), !l || n) {
                    const t = as(a, Zn[o]);
                    l || (i = !1, s += `${br[o] || o}(${t}) `), n && (e[o] = t);
                }
            }
            return s = s.trim(), n ? s = n(e, i ? "" : s) : i && (s = "none"), s;
        }(e, t.transform, n) : s.transform && (s.transform = "none")), a) {
            const { originX: t = "50%", originY: e = "50%", originZ: n = 0 } = r;
            s.transformOrigin = `${t} ${e} ${n}`;
        }
    }
    function Vr(t, { style: e, vars: n }, s, i) {
        const r = t.style;
        let o;
        for(o in e)r[o] = e[o];
        for(o in i?.applyProjectionStyles(r, s), n)r.setProperty(o, n[o]);
    }
    const Mr = {};
    function Sr(t, { layout: e, layoutId: n }) {
        return Xe.has(t) || t.startsWith("origin") || (e || void 0 !== n) && (!!Mr[t] || "opacity" === t);
    }
    function Ar(t, e, n) {
        const { style: s } = t, i = {};
        for(const r in s)(ai(s[r]) || e.style && ai(e.style[r]) || Sr(r, t) || void 0 !== n?.getValue(r)?.liveStyle) && (i[r] = s[r]);
        return i;
    }
    class kr extends wr {
        constructor(){
            super(...arguments), this.type = "html", this.renderInstance = Vr;
        }
        readValueFromInstance(t, e) {
            if (Xe.has(e)) return this.projection?.isProjecting ? Ke(e) : Ue(t, e);
            {
                const s = (n = t, window.getComputedStyle(n)), i = (_(e) ? s.getPropertyValue(e) : s[e]) || 0;
                return "string" == typeof i ? i.trim() : i;
            }
            var n;
        }
        measureInstanceViewportBox(t, { transformPagePoint: e }) {
            return function(t, e) {
                return function({ top: t, left: e, right: n, bottom: s }) {
                    return {
                        x: {
                            min: e,
                            max: n
                        },
                        y: {
                            min: t,
                            max: s
                        }
                    };
                }(function(t, e) {
                    if (!e) return t;
                    const n = e({
                        x: t.left,
                        y: t.top
                    }), s = e({
                        x: t.right,
                        y: t.bottom
                    });
                    return {
                        top: n.y,
                        left: n.x,
                        bottom: s.y,
                        right: s.x
                    };
                }(t.getBoundingClientRect(), e));
            }(t, e);
        }
        build(t, e, n) {
            xr(t, e, n.transformTemplate);
        }
        scrapeMotionValuesFromProps(t, e, n) {
            return Ar(t, e, n);
        }
    }
    class Er extends vr {
        constructor(){
            super(...arguments), this.type = "object";
        }
        readValueFromInstance(t, e) {
            if (function(t, e) {
                return t in e;
            }(e, t)) {
                const n = t[e];
                if ("string" == typeof n || "number" == typeof n) return n;
            }
        }
        getBaseTargetFromProps() {}
        removeValueFromRenderState(t, e) {
            delete e.output[t];
        }
        measureInstanceViewportBox() {
            return {
                x: {
                    min: 0,
                    max: 0
                },
                y: {
                    min: 0,
                    max: 0
                }
            };
        }
        build(t, e) {
            Object.assign(t.output, e);
        }
        renderInstance(t, { output: e }) {
            Object.assign(t, e);
        }
        sortInstanceNodePosition() {
            return 0;
        }
    }
    const Pr = {
        offset: "stroke-dashoffset",
        array: "stroke-dasharray"
    }, Cr = {
        offset: "strokeDashoffset",
        array: "strokeDasharray"
    };
    function Or(t, { attrX: e, attrY: n, attrScale: s, pathLength: i, pathSpacing: r = 1, pathOffset: o = 0, ...a }, l, u, c) {
        if (xr(t, a, u), l) return void (t.style.viewBox && (t.attrs.viewBox = t.style.viewBox));
        t.attrs = t.style, t.style = {};
        const { attrs: h, style: d } = t;
        h.transform && (d.transform = h.transform, delete h.transform), (d.transform || h.transformOrigin) && (d.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), d.transform && (d.transformBox = c?.transformBox ?? "fill-box", delete h.transformBox), void 0 !== e && (h.x = e), void 0 !== n && (h.y = n), void 0 !== s && (h.scale = s), void 0 !== i && function(t, e, n = 1, s = 0, i = !0) {
            t.pathLength = 1;
            const r = i ? Pr : Cr;
            t[r.offset] = mt.transform(-s);
            const o = mt.transform(e), a = mt.transform(n);
            t[r.array] = `${o} ${a}`;
        }(h, i, r, o, !1);
    }
    const Fr = new Set([
        "baseFrequency",
        "diffuseConstant",
        "kernelMatrix",
        "kernelUnitLength",
        "keySplines",
        "keyTimes",
        "limitingConeAngle",
        "markerHeight",
        "markerWidth",
        "numOctaves",
        "targetX",
        "targetY",
        "surfaceScale",
        "specularConstant",
        "specularExponent",
        "stdDeviation",
        "tableValues",
        "viewBox",
        "gradientTransform",
        "pathLength",
        "startOffset",
        "textLength",
        "lengthAdjust"
    ]);
    class Rr extends wr {
        constructor(){
            super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = hr;
        }
        getBaseTargetFromProps(t, e) {
            return t[e];
        }
        readValueFromInstance(t, e) {
            if (Xe.has(e)) {
                const t = _n(e);
                return t && t.default || 0;
            }
            return e = Fr.has(e) ? e : Ji(e), t.getAttribute(e);
        }
        scrapeMotionValuesFromProps(t, e, n) {
            return function(t, e, n) {
                const s = Ar(t, e, n);
                for(const n in t)(ai(t[n]) || ai(e[n])) && (s[-1 !== ze.indexOf(n) ? "attr" + n.charAt(0).toUpperCase() + n.substring(1) : n] = t[n]);
                return s;
            }(t, e, n);
        }
        build(t, e, n) {
            Or(t, e, this.isSVGTag, n.transformTemplate, n.style);
        }
        renderInstance(t, e, n, s) {
            !function(t, e, n, s) {
                Vr(t, e, void 0, s);
                for(const n in e.attrs)t.setAttribute(Fr.has(n) ? n : Ji(n), e.attrs[n]);
            }(t, e, 0, s);
        }
        mount(t) {
            var e;
            this.isSVGTag = "string" == typeof (e = t.tagName) && "svg" === e.toLowerCase(), super.mount(t);
        }
    }
    function Br(t) {
        const e = {
            presenceContext: null,
            props: {},
            visualState: {
                renderState: {
                    transform: {},
                    transformOrigin: {},
                    style: {},
                    vars: {},
                    attrs: {}
                },
                latestValues: {}
            }
        }, n = Is(t) && !si(t) ? new Rr(e) : new kr(e);
        n.mount(t), zi.set(t, n);
    }
    function Lr(t) {
        const e = new Er({
            presenceContext: null,
            props: {},
            visualState: {
                renderState: {
                    output: {}
                },
                latestValues: {}
            }
        });
        e.mount(t), zi.set(t, e);
    }
    function Dr(t, e, n, s) {
        const i = [];
        if (function(t, e) {
            return ai(t) || "number" == typeof t || "string" == typeof t && !Fi(e);
        }(t, e)) i.push(function(t, e, n) {
            const s = ai(t) ? t : gs(t);
            return s.start(or("", s, e, n)), s.animation;
        }(t, Fi(e) && e.default || e, n && n.default || n));
        else {
            const r = Ri(t, e, s), o = r.length;
            for(let t = 0; t < o; t++){
                const s = r[t], a = s instanceof Element ? Br : Lr;
                zi.has(s) || a(s);
                const l = zi.get(s), u = {
                    ...n
                };
                "delay" in u && "function" == typeof u.delay && (u.delay = u.delay(t, o)), i.push(...lr(l, {
                    ...e,
                    transition: u
                }, {}));
            }
        }
        return i;
    }
    function Ir(t, e, n) {
        const s = [], i = function(t, { defaultTransition: e = {}, ...n } = {}, s, i) {
            const r = e.duration || .3, o = new Map, a = new Map, l = {}, u = new Map;
            let c = 0, h = 0, d = 0;
            for(let n = 0; n < t.length; n++){
                const o = t[n];
                if ("string" == typeof o) {
                    u.set(o, h);
                    continue;
                }
                if (!Array.isArray(o)) {
                    u.set(o.name, Li(h, o.at, c, u));
                    continue;
                }
                let [p, f, g = {}] = o;
                void 0 !== g.at && (h = Li(h, g.at, c, u));
                let y = 0;
                const v = (t, n, s, o = 0, a = 0)=>{
                    const l = Ki(t), { delay: u = 0, times: c = xe(l), type: p = "keyframes", repeat: f, repeatType: g, repeatDelay: v = 0, ...w } = n;
                    let { ease: b = e.ease || "easeOut", duration: T } = n;
                    const x = "function" == typeof u ? u(o, a) : u, V = l.length, M = gn(p) ? p : i?.[p || "keyframes"];
                    if (V <= 2 && M) {
                        let t = 100;
                        if (2 === V && Yi(l)) {
                            const e = l[1] - l[0];
                            t = Math.abs(e);
                        }
                        const e = {
                            ...w
                        };
                        void 0 !== T && (e.duration = m(T));
                        const n = qt(e, t, M);
                        b = n.ease, T = n.duration;
                    }
                    T ?? (T = r);
                    const S = h + x;
                    1 === c.length && 0 === c[0] && (c[1] = 1);
                    const A = c.length - l.length;
                    if (A > 0 && Te(c, A), 1 === l.length && l.unshift(null), f) {
                        T = Bi(T, f);
                        const t = [
                            ...l
                        ], e = [
                            ...c
                        ];
                        b = Array.isArray(b) ? [
                            ...b
                        ] : [
                            b
                        ];
                        const n = [
                            ...b
                        ];
                        for(let s = 0; s < f; s++){
                            l.push(...t);
                            for(let i = 0; i < t.length; i++)c.push(e[i] + (s + 1)), b.push(0 === i ? "linear" : L(n, i - 1));
                        }
                        Ii(c, f);
                    }
                    const k = S + T;
                    Di(s, l, b, c, S, k), y = Math.max(x + T, y), d = Math.max(k, d);
                };
                if (ai(p)) v(f, g, Ni("default", ji(p, a)));
                else {
                    const t = Ri(p, f, s, l), e = t.length;
                    for(let n = 0; n < e; n++){
                        const s = ji(t[n], a);
                        for(const t in f)v(f[t], $i(g, t), Ni(t, s), n, e);
                    }
                }
                c = h, h += y;
            }
            return a.forEach((t, s)=>{
                for(const i in t){
                    const r = t[i];
                    r.sort(Wi);
                    const a = [], l = [], u = [];
                    for(let t = 0; t < r.length; t++){
                        const { at: e, value: n, easing: s } = r[t];
                        a.push(n), l.push(p(0, d, e)), u.push(s || "easeOut");
                    }
                    0 !== l[0] && (l.unshift(0), a.unshift(a[0]), u.unshift("easeInOut")), 1 !== l[l.length - 1] && (l.push(1), a.push(null)), o.has(s) || o.set(s, {
                        keyframes: {},
                        transition: {}
                    });
                    const c = o.get(s);
                    c.keyframes[i] = a, c.transition[i] = {
                        ...e,
                        duration: d,
                        ease: u,
                        times: l,
                        ...n
                    };
                }
            }), o;
        }(t, e, n, {
            spring: ve
        });
        return i.forEach(({ keyframes: t, transition: e }, n)=>{
            s.push(...Dr(n, t, e));
        }), s;
    }
    function Wr(t) {
        return function(e, s, i) {
            let r = [];
            var o;
            o = e, r = Array.isArray(o) && o.some(Array.isArray) ? Ir(e, s, t) : Dr(e, s, i, t);
            const a = new Pn(r);
            return t && (t.animations.push(a), a.finished.then(()=>{
                n(t.animations, a);
            })), a;
        };
    }
    const jr = Wr();
    const Nr = (t)=>function(e, n, s) {
            return new Pn(function(t, e, n, s) {
                const i = rs(t, s), r = i.length, o = [];
                for(let t = 0; t < r; t++){
                    const s = i[t], a = {
                        ...n
                    };
                    "function" == typeof a.delay && (a.delay = a.delay(t, r));
                    for(const t in e){
                        let n = e[t];
                        Array.isArray(n) || (n = [
                            n
                        ]);
                        const i = {
                            ...In(a, t)
                        };
                        i.duration && (i.duration = m(i.duration)), i.delay && (i.delay = m(i.delay));
                        const r = Rn(s), l = Fn(t, i.pseudoElement || ""), u = r.get(l);
                        u && u.stop(), o.push({
                            map: r,
                            key: l,
                            unresolvedKeyframes: n,
                            options: {
                                ...i,
                                element: s,
                                name: t,
                                allowFlatten: !a.type && !a.ease
                            }
                        });
                    }
                }
                for(let t = 0; t < o.length; t++){
                    const { unresolvedKeyframes: e, options: n } = o[t], { element: s, name: i, pseudoElement: r } = n;
                    r || null !== e[0] || (e[0] = Ds(s, i)), Re(e), ns(e, i), !r && e.length < 2 && e.unshift(Ds(s, i)), n.keyframes = e;
                }
                const a = [];
                for(let t = 0; t < o.length; t++){
                    const { map: e, key: n, options: s } = o[t], i = new vn(s);
                    e.set(n, i), i.finished.finally(()=>e.delete(n)), a.push(i);
                }
                return a;
            }(e, n, s, t));
        }, Kr = Nr(), $r = {
        x: {
            length: "Width",
            position: "Left"
        },
        y: {
            length: "Height",
            position: "Top"
        }
    };
    function Ur(t, e, n, s) {
        const i = n[e], { length: r, position: o } = $r[e], a = i.current, l = n.time;
        i.current = t[`scroll${o}`], i.scrollLength = t[`scroll${r}`] - t[`client${r}`], i.offset.length = 0, i.offset[0] = 0, i.offset[1] = i.scrollLength, i.progress = p(0, i.scrollLength, i.current);
        const u = s - l;
        i.velocity = u > 50 ? 0 : y(i.current - a, u);
    }
    const Yr = {
        start: 0,
        center: .5,
        end: 1
    };
    function zr(t, e, n = 0) {
        let s = 0;
        if (t in Yr && (t = Yr[t]), "string" == typeof t) {
            const e = parseFloat(t);
            t.endsWith("px") ? s = e : t.endsWith("%") ? t = e / 100 : t.endsWith("vw") ? s = e / 100 * document.documentElement.clientWidth : t.endsWith("vh") ? s = e / 100 * document.documentElement.clientHeight : t = e;
        }
        return "number" == typeof t && (s = e * t), n + s;
    }
    const Xr = [
        0,
        0
    ];
    function Hr(t, e, n, s) {
        let i = Array.isArray(t) ? t : Xr, r = 0, o = 0;
        return "number" == typeof t ? i = [
            t,
            t
        ] : "string" == typeof t && (i = (t = t.trim()).includes(" ") ? t.split(" ") : [
            t,
            Yr[t] ? t : "0"
        ]), r = zr(i[0], n, s), o = zr(i[1], e), r - o;
    }
    const Gr = {
        Enter: [
            [
                0,
                1
            ],
            [
                1,
                1
            ]
        ],
        Exit: [
            [
                0,
                0
            ],
            [
                1,
                0
            ]
        ],
        Any: [
            [
                1,
                0
            ],
            [
                0,
                1
            ]
        ],
        All: [
            [
                0,
                0
            ],
            [
                1,
                1
            ]
        ]
    }, Zr = {
        x: 0,
        y: 0
    };
    function qr(t, e, n) {
        const { offset: i = Gr.All } = n, { target: r = t, axis: o = "y" } = n, a = "y" === o ? "height" : "width", l = r !== t ? function(t, e) {
            const n = {
                x: 0,
                y: 0
            };
            let s = t;
            for(; s && s !== e;)if (ps(s)) n.x += s.offsetLeft, n.y += s.offsetTop, s = s.offsetParent;
            else if ("svg" === s.tagName) {
                const t = s.getBoundingClientRect();
                s = s.parentElement;
                const e = s.getBoundingClientRect();
                n.x += t.left - e.left, n.y += t.top - e.top;
            } else {
                if (!(s instanceof SVGGraphicsElement)) break;
                {
                    const { x: t, y: e } = s.getBBox();
                    n.x += t, n.y += e;
                    let i = null, r = s.parentNode;
                    for(; !i;)"svg" === r.tagName && (i = r), r = s.parentNode;
                    s = i;
                }
            }
            return n;
        }(r, t) : Zr, u = r === t ? {
            width: t.scrollWidth,
            height: t.scrollHeight
        } : function(t) {
            return "getBBox" in t && "svg" !== t.tagName ? t.getBBox() : {
                width: t.clientWidth,
                height: t.clientHeight
            };
        }(r), c = {
            width: t.clientWidth,
            height: t.clientHeight
        };
        e[o].offset.length = 0;
        let h = !e[o].interpolate;
        const d = i.length;
        for(let t = 0; t < d; t++){
            const n = Hr(i[t], c[a], u[a], l[o]);
            h || n === e[o].interpolatorOffsets[t] || (h = !0), e[o].offset[t] = n;
        }
        h && (e[o].interpolate = be(e[o].offset, xe(i), {
            clamp: !1
        }), e[o].interpolatorOffsets = [
            ...e[o].offset
        ]), e[o].progress = s(0, 1, e[o].interpolate(e[o].current));
    }
    function _r(t, e, n, s = {}) {
        return {
            measure: (e)=>{
                !function(t, e = t, n) {
                    if (n.x.targetOffset = 0, n.y.targetOffset = 0, e !== t) {
                        let s = e;
                        for(; s && s !== t;)n.x.targetOffset += s.offsetLeft, n.y.targetOffset += s.offsetTop, s = s.offsetParent;
                    }
                    n.x.targetLength = e === t ? e.scrollWidth : e.clientWidth, n.y.targetLength = e === t ? e.scrollHeight : e.clientHeight, n.x.containerLength = t.clientWidth, n.y.containerLength = t.clientHeight;
                }(t, s.target, n), function(t, e, n) {
                    Ur(t, "x", e, n), Ur(t, "y", e, n), e.time = n;
                }(t, n, e), (s.offset || s.target) && qr(t, n, s);
            },
            notify: ()=>e(n)
        };
    }
    const Jr = new WeakMap, Qr = new WeakMap, to = new WeakMap, eo = (t)=>t === document.scrollingElement ? window : t;
    function no(t, { container: e = document.scrollingElement, ...n } = {}) {
        if (!e) return c;
        let s = to.get(e);
        s || (s = new Set, to.set(e, s));
        const i = _r(e, t, {
            time: 0,
            x: {
                current: 0,
                offset: [],
                progress: 0,
                scrollLength: 0,
                targetOffset: 0,
                targetLength: 0,
                containerLength: 0,
                velocity: 0
            },
            y: {
                current: 0,
                offset: [],
                progress: 0,
                scrollLength: 0,
                targetOffset: 0,
                targetLength: 0,
                containerLength: 0,
                velocity: 0
            }
        }, n);
        if (s.add(i), !Jr.has(e)) {
            const t = ()=>{
                for (const t of s)t.measure(Y.timestamp);
                $.preUpdate(n);
            }, n = ()=>{
                for (const t of s)t.notify();
            }, i = ()=>$.read(t);
            Jr.set(e, i);
            const r = eo(e);
            window.addEventListener("resize", i, {
                passive: !0
            }), e !== document.documentElement && Qr.set(e, Zs(e, i)), r.addEventListener("scroll", i, {
                passive: !0
            }), i();
        }
        const r = Jr.get(e);
        return $.read(r, !1, !0), ()=>{
            U(r);
            const t = to.get(e);
            if (!t) return;
            if (t.delete(i), t.size) return;
            const n = Jr.get(e);
            Jr.delete(e), n && (eo(e).removeEventListener("scroll", n), Qr.get(e)?.(), window.removeEventListener("resize", n));
        };
    }
    const so = new Map;
    function io({ source: t, container: e, ...n }) {
        const { axis: s } = n;
        t && (e = t);
        const i = so.get(e) ?? new Map;
        so.set(e, i);
        const r = n.target ?? "self", o = i.get(r) ?? {}, a = s + (n.offset ?? []).join(",");
        return o[a] || (o[a] = !n.target && ln() ? new ScrollTimeline({
            source: e,
            axis: s
        }) : function(t) {
            const e = {
                value: 0
            }, n = no((n)=>{
                e.value = 100 * n[t.axis].progress;
            }, t);
            return {
                currentTime: e,
                cancel: n
            };
        }({
            container: e,
            ...n
        })), o[a];
    }
    const ro = {
        some: 0,
        all: 1
    };
    const oo = (t, e)=>Math.abs(t - e);
    t.AsyncMotionValueAnimation = kn, t.DOMKeyframesResolver = ts, t.GroupAnimation = En, t.GroupAnimationWithThen = Pn, t.JSAnimation = Fe, t.KeyframeResolver = rn, t.MotionGlobalConfig = r, t.MotionValue = ms, t.NativeAnimation = vn, t.NativeAnimationExtended = Tn, t.NativeAnimationWrapper = Cn, t.SubscriptionManager = f, t.ViewTransitionBuilder = Pi, t.acceleratedValues = is, t.activeAnimations = Z, t.addAttrValue = cs, t.addStyleValue = ws, t.addUniqueItem = e, t.alpha = nt, t.analyseComplexValue = St, t.animate = jr, t.animateMini = Kr, t.animateValue = function(t) {
        return new Fe(t);
    }, t.animateView = function(t, e = {}) {
        return new Pi(t, e);
    }, t.animationMapKey = Fn, t.anticipate = k, t.applyGeneratorOptions = yn, t.applyPxDefaults = ns, t.attachSpring = li, t.attrEffect = hs, t.backIn = S, t.backInOut = A, t.backOut = M, t.calcGeneratorDuration = Zt, t.cancelFrame = U, t.cancelMicrotask = Ms, t.cancelSync = Oi, t.circIn = E, t.circInOut = C, t.circOut = P, t.clamp = s, t.collectMotionValues = fs, t.color = bt, t.complex = Pt, t.convertOffsetToTimes = Ve, t.createGeneratorEasing = qt, t.createRenderBatcher = K, t.createScopedAnimate = Wr, t.cubicBezier = T, t.cubicBezierAsString = dn, t.defaultEasing = Me, t.defaultOffset = xe, t.defaultTransformValue = Ke, t.defaultValueTypes = qn, t.degrees = pt, t.delay = function(t, e) {
        return function(t, e) {
            const n = G.now(), s = ({ timestamp: i })=>{
                const r = i - n;
                r >= e && (U(s), t(r - e));
            };
            return $.setup(s, !0), ()=>U(s);
        }(t, m(e));
    }, t.dimensionValueTypes = Nn, t.distance = oo, t.distance2D = function(t, e) {
        const n = oo(t.x, e.x), s = oo(t.y, e.y);
        return Math.sqrt(n ** 2 + s ** 2);
    }, t.easeIn = O, t.easeInOut = R, t.easeOut = F, t.easingDefinitionToFunction = W, t.fillOffset = Te, t.fillWildcards = Re, t.findDimensionValueType = Kn, t.findValueType = di, t.flushKeyframeResolvers = sn, t.frame = $, t.frameData = Y, t.frameSteps = z, t.generateLinearEasing = Ht, t.getAnimatableNone = Jn, t.getAnimationMap = Rn, t.getComputedStyle = Ds, t.getDefaultValueType = _n, t.getEasingForSegment = L, t.getMixer = Kt, t.getOriginIndex = ii, t.getValueAsType = as, t.getValueTransition = In, t.getVariableValue = Dn, t.getViewAnimationLayerInfo = wi, t.getViewAnimations = Ti, t.hasWarned = function(t) {
        return v.has(t);
    }, t.hex = ht, t.hover = function(t, e, n = {}) {
        const [s, i, r] = ks(t, n), o = (t)=>{
            if (!Es(t)) return;
            const { target: n } = t, s = e(n, t);
            if ("function" != typeof s || !n) return;
            const r = (t)=>{
                Es(t) && (s(t), n.removeEventListener("pointerleave", r));
            };
            n.addEventListener("pointerleave", r, i);
        };
        return s.forEach((t)=>{
            t.addEventListener("pointerenter", o, i);
        }), r;
    }, t.hsla = wt, t.hslaToRgba = Ot, t.inView = function(t, e, { root: n, margin: s, amount: i = "some" } = {}) {
        const r = rs(t), o = new WeakMap, a = new IntersectionObserver((t)=>{
            t.forEach((t)=>{
                const n = o.get(t.target);
                if (t.isIntersecting !== Boolean(n)) {
                    if (t.isIntersecting) {
                        const n = e(t.target, t);
                        "function" == typeof n ? o.set(t.target, n) : a.unobserve(t.target);
                    } else "function" == typeof n && (n(t), o.delete(t.target));
                }
            });
        }, {
            root: n,
            rootMargin: s,
            threshold: "number" == typeof i ? i : ro[i]
        });
        return r.forEach((t)=>a.observe(t)), ()=>a.disconnect();
    }, t.inertia = we, t.interpolate = be, t.invariant = i, t.invisibleValues = Wt, t.isBezierDefinition = D, t.isCSSVariableName = _, t.isCSSVariableToken = Q, t.isDragActive = As, t.isDragging = Ss, t.isEasingArray = B, t.isGenerator = gn, t.isHTMLElement = ps, t.isMotionValue = ai, t.isNodeOrChild = Ps, t.isNumericalString = o, t.isObject = a, t.isPrimaryPointer = Cs, t.isSVGElement = Is, t.isSVGSVGElement = si, t.isWaapiSupportedEasing = function t(e) {
        return Boolean("function" == typeof e && hn() || !e || "string" == typeof e && (e in pn || hn()) || D(e) || Array.isArray(e) && e.every(t));
    }, t.isZeroValueString = l, t.keyframes = Se, t.makeAnimationInstant = Vn, t.mapEasingToNativeEasing = fn, t.mapValue = function(t, e, n, s) {
        const i = ri(e, n, s);
        return oi(()=>i(t.get()));
    }, t.maxGeneratorDuration = Gt, t.memo = u, t.microtask = Vs, t.millisecondsToSeconds = g, t.mirrorEasing = x, t.mix = zt, t.mixArray = $t, t.mixColor = It, t.mixComplex = Yt, t.mixImmediate = Ft, t.mixLinearColor = Bt, t.mixNumber = Rt, t.mixObject = Ut, t.mixVisibility = jt, t.motionValue = gs, t.moveItem = function([...t], e, n) {
        const s = e < 0 ? t.length + e : e;
        if (s >= 0 && s < t.length) {
            const s = n < 0 ? t.length + n : n, [i] = t.splice(e, 1);
            t.splice(s, 0, i);
        }
        return t;
    }, t.noop = c, t.number = et, t.numberValueTypes = Zn, t.observeTimeline = qs, t.parseCSSVariable = Ln, t.parseValueFromTransform = $e, t.percent = ft, t.pipe = d, t.positionalKeys = Wn, t.press = function(t, e, n = {}) {
        const [s, i, r] = ks(t, n), o = (t)=>{
            const s = t.currentTarget;
            if (!Ls(t)) return;
            Fs.add(s);
            const r = e(s, t), o = (t, e)=>{
                window.removeEventListener("pointerup", a), window.removeEventListener("pointercancel", l), Fs.has(s) && Fs.delete(s), Ls(t) && "function" == typeof r && r(t, {
                    success: e
                });
            }, a = (t)=>{
                o(t, s === window || s === document || n.useGlobalTarget || Ps(s, t.target));
            }, l = (t)=>{
                o(t, !1);
            };
            window.addEventListener("pointerup", a, i), window.addEventListener("pointercancel", l, i);
        };
        return s.forEach((t)=>{
            var e;
            (n.useGlobalTarget ? window : t).addEventListener("pointerdown", o, i), ps(t) && (t.addEventListener("focus", (t)=>((t, e)=>{
                    const n = t.currentTarget;
                    if (!n) return;
                    const s = Rs(()=>{
                        if (Fs.has(n)) return;
                        Bs(n, "down");
                        const t = Rs(()=>{
                            Bs(n, "up");
                        });
                        n.addEventListener("keyup", t, e), n.addEventListener("blur", ()=>Bs(n, "cancel"), e);
                    });
                    n.addEventListener("keydown", s, e), n.addEventListener("blur", ()=>n.removeEventListener("keydown", s), e);
                })(t, i)), e = t, Os.has(e.tagName) || -1 !== e.tabIndex || t.hasAttribute("tabindex") || (t.tabIndex = 0));
        }), r;
    }, t.progress = p, t.progressPercentage = vt, t.propEffect = ds, t.px = mt, t.readTransformValue = Ue, t.recordStats = function() {
        if (N.value) throw ei(), new Error("Stats are already being measured");
        const t = N;
        return t.value = {
            frameloop: {
                setup: [],
                rate: [],
                read: [],
                resolveKeyframes: [],
                preUpdate: [],
                update: [],
                preRender: [],
                render: [],
                postRender: []
            },
            animations: {
                mainThread: [],
                waapi: [],
                layout: []
            },
            layoutProjection: {
                nodes: [],
                calculatedTargetDeltas: [],
                calculatedProjections: []
            }
        }, t.addProjectionMetrics = (e)=>{
            const { layoutProjection: n } = t.value;
            n.nodes.push(e.nodes), n.calculatedTargetDeltas.push(e.calculatedTargetDeltas), n.calculatedProjections.push(e.calculatedProjections);
        }, $.postRender(_s, !0), ni;
    }, t.removeItem = n, t.resize = Zs, t.resolveElements = rs, t.reverseEasing = V, t.rgbUnit = ut, t.rgba = ct, t.scale = st, t.scroll = function(t, { axis: e = "y", container: n = document.scrollingElement, ...s } = {}) {
        if (!n) return c;
        const i = {
            axis: e,
            container: n,
            ...s
        };
        return "function" == typeof t ? function(t, e) {
            return function(t) {
                return 2 === t.length;
            }(t) ? no((n)=>{
                t(n[e.axis].progress, n);
            }, e) : qs(t, io(e));
        }(t, i) : function(t, e) {
            const n = io(e);
            return t.attachTimeline({
                timeline: e.target ? void 0 : n,
                observe: (t)=>(t.pause(), qs((e)=>{
                        t.time = t.duration * e;
                    }, n))
            });
        }(t, i);
    }, t.scrollInfo = no, t.secondsToMilliseconds = m, t.setDragLock = function(t) {
        return "x" === t || "y" === t ? Ss[t] ? null : (Ss[t] = !0, ()=>{
            Ss[t] = !1;
        }) : Ss.x || Ss.y ? null : (Ss.x = Ss.y = !0, ()=>{
            Ss.x = Ss.y = !1;
        });
    }, t.setStyle = an, t.spring = ve, t.springValue = function(t, e) {
        const n = gs(ai(t) ? t.get() : t);
        return li(n, t, e), n;
    }, t.stagger = function(t = .1, { startDelay: e = 0, from: n = 0, ease: s } = {}) {
        return (i, r)=>{
            const o = "number" == typeof n ? n : ii(n, r), a = Math.abs(o - i);
            let l = t * a;
            if (s) {
                const e = r * t;
                l = W(s)(l / e) * e;
            }
            return e + l;
        };
    }, t.startWaapiAnimation = mn, t.statsBuffer = N, t.steps = function(t, e = "end") {
        return (n)=>{
            const i = (n = "end" === e ? Math.min(n, .999) : Math.max(n, .001)) * t, r = "end" === e ? Math.floor(i) : Math.ceil(i);
            return s(0, 1, r / t);
        };
    }, t.styleEffect = bs, t.supportedWaapiEasing = pn, t.supportsBrowserAnimation = An, t.supportsFlags = un, t.supportsLinearEasing = hn, t.supportsPartialKeyframes = ss, t.supportsScrollTimeline = ln, t.svgEffect = xs, t.sync = Ci, t.testValueType = jn, t.time = G, t.transform = ri, t.transformPropOrder = ze, t.transformProps = Xe, t.transformValue = oi, t.transformValueTypes = Gn, t.velocityPerSecond = y, t.vh = gt, t.vw = yt, t.warnOnce = function(t, e, n) {
        t || v.has(e) || (console.warn(function(t, e) {
            return e ? `${t}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : t;
        }(e, n)), v.add(e));
    }, t.warning = ()=>{}, t.wrap = w;
});


var $a9fcb71ecd6bca7e$exports = {};
!function(e, n) {
    n($a9fcb71ecd6bca7e$exports);
}($a9fcb71ecd6bca7e$exports, function(e) {
    function n(e) {
        return new Promise(function(n, r, t) {
            (t = new XMLHttpRequest()).open("GET", e, t.withCredentials = !0), t.onload = function() {
                200 === t.status ? n() : r();
            }, t.send();
        });
    }
    var r, t = (r = document.createElement("link")).relList && r.relList.supports && r.relList.supports("prefetch") ? function(e) {
        return new Promise(function(n, r, t) {
            (t = document.createElement("link")).rel = "prefetch", t.href = e, t.onload = n, t.onerror = r, document.head.appendChild(t);
        });
    } : n, o = window.requestIdleCallback || function(e) {
        var n = Date.now();
        return setTimeout(function() {
            e({
                didTimeout: !1,
                timeRemaining: function() {
                    return Math.max(0, 50 - (Date.now() - n));
                }
            });
        }, 1);
    }, i = new Set(), c = new Set(), u = !1;
    function a(e) {
        if (e) {
            if (e.saveData) return new Error("Save-Data is enabled");
            if (/2g/.test(e.effectiveType)) return new Error("network conditions are poor");
        }
        return !0;
    }
    function s(e, r, o) {
        var s = a(navigator.connection);
        return s instanceof Error ? Promise.reject(new Error("Cannot prefetch, " + s.message)) : (c.size > 0 && !u && console.warn("[Warning] You are using both prefetching and prerendering on the same document"), Promise.all([].concat(e).map(function(e) {
            if (!i.has(e)) return i.add(e), (r ? function(e) {
                return window.fetch ? fetch(e, {
                    credentials: "include"
                }) : n(e);
            } : t)(new URL(e, location.href).toString());
        })));
    }
    function f(e, n) {
        var r = a(navigator.connection);
        if (r instanceof Error) return Promise.reject(new Error("Cannot prerender, " + r.message));
        if (!HTMLScriptElement.supports("speculationrules")) return s(e), Promise.reject(new Error("This browser does not support the speculation rules API. Falling back to prefetch."));
        if (document.querySelector('script[type="speculationrules"]')) return Promise.reject(new Error("Speculation Rules is already defined and cannot be altered."));
        for(var t = 0, o = [].concat(e); t < o.length; t += 1){
            var f = o[t];
            if (window.location.origin !== new URL(f, window.location.href).origin) return Promise.reject(new Error("Only same origin URLs are allowed: " + f));
            c.add(f);
        }
        i.size > 0 && !u && console.warn("[Warning] You are using both prefetching and prerendering on the same document");
        var l = function(e) {
            var n = document.createElement("script");
            n.type = "speculationrules", n.text = '{"prerender":[{"source": "list","urls": ["' + Array.from(e).join('","') + '"]}]}';
            try {
                document.head.appendChild(n);
            } catch (e) {
                return e;
            }
            return !0;
        }(c);
        return !0 === l ? Promise.resolve() : Promise.reject(l);
    }
    e.listen = function(e) {
        if (e || (e = {}), window.IntersectionObserver) {
            var n = function(e) {
                e = e || 1;
                var n = [], r = 0;
                function t() {
                    r < e && n.length > 0 && (n.shift()(), r++);
                }
                return [
                    function(e) {
                        n.push(e) > 1 || t();
                    },
                    function() {
                        r--, t();
                    }
                ];
            }(e.throttle || 1 / 0), r = n[0], t = n[1], a = e.limit || 1 / 0, l = e.origins || [
                location.hostname
            ], d = e.ignores || [], h = e.delay || 0, p = [], m = e.timeoutFn || o, w = "function" == typeof e.hrefFn && e.hrefFn, g = e.prerender || !1;
            u = e.prerenderAndPrefetch || !1;
            var v = new IntersectionObserver(function(n) {
                n.forEach(function(n) {
                    if (n.isIntersecting) p.push((n = n.target).href), function(e, n) {
                        n ? setTimeout(e, n) : e();
                    }(function() {
                        -1 !== p.indexOf(n.href) && (v.unobserve(n), (u || g) && c.size < 1 ? f(w ? w(n) : n.href).catch(function(n) {
                            if (!e.onError) throw n;
                            e.onError(n);
                        }) : i.size < a && !g && r(function() {
                            s(w ? w(n) : n.href, e.priority).then(t).catch(function(n) {
                                t(), e.onError && e.onError(n);
                            });
                        }));
                    }, h);
                    else {
                        var o = p.indexOf((n = n.target).href);
                        o > -1 && p.splice(o);
                    }
                });
            }, {
                threshold: e.threshold || 0
            });
            return m(function() {
                (e.el || document).querySelectorAll("a").forEach(function(e) {
                    l.length && !l.includes(e.hostname) || function e(n, r) {
                        return Array.isArray(r) ? r.some(function(r) {
                            return e(n, r);
                        }) : (r.test || r).call(r, n.href, n);
                    }(e, d) || v.observe(e);
                });
            }, {
                timeout: e.timeout || 2e3
            }), function() {
                i.clear(), v.disconnect();
            };
        }
    }, e.prefetch = s, e.prerender = f;
});


(0, $741eecd46cc7b84e$export$25ce5a424b770e84).use([
    (0, $6c4c87b8e88c750e$export$2e2bcd8739ae039),
    (0, $fc47eaceb85ed9f7$export$2e2bcd8739ae039),
    (0, $3f8a9fc61494dd15$export$2e2bcd8739ae039),
    (0, $43e182233ae826c7$export$2e2bcd8739ae039),
    (0, $7b7283f9d1a7b89a$export$2e2bcd8739ae039),
    (0, $3170bcab9c0824c8$export$2e2bcd8739ae039)
]);
const $5beed8c089bcee16$var$easeOutExpo = (0, $4565420568d42cac$exports.cubicBezier)(0.35, 0.75, 0.5, 1);
const $5beed8c089bcee16$var$easeOutExpo2 = (0, $4565420568d42cac$exports.cubicBezier)(0.2, 0.95, 0.4, 1);
/* Helper functions */ function $5beed8c089bcee16$var$setItemWithExpiry(key, value, ttl) {
    const now = new Date();
    const item = {
        value: value,
        expiry: Math.round(now.getTime() / 1000) + ttl
    };
    localStorage.setItem(key, JSON.stringify(item));
}
function $5beed8c089bcee16$var$getItemWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    // Check if item exists before parsing
    if (!itemStr) return null;
    const item = JSON.parse(itemStr);
    const now = new Date();
    const nowInSeconds = Math.round(now.getTime() / 1000);
    // Check if expired
    if (nowInSeconds > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    // Return both the value and remaining minutes
    return {
        value: item.value,
        remainingMinutes: Math.round((item.expiry - nowInSeconds) / 60)
    };
}
// Resize listener setup with viewport change filtering
function $5beed8c089bcee16$var$setupResizeListener(callback, delay = 100) {
    let resizeTimeout;
    let prevWidth = window.innerWidth;
    let prevHeight = window.innerHeight;
    window.addEventListener("resize", ()=>{
        clearTimeout(resizeTimeout); // Debounce the resize event
        resizeTimeout = setTimeout(()=>{
            const currentWidth = window.innerWidth;
            const currentHeight = window.innerHeight;
            // Determine if resize is significant
            const isWidthChanged = currentWidth !== prevWidth;
            const isHeightSignificant = Math.abs(currentHeight - prevHeight) > 50;
            if (isWidthChanged || isHeightSignificant) {
                // Call the provided callback only on significant changes
                callback();
                // Update the stored dimensions
                prevWidth = currentWidth;
                prevHeight = currentHeight;
            }
        }, delay);
    });
}
// Check the reduced-motion preference and set localy
function $5beed8c089bcee16$var$reducedMotion() {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    localStorage.setItem("reduced-motion", reducedMotion);
}
// Manual toggle off animations
function $5beed8c089bcee16$var$toggleMotion() {
    const button = document.getElementById("toggle-reduced-motion");
    const manualReducedMotion = localStorage.getItem("manual-reduced-motion");
    button?.addEventListener("click", (event)=>{
        localStorage.setItem("manual-reduced-motion", newState);
    });
}
function $5beed8c089bcee16$var$toggleDarkmode() {
    const button = document.getElementById("toggle_theme");
    button?.addEventListener("click", ()=>{
        document.documentElement.classList.toggle("dark");
        if (localStorage.theme === "light") localStorage.theme = "dark";
        else if (localStorage.theme === "dark") localStorage.theme = "light";
        else localStorage.theme = "dark";
    });
}
function $5beed8c089bcee16$var$filterCase() {
    const filterContainer = document.querySelector("#filterContainer");
    if (!filterContainer) return;
    const filterButtons = document.querySelectorAll("button[data-filter]");
    const clearButton = filterButtons[0];
    const links = filterContainer?.querySelectorAll("article");
    let activeFilters = new Set();
    function filterLinks() {
        const activeFiltersArray = Array.from(activeFilters);
        links?.forEach((link)=>{
            const linkCategories = link.dataset.filter.split(",");
            let showLink = false;
            if (activeFilters.size === 0) showLink = true;
            else showLink = activeFiltersArray.every((filter)=>linkCategories.includes(filter));
            if (showLink) link.classList.remove("hidden");
            else link.classList.add("hidden");
        });
        updateURL();
    }
    function updateURL() {
        const urlParams = new URLSearchParams();
        if (activeFilters.size > 0) {
            const filterString = Array.from(activeFilters).join("&");
            urlParams.set("filter", filterString);
        }
        const currentHash = window.location.hash || "";
        const newURL = `${window.location.pathname}${urlParams.toString() ? "?" + urlParams.toString() : ""}${currentHash}`;
        window.history.replaceState(null, null, newURL);
    }
    function handleURLParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const filterParam = urlParams.get("filter");
        if (filterParam) // Split by "&" since that's how we store them
        filterParam.split("&").forEach((filter)=>{
            activeFilters.add(filter);
        });
    }
    // 1. Handle URL parameters *first*
    handleURLParams();
    // 2. Attach event listeners *after* handling URL parameters
    filterButtons?.forEach((button)=>{
        button.addEventListener("click", ()=>{
            const filter = button.dataset.filter;
            if (button === clearButton) {
                activeFilters.clear();
                filterButtons.forEach((btn)=>btn.classList.remove("active"));
                button.classList.add("active");
            } else {
                clearButton.classList.remove("active");
                if (activeFilters.has(filter)) {
                    activeFilters.delete(filter);
                    button.classList.remove("active");
                } else {
                    activeFilters.add(filter);
                    button.classList.add("active");
                }
            }
            if (activeFilters.size === 0) clearButton.classList.add("active");
            filterLinks();
        });
    });
    // 3. Perform initial filtering *after* attaching event listeners and setting activeFilters
    filterLinks();
    // 4. Set active button styles after the initial filter
    activeFilters.forEach((filter)=>{
        const button = document.querySelector(`[data-filter="${filter}"]`);
        if (button) {
            button.classList.add("active");
            clearButton.classList.remove("active");
        }
    });
}
function $5beed8c089bcee16$var$toggleTabsContent(buttonSelector, contentSelector, activeClass = "active") {
    const buttons = document.querySelectorAll(buttonSelector);
    const contents = document.querySelectorAll(contentSelector);
    buttons.forEach((button)=>{
        button.addEventListener("click", ()=>{
            const tabValue = button.getAttribute("data-tab");
            buttons.forEach((btn)=>btn.classList.remove(activeClass));
            contents.forEach((content)=>content.classList.add("hidden"));
            button.classList.add(activeClass);
            const targetContent = document.querySelector(`${contentSelector}[data-tab="${tabValue}"]`);
            if (targetContent) targetContent.classList.remove("hidden");
        });
    });
}
/* Needs update? */ function $5beed8c089bcee16$var$toggleOverlays(duration1) {
    const hamburgerButton = document.getElementById("hamburgerButton");
    const backdrop = document.getElementById("backdropOverlay");
    const menuTakeover = document.getElementById("menuTakeover");
    const menuBackdrop = document.getElementById("menuTakeoverBackdrop");
    const focusableElements = menuTakeover.querySelectorAll("a, button, input, [tabindex]");
    // Initialize focus state
    const setFocusable = (enabled)=>{
        focusableElements.forEach((el)=>{
            el.tabIndex = enabled ? 0 : -1;
        });
        if (enabled) {
            menuTakeover.removeAttribute("inert");
            menuTakeover.setAttribute("aria-hidden", "false");
        } else {
            menuTakeover.setAttribute("inert", "");
            menuTakeover.setAttribute("aria-hidden", "true");
        }
    };
    setFocusable(false); // Disable focus initially
    const motionOpenMenu = [
        [
            menuTakeover,
            {
                width: [
                    "0%",
                    "100%"
                ]
            },
            {
                ease: $5beed8c089bcee16$var$easeOutExpo2
            }
        ]
    ];
    const motionCloseMenu = [
        [
            menuTakeover,
            {
                width: [
                    "100%",
                    "0%"
                ]
            },
            {
                ease: $5beed8c089bcee16$var$easeOutExpo2
            }
        ]
    ];
    const bodyDark = ()=>(0, $4565420568d42cac$exports.animate)(menuBackdrop, {
            opacity: [
                "0%",
                "100%"
            ]
        }, {
            duration: duration1,
            ease: $5beed8c089bcee16$var$easeOutExpo2
        });
    const bodyLight = ()=>(0, $4565420568d42cac$exports.animate)(menuBackdrop, {
            opacity: [
                "100%",
                "0%"
            ]
        }, {
            duration: duration1,
            ease: $5beed8c089bcee16$var$easeOutExpo2
        });
    let isMenuOpen = false;
    const toggleMenu = ()=>{
        if (!isMenuOpen) {
            const openMenu = (0, $4565420568d42cac$exports.animate)(motionOpenMenu, {
                defaultTransition: {
                    duration: duration1,
                    ease: $5beed8c089bcee16$var$easeOutExpo2
                }
            });
            bodyDark();
            openMenu.then(()=>{
                setFocusable(true);
            });
        } else {
            const closeMenu = (0, $4565420568d42cac$exports.animate)(motionCloseMenu, {
                defaultTransition: {
                    duration: duration1,
                    ease: $5beed8c089bcee16$var$easeOutExpo2
                }
            });
            bodyLight();
            closeMenu.then(()=>{
                setFocusable(false);
                hamburgerButton.focus(); // Move focus back to the hamburger button
            });
        }
        isMenuOpen = !isMenuOpen;
    };
    hamburgerButton?.addEventListener("click", toggleMenu);
    backdrop?.addEventListener("click", toggleMenu);
}
/* Basic Page-Transition with bfcache Fix */ function $5beed8c089bcee16$var$pageFadeTransition(fadeInMs) {
    const loader = document.getElementById("loader");
    const navbar = document.querySelector("header");
    const firsVisit = $5beed8c089bcee16$var$getItemWithExpiry("first-visit");
    const logoElement = document.getElementById("logo-link");
    const loadingGif = document.getElementById("loading-gif");
    if (!loader) return;
    loader.style.transitionDuration = fadeInMs + "ms";
    // Handle initial page load and bfcache
    window.addEventListener("pageshow", (event)=>{
        if (!event.persisted && !firsVisit) {
            // DO Animation here
            setTimeout(()=>{
                console.log("Fancy loading animation done (2s)");
                hideLoader(fadeInMs);
            }, 25);
            $5beed8c089bcee16$var$setItemWithExpiry("first-visit", "value", 3600); // 1 hours
        } else if (!event.persisted) {
            hideLoader(fadeInMs);
            $5beed8c089bcee16$var$setItemWithExpiry("first-visit", "value", 3600); // 1 hours
        } else {
            console.warn("bfcache");
            setTimeout(()=>{
                hideLoader(fadeInMs);
            }, 25);
        }
    });
    // Transition out the page on link click
    document.querySelectorAll("a").forEach((link)=>{
        if (link.hostname === window.location.hostname && !link.hash && !link.hasAttribute("download")) link.addEventListener("click", function(event) {
            event.preventDefault();
            loader.style.visibility = "visible";
            loader.classList.add("visible");
            hideNavbar(navbar);
            setTimeout(()=>{
                window.location = this.href;
            }, fadeInMs); // Match this to the CSS transition duration
        });
    });
    function hideLoader(delay) {
        setTimeout(()=>{
            loader.classList.remove("visible");
            showNavbar(navbar);
            setTimeout(()=>{
                loader.style.visibility = "hidden";
            }, delay);
        }, 25);
    }
    function hideNavbar(element) {
        if (!element) {
            console.warn("navbar not found");
            return;
        }
        //LogoAnimation.playOut();
        element.style.transform = "none";
        (0, $4565420568d42cac$exports.animate)(element, {
            y: [
                0,
                -80
            ]
        }, {
            duration: 0.5,
            ease: $5beed8c089bcee16$var$easeOutExpo
        });
    }
    function showNavbar(element) {
        if (!element) {
            console.warn("navbar not found");
            return;
        }
        element.style.transform = "none";
        (0, $4565420568d42cac$exports.animate)(element, {
            y: [
                -80,
                0
            ]
        }, {
            duration: 0.5,
            ease: $5beed8c089bcee16$var$easeOutExpo
        });
        loadingGif.classList.add("hidden");
        if (!firsVisit) {
            logoElement.style.pointerEvents = "none";
            $5beed8c089bcee16$var$LogoAnimation.playIn();
            setTimeout(()=>{
                $5beed8c089bcee16$var$LogoAnimation.playOut();
                setTimeout(()=>{
                    logoElement.style.pointerEvents = "auto";
                }, 1000);
            }, 2500);
        }
    }
}
// Lazy load videos
function $5beed8c089bcee16$var$lazyLoadVideos() {
    const lazyVideoElements = document.querySelectorAll("video[data-desktop-src]:not(.hero-video-manual-load)");
    if (!lazyVideoElements.length) return;
    if (!("IntersectionObserver" in window)) return; // Early exit if no observer
    const lazyVideoObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return; // Skip if not intersecting
            const video = entry.target;
            $5beed8c089bcee16$var$handleResponsiveVideoSource(video);
            if (video.hasAttribute("pausable")) setTimeout(()=>$5beed8c089bcee16$var$setupVideoPauseButton(video), 50);
            lazyVideoObserver.unobserve(video); // Stop observing once loaded
        });
    }, {
        rootMargin: "0px 0px 200px 0px"
    });
    lazyVideoElements?.forEach((video)=>lazyVideoObserver.observe(video));
    window.addEventListener("resize", ()=>{
        lazyVideoElements.forEach($5beed8c089bcee16$var$handleResponsiveVideoSource);
    });
}
// Handle responsive video sources
function $5beed8c089bcee16$var$handleResponsiveVideoSource(video) {
    const videoSource = video.querySelector("source");
    const desktopSrc = video.getAttribute("data-desktop-src");
    const mobileSrc = video.getAttribute("data-mobile-src");
    const breakpoint = 768;
    const isMobile = window.innerWidth < breakpoint;
    const newSrc = isMobile && mobileSrc ? mobileSrc : desktopSrc;
    if (videoSource.dataset.src !== newSrc) {
        const wasPaused = sessionStorage.getItem(`videoPaused-${video.id}`) === "true";
        videoSource.dataset.src = newSrc;
        videoSource.src = newSrc;
        video.load();
        if (wasPaused) video.pause();
    }
}
// Set up video pause button functionality
function $5beed8c089bcee16$var$setupVideoPauseButton(video) {
    const button = video.closest(".video-wrapper")?.querySelector("button");
    if (!button) return;
    const playIcon = button.querySelector('img[alt="play video"]');
    const pauseIcon = button.querySelector('img[alt="pause video"]');
    const reducedMotion = localStorage.getItem("reduced-motion") == "true";
    let videoPaused = sessionStorage.getItem(`videoPaused-${video.id}`) == "true";
    // Initial pause for reduced-motion users
    if (reducedMotion) {
        video.currentTime = 1;
        video.pause();
        videoPaused = true;
    } else if (!videoPaused) video.play();
    // Sync UI state
    playIcon.classList.toggle("hidden", !videoPaused);
    pauseIcon.classList.toggle("hidden", videoPaused);
    button?.addEventListener("click", ()=>{
        if (videoPaused) {
            video.play();
            sessionStorage.setItem(`videoPaused-${video.id}`, "false");
        } else {
            video.pause();
            sessionStorage.setItem(`videoPaused-${video.id}`, "true");
        }
        videoPaused = !videoPaused;
        playIcon.classList.toggle("hidden", !videoPaused);
        pauseIcon.classList.toggle("hidden", videoPaused);
    });
    function setButtonWrapperHeight() {
        const buttonWrapper = button?.closest("div");
        const mediaWrapper = video.closest(".video-wrapper")?.querySelector("figure, .figure");
        //console.log(mediaWrapper.offsetHeight);
        const mediaHeight = mediaWrapper?.clientHeight;
        buttonWrapper.style.height = mediaHeight + "px";
    }
    $5beed8c089bcee16$var$setupResizeListener(setButtonWrapperHeight);
    setButtonWrapperHeight();
}
function $5beed8c089bcee16$var$lazyLoadVimeoEmbed() {
    const vimeoEmbeds = document.querySelectorAll("iframe.vimeoplayer");
    vimeoEmbeds?.forEach((iframe)=>{
        const src = iframe.dataset.src;
        (0, $4565420568d42cac$exports.inView)(iframe, ()=>{
            iframe.src = src;
        }, {
            margin: "50%"
        });
    });
}
// Details Accordion animation
function $5beed8c089bcee16$var$detailsAccordionAnimation() {
    document.querySelectorAll("details").forEach((detail)=>{
        const title = detail.querySelector("summary") ?? null;
        const content = detail.querySelector("[data-content]") ?? null;
        if (content) content.style.height = "0px";
        title?.addEventListener("click", (event)=>{
            event.preventDefault();
            if (!detail.open) {
                detail.open = true;
                const open = (0, $4565420568d42cac$exports.animate)(content, {
                    height: "auto"
                }, {
                    duration: 0.5,
                    ease: $5beed8c089bcee16$var$easeOutExpo
                });
                open.then(()=>{
                //console.log("details-opened"); // Reset animate(Scroll)??
                });
            } else {
                const close = (0, $4565420568d42cac$exports.animate)(content, {
                    height: 0
                }, {
                    duration: 0.3,
                    ease: $5beed8c089bcee16$var$easeOutExpo
                });
                close.then(()=>{
                    detail.open = false; //console.log("details-closed"); // Reset animate(Scroll)??
                });
            }
        });
    });
}
// Swiper Slides
function $5beed8c089bcee16$var$loadSlides() {
    const galleryAuto = new (0, $741eecd46cc7b84e$export$25ce5a424b770e84)(".gallery-auto", {
        modules: [
            (0, $6c4c87b8e88c750e$export$2e2bcd8739ae039),
            (0, $fc47eaceb85ed9f7$export$2e2bcd8739ae039),
            (0, $3f8a9fc61494dd15$export$2e2bcd8739ae039)
        ],
        loop: false,
        slidesPerView: "auto",
        spaceBetween: 24,
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        a11y: {
            enabled: true,
            prevSlideMessage: "Tidigare bild",
            nextSlideMessage: "N\xe4sta bild",
            firstSlideMessage: "F\xf6rsta bilden",
            lastSlideMessage: "Sista bilden"
        },
        navigation: {
            nextEl: ".swiper-btn-next",
            prevEl: ".swiper-btn-prev"
        }
    });
    const galleryFullWidth = new (0, $741eecd46cc7b84e$export$25ce5a424b770e84)(".gallery-full", {
        modules: [
            (0, $6c4c87b8e88c750e$export$2e2bcd8739ae039),
            (0, $fc47eaceb85ed9f7$export$2e2bcd8739ae039),
            (0, $3f8a9fc61494dd15$export$2e2bcd8739ae039),
            (0, $43e182233ae826c7$export$2e2bcd8739ae039)
        ],
        loop: true,
        slidesPerView: 1,
        speed: 1000,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        keyboard: {
            enabled: true
        },
        a11y: {
            enabled: true,
            prevSlideMessage: "Tidigare bild",
            nextSlideMessage: "N\xe4sta bild",
            firstSlideMessage: "F\xf6rsta bilden",
            lastSlideMessage: "Sista bilden"
        },
        navigation: {
            nextEl: ".swiper-btn-next",
            prevEl: ".swiper-btn-prev"
        }
    });
    const galleryFullMinimal = new (0, $741eecd46cc7b84e$export$25ce5a424b770e84)(".gallery-full-minimal", {
        modules: [
            (0, $43e182233ae826c7$export$2e2bcd8739ae039),
            (0, $7b7283f9d1a7b89a$export$2e2bcd8739ae039)
        ],
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: false
        },
        effect: "fade",
        fadeEffect: {
            crossFade: true
        }
    });
    const logoScroller = new (0, $741eecd46cc7b84e$export$25ce5a424b770e84)(".awards-marquee", {
        modules: [
            (0, $7b7283f9d1a7b89a$export$2e2bcd8739ae039),
            (0, $3170bcab9c0824c8$export$2e2bcd8739ae039)
        ],
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: true,
        freeMode: {
            enabled: true,
            momentum: false
        },
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        speed: 6000
    });
}
function $5beed8c089bcee16$var$customCursor() {
    const cursorWrapper = document.getElementById("dot-cursor"), dot = document.getElementById("dot"), dotText = document.getElementById("dot-text"), hoverTargetsText = document.querySelectorAll("[data-cursor-text]"), hoverTargetsInvert = document.querySelectorAll("[data-cursor-invert]");
    let mouseX = 0, mouseY = 0, rafActive = false, activeHoverTarget = null;
    document.addEventListener("mousemove", (e)=>{
        mouseX = e.pageX;
        mouseY = e.pageY - window.scrollY;
        if (!rafActive) {
            rafActive = true;
            requestAnimationFrame(updateCursor);
        }
    });
    function updateCursor() {
        cursorWrapper.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
        rafActive = false; // Allow next frame to be requested
    }
    hoverTargetsText?.forEach((target)=>{
        if (target.getAttribute("data-cursor-text") !== "") {
            target.addEventListener("mouseenter", ()=>{
                activeHoverTarget = target;
                const text = target.getAttribute("data-cursor-text"), span = document.createElement("span");
                span.innerHTML = text;
                dotText.innerHTML = "";
                dotText.appendChild(span);
                dotText.style.clipPath = "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)";
            });
            target.addEventListener("mouseleave", ()=>{
                activeHoverTarget = null;
                dotText.style.clipPath = "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)";
                dotText.addEventListener("transitionend", ()=>{
                    if (activeHoverTarget === null) dotText.innerHTML = "";
                }, {
                    once: true
                });
            });
        }
    });
    document.addEventListener("mouseover", (e)=>{
        const target = e.target.closest("[data-cursor-invert]");
        if (target) dot.classList.add("invert");
    });
    document.addEventListener("mouseout", (e)=>{
        const target = e.target.closest("[data-cursor-invert]");
        if (target) dot.classList.remove("invert");
    });
}
/* Move image within parent element */ /* function moveImage() {
	let section = document.querySelectorAll("[data-hoverList]");
	if (section.length === 0) return;

	const isMobile = () => window.innerWidth < 768;

	section.forEach((section) => {
		let listRows = section.querySelectorAll("[data-hoverList-row]"),
			mediaContainer = section.querySelector("[data-hover-media]"),
			media = mediaContainer.querySelectorAll("[data-counter]"),
			offset = mediaContainer.getBoundingClientRect().height / 2,
			targetX = 0,
			targetY = 0,
			currentX = 0,
			currentY = 0,
			rafActive = false;
		const ease = 0.2;
		let mouseMoveThrottle = false;
		let inViewCleanups = [];

		// Mobile: Position media container centrally
		function positionMediaForMobile() {
			if (isMobile()) {
				mediaContainer.style.transform = `translate(${0}px, ${0}px)`;
			}
		}

		// Desktop: Mouse tracking
		section.addEventListener("mousemove", (e) => {
			if (isMobile()) return;

			const rect = section.getBoundingClientRect();

			if (mouseMoveThrottle) return;
			mouseMoveThrottle = true;
			setTimeout(() => (mouseMoveThrottle = false), 1);

			targetX = e.clientX - rect.left;
			targetY = e.clientY - rect.top - offset;
			if (!rafActive) {
				rafActive = true;
				requestAnimationFrame(moveMediaContainer);
			}
		});

		function moveMediaContainer() {
			if (mediaContainer.length === 0) return;

			currentX += (targetX - currentX) * ease;
			currentY += (targetY - currentY) * ease;

			mediaContainer.style.transform = `translate(${currentX}px, ${currentY}px)`;
			if (
				Math.abs(targetX - currentX) > 0.1 ||
				Math.abs(targetY - currentY) > 0.1
			) {
				requestAnimationFrame(moveMediaContainer);
			} else {
				rafActive = false;
			}
		}

		listRows?.forEach((row) => {
			const counter = row.getAttribute("data-counter");

			const showMedia = () => {
				mediaContainer.classList.remove("opacity-0");

				media.forEach((element) => {
					if (element.getAttribute("data-counter") === counter) {
						element.classList.remove("opacity-0");
					} else {
						element.classList.add("opacity-0");
					}
				});
			};

			const hideMedia = () => {
				mediaContainer.classList.add("opacity-0");
			};

			// Desktop: Mouse events
			row.addEventListener("mouseenter", () => {
				if (!isMobile()) showMedia();
			});
			row.addEventListener("mouseleave", () => {
				if (!isMobile()) hideMedia();
			});

			// Keyboard
			row.addEventListener("focusin", showMedia);
			row.addEventListener("focusout", hideMedia);

			row.addEventListener("focus", () => {
				if (isMobile()) return;

				const rect = row.getBoundingClientRect();
				const sectionRect = section.getBoundingClientRect();

				const newX = rect.left - sectionRect.left + rect.width + 16;
				const newY =
					rect.top - sectionRect.top + rect.height / 2 - offset;

				targetX = newX;
				targetY = newY;

				if (!rafActive) {
					rafActive = true;
					requestAnimationFrame(moveMediaContainer);
				}
			});

			try {
				// Calculate the row height to create a centered trigger zone
				const rowHeight = row.getBoundingClientRect().height;
				const viewportHeight = window.innerHeight;
				const topMargin = viewportHeight / 2 - rowHeight / 2;
				const bottomMargin = topMargin;

				const cleanup = inView(
					row,
					(element, enterInfo) => {
						if (isMobile()) {
							row.classList.add("!opacity-100");
							showMedia();
							positionMediaForMobile();
						}

						// Return the leave callback
						return (leaveInfo) => {
							console.log("leaving element");
							if (isMobile()) {
								hideMedia();
								row.classList.remove("!opacity-100");
							}
						};
					},
					{
						margin: `-${topMargin}px 0px -${bottomMargin}px 0px`,
						amount: 0.5, // Triggers when any part of element is in the zone
					}
				);
				inViewCleanups.push(cleanup);
			} catch (error) {
				console.error("Error setting up inView:", error);
			}
		});

		// Handle resize
		let resizeTimeout;
		window.addEventListener("resize", () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				if (isMobile()) {
					positionMediaForMobile();
				}
			}, 100);
		});

		// Initial setup
		positionMediaForMobile();

		// Cleanup function (call this if you need to destroy the functionality)
		section._cleanup = () => {
			inViewCleanups.forEach((cleanup) => cleanup());
		};
	});
} */ function $5beed8c089bcee16$var$moveImage() {
    let section = document.querySelectorAll("[data-hoverList]");
    if (section.length === 0) return;
    const isMobile = ()=>window.innerWidth < 768;
    section.forEach((section)=>{
        let listRows = section.querySelectorAll("[data-hoverList-row]"), mediaContainer = section.querySelector("[data-hover-media]"), media = mediaContainer.querySelectorAll("[data-counter]"), offset = mediaContainer.getBoundingClientRect().height / 2, targetX = 0, targetY = 0, currentX = 0, currentY = 0, rafActive = false;
        const ease = 0.2;
        let mouseMoveThrottle = false;
        let scrollRAF = null;
        let currentActiveRow = null;
        // Mobile: Position media container centrally
        function positionMediaForMobile() {
            if (isMobile()) mediaContainer.style.transform = `translate(${0}px, ${0}px)`;
        }
        // Desktop: Mouse tracking
        section.addEventListener("mousemove", (e)=>{
            if (isMobile()) return;
            const rect = section.getBoundingClientRect();
            if (mouseMoveThrottle) return;
            mouseMoveThrottle = true;
            setTimeout(()=>mouseMoveThrottle = false, 1);
            targetX = e.clientX - rect.left;
            targetY = e.clientY - rect.top - offset;
            if (!rafActive) {
                rafActive = true;
                requestAnimationFrame(moveMediaContainer);
            }
        });
        function moveMediaContainer() {
            if (mediaContainer.length === 0) return;
            currentX += (targetX - currentX) * ease;
            currentY += (targetY - currentY) * ease;
            mediaContainer.style.transform = `translate(${currentX}px, ${currentY}px)`;
            if (Math.abs(targetX - currentX) > 0.1 || Math.abs(targetY - currentY) > 0.1) requestAnimationFrame(moveMediaContainer);
            else rafActive = false;
        }
        // Mobile: Check which row is at center of viewport
        function checkCenterLine() {
            if (!isMobile()) return;
            const viewportCenter = window.innerHeight - window.innerHeight / 4;
            let closestRow = null;
            let closestDistance = Infinity;
            listRows.forEach((row)=>{
                const rect = row.getBoundingClientRect();
                const rowCenter = rect.top + rect.height / 2;
                const distance = Math.abs(viewportCenter - rowCenter);
                // Check if row intersects with center line (within row height)
                if (distance < rect.height / 2) {
                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestRow = row;
                    }
                }
            });
            // Update active row
            if (closestRow !== currentActiveRow) {
                // Hide previous
                if (currentActiveRow) {
                    currentActiveRow.classList.remove("!opacity-100");
                    const prevLink = currentActiveRow.querySelector("a");
                    if (prevLink) prevLink.classList.remove("underline");
                }
                currentActiveRow = closestRow;
                if (currentActiveRow) {
                    // Show new
                    currentActiveRow.classList.add("!opacity-100");
                    const currentLink = currentActiveRow.querySelector("a");
                    if (currentLink) currentLink.classList.add("underline");
                    const counter = currentActiveRow.getAttribute("data-counter");
                    showMediaForCounter(counter);
                } else // No row at center, hide all
                hideAllMedia();
            }
        }
        function showMediaForCounter(counter) {
            mediaContainer.classList.remove("opacity-0");
            media.forEach((element)=>{
                if (element.getAttribute("data-counter") === counter) element.classList.remove("opacity-0");
                else element.classList.add("opacity-0");
            });
        }
        function hideAllMedia() {
            mediaContainer.classList.add("opacity-0");
        }
        // Mobile: Scroll listener with RAF
        function onScroll() {
            if (!isMobile()) return;
            if (scrollRAF) return;
            scrollRAF = requestAnimationFrame(()=>{
                checkCenterLine();
                scrollRAF = null;
            });
        }
        // Desktop: Row interactions
        listRows?.forEach((row)=>{
            const counter = row.getAttribute("data-counter");
            const showMedia = ()=>{
                showMediaForCounter(counter);
            };
            const hideMedia = ()=>{
                hideAllMedia();
            };
            // Desktop: Mouse events
            row.addEventListener("mouseenter", ()=>{
                if (!isMobile()) showMedia();
            });
            row.addEventListener("mouseleave", ()=>{
                if (!isMobile()) hideMedia();
            });
            // Keyboard
            row.addEventListener("focusin", showMedia);
            row.addEventListener("focusout", hideMedia);
            row.addEventListener("focus", ()=>{
                if (isMobile()) return;
                const rect = row.getBoundingClientRect();
                const sectionRect = section.getBoundingClientRect();
                const newX = rect.left - sectionRect.left + rect.width + 16;
                const newY = rect.top - sectionRect.top + rect.height / 2 - offset;
                targetX = newX;
                targetY = newY;
                if (!rafActive) {
                    rafActive = true;
                    requestAnimationFrame(moveMediaContainer);
                }
            });
        });
        // Mobile: Setup scroll listener
        if (isMobile()) {
            window.addEventListener("scroll", onScroll, {
                passive: true
            });
            // Initial check
            checkCenterLine();
        }
        // Handle resize
        let resizeTimeout;
        window.addEventListener("resize", ()=>{
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(()=>{
                const wasMobile = currentActiveRow !== null;
                if (isMobile()) {
                    positionMediaForMobile();
                    if (!wasMobile) window.addEventListener("scroll", onScroll, {
                        passive: true
                    });
                    checkCenterLine();
                } else if (wasMobile) {
                    window.removeEventListener("scroll", onScroll);
                    currentActiveRow = null;
                    hideAllMedia();
                }
            }, 100);
        });
        // Initial setup
        positionMediaForMobile();
        // Cleanup function
        section._cleanup = ()=>{
            window.removeEventListener("scroll", onScroll);
            if (scrollRAF) cancelAnimationFrame(scrollRAF);
        };
    });
}
function $5beed8c089bcee16$var$setupScrollAnimations() {
    function handleFadeElements() {
        const fadeElements = document.querySelectorAll('[data-animation="fade"]');
        if (fadeElements.length === 0) return;
        fadeElements.forEach((element)=>{
            element.style.opacity = "0";
            (0, $4565420568d42cac$exports.inView)(element, ()=>{
                (0, $4565420568d42cac$exports.animate)(element, {
                    opacity: [
                        0,
                        1
                    ]
                }, {
                    duration: 1,
                    ease: $5beed8c089bcee16$var$easeOutExpo
                });
            }, {
                margin: "-10%"
            });
        });
    }
    function handleBlobElements() {
        const textBlobs = document.querySelectorAll('[data-animation="blob"]');
        if (textBlobs.length === 0) return;
        textBlobs.forEach((element)=>{
            (0, $4565420568d42cac$exports.inView)(element, ()=>{
                (0, $4565420568d42cac$exports.animate)(element, {
                    scale: [
                        0,
                        1
                    ]
                }, {
                    duration: 0.6,
                    ease: $5beed8c089bcee16$var$easeOutExpo
                });
            });
        });
    }
    function handleFooterLogo() {
        const footerLogo = document.querySelector("footer");
        const svgParts = footerLogo.querySelectorAll(".svgmilk");
        (0, $4565420568d42cac$exports.inView)(footerLogo, ()=>{
            const footerAnimation = (0, $4565420568d42cac$exports.animate)(svgParts, {
                y: [
                    400,
                    0
                ],
                opacity: [
                    0,
                    1
                ]
            }, {
                duration: 1,
                ease: $5beed8c089bcee16$var$easeOutExpo2,
                delay: (0, $4565420568d42cac$exports.stagger)(0.1, {
                    startDelay: 0.4
                })
            });
            return (leaveInfo)=>footerAnimation.stop();
        }, {
            margin: "-5%"
        });
    }
    function handleBottomsUpAnimation() {
        const element = document.querySelectorAll('[data-animation="bottomsup"]');
        if (element.length === 0) return;
        element.forEach((element)=>{
            element.style.transformOrigin = "bottom center";
            element.style.display = "inline-block";
        });
        element.forEach((element)=>{
            (0, $4565420568d42cac$exports.inView)(element, ()=>{
                (0, $4565420568d42cac$exports.animate)(element, {
                    scaleY: [
                        1,
                        -1
                    ],
                    y: [
                        0,
                        "-50%"
                    ]
                }, {
                    duration: 1,
                    ease: $5beed8c089bcee16$var$easeOutExpo
                });
            }, {
                margin: "0px 0px -50% 0px"
            });
        });
    }
    handleFadeElements();
    handleBlobElements();
    handleFooterLogo();
    handleBottomsUpAnimation();
}
function $5beed8c089bcee16$var$cowGoesMoo() {
    const dot = document.getElementById("milk-i-dot");
    const sounds = [
        "/_private/wp-content/themes/fresh_milk-v1.0.1/assets/sound/cow-mooing-type-01.mp3",
        "/_private/wp-content/themes/fresh_milk-v1.0.1/assets/sound/cow-mooing-type-02.mp3",
        "/_private/wp-content/themes/fresh_milk-v1.0.1/assets/sound/cow-mooing-type-03.mp3",
        "/_private/wp-content/themes/fresh_milk-v1.0.1/assets/sound/cow-mooing-type-04.mp3",
        "/_private/wp-content/themes/fresh_milk-v1.0.1/assets/sound/cow-mooing-type-01.mp3",
        "/_private/wp-content/themes/fresh_milk-v1.0.1/assets/sound/cow-mooing-type-02.mp3",
        "/_private/wp-content/themes/fresh_milk-v1.0.1/assets/sound/cow-mooing-type-03.mp3",
        "/_private/wp-content/themes/fresh_milk-v1.0.1/assets/sound/cow-mooing-type-04.mp3",
        "/_private/wp-content/themes/fresh_milk-v1.0.1/assets/sound/cat-mooing-type-01.mp3"
    ];
    function getRandomSound() {
        const index = Math.floor(Math.random() * sounds.length);
        return window.location.origin + sounds[index];
    }
    dot.addEventListener("click", ()=>{
        $5beed8c089bcee16$var$playSound(getRandomSound(), {
            pitch: 1,
            speed: 1,
            lowpassFrequency: null,
            highpassFrequency: null
        });
    });
}
function $5beed8c089bcee16$var$playSound(soundFilePath, options = {
    pitch: 1,
    speed: 1,
    lowpassFrequency: null,
    highpassFrequency: null
}) {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const audioElement = new Audio(soundFilePath);
    const source = audioContext.createMediaElementSource(audioElement);
    if (audioElement == null || undefined) {
        console.warn("soundfile-not-found");
        return;
    }
    // Apply pitch/speed (playbackRate)
    audioElement.playbackRate = options.speed * options.pitch;
    // Apply filters
    let lastNode = source;
    if (options.lowpassFrequency !== null) {
        const lowpassFilter = audioContext.createBiquadFilter();
        lowpassFilter.type = "lowpass";
        lowpassFilter.frequency.setValueAtTime(mergedOptions.lowpassFrequency, audioContext.currentTime);
        lastNode.connect(lowpassFilter);
        lastNode = lowpassFilter;
    }
    if (options.highpassFrequency !== null) {
        const highpassFilter = audioContext.createBiquadFilter();
        highpassFilter.type = "highpass";
        highpassFilter.frequency.setValueAtTime(mergedOptions.highpassFrequency, audioContext.currentTime);
        lastNode.connect(highpassFilter);
        lastNode = highpassFilter;
    }
    // Connect the final node to the destination (speakers)
    lastNode.connect(audioContext.destination);
    // Play the audio
    audioElement.play();
    // Return the audio element, context, and source for potential later manipulation
    return {
        audioElement: audioElement,
        audioContext: audioContext,
        source: source
    };
}
function $5beed8c089bcee16$var$newsletterModal(YTimeIn, FadeTimeIn, YTimeOut, FadeTimeOut) {
    const toggles = document.querySelectorAll('a[href="#nyhetsbrev"]');
    const closeModalButton = document.querySelector("#closeNewsletterModal");
    const modal = document.getElementById("newsletterModal");
    const backdrop = document.getElementById("newsletterModalBackdrop"); // Get the backdrop element
    let lastFocusedElement = null; // Variable to store the element that opened the modal
    // Function to open the modal
    function openModal() {
        if (!modal) return; // Exit if modal element is not found
        // Store the element that currently has focus (the button that was clicked)
        lastFocusedElement = document.activeElement;
        modal.style.display = "block"; // Show the modal
        modal.setAttribute("aria-hidden", "false");
        modal.setAttribute("tabindex", "-1"); // Make modal focusable for initial focus
        (0, $4565420568d42cac$exports.animate)(modal, {
            y: [
                "100%",
                0
            ]
        }, {
            duration: YTimeIn,
            ease: $5beed8c089bcee16$var$easeOutExpo2
        });
        // Show the backdrop
        if (backdrop) {
            backdrop.style.display = "block";
            backdrop.setAttribute("aria-hidden", "false"); // Set to false when visible, or keep true if purely visual
            (0, $4565420568d42cac$exports.animate)(backdrop, {
                opacity: [
                    0,
                    1
                ]
            }, {
                duration: FadeTimeIn,
                ease: $5beed8c089bcee16$var$easeOutExpo2
            });
        }
        // Focus the first interactive element inside the modal, typically the close button
        const firstFocusableElement = modal.querySelector(".modal-close-button, input, button, a[href]");
        if (firstFocusableElement) firstFocusableElement.focus();
        else modal.focus(); // Fallback: focus the modal container itself
    // Optional: Hide main page content from screen readers if not relying solely on aria-modal="true"
    // const mainContent = document.querySelector('main');
    // if (mainContent) {
    //     mainContent.setAttribute('aria-hidden', 'true');
    // }
    }
    // Function to close the modal
    function closeModal() {
        if (!modal) return; // Exit if modal element is not found
        // 1. Return focus to the element that opened the modal BEFORE hiding it
        if (lastFocusedElement) {
            lastFocusedElement.focus();
            lastFocusedElement = null; // Clear the stored element
        } else // Fallback: If no previous focus, send focus to body (less ideal but prevents focus loss)
        document.body.focus();
        // 2. Hide the modal
        (0, $4565420568d42cac$exports.animate)(modal, {
            y: [
                0,
                "100%"
            ]
        }, {
            duration: YTimeOut,
            ease: $5beed8c089bcee16$var$easeOutExpo2
        }).then(()=>{
            modal.style.display = "none";
            modal.setAttribute("aria-hidden", "true"); // Update aria-hidden after hiding
        });
        // 3. Hide the backdrop
        if (backdrop) (0, $4565420568d42cac$exports.animate)(backdrop, {
            opacity: [
                1,
                0
            ]
        }, {
            duration: FadeTimeOut,
            ease: $5beed8c089bcee16$var$easeOutExpo2
        }).then(()=>{
            backdrop.style.display = "none";
            backdrop.setAttribute("aria-hidden", "true");
        });
    // Optional: Unhide main page content from screen readers
    // const mainContent = document.querySelector('main');
    // if (mainContent) {
    //     mainContent.setAttribute('aria-hidden', 'false');
    // }
    }
    // Event listener for all buttons that open the modal
    toggles.forEach((button)=>{
        button.addEventListener("click", function(event) {
            event.preventDefault(); // Stop default anchor behavior
            openModal();
        });
    });
    // Event listener for the close button inside the modal
    if (!closeModalButton) return;
    else closeModalButton.addEventListener("click", closeModal);
    // Event listener for clicking outside the modal (on the backdrop)
    // IMPORTANT: Ensure your backdrop covers the whole screen and is behind the modal.
    // If you click on the modal content itself, this should NOT trigger a close.
    if (backdrop) // Only add listener if backdrop exists
    backdrop.addEventListener("click", function(event) {
        // Check if the click was directly on the backdrop itself, not on the modal content
        if (event.target === backdrop) closeModal();
    });
    // Event listener for Escape key press
    document.addEventListener("keydown", function(event) {
        // Check if the modal is currently open and the escape key was pressed
        if (event.key === "Escape" && modal.style.display === "block") {
            event.preventDefault(); // Prevent default browser behavior (like scrolling)
            closeModal();
        }
    });
}
function $5beed8c089bcee16$var$analyticsInit(fadeInMs) {
    const consentKey = "cookieConsent";
    const acceptTTL = 15552000; // 180 days
    const declineTTL = 2592000; // 30 days
    let lastFocusedElement = null;
    let open = false;
    // Check existing consent
    const consent = $5beed8c089bcee16$var$getItemWithExpiry(consentKey)?.value;
    if (consent === "accepted") loadGA();
    else if (!consent) showBanner();
    else console.warn("Cookie read failed");
    function showBanner() {
        lastFocusedElement = document.activeElement;
        open = !open;
        const banner = document.createElement("div");
        banner.innerHTML = `
        <div class="fixed right-0 bottom-8 z-40 max-w-full text-text p-6 rounded-sm bg-yellow text-black" data-cursor-invert style="transform: translateY(0%);">
            <p>Milk comes with cookies. Read more about our <a href="<?= site_url();?>">Privacy Policy</a>.</p>
            <div class="flex gap-4">
                <button id="cookie-accept" class="underline hover:no-underline">That's cool</button>
                <button id="cookie-decline" class="underline hover:no-underline">No thanks</button>
            </div>
        </div>`;
        document.body.prepend(banner);
        const acceptButton = document.getElementById("cookie-accept");
        const declineButton = document.getElementById("cookie-decline");
        acceptButton.onclick = function() {
            $5beed8c089bcee16$var$setItemWithExpiry(consentKey, "accepted", acceptTTL);
            loadGA();
            (0, $4565420568d42cac$exports.animate)(banner.querySelector(".fixed"), {
                y: [
                    0,
                    "125%"
                ]
            }, {
                duration: fadeInMs / 1000,
                ease: $5beed8c089bcee16$var$easeOutExpo2
            });
            setTimeout(()=>{
                banner.remove();
                open = !open;
            }, fadeInMs);
        };
        declineButton.onclick = function() {
            $5beed8c089bcee16$var$setItemWithExpiry(consentKey, "declined", declineTTL);
            (0, $4565420568d42cac$exports.animate)(banner.querySelector(".fixed"), {
                y: [
                    0,
                    "125%"
                ]
            }, {
                duration: fadeInMs / 1000,
                ease: $5beed8c089bcee16$var$easeOutExpo2
            });
            setTimeout(()=>{
                banner.remove();
                open = !open;
            }, fadeInMs);
        };
    }
    function loadGA() {
        if (window.gtag) {
            console.log("GA already initialized");
            return;
        } // prevent double init
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag("js", new Date());
        gtag("config", "G-QLCNM0GEZ8", {
            anonymize_ip: true
        });
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://www.googletagmanager.com/gtag/js?id=G-QLCNM0GEZ8";
        document.head.appendChild(script);
    }
    const toggleButton = document.querySelectorAll("button[data-cookie]");
    toggleButton.forEach((button)=>{
        button.addEventListener("click", ()=>{
            if (open === false) {
                lastFocusedElement?.focus();
                showBanner();
            }
        });
    });
}
function $5beed8c089bcee16$var$milkShake() {
    // Early exit if DeviceMotionEvent not supported (desktop)
    if (typeof window.DeviceMotionEvent === "undefined" || window.innerWidth > 768) {
        console.log("DeviceMotionEvent not supported - skipping milkshake");
        return;
    }
    function startMotion() {
        console.log("milkshake motion started");
        window.addEventListener("devicemotion", (event)=>{
            const acc = event.accelerationIncludingGravity;
            if (!acc) return;
            const x = acc.x || 0;
            const y = acc.y || 0;
            const z = acc.z || 0;
            const total = Math.abs(x) + Math.abs(y) + Math.abs(z);
            // Log motion values to console
            console.log(`Motion - x: ${x.toFixed(2)}, y: ${y.toFixed(2)}, z: ${z.toFixed(2)}, total: ${total.toFixed(2)}`);
            if (total > 30) alert("Milkshake!!");
        });
    }
    // iOS 13+ with permission API
    if (typeof DeviceMotionEvent.requestPermission === "function") // Check current permission state
    navigator.permissions.query({
        name: "accelerometer"
    }).then((result)=>{
        console.log("permission state:", result.state);
        if (result.state === "granted") // Already granted, start immediately
        startMotion();
        else // Need to request permission, create overlay
        createOverlayForPermission();
    }).catch(()=>{
        // Fallback: if query fails, just create overlay
        console.log("permission query failed, creating overlay");
        createOverlayForPermission();
    });
    else // Android / older iOS - no permission needed
    startMotion();
    function createOverlayForPermission() {
        const overlay = document.createElement("div");
        overlay.style.position = "fixed";
        overlay.style.top = "0";
        overlay.style.left = "0";
        overlay.style.width = "100%";
        overlay.style.height = "100%";
        overlay.style.background = "transparent";
        overlay.style.zIndex = "100000";
        overlay.style.cursor = "pointer";
        document.body.appendChild(overlay);
        overlay.addEventListener("click", ()=>{
            console.log("overlay clicked - requesting motion permission");
            DeviceMotionEvent.requestPermission().then((response)=>{
                console.log("permission response:", response);
                if (response === "granted") startMotion();
                else console.warn("Permission denied");
                overlay.remove();
            }).catch((error)=>{
                console.error("permission error:", error);
                overlay.remove();
            });
        });
    }
}
function $5beed8c089bcee16$var$milkShakeDebug() {
    console.log("milkshake debug init");
    // --- Create debug box ---
    const box = document.createElement("div");
    box.id = "motion-debug-box";
    box.style.position = "fixed";
    box.style.bottom = "10px";
    box.style.right = "10px";
    box.style.background = "rgba(0,0,0,0.7)";
    box.style.color = "white";
    box.style.padding = "10px 14px";
    box.style.fontSize = "14px";
    box.style.borderRadius = "8px";
    box.style.zIndex = "99999";
    box.style.fontFamily = "monospace";
    box.style.whiteSpace = "pre";
    box.innerText = "x: -\ny: -\nz: -\n(total: -)";
    document.body.appendChild(box);
    // --- Create invisible overlay ---
    const overlay = document.createElement("div");
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.background = "transparent";
    overlay.style.zIndex = "100000";
    overlay.style.cursor = "pointer";
    document.body.appendChild(overlay);
    function updateBox(acc) {
        box.innerText = `x: ${acc.x.toFixed(2)}\n` + `y: ${acc.y.toFixed(2)}\n` + `z: ${acc.z.toFixed(2)}\n` + `total: ${(Math.abs(acc.x) + Math.abs(acc.y) + Math.abs(acc.z)).toFixed(2)}`;
    }
    function startMotion() {
        console.log("motion start");
        window.addEventListener("devicemotion", (event)=>{
            const acc = event.accelerationIncludingGravity;
            if (!acc) return;
            updateBox(acc);
        });
    }
    overlay.addEventListener("click", ()=>{
        console.log("overlay clicked");
        if (typeof window.DeviceMotionEvent === "undefined") {
            box.innerText = "DeviceMotionEvent\nnot supported";
            overlay.remove();
            return;
        }
        if (typeof DeviceMotionEvent.requestPermission === "function") DeviceMotionEvent.requestPermission().then((response)=>{
            console.log("permission response:", response);
            if (response === "granted") {
                startMotion();
                overlay.remove();
            } else {
                box.innerText = "Permission Denied";
                overlay.remove();
            }
        }).catch((error)=>{
            console.error("permission error:", error);
            box.innerText = "Error";
            overlay.remove();
        });
        else {
            startMotion();
            overlay.remove();
        }
    });
}
function $5beed8c089bcee16$var$HeroMediaRotator() {
    class HeroMediaRotator {
        constructor(container){
            this.container = container;
            this.mode = container.dataset.heroMode; // 'loop' or 'static'
            this.imageDuration = parseInt(container.dataset.imageDuration) || 5000;
            this.totalItems = parseInt(container.dataset.totalItems) || 0;
            this.currentIndex = -1;
            this.items = Array.from(container.querySelectorAll(".hero-media-item"));
            this.imageTimer = null;
            this.loadedVideos = new Set(); // Track which videos we've loaded
            if (this.totalItems > 0) this.init();
        }
        init() {
            // Disable lazy loading for hero videos by adding a marker class
            this.items.forEach((item)=>{
                const video = item.querySelector("video");
                if (video) video.classList.add("hero-video-manual-load");
            });
            // Show random initial item
            this.showRandomItem();
            // Only set up loop mode if enabled and we have multiple items
            if (this.mode === "loop" && this.totalItems > 1) this.setupLoopMode();
            else if (this.totalItems === 1) // Single item: make videos loop forever
            this.setupSingleItemMode();
        }
        showRandomItem() {
            // Generate random index different from current
            let randomIndex;
            if (this.totalItems === 1) randomIndex = 0;
            else do randomIndex = Math.floor(Math.random() * this.totalItems);
            while (randomIndex === this.currentIndex);
            this.showItem(randomIndex);
        }
        showItem(index) {
            // Hide current item
            if (this.currentIndex >= 0) {
                const prevItem = this.items[this.currentIndex];
                prevItem.classList.remove("opacity-100");
                prevItem.classList.add("opacity-0");
                this.pauseCurrentVideo();
            }
            // Clear any existing image timer
            if (this.imageTimer) {
                clearTimeout(this.imageTimer);
                this.imageTimer = null;
            }
            // Show new item
            this.currentIndex = index;
            const currentItem = this.items[this.currentIndex];
            // Load the video if not already loaded
            this.loadVideo(currentItem);
            // Remove opacity-0 and add opacity-100 for Tailwind
            currentItem.classList.remove("opacity-0");
            currentItem.classList.add("opacity-100");
            // Handle video or image
            const video = currentItem.querySelector("video");
            if (video) // Small delay to ensure DOM is ready
            setTimeout(()=>this.playCurrentVideo(), 100);
            // Preload next video if in loop mode
            if (this.mode === "loop" && this.totalItems > 1) this.preloadNextVideo();
        }
        loadVideo(item) {
            const video = item.querySelector("video[data-desktop-src]");
            if (!video || this.loadedVideos.has(video)) return;
            // Use your existing responsive video handler if available
            if (typeof window.handleResponsiveVideoSource === "function") window.handleResponsiveVideoSource(video);
            else {
                // Fallback: simple load
                const desktopSrc = video.dataset.desktopSrc;
                const mobileSrc = video.dataset.mobileSrc;
                const isMobile = window.innerWidth < 768;
                const src = isMobile && mobileSrc ? mobileSrc : desktopSrc;
                const source = video.querySelector("source");
                if (source && src) {
                    source.src = src;
                    video.load();
                }
            }
            this.loadedVideos.add(video);
        }
        preloadNextVideo() {
            // Get a random next index
            let nextIndex;
            do nextIndex = Math.floor(Math.random() * this.totalItems);
            while (nextIndex === this.currentIndex);
            const nextItem = this.items[nextIndex];
            const video = nextItem.querySelector("video");
            // Only preload if it's a video
            if (video) this.loadVideo(nextItem);
        }
        setupLoopMode() {
            // Listen for video end events
            this.items.forEach((item, index)=>{
                const video = item.querySelector("video");
                if (video) {
                    // Remove loop attribute so video ends and triggers our rotation
                    video.removeAttribute("loop");
                    video.loop = false;
                    video.addEventListener("ended", ()=>{
                        if (index === this.currentIndex) this.showNextItem();
                    });
                }
            });
            // Set timer for initial item if it's an image
            const currentItem = this.items[this.currentIndex];
            const isImage = !currentItem.querySelector("video");
            if (isImage) this.startImageTimer();
        }
        setupSingleItemMode() {
            // For single items, ensure videos loop and images stay forever
            const item = this.items[0];
            const video = item.querySelector("video");
            if (video) {
                // Ensure video loops forever
                video.setAttribute("loop", "");
                video.loop = true;
            }
        // Images just stay visible forever (no timer needed)
        }
        showNextItem() {
            // Calculate next index (can repeat, just not same as current)
            let nextIndex;
            if (this.totalItems === 1) nextIndex = 0;
            else do nextIndex = Math.floor(Math.random() * this.totalItems);
            while (nextIndex === this.currentIndex);
            this.showItem(nextIndex);
            // Start timer if next item is an image
            const nextItem = this.items[nextIndex];
            const isImage = !nextItem.querySelector("video");
            if (isImage) this.startImageTimer();
        }
        startImageTimer() {
            this.imageTimer = setTimeout(()=>{
                this.showNextItem();
            }, this.imageDuration);
        }
        playCurrentVideo() {
            const video = this.items[this.currentIndex].querySelector("video");
            if (video) {
                // Reset video to start
                video.currentTime = 0;
                video.play().catch((err)=>{
                    console.warn("Video autoplay failed:", err);
                });
            }
        }
        pauseCurrentVideo() {
            if (this.currentIndex >= 0) {
                const video = this.items[this.currentIndex].querySelector("video");
                if (video) video.pause();
            }
        }
        destroy() {
            if (this.imageTimer) clearTimeout(this.imageTimer);
            this.pauseCurrentVideo();
        }
    }
    // Initialize all hero media containers
    function initHeroMediaRotators() {
        const containers = document.querySelectorAll(".hero-media-container");
        //console.log("Found containers:", containers.length);
        const rotators = [];
        containers.forEach((container)=>{
            //console.log("Initializing container:", container);
            rotators.push(new HeroMediaRotator(container));
        });
        // Cleanup on page unload
        window.addEventListener("beforeunload", ()=>{
            rotators.forEach((rotator)=>rotator.destroy());
        });
        return rotators;
    }
    // Try multiple initialization methods to ensure it runs
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initHeroMediaRotators);
    else // DOM already loaded
    initHeroMediaRotators();
}
function $5beed8c089bcee16$var$LogoHoverAnimation() {
    const logoElement = document.getElementById("logo-link");
    const player = $5beed8c089bcee16$var$LogoAnimation.getPlayer();
    let isPlayingIn = false;
    let isPlayingOut = false;
    let hasPlayedIn = false;
    let shouldPlayOutAfterIn = false; // <-- new flag
    logoElement.addEventListener("mouseenter", ()=>{
        // if we're already in the middle of playing in/out, ignore
        if (isPlayingIn || isPlayingOut) return;
        // cancel any pending out
        shouldPlayOutAfterIn = false;
        isPlayingIn = true;
        $5beed8c089bcee16$var$LogoAnimation.playIn();
        player.addEventListener("complete", function handlePlayInComplete() {
            isPlayingIn = false;
            player.removeEventListener("complete", handlePlayInComplete);
            hasPlayedIn = true;
            // If the user already left during playIn, immediately playOut
            if (shouldPlayOutAfterIn || !logoElement.matches(":hover")) triggerPlayOut();
        }, {
            once: true
        });
    });
    logoElement.addEventListener("mouseleave", ()=>{
        // If we're still playing in, mark that we should play out after it’s done
        if (isPlayingIn) {
            shouldPlayOutAfterIn = true;
            return;
        }
        // If we're already playing out or haven't played in yet, ignore
        if (isPlayingOut || !hasPlayedIn) return;
        triggerPlayOut();
    });
    function triggerPlayOut() {
        if (isPlayingOut) return; // prevent double fire
        isPlayingOut = true;
        isPlayingIn = false;
        hasPlayedIn = false;
        shouldPlayOutAfterIn = false;
        $5beed8c089bcee16$var$LogoAnimation.playOut();
        player.addEventListener("complete", function handlePlayOutComplete() {
            isPlayingOut = false;
            player.removeEventListener("complete", handlePlayOutComplete);
        }, {
            once: true
        });
    }
}
const $5beed8c089bcee16$var$heroFadeOutOnScroll = (()=>{
    const parentContainer = document.querySelector(".parent-container");
    const fadeContainer = document.querySelector(".fade-container");
    if (!parentContainer || !fadeContainer) return;
    (0, $4565420568d42cac$exports.scroll)((0, $4565420568d42cac$exports.animate)(fadeContainer, {
        opacity: [
            0,
            1
        ]
    }), {
        target: parentContainer,
        offset: [
            "40vh start",
            "end end"
        ]
    });
})();
const $5beed8c089bcee16$var$LogoAnimation = (()=>{
    let player = null;
    let isLoaded = false;
    let queuedAction = null;
    function init() {
        const el = document.getElementById("lottie-nav");
        if (!el) return;
        const src = el.getAttribute("data-src");
        isLoaded = false;
        queuedAction = null;
        player = new (0, $37d251801dc1953a$export$2c434b74e61f4f56)({
            canvas: el,
            src: src,
            autoplay: false,
            loop: false,
            speed: 1.5
        });
        player.addEventListener("load", onLoad);
        // 🔴 Critical fix for cached assets
        if (player.isLoaded) onLoad();
    }
    function onLoad() {
        if (isLoaded) return;
        isLoaded = true;
        if (queuedAction) {
            const action = queuedAction;
            queuedAction = null;
            action();
        }
    }
    function ensureReady(action) {
        if (!player) {
            queuedAction = action;
            return;
        }
        if (isLoaded || player.isLoaded) {
            isLoaded = true;
            action();
        } else queuedAction = action;
    }
    function playIn() {
        ensureReady(()=>{
            player.setSegment(0, 50);
            player.setFrame(0);
            player.play();
        });
    }
    function playOut() {
        ensureReady(()=>{
            player.setFrame(50);
            player.setSegment(50, 180);
            player.play();
        });
    }
    function playFull() {
        ensureReady(()=>{
            player.setSegment(0, 180);
            player.setFrame(0);
            player.play();
        });
    }
    function playOutIn() {
        playFull();
    }
    function getPlayer() {
        return player;
    }
    return {
        init: init,
        playIn: playIn,
        playOut: playOut,
        playFull: playFull,
        playOutIn: playOutIn,
        getPlayer: getPlayer
    };
})();
const $5beed8c089bcee16$var$loadingAnimation = (()=>{
    let player;
    function init() {
        const el = document.getElementById("lottie-nav");
        const src = el.getAttribute("data-src");
        player = new (0, $37d251801dc1953a$export$2c434b74e61f4f56)({
            canvas: el,
            src: src,
            autoplay: false,
            loop: false
        });
        player.addEventListener("load", ()=>{
        //console.log("Lottie loaded, total frames:", player.totalFrames);
        });
    }
    function playFull() {
        if (!player) return;
        player.setSegment(0, 180);
        player.play();
    }
    return {
        init: init,
        playFull: playFull
    };
})();
// Quicklink - Load only in Firefox and Safari
window.addEventListener("load", ()=>{
    const ua = navigator.userAgent;
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    const isFirefox = /firefox/i.test(ua);
    //console.log(isFirefox + " - " + isSafari);
    if (isSafari || isFirefox) (0, $a9fcb71ecd6bca7e$exports.listen)({
        limit: 12,
        throttle: 3,
        urls: [
            "/case",
            "/om-oss",
            "/kontakt",
            "/nyheter"
        ],
        ignores: [
            (uri)=>uri.endsWith(".pdf"),
            /^\/wp-admin\//
        ]
    });
});
/* Load functions */ // Initialize immediately if DOM is already loaded, otherwise wait for DOMContentLoaded
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $5beed8c089bcee16$var$initAllFunctions);
else // DOM already loaded (cached page or script loaded late)
$5beed8c089bcee16$var$initAllFunctions();
function $5beed8c089bcee16$var$initAllFunctions() {
    //toggleReducedMotion(); // Manual toggle of animations
    //toggleDarkmode();
    //addImageSize();
    //setupResizeListener(addImageSize);
    $5beed8c089bcee16$var$reducedMotion();
    $5beed8c089bcee16$var$lazyLoadVimeoEmbed();
    $5beed8c089bcee16$var$HeroMediaRotator();
    $5beed8c089bcee16$var$lazyLoadVideos();
    $5beed8c089bcee16$var$analyticsInit(500);
    $5beed8c089bcee16$var$customCursor();
    $5beed8c089bcee16$var$filterCase();
    $5beed8c089bcee16$var$toggleTabsContent(".tab-buttons button", ".tab-content > div");
    $5beed8c089bcee16$var$cowGoesMoo();
    $5beed8c089bcee16$var$loadSlides();
    $5beed8c089bcee16$var$LogoAnimation.init();
    $5beed8c089bcee16$var$LogoHoverAnimation();
    if (localStorage.getItem("reduced-motion") !== "true") {
        $5beed8c089bcee16$var$newsletterModal(0.8, 0.6, 0.6, 0.7);
        $5beed8c089bcee16$var$detailsAccordionAnimation();
        $5beed8c089bcee16$var$pageFadeTransition(300);
        $5beed8c089bcee16$var$setupScrollAnimations();
        $5beed8c089bcee16$var$moveImage();
        $5beed8c089bcee16$var$toggleOverlays(duration = 0.8);
    //milkShake();
    } else {
        $5beed8c089bcee16$var$newsletterModal(0, 0, 0, 0);
        $5beed8c089bcee16$var$pageFadeTransition(800); // Slows down fade effect
        $5beed8c089bcee16$var$toggleOverlays(duration = 0);
    }
}

})();
//# sourceMappingURL=scripts.js.map
